import * as z from 'zod';

import type {
  AlarmDefinition,
  AllocatedInjectionStringAgent,
  AllocatedPropertiesString,
  AllocatedRatesDailyStringAgent,
  AllocatedRatesVfmStringAgent,
  AllocationFactorsFieldAgent,
  AllocationOutputString,
  AsphalteneCurve,
  Asset,
  Choke,
  ChokeCurveInfo,
  ChokeOutputsNetworkAgent,
  Cognite3DModel,
  Cognite3DObject,
  Cognite3DRevision,
  Cognite3DTransformation,
  Cognite360Image,
  Cognite360ImageAnnotation,
  Cognite360ImageCollection,
  Cognite360ImageModel,
  Cognite360ImageStation,
  CogniteActivity,
  CogniteAnnotation,
  CogniteAsset,
  CogniteAssetClass,
  CogniteAssetType,
  CogniteCadModel,
  CogniteCadNode,
  CogniteCadRevision,
  CogniteCubeMap,
  CogniteDescribable,
  CogniteDiagramAnnotation,
  CogniteEquipment,
  CogniteEquipmentType,
  CogniteFile,
  CogniteFileCategory,
  CogniteMaintenanceOrder,
  CogniteNotification,
  CogniteOperation,
  CognitePointCloudModel,
  CognitePointCloudRevision,
  CognitePointCloudVolume,
  CogniteSchedulable,
  CogniteSourceable,
  CogniteSourceSystem,
  CogniteTimeSeries,
  CogniteUnit,
  CogniteVisualizable,
  Company,
  DailyRollupAssetAgent,
  DailyRollupCompanyAgent,
  DailyRollupFieldAgent,
  DailyRollupLocationAgent,
  DailyRollupOutputAsset,
  DailyRollupOutputCompany,
  DailyRollupOutputField,
  DailyRollupOutputLocation,
  DailyRollupOutputReservoir,
  DailyRollupOutputWell,
  DailyRollupReservoirAgent,
  DataDrivenRatesStringAgent,
  DataMapping,
  Entity,
  EntityAgent,
  EspAlarmsAgent,
  EspCable,
  EspCalculationsStringAgent,
  EspCurveDataStringAgent,
  EspLimitsStringAgent,
  EspMeasurementsStringAgent,
  EspMotor,
  EspPump,
  EspPumpDetails,
  EstimatedRatesStringAgent,
  EventsString,
  Field,
  FieldFormation,
  FieldInputs,
  FieldInputsAgent,
  FieldOutputs,
  FieldOutputsAgent,
  FlatHierarchy,
  FlatHierarchyAgent,
  FlowAssuranceAlarmsAgent,
  FlowlineOutputsNetworkAgent,
  FluidComposition,
  FormationVolumeFactor,
  GasLiftAlarmsAgent,
  GasLiftCalculationsStringAgent,
  GasLiftLimitsStringAgent,
  GasLiftMeasurementsStringAgent,
  GlValveData,
  InactiveString,
  InactiveStringAgent,
  InjectionAlarmsAgent,
  InjectionAllocationFactor,
  InjectionHeader,
  InjectionHeaderOutputsNetworkAgent,
  InjectionPerformanceStringAgent,
  InjPressGuidelineString,
  InjPressGuidelineStringAgent,
  Joint,
  JointOutputsNetworkAgent,
  LiftTypeParameterString,
  Location,
  LocationInputs,
  ManifoldInputs,
  MapGridMapping,
  MeasuredInjectionStringAgent,
  MeasuredRatesWellTestStringAgent,
  ModelManagementAlarmsAgent,
  ModelMatchedRatesStringAgent,
  Mpfm,
  MpfmInputs,
  MpfmOutputs,
  MpfmWellTestOutputs,
  Network,
  NetworkAlarmsAgent,
  NetworkInputs,
  NetworkInputsAgent,
  NetworkModel,
  NetworkModelAgent,
  NetworkOutputsField,
  NetworkOutputsFieldAgent,
  NetworkOutputsFieldValidated,
  NetworkOutputsReservoir,
  NetworkOutputsRuns,
  NetworkOutputsString,
  NetworkOutputsStringAgent,
  NetworkOutputsStringValidated,
  NetworkRiskOptimizationScenarios,
  NetworkRiskPipelineAgent,
  NetworkRiskPipelineOptimizationScenariosAgent,
  NetworkRiskStringAgent,
  NetworkRiskStringOptimizationScenariosAgent,
  OpportunityAgent,
  OptimizedRatesNetworkStringAgent,
  OptimizedRatesSrmStringAgent,
  Pipeline,
  PriorityRatesStringAgent,
  ProdplanString,
  ProdplanStringAgent,
  ProdplanStringReservoirSector,
  ProducerGuidelinesStringAgent,
  ProductionAllocationAlarmsAgent,
  ProsperModel,
  ProsperModelAgent,
  ProsperModelEventLog,
  ProsperModelMetrics,
  PseudoPressureTable,
  PtsOutputsString,
  PtsOutputsStringAgent,
  PtsReferenceConditions,
  PumpOutputsNetworkAgent,
  PvtAnalysisString,
  PvtAnalysisStringAgent,
  RateDiagnosticsStringAgent,
  Reservoir,
  ReservoirGuideline,
  ReservoirInputs,
  ReservoirInputsAgent,
  ReservoirOutputs,
  ReservoirOutputsAgent,
  ReservoirProdplan,
  SaturationPressureMapping,
  Sector,
  SectorHierarchy,
  SectorHierarchyAgent,
  SectorOutputs,
  SectorProdplan,
  Separator,
  SeparatorInputs,
  SeparatorOutputsNetworkAgent,
  ShgInjection,
  ShgProducerGuideline,
  ShgProduction,
  SPressSettings,
  SrmOutputsAllEntities,
  SrmOutputsString,
  SrmScenarioInfo,
  SrmSettings,
  StringAsset,
  StringFluidComposition,
  StringFluidCompositionAgent,
  StringFunction,
  StringInputsStatic,
  StringOutputsNetworkAgent,
  StringReservoirInputs,
  SurveillanceAlarmsAgent,
  TicketRegistryAgent,
  TimeSeries,
  ValueTrackingAgent,
  VrrFormationVolumeFactor,
  VrrMonitoring,
  VrrSectorHierarchy,
  WaterAnalysis,
  Well,
  WellBehaviourAlarmsAgent,
  WellChokeMapping,
  WellInputsStatic,
  WellInputsString,
  WellInputsStringReverse,
  WellMovementAgent,
  WellOutputsExt_1String,
  WellOutputsString,
  WellPotentialStringAgent,
  WellStatusStringAgent,
  WellTestAnalysisAgent,
  WellTestGaugeString,
  WellTestInputsString,
  WellTestModelParametersAgent,
  WellTestOutputsString,
  WellTestRaw,
  WellTestReservoirAnalysisAgent,
  Wf3OutputsString,
  Wf05FieldOutputs,
  Wf05StringOutputs,
  Wf05StringReservoirOutputs,
  WfAlarms,
  WfAlarmsAgent,
  WfFieldAlarms,
  WfReservoirAlarms,
  WfSectorAlarms,
  WfStringAlarms,
  WfWellAlarms,
} from '#schema/generated/ipso/types.ts';
import {
  Cognite3DGroupGroupType,
  Cognite3DModelType,
  Cognite3DRevisionStatus,
  Cognite3DRevisionType,
  CogniteAnnotationStatus,
  CognitePointCloudVolumeVolumeType,
  CogniteTimeSeriesType,
} from '#schema/generated/ipso/types.ts';

type Properties<T> = {
  [K in keyof T]: z.ZodType<T[K], T[K] | undefined>;
};

type definedNonNullAny = {};

export const isDefinedNonNullAny = (v: any): v is definedNonNullAny => v !== undefined && v !== null;

export const definedNonNullAnySchema = z.any().refine((v) => isDefinedNonNullAny(v));

export const CogniteTimeSeriesTypeSchema: z.ZodType<CogniteTimeSeriesType, CogniteTimeSeriesType> =
  z.enum(CogniteTimeSeriesType);

export const CognitePointCloudVolumeVolumeTypeSchema: z.ZodType<
  CognitePointCloudVolumeVolumeType,
  CognitePointCloudVolumeVolumeType
> = z.enum(CognitePointCloudVolumeVolumeType);

export const CogniteAnnotationStatusSchema: z.ZodType<CogniteAnnotationStatus, CogniteAnnotationStatus> =
  z.enum(CogniteAnnotationStatus);

export const Cognite3DRevisionTypeSchema: z.ZodType<Cognite3DRevisionType, Cognite3DRevisionType> =
  z.enum(Cognite3DRevisionType);

export const Cognite3DRevisionStatusSchema: z.ZodType<Cognite3DRevisionStatus, Cognite3DRevisionStatus> =
  z.enum(Cognite3DRevisionStatus);

export const Cognite3DModelTypeSchema: z.ZodType<Cognite3DModelType, Cognite3DModelType> = z.enum(Cognite3DModelType);

export const Cognite3DGroupGroupTypeSchema: z.ZodType<Cognite3DGroupGroupType, Cognite3DGroupGroupType> =
  z.enum(Cognite3DGroupGroupType);

export const CogniteUnitSchema: z.ZodObject<Properties<CogniteUnit>> = z
  .object({
    __typename: z.literal('CogniteUnit').optional(),
    aliases: z.array(z.string().nullable()).nullish().describe('Alternative names for the node'),
    description: z.string().nullish().describe('Description of the instance'),
    name: z.string().nullish().describe('Name of the instance'),
    quantity: z.string().nullish().describe('Specifies the physical quantity the unit measures'),
    source: z.string().nullish().describe('Source of the unit definition'),
    sourceReference: z.string().nullish().describe('Reference to the source of the unit definition'),
    symbol: z.string().nullish().describe('The symbol for the unit of measurement'),
    tags: z.array(z.string().nullable()).nullish().describe('Text based labels for generic use, limited to 1000'),
  })
  .describe('Represents a single unit of measurement');

export const CogniteFileCategorySchema: z.ZodObject<Properties<CogniteFileCategory>> = z
  .object({
    __typename: z.literal('CogniteFileCategory').optional(),
    aliases: z.array(z.string().nullable()).nullish().describe('Alternative names for the node'),
    code: z
      .string()
      .nullish()
      .describe("An identifier for the category, for example, 'AA' for Accounting (from Norsok.)\n@name Code"),
    description: z.string().nullish().describe('Description of the instance'),
    name: z.string().nullish().describe('Name of the instance'),
    standard: z
      .string()
      .nullish()
      .describe("The name of the standard the category originates from, for example, 'Norsok'.\n@name Standard"),
    standardReference: z
      .string()
      .nullish()
      .describe('A reference to the source of the category standard.\n@name Standard reference'),
    tags: z.array(z.string().nullable()).nullish().describe('Text based labels for generic use, limited to 1000'),
  })
  .describe(
    'Represents the categories of files as determined by contextualization or categorization.\n@name File category',
  );

export const CogniteEquipmentTypeSchema: z.ZodObject<Properties<CogniteEquipmentType>> = z
  .object({
    __typename: z.literal('CogniteEquipmentType').optional(),
    aliases: z.array(z.string().nullable()).nullish().describe('Alternative names for the node'),
    code: z.string().nullish().describe('A unique identifier for the type of equipment.\n@name Code'),
    description: z.string().nullish().describe('Description of the instance'),
    equipmentClass: z.string().nullish().describe('Represents the class of equipment.\n@name Equipment class'),
    name: z.string().nullish().describe('Name of the instance'),
    standard: z
      .string()
      .nullish()
      .describe(
        'An identifier for the standard this equipment type is sourced from, for example, ISO14224.\n@name Standard',
      ),
    standardReference: z
      .string()
      .nullish()
      .describe('A reference to the source of the equipment standard.\n@name Standard reference'),
    tags: z.array(z.string().nullable()).nullish().describe('Text based labels for generic use, limited to 1000'),
  })
  .describe('Represents the type of equipment.\n@name Equipment type');

export const CogniteDescribableSchema: z.ZodObject<Properties<CogniteDescribable>> = z
  .object({
    aliases: z.array(z.string().nullable()).nullish().describe('Alternative names for the node'),
    description: z.string().nullish().describe('Description of the instance'),
    name: z.string().nullish().describe('Name of the instance'),
    tags: z.array(z.string().nullable()).nullish().describe('Text based labels for generic use, limited to 1000'),
  })
  .describe(
    'The describable core concept is used as a standard way of holding the bare minimum of information about the instance',
  );

export const EspPumpSchema: z.ZodObject<Properties<EspPump>> = z
  .object({
    __typename: z.literal('ESPPump').optional(),
    description: z.string().nullish().describe("Text attribute 'description' for this 'ESPPump' row."),
    frequency: z.number().nullish().describe("Numeric value 'frequency' (floating point) for this 'ESPPump' row."),
    manufacturer: z.string().nullish().describe("Text attribute 'manufacturer' for this 'ESPPump' row."),
    maximumRate: z.number().nullish().describe("Numeric value 'maximumRate' (floating point) for this 'ESPPump' row."),
    minimumRate: z.number().nullish().describe("Numeric value 'minimumRate' (floating point) for this 'ESPPump' row."),
    name: z.string().nullish().describe("Text attribute 'name' for this 'ESPPump' row."),
    prosperIndex: z.int64().nullish().describe("Numeric value 'prosperIndex' (integer) for this 'ESPPump' row."),
    pumpSize: z.number().nullish().describe("Numeric value 'pumpSize' (floating point) for this 'ESPPump' row."),
    stages: z.number().nullish().describe("Numeric value 'stages' (integer) for this 'ESPPump' row."),
  })
  .describe("View 'ESPPump' in the iPSO production optimization solution data model.");

export const EspMotorSchema: z.ZodObject<Properties<EspMotor>> = z
  .object({
    __typename: z.literal('ESPMotor').optional(),
    current: z.number().nullish().describe("Numeric value 'current' (floating point) for this 'ESPMotor' row."),
    description: z.string().nullish().describe("Text attribute 'description' for this 'ESPMotor' row."),
    manufacturer: z.string().nullish().describe("Text attribute 'manufacturer' for this 'ESPMotor' row."),
    motorSeries: z.string().nullish().describe("Text attribute 'motorSeries' for this 'ESPMotor' row."),
    power: z.number().nullish().describe("Numeric value 'power' (floating point) for this 'ESPMotor' row."),
    prosperIndex: z.int64().nullish().describe("Numeric value 'prosperIndex' (integer) for this 'ESPMotor' row."),
    voltage: z.number().nullish().describe("Numeric value 'voltage' (floating point) for this 'ESPMotor' row."),
  })
  .describe("View 'ESPMotor' in the iPSO production optimization solution data model.");

export const EspCableSchema: z.ZodObject<Properties<EspCable>> = z
  .object({
    __typename: z.literal('ESPCable').optional(),
    cableType: z.string().nullish().describe("Text attribute 'cableType' for this 'ESPCable' row."),
    description: z.string().nullish().describe("Text attribute 'description' for this 'ESPCable' row."),
    maxCurrentAllowed: z
      .number()
      .nullish()
      .describe("Numeric value 'maxCurrentAllowed' (floating point) for this 'ESPCable' row."),
    prosperIndex: z.int64().nullish().describe("Numeric value 'prosperIndex' (integer) for this 'ESPCable' row."),
    voltageDropCoefficient: z
      .number()
      .nullish()
      .describe("Numeric value 'voltageDropCoefficient' (floating point) for this 'ESPCable' row."),
  })
  .describe("View 'ESPCable' in the iPSO production optimization solution data model.");

export const CogniteAssetClassSchema: z.ZodObject<Properties<CogniteAssetClass>> = z
  .object({
    __typename: z.literal('CogniteAssetClass').optional(),
    aliases: z.array(z.string().nullable()).nullish().describe('Alternative names for the node'),
    code: z.string().nullish().describe('A unique identifier for the class of asset.\n@name Code'),
    description: z.string().nullish().describe('Description of the instance'),
    name: z.string().nullish().describe('Name of the instance'),
    standard: z
      .string()
      .nullish()
      .describe('A text string to specify which standard the class is from.\n@name Standard'),
    tags: z.array(z.string().nullable()).nullish().describe('Text based labels for generic use, limited to 1000'),
  })
  .describe('Represents the class of an asset.\n@name Asset class');

export const CogniteAssetTypeSchema: z.ZodObject<Properties<CogniteAssetType>> = z
  .object({
    __typename: z.literal('CogniteAssetType').optional(),
    aliases: z.array(z.string().nullable()).nullish().describe('Alternative names for the node'),
    assetClass: z
      .lazy(() => CogniteAssetClassSchema.nullish())
      .describe(
        "Specifies the class the type belongs to. It's a direct relation to CogniteAssetClass.\n@name Asset class",
      ),
    code: z.string().nullish().describe('A unique identifier for the type of asset.\n@name Code'),
    description: z.string().nullish().describe('Description of the instance'),
    name: z.string().nullish().describe('Name of the instance'),
    standard: z
      .string()
      .nullish()
      .describe('A text string to specify which standard the type is from.\n@name Standard'),
    tags: z.array(z.string().nullable()).nullish().describe('Text based labels for generic use, limited to 1000'),
  })
  .describe('Represents the type of an asset.\n@name Asset type');

export const CogniteSourceSystemSchema: z.ZodObject<Properties<CogniteSourceSystem>> = z
  .object({
    __typename: z.literal('CogniteSourceSystem').optional(),
    aliases: z.array(z.string().nullable()).nullish().describe('Alternative names for the node'),
    description: z.string().nullish().describe('Description of the instance'),
    manufacturer: z.string().nullish().describe('Manufacturer of the source system'),
    name: z.string().nullish().describe('Name of the instance'),
    tags: z.array(z.string().nullable()).nullish().describe('Text based labels for generic use, limited to 1000'),
    version: z.string().nullish().describe('Version identifier for the source system'),
  })
  .describe('The CogniteSourceSystem core concept is used to standardize the way source system is stored.');

export const Cognite3DTransformationSchema: z.ZodObject<Properties<Cognite3DTransformation>> = z
  .object({
    eulerRotationX: z.number().nullish().describe('The rotation of the object around the X-axis in radians'),
    eulerRotationY: z.number().nullish().describe('The rotation of the object around the Y-axis in radians'),
    eulerRotationZ: z.number().nullish().describe('The rotation of the object around the Z-axis in radians'),
    scaleX: z.number().nullish().describe('The scaling factor applied to the object along the X-axis'),
    scaleY: z.number().nullish().describe('The scaling factor applied to the object along the Y-axis'),
    scaleZ: z.number().nullish().describe('The scaling factor applied to the object along the Z-axis'),
    translationX: z
      .number()
      .nullish()
      .describe('The displacement of the object along the X-axis in the 3D coordinate system'),
    translationY: z
      .number()
      .nullish()
      .describe('The displacement of the object along the Y-axis in the 3D coordinate system'),
    translationZ: z
      .number()
      .nullish()
      .describe('The displacement of the object along the Z-axis in the 3D coordinate system'),
  })
  .describe(
    "The Cognite3DTransformation object defines a comprehensive 3D transformation, enabling precise adjustments to an object's position, orientation, and size in the 3D coordinate system. It allows for the translation of objects along the three spatial axes, rotation around these axes using Euler angles, and scaling along each axis to modify the object's dimensions. The object's transformation is defined in \"CDF space\", a coordinate system where the positive Z axis is the up direction",
  );

export const Cognite360ImageStationSchema: z.ZodObject<Properties<Cognite360ImageStation>> = z
  .object({
    __typename: z.literal('Cognite360ImageStation').optional(),
    aliases: z.array(z.string().nullable()).nullish().describe('Alternative names for the node'),
    description: z.string().nullish().describe('Description of the instance'),
    groupType: Cognite3DGroupGroupTypeSchema.nullish().describe('Type of group'),
    name: z.string().nullish().describe('Name of the instance'),
    tags: z.array(z.string().nullable()).nullish().describe('Text based labels for generic use, limited to 1000'),
  })
  .describe('A way to group images across collections. Used for creating visual scan history');

export const WellSchema: z.ZodObject<Properties<Well>> = z
  .object({
    __typename: z.literal('Well').optional(),
    endDateTime: z.coerce.date<Date>().nullish().describe("Timestamp 'endDateTime' associated with this 'Well' row."),
    entityType: z.string().nullish().describe("Text attribute 'entityType' for this 'Well' row."),
    name: z.string().nullish().describe("Text attribute 'name' for this 'Well' row."),
    startDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'startDateTime' associated with this 'Well' row."),
  })
  .describe(
    "Typed view over 'Entity' showing wells only (where 'entityType' = 'well'). Use this view together with 'FlatHierarchy' or 'SectorHierarchy' to navigate from fields, reservoirs or sectors to their wells.",
  );

export const WfWellAlarmsSchema: z.ZodObject<Properties<WfWellAlarms>> = z
  .object({
    __typename: z.literal('WfWellAlarms').optional(),
    alarmCounter: z.number().nullish().describe("Numeric value 'alarmCounter' (integer) for this 'WfWellAlarms' row."),
    alarmFlags: z.string().nullish().describe("Text attribute 'alarmFlags' for this 'WfWellAlarms' row."),
    alarmLevel: z.string().nullish().describe("Text attribute 'alarmLevel' for this 'WfWellAlarms' row."),
    alarmMessage: z.string().nullish().describe("Text attribute 'alarmMessage' for this 'WfWellAlarms' row."),
    alarmName: z.string().nullish().describe("Text attribute 'alarmName' for this 'WfWellAlarms' row."),
    alarmType: z.string().nullish().describe("Text attribute 'alarmType' for this 'WfWellAlarms' row."),
    configuration: z.string().nullish().describe("Text attribute 'configuration' for this 'WfWellAlarms' row."),
    endDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'endDateTime' associated with this 'WfWellAlarms' row."),
    entityName: z
      .lazy(() => WellSchema.nullish())
      .describe("Reference to the related 'Well' entity for this 'WfWellAlarms' row."),
    operationType: z.string().nullish().describe("Text attribute 'operationType' for this 'WfWellAlarms' row."),
    startDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'startDateTime' associated with this 'WfWellAlarms' row."),
    ticketId: z.string().nullish().describe("Text attribute 'ticketId' for this 'WfWellAlarms' row."),
    workflowName: z.string().nullish().describe("Text attribute 'workflowName' for this 'WfWellAlarms' row."),
  })
  .describe("View 'WfWellAlarms' in the iPSO production optimization solution data model.");

export const TicketRegistryAgentSchema: z.ZodObject<Properties<TicketRegistryAgent>> = z
  .object({
    __typename: z.literal('TicketRegistry_Agent').optional(),
    actionPlan: z.string().nullish().describe('Detailed action plan with steps to remediate the issue.'),
    assignedTo: z.string().nullish().describe('Person or team assigned to resolve the ticket.'),
    closedDate: z.coerce
      .date<Date>()
      .nullish()
      .describe('Date/time when ticket was closed. Use for closed ticket analysis.'),
    description: z.string().nullish().describe('Full description of the issue, including context and observations.'),
    dueDate: z.coerce
      .date<Date>()
      .nullish()
      .describe('Target date for ticket resolution. Use to find overdue tickets.'),
    entityName: z
      .string()
      .nullish()
      .describe(
        'Name of the well, string, or field the ticket is associated with.\nPrimary filter for "show tickets for well X" queries.',
      ),
    entityType: z
      .string()
      .nullish()
      .describe(
        'Type of entity the ticket relates to: WELL, STRING, FIELD, RESERVOIR.\nUse to filter tickets by entity scope.',
      ),
    isOpportunity: z
      .string()
      .nullish()
      .describe(
        "Flag indicating if ticket represents a production optimization opportunity.\n'true' = opportunity for gain, 'false' = issue/problem.",
      ),
    priority: z
      .string()
      .describe(
        'Ticket priority level: LOW, MEDIUM, HIGH, URGENT.\nUse to filter critical issues that need immediate attention.',
      ),
    recommendation: z.string().nullish().describe('Recommended action or investigation steps to resolve the issue.'),
    reportedDate: z.coerce
      .date<Date>()
      .describe('Date/time when the ticket was created or reported. Use for age-based queries.'),
    status: z
      .string()
      .describe(
        'Current ticket status: OPEN, IN_PROGRESS, CLOSED, CANCELLED.\nUse to filter active vs completed tickets.',
      ),
    ticketCategory: z
      .string()
      .nullish()
      .describe(
        'Category classification (e.g., WELL_ISSUE, ESP_FAILURE, OPTIMIZATION).\nUse to filter tickets by problem type.',
      ),
    ticketId: z.string().describe('Unique ticket identifier. Primary key for joining to TicketHistory or SubTasks.'),
    ticketSource: z
      .string()
      .nullish()
      .describe(
        'Origin of the ticket (e.g., ALARM, MANUAL, SURVEILLANCE, WORKFLOW).\nIndicates how the ticket was created.',
      ),
    ticketSummary: z.string().describe('Brief summary of the issue or action item. Use for quick scanning of tickets.'),
  })
  .describe(
    'Troubleshooting ticket management for tracking open, closed, and assigned\noperations tickets.\n\nContains detailed records of troubleshooting tickets, including their\nlifecycle stages, statuses, and associated metadata such as priority and\nassignment. Sourced from operational ticketing systems, used to analyze ticket\ntrends, assess workload distribution, and identify areas requiring immediate\nattention. Typical analytical questions include tracking the status of tickets\nby category, evaluating response times, and determining the volume of tickets\nrelated to specific entities or opportunities. Excludes financial metrics or\nperformance indicators related to ticket resolution (see operational\nefficiency).',
  );

export const StringFunctionSchema: z.ZodObject<Properties<StringFunction>> = z
  .object({
    __typename: z.literal('String_Function').optional(),
    endDate: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'endDate' associated with this 'String_Function' row."),
    fieldCode: z.string().nullish().describe("Text attribute 'fieldCode' for this 'String_Function' row."),
    primaryWellbore: z.string().nullish().describe("Text attribute 'primaryWellbore' for this 'String_Function' row."),
    startDate: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'startDate' associated with this 'String_Function' row."),
    string: z.string().nullish().describe("Text attribute 'string' for this 'String_Function' row."),
    stringCode: z.string().nullish().describe("Text attribute 'stringCode' for this 'String_Function' row."),
    stringFunction: z.string().nullish().describe("Text attribute 'stringFunction' for this 'String_Function' row."),
    well: z.string().nullish().describe("Text attribute 'well' for this 'String_Function' row."),
  })
  .describe("View 'String_Function' in the iPSO production optimization solution data model.");

export const SeparatorSchema: z.ZodObject<Properties<Separator>> = z
  .object({
    __typename: z.literal('Separator').optional(),
    endDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'endDateTime' associated with this 'Separator' row."),
    entityType: z.string().nullish().describe("Text attribute 'entityType' for this 'Separator' row."),
    name: z.string().nullish().describe("Text attribute 'name' for this 'Separator' row."),
    startDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'startDateTime' associated with this 'Separator' row."),
  })
  .describe("View 'Separator' in the iPSO production optimization solution data model.");

export const SectorSchema: z.ZodObject<Properties<Sector>> = z
  .object({
    __typename: z.literal('Sector').optional(),
    endDateTime: z.coerce.date<Date>().nullish().describe("Timestamp 'endDateTime' associated with this 'Sector' row."),
    entityType: z.string().nullish().describe("Text attribute 'entityType' for this 'Sector' row."),
    name: z.string().nullish().describe("Text attribute 'name' for this 'Sector' row."),
    startDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'startDateTime' associated with this 'Sector' row."),
  })
  .describe("View 'Sector' in the iPSO production optimization solution data model.");

export const WfSectorAlarmsSchema: z.ZodObject<Properties<WfSectorAlarms>> = z
  .object({
    __typename: z.literal('WfSectorAlarms').optional(),
    alarmCounter: z
      .number()
      .nullish()
      .describe("Numeric value 'alarmCounter' (integer) for this 'WfSectorAlarms' row."),
    alarmFlags: z.string().nullish().describe("Text attribute 'alarmFlags' for this 'WfSectorAlarms' row."),
    alarmLevel: z.string().nullish().describe("Text attribute 'alarmLevel' for this 'WfSectorAlarms' row."),
    alarmMessage: z.string().nullish().describe("Text attribute 'alarmMessage' for this 'WfSectorAlarms' row."),
    alarmName: z.string().nullish().describe("Text attribute 'alarmName' for this 'WfSectorAlarms' row."),
    alarmType: z.string().nullish().describe("Text attribute 'alarmType' for this 'WfSectorAlarms' row."),
    configuration: z.string().nullish().describe("Text attribute 'configuration' for this 'WfSectorAlarms' row."),
    endDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'endDateTime' associated with this 'WfSectorAlarms' row."),
    entityName: z
      .lazy(() => SectorSchema.nullish())
      .describe("Reference to the related 'Sector' entity for this 'WfSectorAlarms' row."),
    operationType: z.string().nullish().describe("Text attribute 'operationType' for this 'WfSectorAlarms' row."),
    startDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'startDateTime' associated with this 'WfSectorAlarms' row."),
    ticketId: z.string().nullish().describe("Text attribute 'ticketId' for this 'WfSectorAlarms' row."),
    workflowName: z.string().nullish().describe("Text attribute 'workflowName' for this 'WfSectorAlarms' row."),
  })
  .describe("View 'WfSectorAlarms' in the iPSO production optimization solution data model.");

export const ReservoirSchema: z.ZodObject<Properties<Reservoir>> = z
  .object({
    __typename: z.literal('Reservoir').optional(),
    endDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'endDateTime' associated with this 'Reservoir' row."),
    entityType: z.string().nullish().describe("Text attribute 'entityType' for this 'Reservoir' row."),
    name: z
      .string()
      .nullish()
      .describe(
        "Name of the reservoir. To retrieve all wells in a reservoir, find the reservoir here and filter 'FlatHierarchy' or 'SectorHierarchy' on this reservoir while reading the 'well' property.",
      ),
    startDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'startDateTime' associated with this 'Reservoir' row."),
  })
  .describe(
    "Typed view over 'Entity' showing reservoirs only (where 'entityType' = 'reservoir'). Use this view to identify a reservoir by name, then navigate to its wells or strings through the 'FlatHierarchy' and 'SectorHierarchy' navigation views.",
  );

export const WfReservoirAlarmsSchema: z.ZodObject<Properties<WfReservoirAlarms>> = z
  .object({
    __typename: z.literal('WfReservoirAlarms').optional(),
    alarmCounter: z
      .number()
      .nullish()
      .describe("Numeric value 'alarmCounter' (integer) for this 'WfReservoirAlarms' row."),
    alarmFlags: z.string().nullish().describe("Text attribute 'alarmFlags' for this 'WfReservoirAlarms' row."),
    alarmLevel: z.string().nullish().describe("Text attribute 'alarmLevel' for this 'WfReservoirAlarms' row."),
    alarmMessage: z.string().nullish().describe("Text attribute 'alarmMessage' for this 'WfReservoirAlarms' row."),
    alarmName: z.string().nullish().describe("Text attribute 'alarmName' for this 'WfReservoirAlarms' row."),
    alarmType: z.string().nullish().describe("Text attribute 'alarmType' for this 'WfReservoirAlarms' row."),
    configuration: z.string().nullish().describe("Text attribute 'configuration' for this 'WfReservoirAlarms' row."),
    endDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'endDateTime' associated with this 'WfReservoirAlarms' row."),
    entityName: z
      .lazy(() => ReservoirSchema.nullish())
      .describe("Reference to the related 'Reservoir' entity for this 'WfReservoirAlarms' row."),
    operationType: z.string().nullish().describe("Text attribute 'operationType' for this 'WfReservoirAlarms' row."),
    startDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'startDateTime' associated with this 'WfReservoirAlarms' row."),
    ticketId: z.string().nullish().describe("Text attribute 'ticketId' for this 'WfReservoirAlarms' row."),
    workflowName: z.string().nullish().describe("Text attribute 'workflowName' for this 'WfReservoirAlarms' row."),
  })
  .describe("View 'WfReservoirAlarms' in the iPSO production optimization solution data model.");

export const PipelineSchema: z.ZodObject<Properties<Pipeline>> = z
  .object({
    __typename: z.literal('Pipeline').optional(),
    endDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'endDateTime' associated with this 'Pipeline' row."),
    entityType: z.string().nullish().describe("Text attribute 'entityType' for this 'Pipeline' row."),
    name: z.string().nullish().describe("Text attribute 'name' for this 'Pipeline' row."),
    startDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'startDateTime' associated with this 'Pipeline' row."),
  })
  .describe("View 'Pipeline' in the iPSO production optimization solution data model.");

export const LocationSchema: z.ZodObject<Properties<Location>> = z
  .object({
    __typename: z.literal('Location').optional(),
    endDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'endDateTime' associated with this 'Location' row."),
    entityType: z.string().nullish().describe("Text attribute 'entityType' for this 'Location' row."),
    name: z.string().nullish().describe("Text attribute 'name' for this 'Location' row."),
    startDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'startDateTime' associated with this 'Location' row."),
  })
  .describe("View 'Location' in the iPSO production optimization solution data model.");

export const MpfmSchema: z.ZodObject<Properties<Mpfm>> = z
  .object({
    __typename: z.literal('Mpfm').optional(),
    endDateTime: z.coerce.date<Date>().nullish().describe("Timestamp 'endDateTime' associated with this 'Mpfm' row."),
    entityType: z.string().nullish().describe("Text attribute 'entityType' for this 'Mpfm' row."),
    location: z
      .lazy(() => LocationSchema.nullish())
      .describe("Reference to the related 'Location' entity for this 'Mpfm' row."),
    modelName: z.string().nullish().describe("Text attribute 'modelName' for this 'Mpfm' row."),
    name: z.string().nullish().describe("Text attribute 'name' for this 'Mpfm' row."),
    startDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'startDateTime' associated with this 'Mpfm' row."),
  })
  .describe("View 'Mpfm' in the iPSO production optimization solution data model.");

export const JointSchema: z.ZodObject<Properties<Joint>> = z
  .object({
    __typename: z.literal('Joint').optional(),
    endDateTime: z.coerce.date<Date>().nullish().describe("Timestamp 'endDateTime' associated with this 'Joint' row."),
    entityType: z.string().nullish().describe("Text attribute 'entityType' for this 'Joint' row."),
    name: z.string().nullish().describe("Text attribute 'name' for this 'Joint' row."),
    startDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'startDateTime' associated with this 'Joint' row."),
  })
  .describe("View 'Joint' in the iPSO production optimization solution data model.");

export const InjectionHeaderSchema: z.ZodObject<Properties<InjectionHeader>> = z
  .object({
    __typename: z.literal('InjectionHeader').optional(),
    endDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'endDateTime' associated with this 'InjectionHeader' row."),
    entityType: z.string().nullish().describe("Text attribute 'entityType' for this 'InjectionHeader' row."),
    name: z.string().nullish().describe("Text attribute 'name' for this 'InjectionHeader' row."),
    startDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'startDateTime' associated with this 'InjectionHeader' row."),
  })
  .describe("View 'InjectionHeader' in the iPSO production optimization solution data model.");

export const EntityAgentSchema: z.ZodObject<Properties<EntityAgent>> = z
  .object({
    __typename: z.literal('Entity_Agent').optional(),
    endDateTime: z.coerce.date<Date>().nullish().describe('Timestamp at which the entity was deactivated.'),
    entityType: z
      .string()
      .nullish()
      .describe('Type of entity. Values are company, asset, field, reservoir, sector, location, well, string.'),
    name: z.string().nullish().describe('Display name of the entity.'),
    startDateTime: z.coerce.date<Date>().nullish().describe('Timestamp at which the entity became active.'),
  })
  .describe(
    'Base entity registry — companies, assets, fields, reservoirs, sectors,\nlocations, wells, and strings — scoped to in-scope instance spaces.\n\nSingle catalogue of every logical entity in the iPSO model with its display\nname, type, and effective date range. Underpins the hierarchy and per-entity\nviews; sourced from the central entity repository. Excludes operational or\nmeasurement data.\n\n@name Entity (Agent Scoped)',
  );

export const EntitySchema: z.ZodObject<Properties<Entity>> = z.object({
  __typename: z.literal('Entity').optional(),
  endDateTime: z.coerce.date<Date>().nullish(),
  entityType: z.string().nullish(),
  name: z.string().nullish(),
  startDateTime: z.coerce.date<Date>().nullish(),
});

export const CompanySchema: z.ZodObject<Properties<Company>> = z
  .object({
    __typename: z.literal('Company').optional(),
    endDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'endDateTime' associated with this 'Company' row."),
    entityType: z.string().nullish().describe("Text attribute 'entityType' for this 'Company' row."),
    name: z
      .string()
      .nullish()
      .describe(
        "Name of the company. Use together with 'FlatHierarchy' to scope navigation to assets, fields, reservoirs, wells and strings belonging to this company.",
      ),
    startDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'startDateTime' associated with this 'Company' row."),
  })
  .describe(
    "Typed view over 'Entity' showing companies only (where 'entityType' = 'company'). Use this view to identify the top-level company context, then navigate down to assets, fields, reservoirs, wells and strings through the 'FlatHierarchy' navigation view.",
  );

export const CogniteSourceableSchema: z.ZodObject<Properties<CogniteSourceable>> = z.object({
  source: z.lazy(() => CogniteSourceSystemSchema.nullish()).describe('Direct relation to a source system'),
  sourceContext: z
    .string()
    .nullish()
    .describe(
      'Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set.',
    ),
  sourceCreatedTime: z.coerce
    .date<Date>()
    .nullish()
    .describe('When the instance was created in source system (if available)'),
  sourceCreatedUser: z
    .string()
    .nullish()
    .describe(
      'User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF',
    ),
  sourceId: z.string().nullish().describe('Identifier from the source system'),
  sourceUpdatedTime: z.coerce
    .date<Date>()
    .nullish()
    .describe('When the instance was last updated in the source system (if available)'),
  sourceUpdatedUser: z
    .string()
    .nullish()
    .describe(
      'User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF',
    ),
});

export const CogniteSchedulableSchema: z.ZodObject<Properties<CogniteSchedulable>> = z
  .object({
    endTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('The actual end time of an activity (or similar that extends this)'),
    scheduledEndTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('The planned end time of an activity (or similar that extends this)'),
    scheduledStartTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('The planned start time of an activity (or similar that extends this)'),
    startTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('The actual start time of an activity (or similar that extends this)'),
  })
  .describe('CogniteSchedulable represents the metadata about when an activity (or similar) starts and ends.');

export const CogniteDiagramAnnotationSchema: z.ZodObject<Properties<CogniteDiagramAnnotation>> = z
  .object({
    __typename: z.literal('CogniteDiagramAnnotation').optional(),
    aliases: z.array(z.string().nullable()).nullish().describe('Alternative names for the node'),
    confidence: z.number().nullish().describe('The confidence that the annotation is a good match'),
    description: z.string().nullish().describe('Description of the instance'),
    endNodePageNumber: z
      .int64()
      .nullish()
      .describe(
        'The number of the page on which this annotation is located in the endNode File if an endNode is present. The first page has number 1',
      ),
    endNodeText: z
      .string()
      .nullish()
      .describe(
        'The text extracted from within the bounding box on the endNode. Only applicable if an endNode is defined',
      ),
    endNodeXMax: z
      .number()
      .nullish()
      .describe(
        'Value between [0,1]. Maximum abscissa of the bounding box (right edge). Must be strictly more than endNodeXMin. Only applicable if an endNode is defined',
      ),
    endNodeXMin: z
      .number()
      .nullish()
      .describe(
        'Value between [0,1]. Minimum abscissa of the bounding box (left edge). Must be strictly less than endNodeXMax. Only applicable if an endNode is defined',
      ),
    endNodeYMax: z
      .number()
      .nullish()
      .describe(
        'Value between [0,1]. Maximum ordinate of the bounding box (top edge). Must be strictly more than endNodeYMin. Only applicable if an endNode is defined',
      ),
    endNodeYMin: z
      .number()
      .nullish()
      .describe(
        'Value between [0,1]. Minimum ordinate of the bounding box (bottom edge). Must be strictly less than endNodeYMax. Only applicable if an endNode is defined',
      ),
    name: z.string().nullish().describe('Name of the instance'),
    source: z.lazy(() => CogniteSourceSystemSchema.nullish()).describe('Direct relation to a source system'),
    sourceContext: z
      .string()
      .nullish()
      .describe(
        'Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set.',
      ),
    sourceCreatedTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('When the instance was created in source system (if available)'),
    sourceCreatedUser: z
      .string()
      .nullish()
      .describe(
        'User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF',
      ),
    sourceId: z.string().nullish().describe('Identifier from the source system'),
    sourceUpdatedTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('When the instance was last updated in the source system (if available)'),
    sourceUpdatedUser: z
      .string()
      .nullish()
      .describe(
        'User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF',
      ),
    startNodePageNumber: z
      .int64()
      .nullish()
      .describe(
        'The number of the page on which this annotation is located in `startNode` File. The first page has number 1',
      ),
    startNodeText: z.string().nullish().describe('The text extracted from within the bounding box on the startNode'),
    startNodeXMax: z
      .number()
      .nullish()
      .describe(
        'Value between [0,1]. Maximum abscissa of the bounding box (right edge). Must be strictly more than startNodeXMin',
      ),
    startNodeXMin: z
      .number()
      .nullish()
      .describe(
        'Value between [0,1]. Minimum abscissa of the bounding box (left edge). Must be strictly less than startNodeXMax',
      ),
    startNodeYMax: z
      .number()
      .nullish()
      .describe(
        'Value between [0,1]. Maximum ordinate of the bounding box (top edge). Must be strictly more than startNodeYMin',
      ),
    startNodeYMin: z
      .number()
      .nullish()
      .describe(
        'Value between [0,1]. Minimum ordinate of the bounding box (bottom edge). Must be strictly less than startNodeYMax',
      ),
    status: CogniteAnnotationStatusSchema.nullish().describe('The status of the annotation'),
    tags: z.array(z.string().nullable()).nullish().describe('Text based labels for generic use, limited to 1000'),
  })
  .describe('Annotation for diagrams');

export const CogniteAnnotationSchema: z.ZodObject<Properties<CogniteAnnotation>> = z
  .object({
    aliases: z.array(z.string().nullable()).nullish().describe('Alternative names for the node'),
    confidence: z.number().nullish().describe('The confidence that the annotation is a good match'),
    description: z.string().nullish().describe('Description of the instance'),
    name: z.string().nullish().describe('Name of the instance'),
    source: z.lazy(() => CogniteSourceSystemSchema.nullish()).describe('Direct relation to a source system'),
    sourceContext: z
      .string()
      .nullish()
      .describe(
        'Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set.',
      ),
    sourceCreatedTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('When the instance was created in source system (if available)'),
    sourceCreatedUser: z
      .string()
      .nullish()
      .describe(
        'User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF',
      ),
    sourceId: z.string().nullish().describe('Identifier from the source system'),
    sourceUpdatedTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('When the instance was last updated in the source system (if available)'),
    sourceUpdatedUser: z
      .string()
      .nullish()
      .describe(
        'User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF',
      ),
    status: CogniteAnnotationStatusSchema.nullish().describe('The status of the annotation'),
    tags: z.array(z.string().nullable()).nullish().describe('Text based labels for generic use, limited to 1000'),
  })
  .describe('Annotation represents contextualization results or links');

export const Cognite360ImageAnnotationSchema: z.ZodObject<Properties<Cognite360ImageAnnotation>> = z.object({
  __typename: z.literal('Cognite360ImageAnnotation').optional(),
  aliases: z.array(z.string().nullable()).nullish().describe('Alternative names for the node'),
  confidence: z.number().nullish().describe('The confidence that the annotation is a good match'),
  description: z.string().nullish().describe('Description of the instance'),
  formatVersion: z.string().nullish().describe('Specifies the storage representation for the polygon'),
  name: z.string().nullish().describe('Name of the instance'),
  polygon: z
    .array(z.number().nullable())
    .nullish()
    .describe('List of floats representing the polygon. Format depends on formatVersion'),
  source: z.lazy(() => CogniteSourceSystemSchema.nullish()).describe('Direct relation to a source system'),
  sourceContext: z
    .string()
    .nullish()
    .describe(
      'Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set.',
    ),
  sourceCreatedTime: z.coerce
    .date<Date>()
    .nullish()
    .describe('When the instance was created in source system (if available)'),
  sourceCreatedUser: z
    .string()
    .nullish()
    .describe(
      'User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF',
    ),
  sourceId: z.string().nullish().describe('Identifier from the source system'),
  sourceUpdatedTime: z.coerce
    .date<Date>()
    .nullish()
    .describe('When the instance was last updated in the source system (if available)'),
  sourceUpdatedUser: z
    .string()
    .nullish()
    .describe(
      'User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF',
    ),
  status: CogniteAnnotationStatusSchema.nullish().describe('The status of the annotation'),
  tags: z.array(z.string().nullable()).nullish().describe('Text based labels for generic use, limited to 1000'),
});

export const Cognite360ImageSchema: z.ZodObject<Properties<Cognite360Image>> = z.object({
  __typename: z.literal('Cognite360Image').optional(),
  back: z
    .lazy(() => CogniteFileSchema.nullish())
    .describe('Direct relation to a file holding the back projection of the cube map'),
  bottom: z
    .lazy(() => CogniteFileSchema.nullish())
    .describe('Direct relation to a file holding the bottom projection of the cube map'),
  collection360: z
    .lazy(() => Cognite360ImageCollectionSchema.nullish())
    .describe('Direct relation to Cognite360ImageCollection'),
  eulerRotationX: z.number().nullish().describe('The rotation of the object around the X-axis in radians'),
  eulerRotationY: z.number().nullish().describe('The rotation of the object around the Y-axis in radians'),
  eulerRotationZ: z.number().nullish().describe('The rotation of the object around the Z-axis in radians'),
  front: z
    .lazy(() => CogniteFileSchema.nullish())
    .describe('Direct relation to a file holding the front projection of the cube map'),
  left: z
    .lazy(() => CogniteFileSchema.nullish())
    .describe('Direct relation to a file holding the left projection of the cube map'),
  right: z
    .lazy(() => CogniteFileSchema.nullish())
    .describe('Direct relation to a file holding the right projection of the cube map'),
  scaleX: z.number().nullish().describe('The scaling factor applied to the object along the X-axis'),
  scaleY: z.number().nullish().describe('The scaling factor applied to the object along the Y-axis'),
  scaleZ: z.number().nullish().describe('The scaling factor applied to the object along the Z-axis'),
  station360: z
    .lazy(() => Cognite360ImageStationSchema.nullish())
    .describe(
      'Direct relation to Cognite3DGroup instance that groups different Cognite360Image instances to the same station',
    ),
  takenAt: z.coerce.date<Date>().nullish().describe('The timestamp when the 6 photos were taken'),
  top: z
    .lazy(() => CogniteFileSchema.nullish())
    .describe('Direct relation to a file holding the top projection of the cube map'),
  translationX: z
    .number()
    .nullish()
    .describe('The displacement of the object along the X-axis in the 3D coordinate system'),
  translationY: z
    .number()
    .nullish()
    .describe('The displacement of the object along the Y-axis in the 3D coordinate system'),
  translationZ: z
    .number()
    .nullish()
    .describe('The displacement of the object along the Z-axis in the 3D coordinate system'),
});

export const Cognite3DObjectSchema: z.ZodObject<Properties<Cognite3DObject>> = z
  .object({
    __typename: z.literal('Cognite3DObject').optional(),
    aliases: z.array(z.string().nullable()).nullish().describe('Alternative names for the node'),
    asset: z.lazy(() => CogniteAssetSchema.nullish()).describe('Asset that is tied to this 3D object'),
    cadNodes: z
      .array(z.lazy(() => CogniteCadNodeSchema.nullable()))
      .nullish()
      .describe('List of up to 1000 CADNodes that represents the connected CogniteAsset'),
    description: z.string().nullish().describe('Description of the instance'),
    images360: z
      .array(z.lazy(() => Cognite360ImageSchema.nullable()))
      .nullish()
      .describe('Edge connection to Cognite360Image annotations that represents the connected CogniteAsset'),
    name: z.string().nullish().describe('Name of the instance'),
    pointCloudVolumes: z
      .array(z.lazy(() => CognitePointCloudVolumeSchema.nullable()))
      .nullish()
      .describe('List of up to 1000 PointCloudVolumes that represents the connected CogniteAsset'),
    tags: z.array(z.string().nullable()).nullish().describe('Text based labels for generic use, limited to 1000'),
    xMax: z.number().nullish().describe('Highest X value in bounding box'),
    xMin: z.number().nullish().describe('Lowest X value in bounding box'),
    yMax: z.number().nullish().describe('Highest Y value in bounding box'),
    yMin: z.number().nullish().describe('Lowest Y value in bounding box'),
    zMax: z.number().nullish().describe('Highest Z value in bounding box'),
    zMin: z.number().nullish().describe('Lowest Z value in bounding box'),
  })
  .describe(
    'This is the virtual position representation of an object in the physical world, connecting an asset to one or more 3D resources',
  );

export const CogniteVisualizableSchema: z.ZodObject<Properties<CogniteVisualizable>> = z
  .object({
    object3D: z
      .lazy(() => Cognite3DObjectSchema.nullish())
      .describe('Direct relation to an Object3D instance representing the 3D resource'),
  })
  .describe('CogniteVisualizable defines the standard way to reference a related 3D resource');

export const CogniteAssetSchema: z.ZodObject<Properties<CogniteAsset>> = z
  .object({
    __typename: z.literal('CogniteAsset').optional(),
    activities: z
      .array(z.lazy(() => CogniteActivitySchema.nullable()))
      .nullish()
      .describe('An automatically updated list of activities related to the asset.\n@name Activities'),
    aliases: z.array(z.string().nullable()).nullish().describe('Alternative names for the node'),
    assetClass: z
      .lazy(() => CogniteAssetClassSchema.nullish())
      .describe("Specifies the class of the asset. It's a direct relation to CogniteAssetClass.\n@name Asset class"),
    children: z
      .array(z.lazy(() => CogniteAssetSchema.nullable()))
      .nullish()
      .describe('An automatically updated list of assets with this asset as their parent.\n@name Children'),
    description: z.string().nullish().describe('Description of the instance'),
    equipment: z
      .array(z.lazy(() => CogniteEquipmentSchema.nullable()))
      .nullish()
      .describe('An automatically updated list of equipment related to the asset.\n@name Equipment'),
    files: z
      .array(z.lazy(() => CogniteFileSchema.nullable()))
      .nullish()
      .describe('An automatically updated list of files related to the asset.\n@name Files'),
    name: z.string().nullish().describe('Name of the instance'),
    object3D: z
      .lazy(() => Cognite3DObjectSchema.nullish())
      .describe('Direct relation to an Object3D instance representing the 3D resource'),
    parent: z.lazy(() => CogniteAssetSchema.nullish()).describe('The parent of the asset.\n@name Parent'),
    path: z
      .array(z.lazy(() => CogniteAssetSchema.nullable()))
      .nullish()
      .describe(
        "An automatically updated ordered list of this asset's ancestors, starting with the root asset. Enables subtree filtering to find all assets under a parent.\n@name Path",
      ),
    pathLastUpdatedTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('The last time the path was updated for this asset.\n@name Path last updated time'),
    root: z
      .lazy(() => CogniteAssetSchema.nullish())
      .describe('An automatically updated reference to the top-level asset of the hierarchy.\n@name Root'),
    source: z.lazy(() => CogniteSourceSystemSchema.nullish()).describe('Direct relation to a source system'),
    sourceContext: z
      .string()
      .nullish()
      .describe(
        'Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set.',
      ),
    sourceCreatedTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('When the instance was created in source system (if available)'),
    sourceCreatedUser: z
      .string()
      .nullish()
      .describe(
        'User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF',
      ),
    sourceId: z.string().nullish().describe('Identifier from the source system'),
    sourceUpdatedTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('When the instance was last updated in the source system (if available)'),
    sourceUpdatedUser: z
      .string()
      .nullish()
      .describe(
        'User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF',
      ),
    tags: z.array(z.string().nullable()).nullish().describe('Text based labels for generic use, limited to 1000'),
    timeSeries: z
      .array(z.lazy(() => CogniteTimeSeriesSchema.nullable()))
      .nullish()
      .describe('An automatically updated list of time series related to the asset.\n@name Time series'),
    type: z
      .lazy(() => CogniteAssetTypeSchema.nullish())
      .describe("Specifies the type of the asset. It's a direct relation to CogniteAssetType.\n@name Asset type"),
  })
  .describe(
    "Assets represent systems that support industrial functions or processes. Assets are often called 'functional location'.\n@name Asset",
  );

export const CogniteActivitySchema: z.ZodObject<Properties<CogniteActivity>> = z
  .object({
    __typename: z.literal('CogniteActivity').optional(),
    aliases: z.array(z.string().nullable()).nullish().describe('Alternative names for the node'),
    assets: z
      .array(z.lazy(() => CogniteAssetSchema.nullable()))
      .nullish()
      .describe('A list of assets the activity is related to.\n@name Assets'),
    description: z.string().nullish().describe('Description of the instance'),
    endTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('The actual end time of an activity (or similar that extends this)'),
    equipment: z
      .array(z.lazy(() => CogniteEquipmentSchema.nullable()))
      .nullish()
      .describe('A list of equipment the activity is related to.\n@name Equipment'),
    name: z.string().nullish().describe('Name of the instance'),
    scheduledEndTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('The planned end time of an activity (or similar that extends this)'),
    scheduledStartTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('The planned start time of an activity (or similar that extends this)'),
    source: z.lazy(() => CogniteSourceSystemSchema.nullish()).describe('Direct relation to a source system'),
    sourceContext: z
      .string()
      .nullish()
      .describe(
        'Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set.',
      ),
    sourceCreatedTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('When the instance was created in source system (if available)'),
    sourceCreatedUser: z
      .string()
      .nullish()
      .describe(
        'User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF',
      ),
    sourceId: z.string().nullish().describe('Identifier from the source system'),
    sourceUpdatedTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('When the instance was last updated in the source system (if available)'),
    sourceUpdatedUser: z
      .string()
      .nullish()
      .describe(
        'User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF',
      ),
    startTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('The actual start time of an activity (or similar that extends this)'),
    tags: z.array(z.string().nullable()).nullish().describe('Text based labels for generic use, limited to 1000'),
    timeSeries: z
      .array(z.lazy(() => CogniteTimeSeriesSchema.nullable()))
      .nullish()
      .describe('A list of time series the activity is related to.\n@name Time series'),
  })
  .describe(
    'Represents activities. Activities typically happen over a period and have a start and end time.\n@name Activity',
  );

export const CogniteEquipmentSchema: z.ZodObject<Properties<CogniteEquipment>> = z
  .object({
    __typename: z.literal('CogniteEquipment').optional(),
    activities: z
      .array(z.lazy(() => CogniteActivitySchema.nullable()))
      .nullish()
      .describe('An automatically updated list of activities related to the equipment.\n@name Activities'),
    aliases: z.array(z.string().nullable()).nullish().describe('Alternative names for the node'),
    asset: z.lazy(() => CogniteAssetSchema.nullish()).describe('The asset the equipment is related to.\n@name Asset'),
    description: z.string().nullish().describe('Description of the instance'),
    equipmentType: z
      .lazy(() => CogniteEquipmentTypeSchema.nullish())
      .describe(
        "Specifies the type of the equipment. It's a direct relation to CogniteEquipmentType.\n@name Equipment type",
      ),
    files: z
      .array(z.lazy(() => CogniteFileSchema.nullable()))
      .nullish()
      .describe('A list of files the equipment relates to.\n@name Files'),
    manufacturer: z.string().nullish().describe('The manufacturer of the equipment.\n@name Manufacturer'),
    name: z.string().nullish().describe('Name of the instance'),
    serialNumber: z.string().nullish().describe('The serial number of the equipment.\n@name Serial number'),
    source: z.lazy(() => CogniteSourceSystemSchema.nullish()).describe('Direct relation to a source system'),
    sourceContext: z
      .string()
      .nullish()
      .describe(
        'Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set.',
      ),
    sourceCreatedTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('When the instance was created in source system (if available)'),
    sourceCreatedUser: z
      .string()
      .nullish()
      .describe(
        'User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF',
      ),
    sourceId: z.string().nullish().describe('Identifier from the source system'),
    sourceUpdatedTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('When the instance was last updated in the source system (if available)'),
    sourceUpdatedUser: z
      .string()
      .nullish()
      .describe(
        'User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF',
      ),
    tags: z.array(z.string().nullable()).nullish().describe('Text based labels for generic use, limited to 1000'),
    timeSeries: z
      .array(z.lazy(() => CogniteTimeSeriesSchema.nullable()))
      .nullish()
      .describe('An automatically updated list of time series related to the equipment.\n@name Time series'),
  })
  .describe('Equipment represents physical supplies or devices.\n@name Equipment');

export const CogniteTimeSeriesSchema: z.ZodObject<Properties<CogniteTimeSeries>> = z
  .object({
    __typename: z.literal('CogniteTimeSeries').optional(),
    activities: z
      .array(z.lazy(() => CogniteActivitySchema.nullable()))
      .nullish()
      .describe('An automatically updated list of activities the time series is related to.\n@name Activities'),
    aliases: z.array(z.string().nullable()).nullish().describe('Alternative names for the node'),
    assets: z
      .array(z.lazy(() => CogniteAssetSchema.nullable()))
      .nullish()
      .describe('A list of assets the time series is related to.\n@name Assets'),
    description: z.string().nullish().describe('Description of the instance'),
    equipment: z
      .array(z.lazy(() => CogniteEquipmentSchema.nullable()))
      .nullish()
      .describe('A list of equipment the time series is related to.\n@name Equipment'),
    isStep: z
      .boolean()
      .default(false)
      .nullish()
      .describe('Specifies whether the time series is a step time series or not.\n@name Is step'),
    name: z.string().nullish().describe('Name of the instance'),
    source: z.lazy(() => CogniteSourceSystemSchema.nullish()).describe('Direct relation to a source system'),
    sourceContext: z
      .string()
      .nullish()
      .describe(
        'Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set.',
      ),
    sourceCreatedTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('When the instance was created in source system (if available)'),
    sourceCreatedUser: z
      .string()
      .nullish()
      .describe(
        'User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF',
      ),
    sourceId: z.string().nullish().describe('Identifier from the source system'),
    sourceUnit: z.string().nullish().describe('The unit specified in the source system.\n@name Source unit'),
    sourceUpdatedTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('When the instance was last updated in the source system (if available)'),
    sourceUpdatedUser: z
      .string()
      .nullish()
      .describe(
        'User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF',
      ),
    stateSet: z
      .json()
      .nullish()
      .describe("The state set of the time series. It is only in effect when the type is 'state'.\n@name State set"),
    tags: z.array(z.string().nullable()).nullish().describe('Text based labels for generic use, limited to 1000'),
    type: CogniteTimeSeriesTypeSchema.nullish().describe('Specifies the data type of the data points.\n@name Type'),
    unit: z.lazy(() => CogniteUnitSchema.nullish()).describe('The unit of the time series.\n@name Unit'),
  })
  .describe('Represents a series of data points in time order.\n@name Time series');

export const CogniteMaintenanceOrderSchema: z.ZodObject<Properties<CogniteMaintenanceOrder>> = z
  .object({
    __typename: z.literal('CogniteMaintenanceOrder').optional(),
    aliases: z.array(z.string().nullable()).nullish().describe('Alternative names for the node'),
    assets: z
      .array(z.lazy(() => CogniteAssetSchema.nullable()))
      .nullish()
      .describe('A list of assets the activity is related to.\n@name Assets'),
    description: z.string().nullish().describe('Description of the instance'),
    endTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('The actual end time of an activity (or similar that extends this)'),
    equipment: z
      .array(z.lazy(() => CogniteEquipmentSchema.nullable()))
      .nullish()
      .describe('A list of equipment the activity is related to.\n@name Equipment'),
    mainAsset: z
      .lazy(() => CogniteAssetSchema.nullish())
      .describe('The primary asset (functional location) the maintenance order refers to.\n@name Main asset'),
    name: z.string().nullish().describe('Name of the instance'),
    operations: z
      .array(z.lazy(() => CogniteOperationSchema.nullable()))
      .nullish()
      .describe(
        'Lists the individual work items on the maintenance order. An automatically populated list of operations related to the maintenance order.\n@name Operations',
      ),
    priority: z
      .int64()
      .nullish()
      .describe(
        "A number that shows how important this maintenance order is. Lower numbers mean it's more important, and 0 means it's the most important.\n@name Priority",
      ),
    priorityDescription: z
      .string()
      .nullish()
      .describe('Describes the priority of the maintenance order.\n@name Priority description'),
    scheduledEndTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('The planned end time of an activity (or similar that extends this)'),
    scheduledStartTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('The planned start time of an activity (or similar that extends this)'),
    source: z.lazy(() => CogniteSourceSystemSchema.nullish()).describe('Direct relation to a source system'),
    sourceContext: z
      .string()
      .nullish()
      .describe(
        'Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set.',
      ),
    sourceCreatedTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('When the instance was created in source system (if available)'),
    sourceCreatedUser: z
      .string()
      .nullish()
      .describe(
        'User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF',
      ),
    sourceId: z.string().nullish().describe('Identifier from the source system'),
    sourceUpdatedTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('When the instance was last updated in the source system (if available)'),
    sourceUpdatedUser: z
      .string()
      .nullish()
      .describe(
        'User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF',
      ),
    startTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('The actual start time of an activity (or similar that extends this)'),
    status: z
      .string()
      .nullish()
      .describe(
        "The lifecycle status of the maintenance order, for example, 'Partially complete'. It's often derived from the 'SystemStatus' field in SAP.\n@name Status",
      ),
    tags: z.array(z.string().nullable()).nullish().describe('Text based labels for generic use, limited to 1000'),
    timeSeries: z
      .array(z.lazy(() => CogniteTimeSeriesSchema.nullable()))
      .nullish()
      .describe('A list of time series the activity is related to.\n@name Time series'),
    type: z
      .string()
      .nullish()
      .describe(
        "The code for the type of maintenance order, for example, 'PM01' for 'Corrective maintenance'.\n@name Type",
      ),
  })
  .describe(
    "A formal request or directive to perform maintenance tasks such as repair, inspection, or servicing of equipment or assets. It's often called a 'work order'.\n@name Maintenance order",
  );

export const CogniteOperationSchema: z.ZodObject<Properties<CogniteOperation>> = z
  .object({
    __typename: z.literal('CogniteOperation').optional(),
    aliases: z.array(z.string().nullable()).nullish().describe('Alternative names for the node'),
    assets: z
      .array(z.lazy(() => CogniteAssetSchema.nullable()))
      .nullish()
      .describe('A list of assets the activity is related to.\n@name Assets'),
    description: z.string().nullish().describe('Description of the instance'),
    endTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('The actual end time of an activity (or similar that extends this)'),
    equipment: z
      .array(z.lazy(() => CogniteEquipmentSchema.nullable()))
      .nullish()
      .describe('A list of equipment the activity is related to.\n@name Equipment'),
    mainAsset: z
      .lazy(() => CogniteAssetSchema.nullish())
      .describe('The primary asset (functional location) the operation is related to.\n@name Main asset'),
    mainDiscipline: z
      .string()
      .nullish()
      .describe(
        "The primary skill or resource required to perform the operation, for example, 'maintenance technician').\n@name Main discipline",
      ),
    maintenanceOrder: z
      .lazy(() => CogniteMaintenanceOrderSchema.nullish())
      .describe('The maintenance order the operation is related to.\n@name Maintenance order'),
    name: z.string().nullish().describe('Name of the instance'),
    numberOfMainDiscipline: z
      .int64()
      .nullish()
      .describe(
        'The number of resources required to perform the operation, for example, the number of required maintenance technicians.\n@name Number of main discipline',
      ),
    personHours: z
      .number()
      .nullish()
      .describe(
        'The number of hours required to perform the maintenance operation. The duration is calculated by dividing the personHours by the numberOfMainDiscipline.\n@name Person hours',
      ),
    phase: z
      .string()
      .nullish()
      .describe(
        "The code for the phase the operation belongs to. Each operation belongs to a single phase, for example, 'Scaffolding'.\n@name Phase",
      ),
    scheduledEndTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('The planned end time of an activity (or similar that extends this)'),
    scheduledStartTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('The planned start time of an activity (or similar that extends this)'),
    sequence: z
      .int64()
      .nullish()
      .describe(
        "A number that shows the order in which the operations are performed. Lower numbers mean they happen earlier, and 0 means it's the first operation.\n@name Sequence",
      ),
    source: z.lazy(() => CogniteSourceSystemSchema.nullish()).describe('Direct relation to a source system'),
    sourceContext: z
      .string()
      .nullish()
      .describe(
        'Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set.',
      ),
    sourceCreatedTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('When the instance was created in source system (if available)'),
    sourceCreatedUser: z
      .string()
      .nullish()
      .describe(
        'User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF',
      ),
    sourceId: z.string().nullish().describe('Identifier from the source system'),
    sourceUpdatedTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('When the instance was last updated in the source system (if available)'),
    sourceUpdatedUser: z
      .string()
      .nullish()
      .describe(
        'User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF',
      ),
    startTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('The actual start time of an activity (or similar that extends this)'),
    status: z
      .string()
      .nullish()
      .describe(
        "The lifecycle status of the operation, for example, 'Partially complete'. It's often derived from the UserStatus field in SAP.\n@name Status",
      ),
    tags: z.array(z.string().nullable()).nullish().describe('Text based labels for generic use, limited to 1000'),
    timeSeries: z
      .array(z.lazy(() => CogniteTimeSeriesSchema.nullable()))
      .nullish()
      .describe('A list of time series the activity is related to.\n@name Time series'),
  })
  .describe(
    "Operations represent a specific part of the work included in a maintenance order. Often called a 'work order item'.\n@name Operation",
  );

export const CogniteNotificationSchema: z.ZodObject<Properties<CogniteNotification>> = z
  .object({
    __typename: z.literal('CogniteNotification').optional(),
    aliases: z.array(z.string().nullable()).nullish().describe('Alternative names for the node'),
    asset: z
      .lazy(() => CogniteAssetSchema.nullish())
      .describe('The asset (functional location) the notification is related to.\n@name Asset'),
    description: z.string().nullish().describe('Description of the instance'),
    endTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('The actual end time of an activity (or similar that extends this)'),
    maintenanceOrder: z
      .lazy(() => CogniteMaintenanceOrderSchema.nullish())
      .describe('The maintenance order that was created from the notification.\n@name Maintenance order'),
    name: z.string().nullish().describe('Name of the instance'),
    priority: z
      .int64()
      .nullish()
      .describe(
        "A number that shows how important the notification is. Lower numbers mean it's more important, and 0 means it's the most important.\n@name Priority",
      ),
    priorityDescription: z
      .string()
      .nullish()
      .describe('Describes the priority of the notification.\n@name Priority description'),
    scheduledEndTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('The planned end time of an activity (or similar that extends this)'),
    scheduledStartTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('The planned start time of an activity (or similar that extends this)'),
    source: z.lazy(() => CogniteSourceSystemSchema.nullish()).describe('Direct relation to a source system'),
    sourceContext: z
      .string()
      .nullish()
      .describe(
        'Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set.',
      ),
    sourceCreatedTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('When the instance was created in source system (if available)'),
    sourceCreatedUser: z
      .string()
      .nullish()
      .describe(
        'User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF',
      ),
    sourceId: z.string().nullish().describe('Identifier from the source system'),
    sourceUpdatedTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('When the instance was last updated in the source system (if available)'),
    sourceUpdatedUser: z
      .string()
      .nullish()
      .describe(
        'User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF',
      ),
    startTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('The actual start time of an activity (or similar that extends this)'),
    status: z
      .string()
      .nullish()
      .describe("The current lifecycle status of the notification, for example, 'order created'.\n@name Status"),
    tags: z.array(z.string().nullable()).nullish().describe('Text based labels for generic use, limited to 1000'),
    type: z
      .string()
      .nullish()
      .describe("The code for the notification type, for example, 'M1' for  'Maintenance request'.\n@name Type"),
  })
  .describe(
    'A formal record to report maintenance issues, defects, or requests, starting the process for planning and running maintenance activities.\n@name Notification',
  );

export const CogniteFileSchema: z.ZodObject<Properties<CogniteFile>> = z
  .object({
    __typename: z.literal('CogniteFile').optional(),
    aliases: z.array(z.string().nullable()).nullish().describe('Alternative names for the node'),
    assets: z
      .array(z.lazy(() => CogniteAssetSchema.nullable()))
      .nullish()
      .describe('A list of assets this file is related to.\n@name Assets'),
    category: z
      .lazy(() => CogniteFileCategorySchema.nullish())
      .describe(
        "Specifies the detected category the file belongs to. It's a direct relation to an instance of CogniteFileCategory.\n@name Category",
      ),
    description: z.string().nullish().describe('Description of the instance'),
    directory: z
      .string()
      .nullish()
      .describe(
        'Contains the path elements from the source (if the source system has a file system hierarchy or similar.)\n@name Directory',
      ),
    equipment: z
      .array(z.lazy(() => CogniteEquipmentSchema.nullable()))
      .nullish()
      .describe('An automatically updated list of equipment this file is related to.\n@name Equipment'),
    isUploaded: z
      .boolean()
      .default(false)
      .nullish()
      .describe('Specifies if the file content has been uploaded to Cognite Data Fusion or not.\n@name Is uploaded'),
    mimeType: z.string().nullish().describe('The MIME type of the file.\n@name MIME type'),
    name: z.string().nullish().describe('Name of the instance'),
    source: z.lazy(() => CogniteSourceSystemSchema.nullish()).describe('Direct relation to a source system'),
    sourceContext: z
      .string()
      .nullish()
      .describe(
        'Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set.',
      ),
    sourceCreatedTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('When the instance was created in source system (if available)'),
    sourceCreatedUser: z
      .string()
      .nullish()
      .describe(
        'User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF',
      ),
    sourceId: z.string().nullish().describe('Identifier from the source system'),
    sourceUpdatedTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('When the instance was last updated in the source system (if available)'),
    sourceUpdatedUser: z
      .string()
      .nullish()
      .describe(
        'User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF',
      ),
    tags: z.array(z.string().nullable()).nullish().describe('Text based labels for generic use, limited to 1000'),
    uploadedTime: z.coerce.date<Date>().nullish().describe('The time the file upload completed.\n@name Uploaded time'),
  })
  .describe('Represents files.\n@name File');

export const CognitePointCloudModelSchema: z.ZodObject<Properties<CognitePointCloudModel>> = z
  .object({
    __typename: z.literal('CognitePointCloudModel').optional(),
    aliases: z.array(z.string().nullable()).nullish().describe('Alternative names for the node'),
    description: z.string().nullish().describe('Description of the instance'),
    name: z.string().nullish().describe('Name of the instance'),
    revisions: z
      .array(z.lazy(() => CognitePointCloudRevisionSchema.nullable()))
      .nullish()
      .describe('List of revisions for this PointCloud model'),
    tags: z.array(z.string().nullable()).nullish().describe('Text based labels for generic use, limited to 1000'),
    thumbnail: z.lazy(() => CogniteFileSchema.nullish()).describe('Thumbnail of the 3D model'),
    type: Cognite3DModelTypeSchema.nullish().describe('CAD, PointCloud or Image360'),
  })
  .describe('Navigational aid for traversing CognitePointCloudModel instances');

export const CognitePointCloudRevisionSchema: z.ZodObject<Properties<CognitePointCloudRevision>> = z
  .object({
    __typename: z.literal('CognitePointCloudRevision').optional(),
    model3D: z.lazy(() => CognitePointCloudModelSchema.nullish()).describe('.'),
    published: z.boolean().nullish(),
    revisionId: z.int64().nullish().describe('The 3D API revision identifier for this PointCloud model'),
    status: Cognite3DRevisionStatusSchema.nullish(),
    type: Cognite3DRevisionTypeSchema.nullish(),
  })
  .describe('Navigational aid for traversing CognitePointCloudRevision instances');

export const CogniteCubeMapSchema: z.ZodObject<Properties<CogniteCubeMap>> = z
  .object({
    back: z
      .lazy(() => CogniteFileSchema.nullish())
      .describe('Direct relation to a file holding the back projection of the cube map'),
    bottom: z
      .lazy(() => CogniteFileSchema.nullish())
      .describe('Direct relation to a file holding the bottom projection of the cube map'),
    front: z
      .lazy(() => CogniteFileSchema.nullish())
      .describe('Direct relation to a file holding the front projection of the cube map'),
    left: z
      .lazy(() => CogniteFileSchema.nullish())
      .describe('Direct relation to a file holding the left projection of the cube map'),
    right: z
      .lazy(() => CogniteFileSchema.nullish())
      .describe('Direct relation to a file holding the right projection of the cube map'),
    top: z
      .lazy(() => CogniteFileSchema.nullish())
      .describe('Direct relation to a file holding the top projection of the cube map'),
  })
  .describe('The cube map holds references to 6 images in used to visually represent the surrounding environment');

export const CogniteCadModelSchema: z.ZodObject<Properties<CogniteCadModel>> = z
  .object({
    __typename: z.literal('CogniteCADModel').optional(),
    aliases: z.array(z.string().nullable()).nullish().describe('Alternative names for the node'),
    description: z.string().nullish().describe('Description of the instance'),
    name: z.string().nullish().describe('Name of the instance'),
    revisions: z
      .array(z.lazy(() => CogniteCadRevisionSchema.nullable()))
      .nullish()
      .describe('List of revisions for this CAD model'),
    tags: z.array(z.string().nullable()).nullish().describe('Text based labels for generic use, limited to 1000'),
    thumbnail: z.lazy(() => CogniteFileSchema.nullish()).describe('Thumbnail of the 3D model'),
    type: Cognite3DModelTypeSchema.nullish().describe('CAD, PointCloud or Image360'),
  })
  .describe('Navigational aid for traversing CogniteCADModel instances');

export const CogniteCadRevisionSchema: z.ZodObject<Properties<CogniteCadRevision>> = z.object({
  __typename: z.literal('CogniteCADRevision').optional(),
  model3D: z.lazy(() => CogniteCadModelSchema.nullish()).describe('.'),
  published: z.boolean().nullish(),
  revisionId: z.int64().nullish().describe('The 3D API revision identifier for this CAD model'),
  status: Cognite3DRevisionStatusSchema.nullish(),
  type: Cognite3DRevisionTypeSchema.nullish(),
});

export const CognitePointCloudVolumeSchema: z.ZodObject<Properties<CognitePointCloudVolume>> = z
  .object({
    __typename: z.literal('CognitePointCloudVolume').optional(),
    aliases: z.array(z.string().nullable()).nullish().describe('Alternative names for the node'),
    description: z.string().nullish().describe('Description of the instance'),
    formatVersion: z
      .string()
      .nullish()
      .describe(
        'Specifies the version the ‘volume’ field is following. Volume definition is today 9 floats (property volume)',
      ),
    model3D: z.lazy(() => CogniteCadModelSchema.nullish()).describe('Direct relation to Cognite3DModel instance'),
    name: z.string().nullish().describe('Name of the instance'),
    object3D: z
      .lazy(() => Cognite3DObjectSchema.nullish())
      .describe('Direct relation to object3D grouping for this node'),
    revisions: z
      .array(z.lazy(() => CogniteCadRevisionSchema.nullable()))
      .nullish()
      .describe('List of direct relations to revision information'),
    tags: z.array(z.string().nullable()).nullish().describe('Text based labels for generic use, limited to 1000'),
    volume: z
      .array(z.number().nullable())
      .nullish()
      .describe('Relevant coordinates for the volume type, 9 floats in total, that defines the volume'),
    volumeReferences: z
      .array(z.string().nullable())
      .nullish()
      .describe('Unique volume metric hashes used to access the 3D specialized data storage'),
    volumeType: CognitePointCloudVolumeVolumeTypeSchema.nullish().describe('Type of volume (Cylinder or Box)'),
  })
  .describe('PointCloud volume definition');

export const CogniteCadNodeSchema: z.ZodObject<Properties<CogniteCadNode>> = z
  .object({
    __typename: z.literal('CogniteCADNode').optional(),
    aliases: z.array(z.string().nullable()).nullish().describe('Alternative names for the node'),
    cadNodeReference: z.string().nullish().describe('Reference to a node within a CAD model from the 3D API'),
    description: z.string().nullish().describe('Description of the instance'),
    model3D: z.lazy(() => CogniteCadModelSchema.nullish()).describe('Direct relation to Cognite3DModel'),
    name: z.string().nullish().describe('Name of the instance'),
    object3D: z
      .lazy(() => Cognite3DObjectSchema.nullish())
      .describe('Direct relation to object3D grouping for this node'),
    revisions: z
      .array(z.lazy(() => CogniteCadRevisionSchema.nullable()))
      .nullish()
      .describe('List of direct relations to instances of Cognite3DRevision which this CogniteCADNode exists in.'),
    subTreeSizes: z
      .array(z.int64().nullable())
      .nullish()
      .describe(
        'List of subtree sizes in the same order as revisions. Used by Reveal and similar applications to know how many nodes exists below this node in the hierarchy',
      ),
    tags: z.array(z.string().nullable()).nullish().describe('Text based labels for generic use, limited to 1000'),
    treeIndexes: z
      .array(z.int64().nullable())
      .nullish()
      .describe(
        'List of tree indexes in the same order as revisions. Used by Reveal and similar applications to map from CogniteCADNode to tree index',
      ),
  })
  .describe('Represents nodes from the 3D model that have been contextualized');

export const Cognite360ImageModelSchema: z.ZodObject<Properties<Cognite360ImageModel>> = z
  .object({
    __typename: z.literal('Cognite360ImageModel').optional(),
    aliases: z.array(z.string().nullable()).nullish().describe('Alternative names for the node'),
    collections: z
      .array(z.lazy(() => Cognite360ImageCollectionSchema.nullable()))
      .nullish()
      .describe('List Cognite360Image collections for this instance'),
    description: z.string().nullish().describe('Description of the instance'),
    name: z.string().nullish().describe('Name of the instance'),
    tags: z.array(z.string().nullable()).nullish().describe('Text based labels for generic use, limited to 1000'),
    thumbnail: z.lazy(() => CogniteFileSchema.nullish()).describe('Thumbnail of the 3D model'),
    type: Cognite3DModelTypeSchema.nullish().describe('CAD, PointCloud or Image360'),
  })
  .describe('Navigational aid for traversing Cognite360ImageModel instances');

export const Cognite360ImageCollectionSchema: z.ZodObject<Properties<Cognite360ImageCollection>> = z
  .object({
    __typename: z.literal('Cognite360ImageCollection').optional(),
    aliases: z.array(z.string().nullable()).nullish().describe('Alternative names for the node'),
    description: z.string().nullish().describe('Description of the instance'),
    model3D: z.lazy(() => Cognite360ImageModelSchema.nullish()),
    name: z.string().nullish().describe('Name of the instance'),
    published: z.boolean().nullish(),
    status: Cognite3DRevisionStatusSchema.nullish(),
    tags: z.array(z.string().nullable()).nullish().describe('Text based labels for generic use, limited to 1000'),
    type: Cognite3DRevisionTypeSchema.nullish(),
  })
  .describe('Represents a logical collection of Cognite360Image instances');

export const Cognite3DModelSchema: z.ZodObject<Properties<Cognite3DModel>> = z
  .object({
    aliases: z.array(z.string().nullable()).nullish().describe('Alternative names for the node'),
    description: z.string().nullish().describe('Description of the instance'),
    name: z.string().nullish().describe('Name of the instance'),
    tags: z.array(z.string().nullable()).nullish().describe('Text based labels for generic use, limited to 1000'),
    thumbnail: z.lazy(() => CogniteFileSchema.nullish()).describe('Thumbnail of the 3D model'),
    type: Cognite3DModelTypeSchema.nullish().describe('CAD, PointCloud or Image360'),
  })
  .describe('Groups revisions of 3D data of various kinds together (CAD, PointCloud, Image360)');

export const Cognite3DRevisionSchema: z.ZodObject<Properties<Cognite3DRevision>> = z
  .object({
    model3D: z.lazy(() => Cognite3DModelSchema.nullish()),
    published: z.boolean().nullish(),
    status: Cognite3DRevisionStatusSchema.nullish(),
    type: Cognite3DRevisionTypeSchema.nullish(),
  })
  .describe(
    'Shared revision information for various 3D data types. Normally not used directly, but through CognitePointCloudRevision, Image360Collection or CogniteCADRevision',
  );

export const ChokeSchema: z.ZodObject<Properties<Choke>> = z
  .object({
    __typename: z.literal('Choke').optional(),
    endDateTime: z.coerce.date<Date>().nullish().describe("Timestamp 'endDateTime' associated with this 'Choke' row."),
    entityType: z.string().nullish().describe("Text attribute 'entityType' for this 'Choke' row."),
    name: z.string().nullish().describe("Text attribute 'name' for this 'Choke' row."),
    startDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'startDateTime' associated with this 'Choke' row."),
  })
  .describe("View 'Choke' in the iPSO production optimization solution data model.");

export const AssetSchema: z.ZodObject<Properties<Asset>> = z
  .object({
    __typename: z.literal('Asset').optional(),
    endDateTime: z.coerce.date<Date>().nullish().describe("Timestamp 'endDateTime' associated with this 'Asset' row."),
    entityType: z.string().nullish().describe("Text attribute 'entityType' for this 'Asset' row."),
    name: z
      .string()
      .nullish()
      .describe(
        "Name of the asset. To retrieve all wells in an asset, find the asset here and filter 'FlatHierarchy' on this asset while reading the 'well' (and optionally 'string') property.",
      ),
    startDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'startDateTime' associated with this 'Asset' row."),
  })
  .describe(
    "Typed view over 'Entity' showing assets only (where 'entityType' = 'asset'). Use this view to identify an asset by name, then navigate to its fields, reservoirs, wells or strings via the 'FlatHierarchy' navigation view.",
  );

export const WellInputsStaticSchema: z.ZodObject<Properties<WellInputsStatic>> = z
  .object({
    __typename: z.literal('WellInputs_Static').optional(),
    crs: z.float32().nullish().describe("Numeric value 'crs' (floating point) for this 'WellInputs_Static' row."),
    elevation: z
      .float32()
      .nullish()
      .describe("Numeric value 'elevation' (floating point) for this 'WellInputs_Static' row."),
    elevationRef: z.string().nullish().describe("Text attribute 'elevationRef' for this 'WellInputs_Static' row."),
    entityName: z
      .lazy(() => WellSchema.nullish())
      .describe("Reference to the related 'Well' entity for this 'WellInputs_Static' row."),
    latitude: z
      .float32()
      .nullish()
      .describe("Numeric value 'latitude' (floating point) for this 'WellInputs_Static' row."),
    longitude: z
      .float32()
      .nullish()
      .describe("Numeric value 'longitude' (floating point) for this 'WellInputs_Static' row."),
    originalCRS: z
      .float32()
      .nullish()
      .describe("Numeric value 'originalCRS' (floating point) for this 'WellInputs_Static' row."),
    originalX: z
      .float32()
      .nullish()
      .describe("Numeric value 'originalX' (floating point) for this 'WellInputs_Static' row."),
    originalY: z
      .float32()
      .nullish()
      .describe("Numeric value 'originalY' (floating point) for this 'WellInputs_Static' row."),
    spudDate: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'spudDate' associated with this 'WellInputs_Static' row."),
  })
  .describe("View 'WellInputs_Static' in the iPSO production optimization solution data model.");

export const VrrSectorHierarchySchema: z.ZodObject<Properties<VrrSectorHierarchy>> = z
  .object({
    __typename: z.literal('VRR_SectorHierarchy').optional(),
    allocationFactor: z
      .float32()
      .nullish()
      .describe(
        'Numeric factor (0-1) used to allocate production volumes from this string to the sector. Used in flow allocation calculations when a string produces from multiple sectors.',
      ),
    endDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe(
        'When this sector assignment ended. NULL = currently active. For current assignments only, filter where endDateTime is null.',
      ),
    reservoir: z
      .string()
      .nullish()
      .describe(
        'Subsurface reservoir formation containing the sector. Filter here to find all sectors, wells, or strings within a specific reservoir.',
      ),
    sector: z
      .string()
      .nullish()
      .describe(
        'Subdivision of a reservoir used for flow allocation and production management. Multiple wells/strings can belong to the same sector. Filter here to analyze sector-level production.',
      ),
    startDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe(
        'When this sector assignment became effective. Used for temporal queries when sector assignments change over time.',
      ),
    string: z
      .string()
      .nullish()
      .describe(
        'Completion/producing interval within the well. Each row represents exactly one string. Use string.name for string identifier.',
      ),
    well: z
      .string()
      .nullish()
      .describe(
        'Physical wellbore containing this string. A well may have multiple strings (completions). Use well.name for well identifier.',
      ),
  })
  .describe(
    "DENORMALIZED SECTOR LOOKUP TABLE - For sector-based flow allocation and reservoir analysis.\n\nSTRUCTURE: Each row = one String with its sector/reservoir assignment and allocation factor.\nHierarchy: Reservoir â†’ Sector â†’ Well â†’ String\n\nWHY USE THIS: Navigate sector relationships and retrieve allocation factors for flow calculations.\n\nQUERY PATTERNS:\n- Find strings in a sector: Filter sector.name = 'X', select string\n- Find wells in a reservoir: Filter reservoir.name = 'Y', select DISTINCT well\n- Get allocation factors: Filter by sector or reservoir, select allocationFactor\n\nKEY BEHAVIORS:\n- One row per string means parent entities repeat (use DISTINCT for unique parents)\n- References return full entity objects - access .name, .externalId, etc.\n- Use startDateTime/endDateTime for historical sector assignments",
  );

export const VrrFormationVolumeFactorSchema: z.ZodObject<Properties<VrrFormationVolumeFactor>> = z
  .object({
    __typename: z.literal('VRR_Formation_Volume_Factor').optional(),
    bCO2: z
      .float32()
      .nullish()
      .describe("Numeric value 'bCO2' (floating point) for this 'VRR_Formation_Volume_Factor' row."),
    bGas: z
      .float32()
      .nullish()
      .describe("Numeric value 'bGas' (floating point) for this 'VRR_Formation_Volume_Factor' row."),
    bGasInjector: z
      .float32()
      .nullish()
      .describe("Numeric value 'bGasInjector' (floating point) for this 'VRR_Formation_Volume_Factor' row."),
    bOil: z
      .float32()
      .nullish()
      .describe("Numeric value 'bOil' (floating point) for this 'VRR_Formation_Volume_Factor' row."),
    bWater: z
      .float32()
      .nullish()
      .describe("Numeric value 'bWater' (floating point) for this 'VRR_Formation_Volume_Factor' row."),
    bWaterInjector: z
      .float32()
      .nullish()
      .describe("Numeric value 'bWaterInjector' (floating point) for this 'VRR_Formation_Volume_Factor' row."),
    effectiveDate: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'effectiveDate' associated with this 'VRR_Formation_Volume_Factor' row."),
    entityName: z
      .lazy(() => EntitySchema.nullish())
      .describe("Reference to the related 'Entity' entity for this 'VRR_Formation_Volume_Factor' row."),
    pb: z
      .float32()
      .nullish()
      .describe("Numeric value 'pb' (floating point) for this 'VRR_Formation_Volume_Factor' row."),
    rs: z
      .float32()
      .nullish()
      .describe("Numeric value 'rs' (floating point) for this 'VRR_Formation_Volume_Factor' row."),
  })
  .describe("View 'VRR_Formation_Volume_Factor' in the iPSO production optimization solution data model.");

export const SPressSettingsSchema: z.ZodObject<Properties<SPressSettings>> = z
  .object({
    __typename: z.literal('SPressSettings').optional(),
    dateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'dateTime' associated with this 'SPressSettings' row."),
    entityName: z
      .lazy(() => EntitySchema.nullish())
      .describe("Reference to the related 'Entity' entity for this 'SPressSettings' row."),
    maxReservoirPressure: z
      .float32()
      .nullish()
      .describe("Numeric value 'maxReservoirPressure' (floating point) for this 'SPressSettings' row."),
    minNumberShutInPressures: z
      .number()
      .nullish()
      .describe("Numeric value 'minNumberShutInPressures' (integer) for this 'SPressSettings' row."),
    minReservoirPressure: z
      .float32()
      .nullish()
      .describe("Numeric value 'minReservoirPressure' (floating point) for this 'SPressSettings' row."),
  })
  .describe("View 'SPressSettings' in the iPSO production optimization solution data model.");

export const PseudoPressureTableSchema: z.ZodObject<Properties<PseudoPressureTable>> = z
  .object({
    __typename: z.literal('PseudoPressureTable').optional(),
    pressure: z
      .float32()
      .nullish()
      .describe("Numeric value 'pressure' (floating point) for this 'PseudoPressureTable' row."),
    pseudoPressure: z
      .float32()
      .nullish()
      .describe("Numeric value 'pseudoPressure' (floating point) for this 'PseudoPressureTable' row."),
  })
  .describe("View 'PseudoPressureTable' in the iPSO production optimization solution data model.");

export const MapGridMappingSchema: z.ZodObject<Properties<MapGridMapping>> = z
  .object({
    __typename: z.literal('MapGrid_Mapping').optional(),
    createdBy: z.string().nullish().describe("Text attribute 'createdBy' for this 'MapGrid_Mapping' row."),
    date: z.coerce.date<Date>().nullish().describe("Timestamp 'date' associated with this 'MapGrid_Mapping' row."),
    fieldName: z.string().nullish().describe("Text attribute 'fieldName' for this 'MapGrid_Mapping' row."),
    flowUnitName: z.string().nullish().describe("Text attribute 'flowUnitName' for this 'MapGrid_Mapping' row."),
    isOfficial: z.string().nullish().describe("Text attribute 'isOfficial' for this 'MapGrid_Mapping' row."),
    lat: z.float32().nullish().describe("Numeric value 'lat' (floating point) for this 'MapGrid_Mapping' row."),
    long: z.float32().nullish().describe("Numeric value 'long' (floating point) for this 'MapGrid_Mapping' row."),
    p10: z.float32().nullish().describe("Numeric value 'p10' (floating point) for this 'MapGrid_Mapping' row."),
    p50: z.float32().nullish().describe("Numeric value 'p50' (floating point) for this 'MapGrid_Mapping' row."),
    p90: z.float32().nullish().describe("Numeric value 'p90' (floating point) for this 'MapGrid_Mapping' row."),
    reservoirName: z.string().nullish().describe("Text attribute 'reservoirName' for this 'MapGrid_Mapping' row."),
    reservoirPressureMapGrid: z
      .float32()
      .nullish()
      .describe("Numeric value 'reservoirPressureMapGrid' (floating point) for this 'MapGrid_Mapping' row."),
    reservoirPressureRMSError: z
      .float32()
      .nullish()
      .describe("Numeric value 'reservoirPressureRMSError' (floating point) for this 'MapGrid_Mapping' row."),
    runDate: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'runDate' associated with this 'MapGrid_Mapping' row."),
    x: z.float32().nullish().describe("Numeric value 'x' (floating point) for this 'MapGrid_Mapping' row."),
    y: z.float32().nullish().describe("Numeric value 'y' (floating point) for this 'MapGrid_Mapping' row."),
  })
  .describe("View 'MapGrid_Mapping' in the iPSO production optimization solution data model.");

export const DataMappingSchema: z.ZodObject<Properties<DataMapping>> = z
  .object({
    __typename: z.literal('Data_Mapping').optional(),
    date: z.coerce.date<Date>().nullish().describe("Timestamp 'date' associated with this 'Data_Mapping' row."),
    fieldName: z.string().nullish().describe("Text attribute 'fieldName' for this 'Data_Mapping' row."),
    isOfficial: z.string().nullish().describe("Text attribute 'isOfficial' for this 'Data_Mapping' row."),
    lat: z.float32().nullish().describe("Numeric value 'lat' (floating point) for this 'Data_Mapping' row."),
    long: z.float32().nullish().describe("Numeric value 'long' (floating point) for this 'Data_Mapping' row."),
    reservoirName: z.string().nullish().describe("Text attribute 'reservoirName' for this 'Data_Mapping' row."),
    reservoirPressureRMSError: z
      .float32()
      .nullish()
      .describe("Numeric value 'reservoirPressureRMSError' (floating point) for this 'Data_Mapping' row."),
    reservoirPressureString: z
      .float32()
      .nullish()
      .describe("Numeric value 'reservoirPressureString' (floating point) for this 'Data_Mapping' row."),
    runDate: z.coerce.date<Date>().nullish().describe("Timestamp 'runDate' associated with this 'Data_Mapping' row."),
    stringName: z.string().nullish().describe("Text attribute 'stringName' for this 'Data_Mapping' row."),
    x: z.float32().nullish().describe("Numeric value 'x' (floating point) for this 'Data_Mapping' row."),
    y: z.float32().nullish().describe("Numeric value 'y' (floating point) for this 'Data_Mapping' row."),
  })
  .describe("View 'Data_Mapping' in the iPSO production optimization solution data model.");

export const ChokeCurveInfoSchema: z.ZodObject<Properties<ChokeCurveInfo>> = z
  .object({
    __typename: z.literal('Choke_Curve_Info').optional(),
    chokeBeanSize: z
      .float32()
      .nullish()
      .describe("Numeric value 'chokeBeanSize' (floating point) for this 'Choke_Curve_Info' row."),
    chokeOpening: z
      .float32()
      .nullish()
      .describe("Numeric value 'chokeOpening' (floating point) for this 'Choke_Curve_Info' row."),
    chokeType: z.string().nullish().describe("Text attribute 'chokeType' for this 'Choke_Curve_Info' row."),
  })
  .describe("View 'Choke_Curve_Info' in the iPSO production optimization solution data model.");

export const AsphalteneCurveSchema: z.ZodObject<Properties<AsphalteneCurve>> = z
  .object({
    __typename: z.literal('Asphaltene_Curve').optional(),
    asphP: z.float32().nullish().describe("Numeric value 'asphP' (floating point) for this 'Asphaltene_Curve' row."),
    asphT: z.float32().nullish().describe("Numeric value 'asphT' (floating point) for this 'Asphaltene_Curve' row."),
    asphTable: z.string().nullish().describe("Text attribute 'asphTable' for this 'Asphaltene_Curve' row."),
    date: z.coerce.date<Date>().nullish().describe("Timestamp 'date' associated with this 'Asphaltene_Curve' row."),
    sequence: z.number().nullish().describe("Numeric value 'sequence' (integer) for this 'Asphaltene_Curve' row."),
  })
  .describe("View 'Asphaltene_Curve' in the iPSO production optimization solution data model.");

export const FieldSchema: z.ZodObject<Properties<Field>> = z
  .object({
    __typename: z.literal('Field').optional(),
    endDateTime: z.coerce.date<Date>().nullish().describe("Timestamp 'endDateTime' associated with this 'Field' row."),
    entityType: z.string().nullish().describe("Text attribute 'entityType' for this 'Field' row."),
    name: z
      .string()
      .nullish()
      .describe(
        "Name of the field. To retrieve all wells in a field, find the field here and filter 'FlatHierarchy' on this field while reading the 'well' property.",
      ),
    startDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'startDateTime' associated with this 'Field' row."),
  })
  .describe(
    "Typed view over 'Entity' showing fields only (where 'entityType' = 'field'). Use this view to identify a field by name, then navigate to its wells or strings through the 'FlatHierarchy' and 'SectorHierarchy' navigation views.",
  );

export const WfFieldAlarmsSchema: z.ZodObject<Properties<WfFieldAlarms>> = z
  .object({
    __typename: z.literal('WfFieldAlarms').optional(),
    alarmCounter: z.number().nullish().describe("Numeric value 'alarmCounter' (integer) for this 'WfFieldAlarms' row."),
    alarmFlags: z.string().nullish().describe("Text attribute 'alarmFlags' for this 'WfFieldAlarms' row."),
    alarmLevel: z.string().nullish().describe("Text attribute 'alarmLevel' for this 'WfFieldAlarms' row."),
    alarmMessage: z.string().nullish().describe("Text attribute 'alarmMessage' for this 'WfFieldAlarms' row."),
    alarmName: z.string().nullish().describe("Text attribute 'alarmName' for this 'WfFieldAlarms' row."),
    alarmType: z.string().nullish().describe("Text attribute 'alarmType' for this 'WfFieldAlarms' row."),
    configuration: z.string().nullish().describe("Text attribute 'configuration' for this 'WfFieldAlarms' row."),
    endDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'endDateTime' associated with this 'WfFieldAlarms' row."),
    entityName: z
      .lazy(() => FieldSchema.nullish())
      .describe("Reference to the related 'Field' entity for this 'WfFieldAlarms' row."),
    operationType: z.string().nullish().describe("Text attribute 'operationType' for this 'WfFieldAlarms' row."),
    startDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'startDateTime' associated with this 'WfFieldAlarms' row."),
    ticketId: z.string().nullish().describe("Text attribute 'ticketId' for this 'WfFieldAlarms' row."),
    workflowName: z.string().nullish().describe("Text attribute 'workflowName' for this 'WfFieldAlarms' row."),
  })
  .describe("View 'WfFieldAlarms' in the iPSO production optimization solution data model.");

export const SectorProdplanSchema: z.ZodObject<Properties<SectorProdplan>> = z
  .object({
    __typename: z.literal('Sector_Prodplan').optional(),
    effectiveDate: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'effectiveDate' associated with this 'Sector_Prodplan' row."),
    field: z
      .lazy(() => FieldSchema.nullish())
      .describe("Reference to the related 'Field' entity for this 'Sector_Prodplan' row."),
    reservoir: z
      .lazy(() => ReservoirSchema.nullish())
      .describe("Reference to the related 'Reservoir' entity for this 'Sector_Prodplan' row."),
    sector: z
      .lazy(() => SectorSchema.nullish())
      .describe("Reference to the related 'Sector' entity for this 'Sector_Prodplan' row."),
    submittedMonth: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'submittedMonth' associated with this 'Sector_Prodplan' row."),
    vrrTarget: z
      .float32()
      .nullish()
      .describe("Numeric value 'vrrTarget' (floating point) for this 'Sector_Prodplan' row."),
  })
  .describe("View 'Sector_Prodplan' in the iPSO production optimization solution data model.");

export const SrmScenarioInfoSchema: z.ZodObject<Properties<SrmScenarioInfo>> = z
  .object({
    __typename: z.literal('SRM_Scenario_Info').optional(),
    constraintsFileId: z.int64().nullish(),
    constraintsFileIdGI: z.int64().nullish(),
    constraintsFileIdWI: z.int64().nullish(),
    entityName: z
      .lazy(() => FieldSchema.nullish())
      .describe("Reference to the related 'Field' entity for this 'SRM_Scenario_Info' row."),
    entityType: z.string().nullish(),
    executedBy: z.string().nullish(),
    executionDate: z.coerce.date<Date>().nullish(),
    isOfficial: z.boolean().nullish(),
    runStatusGasInjNetwork: z.string().nullish(),
    runStatusProdNetwork: z.string().nullish(),
    runStatusPublish: z.string().nullish(),
    runStatusSRM: z.string().nullish(),
    runStatusWatInjNetwork: z.string().nullish(),
    scenarioDescription: z.string().nullish(),
    scenarioID: z.string().nullish(),
    scenarioName: z.string().nullish(),
    scenarioType: z.string().nullish(),
  })
  .describe("View 'SRM_Scenario_Info' in the iPSO production optimization solution data model.");

export const ReservoirProdplanSchema: z.ZodObject<Properties<ReservoirProdplan>> = z
  .object({
    __typename: z.literal('Reservoir_Prodplan').optional(),
    effectiveDate: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'effectiveDate' associated with this 'Reservoir_Prodplan' row."),
    field: z
      .lazy(() => FieldSchema.nullish())
      .describe("Reference to the related 'Field' entity for this 'Reservoir_Prodplan' row."),
    prodTarget: z
      .float32()
      .nullish()
      .describe("Numeric value 'prodTarget' (floating point) for this 'Reservoir_Prodplan' row."),
    reservoir: z
      .lazy(() => ReservoirSchema.nullish())
      .describe("Reference to the related 'Reservoir' entity for this 'Reservoir_Prodplan' row."),
    submittedMonth: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'submittedMonth' associated with this 'Reservoir_Prodplan' row."),
    vrrTarget: z
      .float32()
      .nullish()
      .describe("Numeric value 'vrrTarget' (floating point) for this 'Reservoir_Prodplan' row."),
  })
  .describe("View 'Reservoir_Prodplan' in the iPSO production optimization solution data model.");

export const ReservoirGuidelineSchema: z.ZodObject<Properties<ReservoirGuideline>> = z
  .object({
    __typename: z.literal('Reservoir_Guideline').optional(),
    effectiveDate: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'effectiveDate' associated with this 'Reservoir_Guideline' row."),
    expectedReservoirPressure: z
      .float32()
      .nullish()
      .describe("Numeric value 'expectedReservoirPressure' (floating point) for this 'Reservoir_Guideline' row."),
    field: z
      .lazy(() => FieldSchema.nullish())
      .describe("Reference to the related 'Field' entity for this 'Reservoir_Guideline' row."),
    reservoir: z
      .lazy(() => ReservoirSchema.nullish())
      .describe("Reference to the related 'Reservoir' entity for this 'Reservoir_Guideline' row."),
    reservoirAllowableRate: z
      .float32()
      .nullish()
      .describe("Numeric value 'reservoirAllowableRate' (floating point) for this 'Reservoir_Guideline' row."),
    sector: z
      .lazy(() => SectorSchema.nullish())
      .describe("Reference to the related 'Sector' entity for this 'Reservoir_Guideline' row."),
    technicalGasRate: z
      .float32()
      .nullish()
      .describe("Numeric value 'technicalGasRate' (floating point) for this 'Reservoir_Guideline' row."),
    technicalOilRate: z
      .float32()
      .nullish()
      .describe("Numeric value 'technicalOilRate' (floating point) for this 'Reservoir_Guideline' row."),
    vrrRequirement: z
      .float32()
      .nullish()
      .describe("Numeric value 'vrrRequirement' (floating point) for this 'Reservoir_Guideline' row."),
    vrrTarget: z
      .float32()
      .nullish()
      .describe("Numeric value 'vrrTarget' (floating point) for this 'Reservoir_Guideline' row."),
  })
  .describe("View 'Reservoir_Guideline' in the iPSO production optimization solution data model.");

export const PtsReferenceConditionsSchema: z.ZodObject<Properties<PtsReferenceConditions>> = z
  .object({
    __typename: z.literal('PTS_Reference_Conditions').optional(),
    date: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'date' associated with this 'PTS_Reference_Conditions' row."),
    fieldCode: z.string().nullish().describe("Text attribute 'fieldCode' for this 'PTS_Reference_Conditions' row."),
    fieldName: z
      .lazy(() => FieldSchema.nullish())
      .describe("Reference to the related 'Field' entity for this 'PTS_Reference_Conditions' row."),
    refStgPress1: z
      .float32()
      .nullish()
      .describe("Numeric value 'refStgPress1' (floating point) for this 'PTS_Reference_Conditions' row."),
    refStgPress2: z
      .float32()
      .nullish()
      .describe("Numeric value 'refStgPress2' (floating point) for this 'PTS_Reference_Conditions' row."),
    refStgPress3: z
      .float32()
      .nullish()
      .describe("Numeric value 'refStgPress3' (floating point) for this 'PTS_Reference_Conditions' row."),
    refStgPress4: z
      .float32()
      .nullish()
      .describe("Numeric value 'refStgPress4' (floating point) for this 'PTS_Reference_Conditions' row."),
    refStgPress5: z
      .float32()
      .nullish()
      .describe("Numeric value 'refStgPress5' (floating point) for this 'PTS_Reference_Conditions' row."),
    refStgTemp1: z
      .float32()
      .nullish()
      .describe("Numeric value 'refStgTemp1' (floating point) for this 'PTS_Reference_Conditions' row."),
    refStgTemp2: z
      .float32()
      .nullish()
      .describe("Numeric value 'refStgTemp2' (floating point) for this 'PTS_Reference_Conditions' row."),
    refStgTemp3: z
      .float32()
      .nullish()
      .describe("Numeric value 'refStgTemp3' (floating point) for this 'PTS_Reference_Conditions' row."),
    refStgTemp4: z
      .float32()
      .nullish()
      .describe("Numeric value 'refStgTemp4' (floating point) for this 'PTS_Reference_Conditions' row."),
    refStgTemp5: z
      .float32()
      .nullish()
      .describe("Numeric value 'refStgTemp5' (floating point) for this 'PTS_Reference_Conditions' row."),
  })
  .describe("View 'PTS_Reference_Conditions' in the iPSO production optimization solution data model.");

export const NetworkSchema: z.ZodObject<Properties<Network>> = z
  .object({
    __typename: z.literal('Network').optional(),
    connectedFields: z
      .array(z.lazy(() => FieldSchema.nullable()))
      .nullish()
      .describe("Reference to the related 'Field' entity for this 'Network' row."),
    endDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'endDateTime' associated with this 'Network' row."),
    entityType: z.string().nullish().describe("Text attribute 'entityType' for this 'Network' row."),
    field: z
      .array(z.lazy(() => FieldSchema.nullable()))
      .nullish()
      .describe("Property 'field' for this 'Network' row."),
    fieldName: z
      .lazy(() => FieldSchema.nullish())
      .describe("Reference to the related 'Field' entity for this 'Network' row."),
    linkedField: z
      .array(z.json().nullable())
      .nullish()
      .describe("Direct relation property 'linkedField' for this 'Network' row."),
    name: z.string().nullish().describe("Text attribute 'name' for this 'Network' row."),
    networkType: z.string().nullish().describe("Text attribute 'networkType' for this 'Network' row."),
    primaryFluid: z.string().nullish().describe("Text attribute 'primaryFluid' for this 'Network' row."),
    startDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'startDateTime' associated with this 'Network' row."),
  })
  .describe("View 'Network' in the iPSO production optimization solution data model.");

export const NetworkModelAgentSchema: z.ZodObject<Properties<NetworkModelAgent>> = z
  .object({
    __typename: z.literal('NetworkModel_Agent').optional(),
    changeDetails: z.string().nullish().describe('Description of changes made in latest model update.'),
    connectedFields: z
      .array(z.lazy(() => FieldSchema.nullable()))
      .nullish()
      .describe('Fields connected to this network model.'),
    description: z.string().nullish().describe('Model description and engineering notes.'),
    garFileName: z.string().nullish().describe('GAP model file name (current version).'),
    modelConfig: z.json().nullish().describe('Model configuration parameters.'),
    modelEffectiveTime: z.coerce.date<Date>().nullish().describe('When this model version became effective.'),
    modelUpdatedBy: z.string().nullish().describe('User who last updated the model.'),
    modelUpdatedTime: z.coerce.date<Date>().nullish().describe('Timestamp of last model update.'),
    modelUploadedBy: z.string().nullish().describe('User who uploaded the model.'),
    modelUploadedTime: z.coerce.date<Date>().nullish().describe('Timestamp of model upload.'),
    network: z.lazy(() => NetworkSchema.nullish()).describe('Reference to parent network entity.'),
    networkType: z.string().nullish().describe('Type of network model.'),
    originalGarFileName: z.string().nullish().describe('Original GAP model file name before modifications.'),
    pressureMatchedWellModels: z.number().nullish().describe('Count of well models with successful pressure match.'),
    productivityIndexDifferencePercentage: z
      .json()
      .nullish()
      .describe('PI difference between model and well test (%).'),
    source: z.string().nullish().describe('Origin of the model.'),
    status: z.string().nullish().describe('Model status (e.g., Valid, Invalid, Draft).'),
    totalWellModels: z.number().nullish().describe('Total number of well models in this network.'),
    wf9Consumed: z.boolean().nullish().describe('Whether WF-9 model management has processed this model (0/1).'),
  })
  .describe(
    'GAP network model configuration, metadata, and calibration status (WF7/WF8).\n\nPer-network metadata: model version, last upload and calibration dates,\nconnected fields, and simulation/solver settings for each GAP network\ninstance. Use to check which GAP model is active, when it was last\ncalibrated, and which fields it covers. Excludes simulation outputs and\nproduction metrics (see NetworkOutputs_Field_Agent and NetworkOutputs_String_Agent).\n\nUse for: Network Surveillance (WF7).\n\n@name Network Model (Agent)',
  );

export const NetworkModelSchema: z.ZodObject<Properties<NetworkModel>> = z
  .object({
    __typename: z.literal('NetworkModel').optional(),
    asphalteneCurve: z.json().nullish().describe('asphaltene curve for the network'),
    azureBlobUrl: z.string().nullish(),
    changeDetails: z.string().nullish().describe("Text attribute 'changeDetails' for this 'NetworkModel' row."),
    connectedFields: z
      .array(z.lazy(() => FieldSchema.nullable()))
      .nullish()
      .describe("Reference to the related 'Field' entity for this 'NetworkModel' row."),
    description: z.string().nullish().describe("Text attribute 'description' for this 'NetworkModel' row."),
    estimatedGasRate: z.number().nullish(),
    estimatedLiquidRate: z.number().nullish(),
    estimatedOilRate: z.number().nullish(),
    gapFileName: z.string().nullish().describe('Name of the Petroleum Experts GAP file.'),
    garFileName: z.string().nullish().describe("Text attribute 'garFileName' for this 'NetworkModel' row."),
    hydrateCurve: z.json().nullish().describe('hydrate curve for the network'),
    inputModel: z.lazy(() => NetworkModelSchema.nullish()),
    legacyGapFileExternalId: z
      .string()
      .nullish()
      .describe("Text attribute 'legacyGapFileExternalId' for this 'NetworkModel' row."),
    legacyGapFileId: z
      .int64()
      .nullish()
      .describe("Numeric value 'legacyGapFileId' (integer) for this 'NetworkModel' row."),
    legacyGarFileExternalId: z
      .string()
      .nullish()
      .describe("Text attribute 'legacyGarFileExternalId' for this 'NetworkModel' row."),
    legacyGarFileId: z
      .int64()
      .nullish()
      .describe("Numeric value 'legacyGarFileId' (integer) for this 'NetworkModel' row."),
    legacyInputGapFileId: z
      .int64()
      .nullish()
      .describe("Numeric value 'legacyInputGapFileId' (integer) for this 'NetworkModel'"),
    legacyInputGarFileId: z
      .int64()
      .nullish()
      .describe("Numeric value 'legacyInputGarFileId' (integer) for this 'NetworkModel'"),
    measuredGasRate: z.number().nullish(),
    measuredLiquidRate: z.number().nullish(),
    measuredOilRate: z.number().nullish(),
    modelConfig: z.json().nullish().describe("Property 'modelConfig' for this 'NetworkModel' row."),
    modelConfigLegacyFileExternalId: z
      .string()
      .nullish()
      .describe("Text attribute 'modelConfigLegacyFileExternalId' for this 'NetworkModel' row."),
    modelEffectiveTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'modelEffectiveTime' associated with this 'NetworkModel' row."),
    modelSimIntConfig: z.json().nullish(),
    modelSimIntRevisionConfigLegacyFileExternalId: z
      .string()
      .nullish()
      .describe("Text attribute 'modelSimIntRevisionConfigLegacyFileExternalId' for this 'NetworkModel' row."),
    modelUpdatedBy: z.string().nullish().describe("Text attribute 'modelUpdatedBy' for this 'NetworkModel' row."),
    modelUpdatedTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'modelUpdatedTime' associated with this 'NetworkModel' row."),
    modelUploadedBy: z.string().nullish().describe("Text attribute 'modelUploadedBy' for this 'NetworkModel' row."),
    modelUploadedTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'modelUploadedTime' associated with this 'NetworkModel' row."),
    network: z
      .lazy(() => NetworkSchema.nullish())
      .describe("Reference to the related 'Network' entity for this 'NetworkModel' row."),
    networkSourceFileType: z.string().nullish().describe('Source file type. For example gap or gar'),
    networkType: z.string().nullish().describe("Text attribute 'networkType' for this 'NetworkModel' row."),
    openServerCommandsLegacyFileId: z.int64().nullish().describe('OpenServer commands used to modify the network'),
    originalGarFileName: z
      .string()
      .nullish()
      .describe("Text attribute 'originalGarFileName' for this 'NetworkModel' row."),
    pressureMatchedWellModels: z
      .number()
      .nullish()
      .describe("Numeric value 'pressureMatchedWellModels' (integer) for this 'NetworkModel' row."),
    productivityIndexDifferencePercentage: z
      .json()
      .nullish()
      .describe("Property 'productivityIndexDifferencePercentage' for this 'NetworkModel' row."),
    simIntExternalId: z.string().nullish().describe("Text attribute 'simIntExternalId' for this 'NetworkModel' row."),
    simIntModelExternalId: z
      .string()
      .nullish()
      .describe("Text attribute 'simIntModelExternalId' for this 'NetworkModel' row."),
    simIntModelRevisionCreatedTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'simIntModelRevisionCreatedTime' associated with this 'NetworkModel' row."),
    simIntModelRevisionDescription: z
      .string()
      .nullish()
      .describe("Text attribute 'simIntModelRevisionDescription' for this 'NetworkModel' row."),
    simIntModelRevisionExternalId: z
      .string()
      .nullish()
      .describe("Text attribute 'simIntModelRevisionExternalId' for this 'NetworkModel' row."),
    simIntModelRevisionId: z
      .string()
      .nullish()
      .describe("Text attribute 'simIntModelRevisionId' for this 'NetworkModel' row."),
    simIntModelRevisionLogId: z
      .string()
      .nullish()
      .describe("Text attribute 'simIntModelRevisionLogId' for this 'NetworkModel' row."),
    simIntModelRevisionStatus: z
      .string()
      .nullish()
      .describe("Text attribute 'simIntModelRevisionStatus' for this 'NetworkModel' row."),
    simIntModelRevisionStatusMessage: z
      .string()
      .nullish()
      .describe("Text attribute 'simIntModelRevisionStatusMessage' for this 'NetworkModel' row."),
    simIntModelRevisionUpdatedTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'simIntModelRevisionUpdatedTime' associated with this 'NetworkModel' row."),
    simIntModelRevisionVersionId: z
      .number()
      .nullish()
      .describe("Numeric value 'simIntModelRevisionVersionId' (integer) for this 'NetworkModel' row."),
    source: z.string().nullish().describe("Text attribute 'source' for this 'NetworkModel' row."),
    status: z.string().nullish().describe("Text attribute 'status' for this 'NetworkModel' row."),
    totalWellModels: z
      .number()
      .nullish()
      .describe("Numeric value 'totalWellModels' (integer) for this 'NetworkModel' row."),
    waxCurve: z.json().nullish().describe('wax curve for the network'),
    wf8Processed: z.boolean().nullish().describe("Boolean flag 'wf8Processed' for this 'NetworkModel' row."),
    wf9Consumed: z
      .boolean()
      .nullish()
      .describe('True means this network model was consumed by network model management workflow.'),
    wf9GarFileId: z.int64().nullish(),
    wf9Processed: z.boolean().nullish().describe("Boolean flag 'wf9Processed' for this 'NetworkModel' row."),
  })
  .describe("View 'NetworkModel' in the iPSO production optimization solution data model.");

export const FieldFormationSchema: z.ZodObject<Properties<FieldFormation>> = z
  .object({
    __typename: z.literal('FieldFormation').optional(),
    datumDepth: z
      .float32()
      .nullish()
      .describe("Numeric value 'datumDepth' (floating point) for this 'FieldFormation' row."),
    field: z
      .lazy(() => FieldSchema.nullish())
      .describe("Reference to the related 'Field' entity for this 'FieldFormation' row."),
    gasGradient: z
      .float32()
      .nullish()
      .describe("Numeric value 'gasGradient' (floating point) for this 'FieldFormation' row."),
    gasOilContact: z
      .float32()
      .nullish()
      .describe("Numeric value 'gasOilContact' (floating point) for this 'FieldFormation' row."),
    gaswaterContact: z
      .float32()
      .nullish()
      .describe("Numeric value 'gaswaterContact' (floating point) for this 'FieldFormation' row."),
    oilGradient: z
      .float32()
      .nullish()
      .describe("Numeric value 'oilGradient' (floating point) for this 'FieldFormation' row."),
    oilWaterContact: z
      .float32()
      .nullish()
      .describe("Numeric value 'oilWaterContact' (floating point) for this 'FieldFormation' row."),
    reservoir: z
      .lazy(() => ReservoirSchema.nullish())
      .describe("Reference to the related 'Reservoir' entity for this 'FieldFormation' row."),
    reservoirType: z.string().nullish().describe("Text attribute 'reservoirType' for this 'FieldFormation' row."),
    rw: z.float32().nullish().describe("Numeric value 'rw' (floating point) for this 'FieldFormation' row."),
    startDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'startDateTime' associated with this 'FieldFormation' row."),
    stopDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'stopDateTime' associated with this 'FieldFormation' row."),
    waterGradient: z
      .float32()
      .nullish()
      .describe("Numeric value 'waterGradient' (floating point) for this 'FieldFormation' row."),
  })
  .describe("View 'FieldFormation' in the iPSO production optimization solution data model.");

export const StringAssetSchema: z.ZodObject<Properties<StringAsset>> = z
  .object({
    __typename: z.literal('String_asset').optional(),
    endDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'endDateTime' associated with this 'String_asset' row."),
    entityType: z.string().nullish().describe("Text attribute 'entityType' for this 'String_asset' row."),
    name: z.string().nullish().describe('String name'),
    startDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'startDateTime' associated with this 'String_asset' row."),
  })
  .describe(
    "Typed view over 'Entity' showing well strings (completions) only (where 'entityType' = 'string'). Use this view together with 'FlatHierarchy' or 'SectorHierarchy' to navigate from wells, fields, reservoirs or sectors down to individual strings.",
  );

export const WfStringAlarmsSchema: z.ZodObject<Properties<WfStringAlarms>> = z
  .object({
    __typename: z.literal('WfStringAlarms').optional(),
    alarmCounter: z
      .number()
      .nullish()
      .describe("Numeric value 'alarmCounter' (integer) for this 'WfStringAlarms' row."),
    alarmFlags: z.string().nullish().describe("Text attribute 'alarmFlags' for this 'WfStringAlarms' row."),
    alarmLevel: z.string().nullish().describe("Text attribute 'alarmLevel' for this 'WfStringAlarms' row."),
    alarmMessage: z.string().nullish().describe("Text attribute 'alarmMessage' for this 'WfStringAlarms' row."),
    alarmName: z.string().nullish().describe("Text attribute 'alarmName' for this 'WfStringAlarms' row."),
    alarmType: z.string().nullish().describe("Text attribute 'alarmType' for this 'WfStringAlarms' row."),
    configuration: z.string().nullish().describe("Text attribute 'configuration' for this 'WfStringAlarms' row."),
    endDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'endDateTime' associated with this 'WfStringAlarms' row."),
    entityName: z
      .lazy(() => StringAssetSchema.nullish())
      .describe("Reference to the related 'String_asset' entity for this 'WfStringAlarms' row."),
    operationType: z.string().nullish().describe("Text attribute 'operationType' for this 'WfStringAlarms' row."),
    startDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'startDateTime' associated with this 'WfStringAlarms' row."),
    ticketId: z.string().nullish().describe("Text attribute 'ticketId' for this 'WfStringAlarms' row."),
    workflowName: z.string().nullish().describe("Text attribute 'workflowName' for this 'WfStringAlarms' row."),
  })
  .describe("View 'WfStringAlarms' in the iPSO production optimization solution data model.");

export const WfAlarmsAgentSchema: z.ZodObject<Properties<WfAlarmsAgent>> = z
  .object({
    __typename: z.literal('WfAlarms_Agent').optional(),
    alarmCategory: z
      .string()
      .nullish()
      .describe('Alarm category from AlarmDefinition (e.g., ESP, Gas Lift, Production).'),
    alarmCode: z.json().nullish().describe('Reference to AlarmDefinition node.'),
    alarmCodeExternalId: z
      .string()
      .nullish()
      .describe('External ID of the alarm code (e.g., WF12-001) for easy filtering.'),
    alarmCounter: z.number().nullish().describe('Count of how many times this alarm has occurred.'),
    alarmCriticality: z.string().nullish().describe('Alarm criticality level from AlarmDefinition.'),
    alarmFlags: z.string().nullish().describe('Alarm validity flag (Valid, Invalid, etc.).'),
    alarmMessage: z.string().nullish().describe('Standard alarm message template from AlarmDefinition.'),
    alarmName: z.string().nullish().describe('Human-readable alarm name from AlarmDefinition.'),
    alarmPriority: z
      .string()
      .nullish()
      .describe('Alarm priority level from AlarmDefinition (e.g., HIGH, MEDIUM, LOW).'),
    customWorkflowAlarmMessage: z
      .string()
      .nullish()
      .describe('Detailed alarm message with specific conditions that triggered it.'),
    endDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('When the alarm was cleared. Null means alarm is still active.'),
    entityExternalId: z.string().describe('External ID of the entity for joining to other views.'),
    entityName: z.string().describe('Display name of the entity (well, string) with the alarm.'),
    entityType: z.string().describe('Type of entity (string, well, field).'),
    startDateTime: z.coerce.date<Date>().describe('When the alarm was triggered.'),
    subCategory: z.string().nullish().describe('Sub-category from AlarmDefinition.'),
    subWorkflowName: z.string().nullish().describe('Sub-workflow name from AlarmDefinition.'),
    ticketId: z.string().nullish().describe('Associated troubleshooting ticket ID if one was created.'),
    wellString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe(
        "Direct relation to String_asset (when entityType = 'string').\nNavigate to string properties like lift type, status, field hierarchy.",
      ),
    workflowCode: z.string().nullish().describe('Workflow code from AlarmDefinition (e.g., WF12).'),
    workflowName: z.string().nullish().describe('Workflow name from AlarmDefinition.'),
  })
  .describe(
    'Denormalized alarms with alarm-definition properties inlined; retention is\nabout 48 hours by alarm start (see delete job).\n\nThe Workflow Alarms (Agent) view holds recent denormalized alarm data,\nincluding properties such as alarmPriority,\nalarmCriticality, and workflow details. This view facilitates analysis of\nalarm occurrences and their characteristics, to address questions related to\nalarm frequency, severity, and workflow impact. Sourced from real-time alarm\nsystems, ensuring that it reflects the most current operational status.\nExcludes pre-filtered alarms for WF12/WF14 (use ESPAlarms_Agent, GasLiftAlarms_Agent).\n\nUse for: Real-Time Surveillance (WF18), cross-workflow alarm rollup.\n\n@name Workflow Alarms (Agent)',
  );

export const WellMovementAgentSchema: z.ZodObject<Properties<WellMovementAgent>> = z
  .object({
    __typename: z.literal('WellMovement_Agent').optional(),
    actualExecutionDate: z.iso.date().nullish(),
    baselineGasRate: z.number().nullish(),
    baselineOilRate: z.number().nullish(),
    baselineWaterRate: z.number().nullish(),
    controlParameter: z.string().nullish(),
    controlParameterPostOptimizedValue: z.number().nullish(),
    controlParameterPreOptimizedValue: z.number().nullish(),
    createdBy: z.string().nullish(),
    createdDate: z.iso.date().nullish(),
    description: z.string().nullish(),
    doNotDisturb: z.boolean().nullish(),
    doNotDisturbEndDate: z.iso.date().nullish(),
    estimatedGasRate: z.number().nullish(),
    estimatedOilRate: z.number().nullish(),
    estimatedWaterRate: z.number().nullish(),
    executionStatus: z.string().nullish(),
    plannedExecutionDate: z.iso.date().nullish(),
    scenarioName: z.string().nullish(),
    scenarioType: z.string().nullish(),
    source: z.string().nullish(),
    status: z.string().nullish(),
    ticketExternalId: z.string().nullish(),
    validationStatus: z.string().nullish(),
    wellName: z.string().nullish(),
    wellString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe('Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context.'),
    wellType: z.string().nullish(),
  })
  .describe(
    'Well movement records including choke adjustments, ESP frequency changes, and\nGL optimization.\n\nContains detailed records of operational changes made to wells, choke\nadjustments, ESP frequency changes, GL rate optimization, and injection rate\nmodifications. Sourced from well management systems and operational logs,\nallowing for analysis of optimization recommendations and their execution\nstatus. Answers questions on the impact of specific adjustments on well\nperformance and efficiency, as well as track the timeline of changes made.\nExcludes historical production data or reservoir characteristics (see other\nrelated views).\n\n@name Well Movement (Agent)',
  );

export const WellBehaviourAlarmsAgentSchema: z.ZodObject<Properties<WellBehaviourAlarmsAgent>> = z
  .object({
    __typename: z.literal('WellBehaviourAlarms_Agent').optional(),
    alarmCategory: z.string().nullish(),
    alarmCode: z.json().nullish(),
    alarmCodeExternalId: z.string().nullish(),
    alarmCriticality: z.string().nullish(),
    alarmFlags: z.string().nullish(),
    alarmName: z.string().nullish(),
    alarmPriority: z.string().nullish(),
    customWorkflowAlarmMessage: z.string().nullish(),
    endDateTime: z.coerce.date<Date>().nullish(),
    entityExternalId: z.string(),
    entityName: z.string(),
    entityType: z.string(),
    startDateTime: z.coerce.date<Date>(),
    subCategory: z.string().nullish(),
    subWorkflowName: z.string().nullish(),
    wellString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe('Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context.'),
    workflowCode: z.string().nullish(),
    workflowName: z.string().nullish(),
  })
  .describe(
    'Well behaviour and productivity alarms with medium or high priority.\n\nContains well behaviour and productivity alarms, alarms classified with medium\nor high priority. Sourced from workflows that monitor well operating\nenvelopes, real-time measurements of well rates and pressures, and reservoir\npressure estimations. Use for alarm frequency, duration, impact on well performance. Excludes low-priority alarms.\n\nUse for: Real-Time Surveillance (WF18), envelope (WF6), rate/pressure (WF10).\n\n@name Well Behaviour & Productivity Alarms (Agent)',
  );

export const SurveillanceAlarmsAgentSchema: z.ZodObject<Properties<SurveillanceAlarmsAgent>> = z
  .object({
    __typename: z.literal('SurveillanceAlarms_Agent').optional(),
    alarmCategory: z.string().nullish(),
    alarmCode: z.json().nullish(),
    alarmCodeExternalId: z.string().nullish(),
    alarmCriticality: z.string().nullish(),
    alarmFlags: z.string().nullish(),
    alarmName: z.string().nullish(),
    alarmPriority: z.string().nullish(),
    customWorkflowAlarmMessage: z.string().nullish(),
    endDateTime: z.coerce.date<Date>().nullish(),
    entityExternalId: z.string(),
    entityName: z.string(),
    entityType: z.string(),
    startDateTime: z.coerce.date<Date>(),
    subCategory: z.string().nullish(),
    subWorkflowName: z.string().nullish(),
    wellString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe('Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context.'),
    workflowCode: z.string().nullish(),
    workflowName: z.string().nullish(),
  })
  .describe(
    'Well surveillance alarms with medium or high priority.\n\nContains well surveillance alarms that are classified as medium or high\npriority, sourced from real-time monitoring systems and well status workflows.\nUse for frequency and types of alarms, wells affected, duration. Excludes low-priority or historical alarms.\n\nUse for: Real-Time Surveillance (WF18), Well Status (WF25).\n\n@name Well Surveillance Alarms (Agent)',
  );

export const StringInputsStaticSchema: z.ZodObject<Properties<StringInputsStatic>> = z
  .object({
    __typename: z.literal('StringInputs_Static').optional(),
    baseLatMidPerf: z
      .float32()
      .nullish()
      .describe("Numeric value 'baseLatMidPerf' (floating point) for this 'StringInputs_Static' row."),
    baseLongMidPerf: z
      .float32()
      .nullish()
      .describe("Numeric value 'baseLongMidPerf' (floating point) for this 'StringInputs_Static' row."),
    baseX: z.float32().nullish().describe("Numeric value 'baseX' (floating point) for this 'StringInputs_Static' row."),
    baseXMidPerf: z
      .float32()
      .nullish()
      .describe("Numeric value 'baseXMidPerf' (floating point) for this 'StringInputs_Static' row."),
    baseY: z.float32().nullish().describe("Numeric value 'baseY' (floating point) for this 'StringInputs_Static' row."),
    baseYMidPerf: z
      .float32()
      .nullish()
      .describe("Numeric value 'baseYMidPerf' (floating point) for this 'StringInputs_Static' row."),
    boreholeShape: z.string().nullish().describe("Text attribute 'boreholeShape' for this 'StringInputs_Static' row."),
    bottomDepth: z
      .float32()
      .nullish()
      .describe("Numeric value 'bottomDepth' (floating point) for this 'StringInputs_Static' row."),
    crs: z.string().nullish().describe("Text attribute 'crs' for this 'StringInputs_Static' row."),
    elevation: z
      .float32()
      .nullish()
      .describe("Numeric value 'elevation' (floating point) for this 'StringInputs_Static' row."),
    elevationRef: z.string().nullish().describe("Text attribute 'elevationRef' for this 'StringInputs_Static' row."),
    endDate: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'endDate' associated with this 'StringInputs_Static' row."),
    entityName: z
      .lazy(() => StringAssetSchema.nullish())
      .describe("Reference to the related 'String_asset' entity for this 'StringInputs_Static' row."),
    originalBaseX: z
      .float32()
      .nullish()
      .describe("Numeric value 'originalBaseX' (floating point) for this 'StringInputs_Static' row."),
    originalBaseY: z
      .float32()
      .nullish()
      .describe("Numeric value 'originalBaseY' (floating point) for this 'StringInputs_Static' row."),
    originalTopX: z
      .float32()
      .nullish()
      .describe("Numeric value 'originalTopX' (floating point) for this 'StringInputs_Static' row."),
    originalTopY: z
      .float32()
      .nullish()
      .describe("Numeric value 'originalTopY' (floating point) for this 'StringInputs_Static' row."),
    startDate: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'startDate' associated with this 'StringInputs_Static' row."),
    topDepth: z
      .float32()
      .nullish()
      .describe("Numeric value 'topDepth' (floating point) for this 'StringInputs_Static' row."),
    topX: z.float32().nullish().describe("Numeric value 'topX' (floating point) for this 'StringInputs_Static' row."),
    topY: z.float32().nullish().describe("Numeric value 'topY' (floating point) for this 'StringInputs_Static' row."),
    wellbore: z.string().nullish().describe("Text attribute 'wellbore' for this 'StringInputs_Static' row."),
    wellboreType: z.string().nullish().describe("Text attribute 'wellboreType' for this 'StringInputs_Static' row."),
  })
  .describe("View 'StringInputs_Static' in the iPSO production optimization solution data model.");

export const SectorHierarchyAgentSchema: z.ZodObject<Properties<SectorHierarchyAgent>> = z
  .object({
    __typename: z.literal('SectorHierarchy_Agent').optional(),
    allocationFactor: z.float32().nullish().describe('Fractional flow allocation for this string within its sector.'),
    endDateTime: z.coerce.date<Date>().nullish().describe('Timestamp at which this sector assignment ended.'),
    reservoir: z.lazy(() => ReservoirSchema.nullish()).describe('Subsurface reservoir containing the sector.'),
    sector: z.lazy(() => SectorSchema.nullish()).describe('Subdivision of a reservoir used for flow allocation.'),
    startDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('Timestamp at which this sector assignment became effective.'),
    string: z.lazy(() => StringAssetSchema.nullish()).describe('Completion or producing interval. One row per string.'),
    well: z.lazy(() => WellSchema.nullish()).describe('Physical wellbore containing the string.'),
  })
  .describe(
    'Reservoir → sector → well → string mapping with per-string allocation\nfactors, scoped to in-scope assets.\n\nLookup table linking each producing string to its sector within a reservoir,\ntogether with the flow allocation factor used in sector-based allocation,\nand the effective date range of the assignment. Complements\nFlatHierarchy_Agent, which carries the broader production hierarchy.\n\n@name SectorHierarchy (Agent Scoped)',
  );

export const SectorHierarchySchema: z.ZodObject<Properties<SectorHierarchy>> = z
  .object({
    __typename: z.literal('SectorHierarchy').optional(),
    allocationFactor: z
      .float32()
      .nullish()
      .describe(
        'Numeric factor (0-1) used to allocate production volumes from this string to the sector. Used in flow allocation calculations when a string produces from multiple sectors.',
      ),
    endDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe(
        'When this sector assignment ended. NULL = currently active. For current assignments only, filter where endDateTime is null.',
      ),
    reservoir: z
      .lazy(() => ReservoirSchema.nullish())
      .describe(
        'Subsurface reservoir formation containing the sector. Filter here to find all sectors, wells, or strings within a specific reservoir.',
      ),
    sector: z
      .lazy(() => SectorSchema.nullish())
      .describe(
        'Subdivision of a reservoir used for flow allocation and production management. Multiple wells/strings can belong to the same sector. Filter here to analyze sector-level production.',
      ),
    startDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe(
        'When this sector assignment became effective. Used for temporal queries when sector assignments change over time.',
      ),
    string: z
      .lazy(() => StringAssetSchema.nullish())
      .describe(
        'Completion/producing interval within the well. Each row represents exactly one string. Use string.name for string identifier.',
      ),
    well: z
      .lazy(() => WellSchema.nullish())
      .describe(
        'Physical wellbore containing this string. A well may have multiple strings (completions). Use well.name for well identifier.',
      ),
  })
  .describe(
    "DENORMALIZED SECTOR LOOKUP TABLE - For sector-based flow allocation and reservoir analysis.\n\nSTRUCTURE: Each row = one String with its sector/reservoir assignment and allocation factor.\nHierarchy: Reservoir â†’ Sector â†’ Well â†’ String\n\nWHY USE THIS: Navigate sector relationships and retrieve allocation factors for flow calculations.\n\nQUERY PATTERNS:\n- Find strings in a sector: Filter sector.name = 'X', select string\n- Find wells in a reservoir: Filter reservoir.name = 'Y', select DISTINCT well\n- Get allocation factors: Filter by sector or reservoir, select allocationFactor\n\nKEY BEHAVIORS:\n- One row per string means parent entities repeat (use DISTINCT for unique parents)\n- References return full entity objects - access .name, .externalId, etc.\n- Use startDateTime/endDateTime for historical sector assignments",
  );

export const SaturationPressureMappingSchema: z.ZodObject<Properties<SaturationPressureMapping>> = z
  .object({
    __typename: z.literal('Saturation_Pressure_Mapping').optional(),
    asphTable: z.string().nullish().describe("Text attribute 'asphTable' for this 'Saturation_Pressure_Mapping' row."),
    effectiveDate: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'effectiveDate' associated with this 'Saturation_Pressure_Mapping' row."),
    entityName: z
      .lazy(() => StringAssetSchema.nullish())
      .describe("Reference to the related 'String_asset' entity for this 'Saturation_Pressure_Mapping' row."),
    prpFile: z.string().nullish().describe("Text attribute 'prpFile' for this 'Saturation_Pressure_Mapping' row."),
    pvtFile: z.string().nullish().describe("Text attribute 'pvtFile' for this 'Saturation_Pressure_Mapping' row."),
    pvtRef: z.string().nullish().describe("Text attribute 'pvtRef' for this 'Saturation_Pressure_Mapping' row."),
    resTemp: z
      .float32()
      .nullish()
      .describe("Numeric value 'resTemp' (floating point) for this 'Saturation_Pressure_Mapping' row."),
    satPress: z
      .float32()
      .nullish()
      .describe("Numeric value 'satPress' (floating point) for this 'Saturation_Pressure_Mapping' row."),
    solutionGOR: z
      .float32()
      .nullish()
      .describe("Numeric value 'solutionGOR' (floating point) for this 'Saturation_Pressure_Mapping' row."),
    wat: z
      .float32()
      .nullish()
      .describe("Numeric value 'wat' (floating point) for this 'Saturation_Pressure_Mapping' row."),
  })
  .describe("View 'Saturation_Pressure_Mapping' in the iPSO production optimization solution data model.");

export const ShgProducerGuidelineSchema: z.ZodObject<Properties<ShgProducerGuideline>> = z
  .object({
    __typename: z.literal('SHG_Producer_Guideline').optional(),
    entityName: z
      .lazy(() => StringAssetSchema.nullish())
      .describe("Reference to the related 'String_asset' entity for this 'SHG_Producer_Guideline' row."),
    maxGOR: z
      .float32()
      .nullish()
      .describe("Numeric value 'maxGOR' (floating point) for this 'SHG_Producer_Guideline' row."),
    maxLiquidRate: z
      .float32()
      .nullish()
      .describe("Numeric value 'maxLiquidRate' (floating point) for this 'SHG_Producer_Guideline' row."),
    maxOilRate: z
      .float32()
      .nullish()
      .describe("Numeric value 'maxOilRate' (floating point) for this 'SHG_Producer_Guideline' row."),
    minBHP: z
      .float32()
      .nullish()
      .describe("Numeric value 'minBHP' (floating point) for this 'SHG_Producer_Guideline' row."),
    minWHP: z
      .float32()
      .nullish()
      .describe("Numeric value 'minWHP' (floating point) for this 'SHG_Producer_Guideline' row."),
  })
  .describe("View 'SHG_Producer_Guideline' in the iPSO production optimization solution data model.");

export const ProsperModelAgentSchema: z.ZodObject<Properties<ProsperModelAgent>> = z
  .object({
    __typename: z.literal('ProsperModel_Agent').optional(),
    espCurrentCable: z
      .string()
      .nullish()
      .describe(
        'Current cable identifier/type from the Prosper model (e.g., cable type or model code). Use for grouping by cable type alongside pump and motor.',
      ),
    espCurrentMotor: z
      .string()
      .nullish()
      .describe(
        'Current motor identifier/model from the Prosper model (e.g., motor type or model code). Use for grouping by motor type alongside pump and cable.',
      ),
    espPumpModel: z
      .string()
      .nullish()
      .describe(
        'ESP pump model/type from the Prosper model (e.g., manufacturer model code). Use for grouping or filtering by ESP type; supports statistical summaries by pump model and vendor.',
      ),
    field: z
      .lazy(() => FieldSchema.nullish())
      .describe('Reference to Field. Use for field-level aggregations. DO NOT USE - THIS IS UNRELIABLE'),
    iprModel: z.string().nullish().describe('IPR model type (e.g., Vogel, Fetkovitch, Jones).'),
    liftMethod: z
      .number()
      .nullish()
      .describe(
        'Artificial lift method. 0=Natural Flow, 1=ESP, 2=Gas Lift, 3=PCP, 4=Rod Pump. Use to filter by lift type.',
      ),
    minStableRate: z.number().nullish().describe('Minimum stable flow rate from model (stb/d).'),
    modelEffectiveTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('When the model became the active/effective model for the string.'),
    modelStatus: z
      .string()
      .nullish()
      .describe(
        'Overall model status. Values: ACCEPTED, PENDING, UNDER_REVIEW, NEEDS_UPDATE. Use to identify valid vs invalid models.',
      ),
    modelUpdatedTime: z.coerce.date<Date>().nullish().describe('When the model was last updated/recalibrated.'),
    modelUploadedTime: z.coerce.date<Date>().nullish().describe('When the Prosper model file was uploaded to iPSO.'),
    pi: z.number().nullish().describe('Productivity index from Prosper model (stb/d/psi).'),
    reservoirPressure: z
      .number()
      .nullish()
      .describe(
        'Reservoir pressure used in Prosper model (psi). Compare across wells in same reservoir to identify outliers.',
      ),
    string_name: z.string().nullish().describe('String name for display (e.g., LI001-L).'),
    vlpModel: z.string().nullish().describe('VLP correlation used (e.g., Beggs and Brill, Hagedorn Brown).'),
    wearFactor: z.number().nullish().describe('ESP wear factor (0-1). Values < 1 indicate pump degradation.'),
    wellString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe('Reference to wellString. Use to join with hierarchy.'),
    wf2ModelMatchedStatus: z.string().nullish().describe('WF2 model matching status for rate estimation workflow.'),
    wf3ModelMatchedStatus: z
      .string()
      .nullish()
      .describe(
        'WF3 auto-calibration status. Values: MATCHED, NEEDS_CALIBRATION, NOT_MATCHED, UNDER_REVIEW. Use to find calibration failures.',
      ),
  })
  .describe(
    'Prosper well model repository with calibration status, version, and model\nmetadata.\n\nContains data on well models, including their calibration status, versioning,\nassociated metadata, and ESP equipment (pump model, current motor, current\ncable), sourced from the Prosper modeling system. This view is designed to\naddress analytical questions related to model availability, calibration\nsuccess, performance metrics, and equipment type across various wells, to\nassess the operational readiness of models in the field. Use cases: monitoring\nmodel compliance, identifying wells requiring immediate attention, evaluating\nthe overall health of the modeling infrastructure, and statistical summaries\nof efficiency or wear grouped by ESP type, pump model, motor, or cable.\n\n@name Prosper Model Status (Agent)',
  );

export const ProsperModelSchema: z.ZodObject<Properties<ProsperModel>> = z
  .object({
    __typename: z.literal('ProsperModel').optional(),
    asphalteneCurve: z.json().nullish().describe("Property 'asphalteneCurve' for this 'ProsperModel' row."),
    bottomPerforationDepth: z
      .number()
      .nullish()
      .describe("Numeric value 'bottomPerforationDepth' (floating point) for this 'ProsperModel' row."),
    bottomPerforationDepthUnit: z
      .string()
      .nullish()
      .describe("Text attribute 'bottomPerforationDepthUnit' for this 'ProsperModel' row."),
    bottomTubingId: z
      .number()
      .nullish()
      .describe("Numeric value 'bottomTubingId' (floating point) for this 'ProsperModel' row."),
    bottomTubingIdUnit: z
      .string()
      .nullish()
      .describe("Text attribute 'bottomTubingIdUnit' for this 'ProsperModel' row."),
    bubblePoint: z.json().nullish().describe("Property 'bubblePoint' for this 'ProsperModel' row."),
    cCoefficient: z
      .number()
      .nullish()
      .describe("Numeric value 'cCoefficient' (floating point) for this 'ProsperModel' row."),
    cCoefficientUnit: z.string().nullish().describe("Text attribute 'cCoefficientUnit' for this 'ProsperModel' row."),
    calibrationWellTestRate: z
      .number()
      .nullish()
      .describe("Numeric value 'calibrationWellTestRate' (floating point) for this 'ProsperModel' row."),
    calibrationWellTestRateUnit: z
      .string()
      .nullish()
      .describe("Text attribute 'calibrationWellTestRateUnit' for this 'ProsperModel' row."),
    calibrationWellTestTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'calibrationWellTestTime' associated with this 'ProsperModel' row."),
    changeDetails: z.string().nullish().describe("Text attribute 'changeDetails' for this 'ProsperModel' row."),
    criticalPoint: z.json().nullish().describe("Property 'criticalPoint' for this 'ProsperModel' row."),
    description: z.string().nullish().describe("Text attribute 'description' for this 'ProsperModel' row."),
    deviationSurveyRecordCount: z
      .number()
      .nullish()
      .describe("Numeric value 'deviationSurveyRecordCount' (integer) for this 'ProsperModel' row."),
    espCurrentCable: z.string().nullish().describe("Text attribute 'espCurrentCable' for this 'ProsperModel' row."),
    espCurrentMotor: z.string().nullish().describe("Text attribute 'espCurrentMotor' for this 'ProsperModel' row."),
    espPumpDepth: z
      .number()
      .nullish()
      .describe("Numeric value 'espPumpDepth' (floating point) for this 'ProsperModel' row."),
    espPumpDepthUnit: z.string().nullish().describe("Text attribute 'espPumpDepthUnit' for this 'ProsperModel' row."),
    espPumpModel: z.string().nullish().describe("Text attribute 'espPumpModel' for this 'ProsperModel' row."),
    espStages: z.number().nullish().describe("Numeric value 'espStages' (integer) for this 'ProsperModel' row."),
    executeStatus: z.string().nullish().describe("Text attribute 'executeStatus' for this 'ProsperModel' row."),
    fbhpAtMinStableRate: z
      .number()
      .nullish()
      .describe("Numeric value 'fbhpAtMinStableRate' (floating point) for this 'ProsperModel' row."),
    fbhpAtMinStableRateUnit: z
      .string()
      .nullish()
      .describe("Text attribute 'fbhpAtMinStableRateUnit' for this 'ProsperModel' row."),
    field: z
      .lazy(() => FieldSchema.nullish())
      .describe("Reference to the related 'Field' entity for this 'ProsperModel' row."),
    fileSize: z.number().nullish().describe("Numeric value 'fileSize' (floating point) for this 'ProsperModel' row."),
    flowExponent: z
      .number()
      .nullish()
      .describe("Numeric value 'flowExponent' (floating point) for this 'ProsperModel' row."),
    fluid: z.number().nullish().describe("Numeric value 'fluid' (integer) for this 'ProsperModel' row."),
    frequencyCorrectionFactor: z.number().nullish().describe('Frequency correction factor for ESP pump'),
    geoThermalGradientRecordCount: z
      .number()
      .nullish()
      .describe("Numeric value 'geoThermalGradientRecordCount' (integer) for this 'ProsperModel' row."),
    glInjectionDepth: z
      .number()
      .nullish()
      .describe("Numeric value 'glInjectionDepth' (floating point) for this 'ProsperModel' row."),
    glInjectionDepthUnit: z
      .string()
      .nullish()
      .describe("Text attribute 'glInjectionDepthUnit' for this 'ProsperModel' row."),
    glMethod: z.number().nullish().describe("Numeric value 'glMethod' (integer) for this 'ProsperModel' row."),
    glOrificeSize: z
      .number()
      .nullish()
      .describe("Numeric value 'glOrificeSize' (floating point) for this 'ProsperModel' row."),
    glOrificeSizeUnit: z.string().nullish().describe("Text attribute 'glOrificeSizeUnit' for this 'ProsperModel' row."),
    glValveDepth: z
      .number()
      .nullish()
      .describe("Numeric value 'glValveDepth' (floating point) for this 'ProsperModel' row."),
    glValveDepthUnit: z.string().nullish().describe("Text attribute 'glValveDepthUnit' for this 'ProsperModel' row."),
    hydrateCurve: z.json().nullish().describe("Property 'hydrateCurve' for this 'ProsperModel' row."),
    iprModel: z.string().nullish().describe("Text attribute 'iprModel' for this 'ProsperModel' row."),
    legacyDataSetId: z
      .int64()
      .nullish()
      .describe("Numeric value 'legacyDataSetId' (integer) for this 'ProsperModel' row."),
    legacyFileExternalId: z
      .string()
      .nullish()
      .describe("Text attribute 'legacyFileExternalId' for this 'ProsperModel' row."),
    legacyFileId: z.int64().nullish().describe("Numeric value 'legacyFileId' (integer) for this 'ProsperModel' row."),
    legacyInputFileId: z.int64().nullish().describe('Input file id if this model was created from another model'),
    liftMethod: z.number().nullish().describe("Numeric value 'liftMethod' (integer) for this 'ProsperModel' row."),
    maxMeasuredDepth: z
      .number()
      .nullish()
      .describe("Numeric value 'maxMeasuredDepth' (floating point) for this 'ProsperModel' row."),
    maxMeasuredDepthUnit: z
      .string()
      .nullish()
      .describe("Text attribute 'maxMeasuredDepthUnit' for this 'ProsperModel' row."),
    maxTrueVerticalDepth: z
      .number()
      .nullish()
      .describe("Numeric value 'maxTrueVerticalDepth' (floating point) for this 'ProsperModel' row."),
    maxTrueVerticalDepthUnit: z
      .string()
      .nullish()
      .describe("Text attribute 'maxTrueVerticalDepthUnit' for this 'ProsperModel' row."),
    mimeType: z.string().nullish().describe("Text attribute 'mimeType' for this 'ProsperModel' row."),
    minStableRate: z
      .number()
      .nullish()
      .describe("Numeric value 'minStableRate' (floating point) for this 'ProsperModel' row."),
    minStableRateUnit: z.string().nullish().describe("Text attribute 'minStableRateUnit' for this 'ProsperModel' row."),
    modelAcceptedBy: z.string().nullish().describe("Text attribute 'modelAcceptedBy' for this 'ProsperModel' row."),
    modelAcceptedTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'modelAcceptedTime' associated with this 'ProsperModel' row."),
    modelEffectiveTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'modelEffectiveTime' associated with this 'ProsperModel' row."),
    modelStatus: z.string().nullish().describe("Text attribute 'modelStatus' for this 'ProsperModel' row."),
    modelUpdatedBy: z.string().nullish().describe("Text attribute 'modelUpdatedBy' for this 'ProsperModel' row."),
    modelUpdatedTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'modelUpdatedTime' associated with this 'ProsperModel' row."),
    modelUploadedBy: z.string().nullish().describe("Text attribute 'modelUploadedBy' for this 'ProsperModel' row."),
    modelUploadedTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'modelUploadedTime' associated with this 'ProsperModel' row."),
    name: z.string().nullish().describe("Text attribute 'name' for this 'ProsperModel' row."),
    originalProsperFileName: z
      .string()
      .nullish()
      .describe("Text attribute 'originalProsperFileName' for this 'ProsperModel' row."),
    pE5Flag: z.number().nullish().describe("Numeric value 'pE5Flag' (integer) for this 'ProsperModel' row."),
    pendingModifications: z.json().nullish().describe("Property 'pendingModifications' for this 'ProsperModel' row."),
    phaseEnvelope: z.json().nullish().describe("Property 'phaseEnvelope' for this 'ProsperModel' row."),
    pi: z.number().nullish().describe("Numeric value 'pi' (floating point) for this 'ProsperModel' row."),
    piUnit: z.string().nullish().describe("Text attribute 'piUnit' for this 'ProsperModel' row."),
    platform: z.string().nullish().describe("Text attribute 'platform' for this 'ProsperModel' row."),
    prosperLocationName: z
      .string()
      .nullish()
      .describe("Text attribute 'prosperLocationName' for this 'ProsperModel' row."),
    prosperWellName: z.string().nullish().describe("Text attribute 'prosperWellName' for this 'ProsperModel' row."),
    pvt: z.number().nullish().describe("Numeric value 'pvt' (floating point) for this 'ProsperModel' row."),
    pvtUnit: z.string().nullish().describe("Text attribute 'pvtUnit' for this 'ProsperModel' row."),
    rateDeviationPercentage: z
      .number()
      .nullish()
      .describe("Numeric value 'rateDeviationPercentage' (floating point) for this 'ProsperModel' row."),
    reservoir: z
      .array(z.lazy(() => ReservoirSchema.nullable()))
      .nullish()
      .describe("Reference to the related 'Reservoir' entity for this 'ProsperModel' row."),
    reservoirBubblePoint: z
      .number()
      .nullish()
      .describe("Numeric value 'reservoirBubblePoint' (floating point) for this 'ProsperModel' row."),
    reservoirBubblePointUnit: z
      .string()
      .nullish()
      .describe("Text attribute 'reservoirBubblePointUnit' for this 'ProsperModel' row."),
    reservoirPressure: z
      .number()
      .nullish()
      .describe("Numeric value 'reservoirPressure' (floating point) for this 'ProsperModel' row."),
    reservoirPressureUnit: z
      .string()
      .nullish()
      .describe("Text attribute 'reservoirPressureUnit' for this 'ProsperModel' row."),
    reservoirTemperature: z
      .number()
      .nullish()
      .describe("Numeric value 'reservoirTemperature' (floating point) for this 'ProsperModel' row."),
    reservoirTemperatureUnit: z
      .string()
      .nullish()
      .describe("Text attribute 'reservoirTemperatureUnit' for this 'ProsperModel' row."),
    simIntExternalId: z.string().nullish().describe("Text attribute 'simIntExternalId' for this 'ProsperModel' row."),
    simIntModelExternalId: z
      .string()
      .nullish()
      .describe("Text attribute 'simIntModelExternalId' for this 'ProsperModel' row."),
    simIntModelRevisionCreatedTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'simIntModelRevisionCreatedTime' associated with this 'ProsperModel' row."),
    simIntModelRevisionDescription: z
      .string()
      .nullish()
      .describe("Text attribute 'simIntModelRevisionDescription' for this 'ProsperModel' row."),
    simIntModelRevisionExternalId: z
      .string()
      .nullish()
      .describe("Text attribute 'simIntModelRevisionExternalId' for this 'ProsperModel' row."),
    simIntModelRevisionId: z
      .string()
      .nullish()
      .describe("Text attribute 'simIntModelRevisionId' for this 'ProsperModel' row."),
    simIntModelRevisionLogId: z
      .string()
      .nullish()
      .describe("Text attribute 'simIntModelRevisionLogId' for this 'ProsperModel' row."),
    simIntModelRevisionStatus: z
      .string()
      .nullish()
      .describe("Text attribute 'simIntModelRevisionStatus' for this 'ProsperModel' row."),
    simIntModelRevisionStatusMessage: z
      .string()
      .nullish()
      .describe("Text attribute 'simIntModelRevisionStatusMessage' for this 'ProsperModel' row."),
    simIntModelRevisionUpdatedTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'simIntModelRevisionUpdatedTime' associated with this 'ProsperModel' row."),
    simIntModelRevisionVersionId: z
      .number()
      .nullish()
      .describe("Numeric value 'simIntModelRevisionVersionId' (integer) for this 'ProsperModel' row."),
    source: z.string().nullish().describe("Text attribute 'source' for this 'ProsperModel' row."),
    sourceLocation: z.string().nullish().describe("Text attribute 'sourceLocation' for this 'ProsperModel' row."),
    string: z
      .lazy(() => StringAssetSchema.nullish())
      .describe("Reference to the related 'String_asset' entity for this 'ProsperModel' row."),
    string_name: z.string().nullish().describe("Text attribute 'string_name' for this 'ProsperModel' row."),
    topPerforationDepth: z
      .number()
      .nullish()
      .describe("Numeric value 'topPerforationDepth' (floating point) for this 'ProsperModel' row."),
    topPerforationDepthUnit: z
      .string()
      .nullish()
      .describe("Text attribute 'topPerforationDepthUnit' for this 'ProsperModel' row."),
    uVal: z.number().nullish().describe("Numeric value 'uVal' (floating point) for this 'ProsperModel' row."),
    uValUnit: z.string().nullish().describe("Text attribute 'uValUnit' for this 'ProsperModel' row."),
    vlpModel: z.string().nullish().describe("Text attribute 'vlpModel' for this 'ProsperModel' row."),
    waxCurve: z.json().nullish().describe("Property 'waxCurve' for this 'ProsperModel' row."),
    wearFactor: z
      .number()
      .nullish()
      .describe("Numeric value 'wearFactor' (floating point) for this 'ProsperModel' row."),
    well: z
      .lazy(() => WellSchema.nullish())
      .describe("Reference to the related 'Well' entity for this 'ProsperModel' row."),
    wellCompletionRecordCount: z
      .number()
      .nullish()
      .describe("Numeric value 'wellCompletionRecordCount' (integer) for this 'ProsperModel' row."),
    wellType: z.number().nullish().describe("Numeric value 'wellType' (integer) for this 'ProsperModel' row."),
    wf2EstimatedRate: z
      .number()
      .nullish()
      .describe("Numeric value 'wf2EstimatedRate' (floating point) for this 'ProsperModel' row."),
    wf2ModelMatchedStatus: z
      .string()
      .nullish()
      .describe("Text attribute 'wf2ModelMatchedStatus' for this 'ProsperModel' row."),
    wf2Processed: z.string().nullish().describe("Text attribute 'wf2Processed' for this 'ProsperModel' row."),
    wf3EstimatedRate: z
      .number()
      .nullish()
      .describe("Numeric value 'wf3EstimatedRate' (floating point) for this 'ProsperModel' row."),
    wf3EstimatedRateUnit: z
      .string()
      .nullish()
      .describe("Text attribute 'wf3EstimatedRateUnit' for this 'ProsperModel' row."),
    wf3ModelMatchedStatus: z
      .string()
      .nullish()
      .describe("Text attribute 'wf3ModelMatchedStatus' for this 'ProsperModel' row."),
  })
  .describe("View 'ProsperModel' in the iPSO production optimization solution data model.");

export const ProsperModelEventLogSchema: z.ZodObject<Properties<ProsperModelEventLog>> = z
  .object({
    __typename: z.literal('ProsperModelEventLog').optional(),
    modelAcceptedBy: z
      .string()
      .nullish()
      .describe("Text attribute 'modelAcceptedBy' for this 'ProsperModelEventLog' row."),
    modelAcceptedTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'modelAcceptedTime' associated with this 'ProsperModelEventLog' row."),
    modelStatus: z.string().nullish().describe("Text attribute 'modelStatus' for this 'ProsperModelEventLog' row."),
    modelUpdatedBy: z
      .string()
      .nullish()
      .describe("Text attribute 'modelUpdatedBy' for this 'ProsperModelEventLog' row."),
    modelUpdatedTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'modelUpdatedTime' associated with this 'ProsperModelEventLog' row."),
    prosperModel: z
      .lazy(() => ProsperModelSchema.nullish())
      .describe("Reference to the related 'ProsperModel' entity for this 'ProsperModelEventLog' row."),
    wf3ModelMatchedStatus: z
      .string()
      .nullish()
      .describe("Text attribute 'wf3ModelMatchedStatus' for this 'ProsperModelEventLog' row."),
  })
  .describe("View 'ProsperModelEventLog' in the iPSO production optimization solution data model.");

export const ProductionAllocationAlarmsAgentSchema: z.ZodObject<Properties<ProductionAllocationAlarmsAgent>> = z
  .object({
    __typename: z.literal('ProductionAllocationAlarms_Agent').optional(),
    alarmCategory: z.string().nullish(),
    alarmCode: z.json().nullish(),
    alarmCodeExternalId: z.string().nullish(),
    alarmCounter: z.number().nullish().describe('Number of consecutive occurrences of this alarm.'),
    alarmCriticality: z.string().nullish(),
    alarmFlags: z.string().nullish(),
    alarmName: z.string().nullish(),
    alarmPriority: z.string().nullish(),
    customWorkflowAlarmMessage: z.string().nullish(),
    endDateTime: z.coerce.date<Date>().nullish(),
    entityExternalId: z.string(),
    entityName: z.string(),
    entityType: z.string(),
    startDateTime: z.coerce.date<Date>(),
    subCategory: z.string().nullish().describe('Alarm sub-category for domain filtering.'),
    subWorkflowName: z.string().nullish().describe('Sub-workflow that generated the alarm.'),
    ticketId: z.string().nullish().describe('Associated ticket/action ID if alarm has been acknowledged.'),
    wellString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe('Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context.'),
    workflowCode: z.string().nullish(),
    workflowName: z.string().nullish(),
  })
  .describe(
    'Production allocation alarms with medium or high priority.\n\nContains production allocation alarms, medium or high priority, derived from\nworkflows WF5 and WF13. Sourced from operational monitoring systems that track\nalarm events, allowing users to analyze alarm occurrences, their severity, and\nassociated workflows. It can answer questions regarding the frequency and\ntypes of alarms and impact on allocation. Excludes low-priority or non-WF5/WF13 alarms.\n\nUse for: Production Allocation (WF5), Gas Lift Estimation (WF13), Real-Time Surveillance (WF18).\n\n@name Production Allocation Alarms (Agent)',
  );

export const ProducerGuidelinesStringAgentSchema: z.ZodObject<Properties<ProducerGuidelinesStringAgent>> = z
  .object({
    __typename: z.literal('ProducerGuidelines_String_Agent').optional(),
    maxGOR: z
      .float32()
      .nullish()
      .describe(
        'Maximum allowed Gas-Oil Ratio (scf/stb) from reservoir management guidelines.\nWells with GOR above this limit are violating guidelines and may need\nchoke adjustment or investigation.',
      ),
    maxLiquidRate: z
      .float32()
      .nullish()
      .describe(
        'Maximum allowed liquid production rate (stb/d) from reservoir management\nguidelines. Wells above this limit may need rate constraints.',
      ),
    maxOilRate: z
      .float32()
      .nullish()
      .describe(
        'Maximum allowed oil production rate (stb/d) from reservoir management\nguidelines. Used for rate constraint optimization.',
      ),
    minBHP: z
      .float32()
      .nullish()
      .describe(
        'Minimum allowed Bottomhole Pressure (psia) from reservoir management guidelines.\nProduction wells operating below this BHP may be causing reservoir damage\nor excessive drawdown.',
      ),
    minWHP: z
      .float32()
      .nullish()
      .describe(
        'Minimum allowed Wellhead Pressure (psia) from reservoir management\nguidelines. Wells operating below this WHP may indicate flow instability,\nliquid loading, or insufficient reservoir energy.',
      ),
    wellString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe('Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context.'),
  })
  .describe(
    'Reservoir management guidelines and operating limits for production strings (WF6).\n\nMax GOR, min BHP/WHP, max liquid/oil rates per string. Use to assess adherence\nto guidelines, identify wells outside limits, and flag reservoir damage risk.\nExcludes historical performance or detailed rates (see other views).\n\nUse for: Well Operating Envelope (WF6).',
  );

export const OpportunityAgentSchema: z.ZodObject<Properties<OpportunityAgent>> = z
  .object({
    __typename: z.literal('Opportunity_Agent').optional(),
    actualExecutionDate: z.iso.date().nullish().describe('Actual date when intervention was executed.'),
    baselineGasRate: z.number().nullish().describe('Current gas production rate before intervention (Mscf/d).'),
    baselineOilRate: z
      .number()
      .nullish()
      .describe('Current oil production rate before intervention (stb/d). Baseline for gain calculation.'),
    baselineWaterRate: z.number().nullish().describe('Current water production rate before intervention (stb/d).'),
    createdDate: z.iso.date().nullish().describe('Date when opportunity was identified and created.'),
    cumulativeOilGain: z
      .number()
      .nullish()
      .describe('Cumulative oil production gained since execution (stb). Tracks realized value.'),
    description: z
      .string()
      .nullish()
      .describe('Detailed description of the opportunity, including technical rationale.'),
    estimatedGasRate: z.number().nullish().describe('Predicted gas rate after intervention (Mscf/d).'),
    estimatedOilRate: z
      .number()
      .nullish()
      .describe('Predicted oil rate after intervention (stb/d). Expected gain = estimated - baseline.'),
    estimatedWaterRate: z.number().nullish().describe('Predicted water rate after intervention (stb/d).'),
    interventionActivity: z
      .string()
      .nullish()
      .describe('Type of intervention required (e.g., WORKOVER, CHOKE_CHANGE, STIMULATION).'),
    owner: z.string().nullish().describe('Person responsible for driving this opportunity to execution.'),
    plannedExecutionDate: z.iso.date().nullish().describe('Scheduled date for intervention execution.'),
    source: z
      .string()
      .nullish()
      .describe('Origin of opportunity identification (e.g., SURVEILLANCE, WORKFLOW, MANUAL).'),
    status: z
      .string()
      .nullish()
      .describe(
        'Current opportunity status: OPEN, VALIDATED, PLANNED, EXECUTED, CLOSED.\nUse to track lifecycle progress.',
      ),
    summary: z
      .string()
      .nullish()
      .describe('Brief summary of the production opportunity. Use for quick identification.'),
    ticketExternalID: z
      .string()
      .nullish()
      .describe('Link to associated ticket in TicketRegistry. Use to join for full ticket details.'),
    type: z.string().nullish().describe('Type of opportunity (e.g., CHOKE_ADJUSTMENT, RECOMPLETION, GAS_LIFT_OPT).'),
    validationComments: z
      .string()
      .nullish()
      .describe('Comments from validation review, including technical justification.'),
    validationStatus: z
      .string()
      .nullish()
      .describe('Validation status: PENDING, VALIDATED, REJECTED. Indicates engineering review state.'),
    valueTrackingEndDate: z.iso.date().nullish().describe('Date when value tracking ended for this opportunity.'),
    valueTrackingEndReason: z
      .string()
      .nullish()
      .describe('Reason for ending value tracking (e.g., RATE_DECLINE, NEW_INTERVENTION).'),
    valueTrackingStatus: z.string().nullish().describe('Status of value tracking: ACTIVE, COMPLETED, NOT_STARTED.'),
    wellName: z
      .string()
      .nullish()
      .describe('Name of the well this opportunity applies to. Primary filter for well-based queries.'),
    wellString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe('Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context.'),
    wellType: z.string().nullish().describe('Well type classification (PRODUCER, INJECTOR, etc.).'),
  })
  .describe(
    'Production optimization opportunities tracking potential gains from well\ninterventions.\n\nContains data related to production optimization opportunities tracking\npotential gains from well interventions. This view aggregates information from\noperational databases and historical performance metrics, to analyze the\neffectiveness of various well interventions. It answers analytical questions\nsuch as the potential oil gain from specific opportunities, the status of open\nor closed interventions, and the validation status of pending opportunities.\nExcludes detailed financial metrics or external market conditions (see other\nrelated views focused on economic analysis).',
  );

export const NetworkAlarmsAgentSchema: z.ZodObject<Properties<NetworkAlarmsAgent>> = z
  .object({
    __typename: z.literal('NetworkAlarms_Agent').optional(),
    alarmCategory: z.string().nullish(),
    alarmCode: z.json().nullish(),
    alarmCodeExternalId: z.string().nullish(),
    alarmCounter: z.number().nullish().describe('Number of consecutive occurrences of this alarm.'),
    alarmCriticality: z.string().nullish(),
    alarmFlags: z.string().nullish(),
    alarmName: z.string().nullish(),
    alarmPriority: z.string().nullish(),
    customWorkflowAlarmMessage: z.string().nullish(),
    endDateTime: z.coerce.date<Date>().nullish(),
    entityExternalId: z.string(),
    entityName: z.string(),
    entityType: z.string(),
    startDateTime: z.coerce.date<Date>(),
    subCategory: z.string().nullish().describe('Alarm sub-category for domain filtering.'),
    subWorkflowName: z.string().nullish().describe('Sub-workflow that generated the alarm.'),
    ticketId: z.string().nullish().describe('Associated ticket/action ID if alarm has been acknowledged.'),
    wellString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe('Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context.'),
    workflowCode: z.string().nullish(),
    workflowName: z.string().nullish(),
  })
  .describe(
    'Network optimization alarms with medium or high priority.\n\nThe Network Optimization Alarms (Agent) view contains data related to alarms\ngenerated during network surveillance and optimization processes, medium and\nhigh-priority alerts. This data is derived from various workflows, including\nnetwork surveillance, model validations, and production optimization\nscenarios, ensuring relevance to operational efficiency. Answers questions on\nfrequency, types, and impact on network performance. Excludes low-priority alarms.\n\nUse for: Network Surveillance (WF7), Network Model Validation (WF8), Production Optimization Scenarios (WF11).\n\n@name Network Optimization Alarms (Agent)',
  );

export const MpfmWellTestOutputsSchema: z.ZodObject<Properties<MpfmWellTestOutputs>> = z
  .object({
    __typename: z.literal('MpfmWellTestOutputs').optional(),
    alarmCount: z
      .number()
      .nullish()
      .describe("Numeric value 'alarmCount' (integer) for this 'MpfmWellTestOutputs' row."),
    entityName: z
      .lazy(() => MpfmSchema.nullish())
      .describe("Reference to the related 'Mpfm' entity for this 'MpfmWellTestOutputs' row."),
    field: z
      .lazy(() => FieldSchema.nullish())
      .describe("Reference to the related 'Field' entity for this 'MpfmWellTestOutputs' row."),
    process1Flag: z.string().nullish().describe("Text attribute 'process1Flag' for this 'MpfmWellTestOutputs' row."),
    process2Flag: z.string().nullish().describe("Text attribute 'process2Flag' for this 'MpfmWellTestOutputs' row."),
    process3Flag: z.string().nullish().describe("Text attribute 'process3Flag' for this 'MpfmWellTestOutputs' row."),
    process4Flag: z.string().nullish().describe("Text attribute 'process4Flag' for this 'MpfmWellTestOutputs' row."),
    singlePointWellTestFlag: z
      .string()
      .nullish()
      .describe("Text attribute 'singlePointWellTestFlag' for this 'MpfmWellTestOutputs' row."),
    stablePeriodEndDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'stablePeriodEndDateTime' associated with this 'MpfmWellTestOutputs' row."),
    stablePeriodFlag: z
      .string()
      .nullish()
      .describe("Text attribute 'stablePeriodFlag' for this 'MpfmWellTestOutputs' row."),
    stablePeriodStartDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'stablePeriodStartDateTime' associated with this 'MpfmWellTestOutputs' row."),
    startDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'startDateTime' associated with this 'MpfmWellTestOutputs' row."),
    stringOnTest: z
      .lazy(() => StringAssetSchema.nullish())
      .describe("Reference to the related 'String_asset' entity for this 'MpfmWellTestOutputs' row."),
    wellOnTest: z
      .lazy(() => WellSchema.nullish())
      .describe("Reference to the related 'Well' entity for this 'MpfmWellTestOutputs' row."),
    wellTestDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'wellTestDateTime' associated with this 'MpfmWellTestOutputs' row."),
  })
  .describe("View 'MpfmWellTestOutputs' in the iPSO production optimization solution data model.");

export const ModelManagementAlarmsAgentSchema: z.ZodObject<Properties<ModelManagementAlarmsAgent>> = z
  .object({
    __typename: z.literal('ModelManagementAlarms_Agent').optional(),
    alarmCategory: z.string().nullish(),
    alarmCode: z.json().nullish(),
    alarmCodeExternalId: z.string().nullish(),
    alarmCriticality: z.string().nullish(),
    alarmFlags: z.string().nullish(),
    alarmName: z.string().nullish(),
    alarmPriority: z.string().nullish(),
    customWorkflowAlarmMessage: z.string().nullish(),
    endDateTime: z.coerce.date<Date>().nullish(),
    entityExternalId: z.string(),
    entityName: z.string(),
    entityType: z.string(),
    startDateTime: z.coerce.date<Date>(),
    subCategory: z.string().nullish(),
    subWorkflowName: z.string().nullish(),
    wellString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe('Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context.'),
    workflowCode: z.string().nullish(),
    workflowName: z.string().nullish(),
  })
  .describe(
    'Model management alarms with medium or high priority.\n\nContains alarms generated during the model management processes, those with\nmedium or high priority. Sourced from the workflows associated with well and\nnetwork model updates and calibrations, allowing users to analyze alarm\noccurrences and their implications on model performance. It can answer\nquestions regarding the frequency and types of alarms triggered, their impact\non operations and entities affected. Excludes low-priority or non-WF9 alarms.\n\nUse for: Well and Network Model Update and Management (WF9), Real-Time Surveillance (WF18).\n\n@name Model Management Alarms (Agent)',
  );

export const InjectionAllocationFactorSchema: z.ZodObject<Properties<InjectionAllocationFactor>> = z
  .object({
    __typename: z.literal('Injection_Allocation_Factor').optional(),
    allocationFactor: z
      .float32()
      .nullish()
      .describe("Numeric value 'allocationFactor' (floating point) for this 'Injection_Allocation_Factor' row."),
    effectiveDate: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'effectiveDate' associated with this 'Injection_Allocation_Factor' row."),
    executionDate: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'executionDate' associated with this 'Injection_Allocation_Factor' row."),
    field: z
      .lazy(() => FieldSchema.nullish())
      .describe("Reference to the related 'Field' entity for this 'Injection_Allocation_Factor' row."),
    injectorString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe("Reference to the related 'String_asset' entity for this 'Injection_Allocation_Factor' row."),
    producerString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe("Reference to the related 'String_asset' entity for this 'Injection_Allocation_Factor' row."),
    reservoir: z
      .lazy(() => ReservoirSchema.nullish())
      .describe("Reference to the related 'Reservoir' entity for this 'Injection_Allocation_Factor' row."),
    source: z.string().nullish().describe("Text attribute 'source' for this 'Injection_Allocation_Factor' row."),
  })
  .describe("View 'Injection_Allocation_Factor' in the iPSO production optimization solution data model.");

export const InjectionAlarmsAgentSchema: z.ZodObject<Properties<InjectionAlarmsAgent>> = z
  .object({
    __typename: z.literal('InjectionAlarms_Agent').optional(),
    alarmCategory: z.string().nullish(),
    alarmCode: z.json().nullish(),
    alarmCodeExternalId: z.string().nullish(),
    alarmCounter: z.number().nullish().describe('Number of consecutive occurrences of this alarm.'),
    alarmCriticality: z.string().nullish(),
    alarmFlags: z.string().nullish(),
    alarmName: z.string().nullish(),
    alarmPriority: z.string().nullish(),
    customWorkflowAlarmMessage: z.string().nullish(),
    endDateTime: z.coerce.date<Date>().nullish(),
    entityExternalId: z.string(),
    entityName: z.string(),
    entityType: z.string(),
    startDateTime: z.coerce.date<Date>(),
    subCategory: z.string().nullish().describe('Alarm sub-category for domain filtering.'),
    subWorkflowName: z.string().nullish().describe('Sub-workflow that generated the alarm.'),
    ticketId: z.string().nullish().describe('Associated ticket/action ID if alarm has been acknowledged.'),
    wellString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe('Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context.'),
    workflowCode: z.string().nullish(),
    workflowName: z.string().nullish(),
  })
  .describe(
    'Injection monitoring and VRR alarms with medium or high priority.\n\nThe Injection Monitoring Alarms (Agent) view contains data related to medium\nand high-priority alarms associated with water or gas injection and VRR\n(Volume Reduction Ratio) monitoring. This data is sourced from operational\nworkflows focused on injection monitoring and includes alarm codes,\npriorities, and timestamps, allowing for the analysis of alarm occurrences and\ntheir implications on operational efficiency. It can answer questions\nregarding frequency, criticality, and duration of injection/VRR alarms. Excludes low-priority alarms.\n\nUse for: Water or Gas Injection Monitoring (WF15), VRR (WF16/WF17), Real-Time Surveillance (WF18).\n\n@name Injection Monitoring Alarms (Agent)',
  );

export const InjPressGuidelineStringAgentSchema: z.ZodObject<Properties<InjPressGuidelineStringAgent>> = z
  .object({
    __typename: z.literal('InjPressGuideline_String_Agent').optional(),
    giMaxBHIP: z.float32().nullish(),
    giMaxInjRate: z.float32().nullish(),
    giMaxWHIP: z.float32().nullish(),
    wellString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe('Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context.'),
    wiMaxBHIP: z.float32().nullish(),
    wiMaxInjRate: z.float32().nullish(),
    wiMaxWHIP: z.float32().nullish(),
  })
  .describe(
    'Injection pressure guidelines and operating limits per well string (WF15).\n\nMax WHP, min BHP, fracture gradient, operating pressure bands. Use for safe\ninjection practices, optimal pressure settings, over-pressurization risk. For\nperformance trends see InjectionPerformance_String_Agent.\n\nUse for: Water or Gas Injection Monitoring (WF15).\n\n@name Injection Pressure Guidelines - String (Agent)',
  );

export const InjPressGuidelineStringSchema: z.ZodObject<Properties<InjPressGuidelineString>> = z
  .object({
    __typename: z.literal('InjPressGuideline_String').optional(),
    entityName: z
      .lazy(() => StringAssetSchema.nullish())
      .describe("Reference to the related 'String_asset' entity for this 'InjPressGuideline_String' row."),
    giMaxBHIP: z
      .float32()
      .nullish()
      .describe("Numeric value 'giMaxBHIP' (floating point) for this 'InjPressGuideline_String' row."),
    giMaxInjRate: z
      .float32()
      .nullish()
      .describe("Numeric value 'giMaxInjRate' (floating point) for this 'InjPressGuideline_String' row."),
    giMaxWHIP: z
      .float32()
      .nullish()
      .describe("Numeric value 'giMaxWHIP' (floating point) for this 'InjPressGuideline_String' row."),
    wiMaxBHIP: z
      .float32()
      .nullish()
      .describe("Numeric value 'wiMaxBHIP' (floating point) for this 'InjPressGuideline_String' row."),
    wiMaxInjRate: z
      .float32()
      .nullish()
      .describe("Numeric value 'wiMaxInjRate' (floating point) for this 'InjPressGuideline_String' row."),
    wiMaxWHIP: z
      .float32()
      .nullish()
      .describe("Numeric value 'wiMaxWHIP' (floating point) for this 'InjPressGuideline_String' row."),
  })
  .describe("View 'InjPressGuideline_String' in the iPSO production optimization solution data model.");

export const GasLiftAlarmsAgentSchema: z.ZodObject<Properties<GasLiftAlarmsAgent>> = z
  .object({
    __typename: z.literal('GasLiftAlarms_Agent').optional(),
    alarmCategory: z.string().nullish(),
    alarmCode: z.json().nullish(),
    alarmCodeExternalId: z.string().nullish(),
    alarmCounter: z.number().nullish().describe('Number of consecutive occurrences of this alarm.'),
    alarmCriticality: z.string().nullish(),
    alarmFlags: z.string().nullish(),
    alarmName: z.string().nullish(),
    alarmPriority: z.string().nullish(),
    customWorkflowAlarmMessage: z.string().nullish(),
    endDateTime: z.coerce.date<Date>().nullish(),
    entityExternalId: z.string(),
    entityName: z.string(),
    entityType: z.string(),
    startDateTime: z.coerce.date<Date>(),
    subCategory: z.string().nullish().describe('Alarm sub-category for domain filtering.'),
    subWorkflowName: z.string().nullish().describe('Sub-workflow that generated the alarm.'),
    ticketId: z.string().nullish().describe('Associated ticket/action ID if alarm has been acknowledged.'),
    wellString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe('Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context.'),
    workflowCode: z.string().nullish(),
    workflowName: z.string().nullish(),
  })
  .describe(
    'Gas lift troubleshooting and diagnostic alarms with medium or high priority.\n\nContains diagnostic alarms, gas lift operations, focusing on those with medium\nor high priority. Sourced from operational monitoring systems that track alarm\nevents, to analyze alarm occurrences and their implications on gas lift\nperformance. It answers analytical questions such as the frequency of high-\npriority alarms and troubleshooting effectiveness. Excludes low-priority or non-WF14 alarms.\n\nUse for: Gas Lift Troubleshooting and Diagnostics (WF14), Real-Time Surveillance (WF18).\n\n@name Gas Lift Diagnostic Alarms (Agent)',
  );

export const GlValveDataSchema: z.ZodObject<Properties<GlValveData>> = z
  .object({
    __typename: z.literal('GL_Valve_Data').optional(),
    domePressure: z
      .float32()
      .nullish()
      .describe("Numeric value 'domePressure' (floating point) for this 'GL_Valve_Data' row."),
    entityName: z
      .lazy(() => StringAssetSchema.nullish())
      .describe("Reference to the related 'String_asset' entity for this 'GL_Valve_Data' row."),
    field: z
      .lazy(() => FieldSchema.nullish())
      .describe("Reference to the related 'Field' entity for this 'GL_Valve_Data' row."),
    gasLiftMandrel: z
      .number()
      .nullish()
      .describe("Numeric value 'gasLiftMandrel' (integer) for this 'GL_Valve_Data' row."),
    glPortSize: z.number().nullish().describe("Numeric value 'glPortSize' (integer) for this 'GL_Valve_Data' row."),
    glValveMaterial: z.string().nullish().describe("Text attribute 'glValveMaterial' for this 'GL_Valve_Data' row."),
    glValveOrificeSeries: z
      .string()
      .nullish()
      .describe("Text attribute 'glValveOrificeSeries' for this 'GL_Valve_Data' row."),
    glValveSize: z
      .float32()
      .nullish()
      .describe("Numeric value 'glValveSize' (floating point) for this 'GL_Valve_Data' row."),
    installationDate: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'installationDate' associated with this 'GL_Valve_Data' row."),
    measuredDepth: z
      .float32()
      .nullish()
      .describe("Numeric value 'measuredDepth' (floating point) for this 'GL_Valve_Data' row."),
    rValue: z.number().nullish().describe("Numeric value 'rValue' (floating point) for this 'GL_Valve_Data' row."),
    testRackOpeningPressure: z
      .float32()
      .nullish()
      .describe("Numeric value 'testRackOpeningPressure' (floating point) for this 'GL_Valve_Data' row."),
    trueVerticalDepth: z
      .float32()
      .nullish()
      .describe("Numeric value 'trueVerticalDepth' (floating point) for this 'GL_Valve_Data' row."),
    type: z.string().nullish().describe("Text attribute 'type' for this 'GL_Valve_Data' row."),
  })
  .describe("View 'GL_Valve_Data' in the iPSO production optimization solution data model.");

export const FormationVolumeFactorSchema: z.ZodObject<Properties<FormationVolumeFactor>> = z
  .object({
    __typename: z.literal('Formation_Volume_Factor').optional(),
    bCO2: z
      .float32()
      .nullish()
      .describe("Numeric value 'bCO2' (floating point) for this 'Formation_Volume_Factor' row."),
    bGas: z
      .float32()
      .nullish()
      .describe("Numeric value 'bGas' (floating point) for this 'Formation_Volume_Factor' row."),
    bGasInjector: z
      .float32()
      .nullish()
      .describe("Numeric value 'bGasInjector' (floating point) for this 'Formation_Volume_Factor' row."),
    bOil: z
      .float32()
      .nullish()
      .describe("Numeric value 'bOil' (floating point) for this 'Formation_Volume_Factor' row."),
    bWater: z
      .float32()
      .nullish()
      .describe("Numeric value 'bWater' (floating point) for this 'Formation_Volume_Factor' row."),
    bWaterInjector: z
      .float32()
      .nullish()
      .describe("Numeric value 'bWaterInjector' (floating point) for this 'Formation_Volume_Factor' row."),
    effectiveDate: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'effectiveDate' associated with this 'Formation_Volume_Factor' row."),
    entityName: z
      .lazy(() => StringAssetSchema.nullish())
      .describe("Reference to the related 'String_asset' entity for this 'Formation_Volume_Factor' row."),
    pb: z.float32().nullish().describe("Numeric value 'pb' (floating point) for this 'Formation_Volume_Factor' row."),
    pressure: z
      .float32()
      .nullish()
      .describe("Numeric value 'pressure' (floating point) for this 'Formation_Volume_Factor' row."),
    reservoir: z
      .lazy(() => ReservoirSchema.nullish())
      .describe("Reference to the related 'Reservoir' entity for this 'Formation_Volume_Factor' row."),
    rs: z.float32().nullish().describe("Numeric value 'rs' (floating point) for this 'Formation_Volume_Factor' row."),
    temperature: z
      .float32()
      .nullish()
      .describe("Numeric value 'temperature' (floating point) for this 'Formation_Volume_Factor' row."),
  })
  .describe("View 'Formation_Volume_Factor' in the iPSO production optimization solution data model.");

export const FlowAssuranceAlarmsAgentSchema: z.ZodObject<Properties<FlowAssuranceAlarmsAgent>> = z
  .object({
    __typename: z.literal('FlowAssuranceAlarms_Agent').optional(),
    alarmCategory: z.string().nullish(),
    alarmCode: z.json().nullish(),
    alarmCodeExternalId: z.string().nullish(),
    alarmCriticality: z.string().nullish(),
    alarmFlags: z.string().nullish(),
    alarmName: z.string().nullish(),
    alarmPriority: z.string().nullish(),
    customWorkflowAlarmMessage: z.string().nullish(),
    endDateTime: z.coerce.date<Date>().nullish(),
    entityExternalId: z.string(),
    entityName: z.string(),
    entityType: z.string(),
    startDateTime: z.coerce.date<Date>(),
    subCategory: z.string().nullish(),
    subWorkflowName: z.string().nullish(),
    wellString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe('Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context.'),
    workflowCode: z.string().nullish(),
    workflowName: z.string().nullish(),
  })
  .describe(
    'Flow assurance detection and mitigation alarms with medium or high priority.\n\nContains flow assurance alarms, medium or high priority, sourced from\noperational monitoring systems within petroleum production environments.\nAnswers questions on the frequency, duration, and types of alarms triggered,\nto assess mitigation and prioritize responses. Excludes low-priority or non-WF20 alarms.\n\nUse for: Flow Assurance Detection and Mitigation (WF20), Real-Time Surveillance (WF18).\n\n@name Flow Assurance Alarms (Agent)',
  );

export const FlatHierarchyAgentSchema: z.ZodObject<Properties<FlatHierarchyAgent>> = z
  .object({
    __typename: z.literal('FlatHierarchy_Agent').optional(),
    asset: z.lazy(() => AssetSchema.nullish()).describe('Operating concession or business unit.'),
    company: z
      .lazy(() => CompanySchema.nullish())
      .describe('Top-level parent entity, e.g. ADNOC ONSHORE, ADNOC OFFSHORE.'),
    endDateTime: z.coerce.date<Date>().nullish().describe('Timestamp at which this hierarchy relationship ended.'),
    field: z.lazy(() => FieldSchema.nullish()).describe('Oil or gas field containing the well.'),
    location: z
      .lazy(() => LocationSchema.nullish())
      .describe(
        'Surface infrastructure where the well connects, such as cluster, platform, manifold, drilling island, or onshore facility.',
      ),
    reservoir: z
      .lazy(() => ReservoirSchema.nullish())
      .describe('Subsurface reservoir formation the string produces from.'),
    startDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('Timestamp at which this hierarchy relationship became effective.'),
    string: z
      .lazy(() => StringAssetSchema.nullish())
      .describe('Completion or producing interval within the well. Leaf entity of this view; one row per string.'),
    well: z.lazy(() => WellSchema.nullish()).describe('Physical wellbore. A well may contain multiple strings.'),
  })
  .describe(
    'Flattened company → asset → field → reservoir → location → well → string\nhierarchy, scoped to in-scope assets.\n\nOne row per string with its full ancestry across the production hierarchy\nand the effective date range of that relationship. Sourced from the base\nFlatHierarchy and refined via the in_scope_asset_node_refs configuration.\nExcludes operational or measurement data.\n\n@name FlatHierarchy (Agent Scoped)',
  );

export const FlatHierarchySchema: z.ZodObject<Properties<FlatHierarchy>> = z
  .object({
    __typename: z.literal('FlatHierarchy').optional(),
    asset: z
      .lazy(() => AssetSchema.nullish())
      .describe(
        'Operating concession or business unit. Groups multiple fields. Filter here to scope queries to a specific asset.',
      ),
    company: z
      .lazy(() => CompanySchema.nullish())
      .describe(
        'Top-level parent entity (e.g., ADNOC ONSHORE, ADNOC OFFSHORE). Access company.name for the company name.',
      ),
    endDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe(
        'When this hierarchy relationship ended. NULL = currently active. For current hierarchy only, filter where endDateTime is null.',
      ),
    field: z
      .lazy(() => FieldSchema.nullish())
      .describe(
        'Oil/gas field containing the well. Common filter target for field-level queries. Each field contains multiple wells and reservoirs.',
      ),
    location: z
      .lazy(() => LocationSchema.nullish())
      .describe(
        'Surface infrastructure where the well connects (platform, manifold, drilling island, or onshore facility). Filter here to find all wells at a specific location.',
      ),
    reservoir: z
      .lazy(() => ReservoirSchema.nullish())
      .describe(
        'Subsurface reservoir formation the string produces from. Multiple strings can target the same reservoir. Filter here to analyze reservoir-level production.',
      ),
    startDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe(
        'When this hierarchy relationship became effective. Used for temporal queries when hierarchy changes over time (e.g., well transferred between fields).',
      ),
    string: z
      .lazy(() => StringAssetSchema.nullish())
      .describe(
        'Completion/producing interval within the well. The LEAF ENTITY of this view - each row represents exactly one string. This is the entity that has production data (oil, gas, water rates). Use string.name for string identifier.',
      ),
    well: z
      .lazy(() => WellSchema.nullish())
      .describe(
        'Physical wellbore containing this string. A well may have multiple strings (completions). Use well.name for well identifier. Filter here to find all strings in a specific well.',
      ),
  })
  .describe(
    "DENORMALIZED HIERARCHY LOOKUP TABLE - Primary view for navigating the asset hierarchy.\n\nSTRUCTURE: Each row = one String (completion) with all its parent entities pre-joined.\nHierarchy: Company â†’ Asset â†’ Field â†’ Reservoir/Location â†’ Well â†’ String\n\nWHY USE THIS: Avoids complex multi-hop joins. Query ANY hierarchy relationship in a single step.\n\nQUERY PATTERNS:\n- Find wells in a field: Filter field.name = 'X', select well\n- Find strings in a reservoir: Filter reservoir.name = 'Y', select string  \n- Find fields in an asset: Filter asset.name = 'A', select DISTINCT field\n- Find parent of any entity: Filter on child, select parent property\n\nKEY BEHAVIORS:\n- One row per string means parent entities repeat (use DISTINCT for unique parents)\n- References return full entity objects - access .name, .externalId, etc.\n- Use startDateTime/endDateTime for historical hierarchy lookups",
  );

export const EspPumpDetailsSchema: z.ZodObject<Properties<EspPumpDetails>> = z
  .object({
    __typename: z.literal('ESP_Pump_Details').optional(),
    adcoInstallation: z
      .float32()
      .nullish()
      .describe("Numeric value 'adcoInstallation' (floating point) for this 'ESP_Pump_Details' row."),
    aghMatl: z.string().nullish().describe("Text attribute 'aghMatl' for this 'ESP_Pump_Details' row."),
    aghModel: z.string().nullish().describe("Text attribute 'aghModel' for this 'ESP_Pump_Details' row."),
    agh_nORu: z.string().nullish().describe("Text attribute 'agh_nORu' for this 'ESP_Pump_Details' row."),
    bohMatl: z.string().nullish().describe("Text attribute 'bohMatl' for this 'ESP_Pump_Details' row."),
    bohSeries: z
      .float32()
      .nullish()
      .describe("Numeric value 'bohSeries' (floating point) for this 'ESP_Pump_Details' row."),
    bohThd: z.string().nullish().describe("Text attribute 'bohThd' for this 'ESP_Pump_Details' row."),
    cableSize: z
      .float32()
      .nullish()
      .describe("Numeric value 'cableSize' (floating point) for this 'ESP_Pump_Details' row."),
    cableTotalLength: z
      .float32()
      .nullish()
      .describe("Numeric value 'cableTotalLength' (floating point) for this 'ESP_Pump_Details' row."),
    cableType: z.string().nullish().describe("Text attribute 'cableType' for this 'ESP_Pump_Details' row."),
    cable_nORu: z.string().nullish().describe("Text attribute 'cable_nORu' for this 'ESP_Pump_Details' row."),
    comments: z.string().nullish().describe("Text attribute 'comments' for this 'ESP_Pump_Details' row."),
    commissionDate: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'commissionDate' associated with this 'ESP_Pump_Details' row."),
    entityName: z
      .lazy(() => StringAssetSchema.nullish())
      .describe("Reference to the related 'String_asset' entity for this 'ESP_Pump_Details' row."),
    espComponent: z.string().nullish().describe("Text attribute 'espComponent' for this 'ESP_Pump_Details' row."),
    espSensorDepth_MD_ft: z
      .float32()
      .nullish()
      .describe("Numeric value 'espSensorDepth_MD_ft' (floating point) for this 'ESP_Pump_Details' row."),
    espSensorDepth_TVD_ft: z
      .float32()
      .nullish()
      .describe("Numeric value 'espSensorDepth_TVD_ft' (floating point) for this 'ESP_Pump_Details' row."),
    field: z
      .lazy(() => FieldSchema.nullish())
      .describe("Reference to the related 'Field' entity for this 'ESP_Pump_Details' row."),
    intakeVgsaMatl: z.string().nullish().describe("Text attribute 'intakeVgsaMatl' for this 'ESP_Pump_Details' row."),
    intakeVgsaModel: z.string().nullish().describe("Text attribute 'intakeVgsaModel' for this 'ESP_Pump_Details' row."),
    intakeVgsaSeries: z
      .float32()
      .nullish()
      .describe("Numeric value 'intakeVgsaSeries' (floating point) for this 'ESP_Pump_Details' row."),
    intakeVgsa_nORu: z.string().nullish().describe("Text attribute 'intakeVgsa_nORu' for this 'ESP_Pump_Details' row."),
    mle: z.float32().nullish().describe("Numeric value 'mle' (floating point) for this 'ESP_Pump_Details' row."),
    mleSeries: z
      .float32()
      .nullish()
      .describe("Numeric value 'mleSeries' (floating point) for this 'ESP_Pump_Details' row."),
    mleType: z.string().nullish().describe("Text attribute 'mleType' for this 'ESP_Pump_Details' row."),
    monitorType: z.string().nullish().describe("Text attribute 'monitorType' for this 'ESP_Pump_Details' row."),
    monitor_nORu: z.string().nullish().describe("Text attribute 'monitor_nORu' for this 'ESP_Pump_Details' row."),
    motorA: z.float32().nullish().describe("Numeric value 'motorA' (floating point) for this 'ESP_Pump_Details' row."),
    motorHsg: z
      .float32()
      .nullish()
      .describe("Numeric value 'motorHsg' (floating point) for this 'ESP_Pump_Details' row."),
    motorMatl: z.string().nullish().describe("Text attribute 'motorMatl' for this 'ESP_Pump_Details' row."),
    motorRefW: z
      .float32()
      .nullish()
      .describe("Numeric value 'motorRefW' (floating point) for this 'ESP_Pump_Details' row."),
    motorSeries: z
      .float32()
      .nullish()
      .describe("Numeric value 'motorSeries' (floating point) for this 'ESP_Pump_Details' row."),
    motorTotalPower: z
      .float32()
      .nullish()
      .describe("Numeric value 'motorTotalPower' (floating point) for this 'ESP_Pump_Details' row."),
    motorTotalV: z
      .float32()
      .nullish()
      .describe("Numeric value 'motorTotalV' (floating point) for this 'ESP_Pump_Details' row."),
    motor_nORu: z.string().nullish().describe("Text attribute 'motor_nORu' for this 'ESP_Pump_Details' row."),
    nORu: z.string().nullish().describe("Text attribute 'nORu' for this 'ESP_Pump_Details' row."),
    numberOfPoles: z
      .number()
      .nullish()
      .describe("Numeric value 'numberOfPoles' (integer) for this 'ESP_Pump_Details' row."),
    packer: z.string().nullish().describe("Text attribute 'packer' for this 'ESP_Pump_Details' row."),
    panelVsdA: z
      .float32()
      .nullish()
      .describe("Numeric value 'panelVsdA' (floating point) for this 'ESP_Pump_Details' row."),
    panelVsdKVA: z
      .float32()
      .nullish()
      .describe("Numeric value 'panelVsdKVA' (floating point) for this 'ESP_Pump_Details' row."),
    panelVsdType: z.string().nullish().describe("Text attribute 'panelVsdType' for this 'ESP_Pump_Details' row."),
    protectorMatl: z.string().nullish().describe("Text attribute 'protectorMatl' for this 'ESP_Pump_Details' row."),
    protectorModel: z.string().nullish().describe("Text attribute 'protectorModel' for this 'ESP_Pump_Details' row."),
    protectorSeries: z
      .float32()
      .nullish()
      .describe("Numeric value 'protectorSeries' (floating point) for this 'ESP_Pump_Details' row."),
    protector_nORu: z.string().nullish().describe("Text attribute 'protector_nORu' for this 'ESP_Pump_Details' row."),
    pullDate: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'pullDate' associated with this 'ESP_Pump_Details' row."),
    pullReason: z.string().nullish().describe("Text attribute 'pullReason' for this 'ESP_Pump_Details' row."),
    pumpAr: z.string().nullish().describe("Text attribute 'pumpAr' for this 'ESP_Pump_Details' row."),
    pumpHsg: z
      .float32()
      .nullish()
      .describe("Numeric value 'pumpHsg' (floating point) for this 'ESP_Pump_Details' row."),
    pumpMatl: z.string().nullish().describe("Text attribute 'pumpMatl' for this 'ESP_Pump_Details' row."),
    pumpModel: z.string().nullish().describe("Text attribute 'pumpModel' for this 'ESP_Pump_Details' row."),
    pumpSeries: z
      .float32()
      .nullish()
      .describe("Numeric value 'pumpSeries' (floating point) for this 'ESP_Pump_Details' row."),
    pump_nORu: z.string().nullish().describe("Text attribute 'pump_nORu' for this 'ESP_Pump_Details' row."),
    rootCause: z.string().nullish().describe("Text attribute 'rootCause' for this 'ESP_Pump_Details' row."),
    runDate: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'runDate' associated with this 'ESP_Pump_Details' row."),
    status: z.string().nullish().describe("Text attribute 'status' for this 'ESP_Pump_Details' row."),
    stopORfailureDate: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'stopORfailureDate' associated with this 'ESP_Pump_Details' row."),
    supplyCompany: z.string().nullish().describe("Text attribute 'supplyCompany' for this 'ESP_Pump_Details' row."),
    tol_MD: z.float32().nullish().describe("Numeric value 'tol_MD' (floating point) for this 'ESP_Pump_Details' row."),
    tol_TVD: z
      .float32()
      .nullish()
      .describe("Numeric value 'tol_TVD' (floating point) for this 'ESP_Pump_Details' row."),
    topReservoirDepth_MD: z
      .float32()
      .nullish()
      .describe("Numeric value 'topReservoirDepth_MD' (floating point) for this 'ESP_Pump_Details' row."),
    topReservoirDepth_TVD: z
      .float32()
      .nullish()
      .describe("Numeric value 'topReservoirDepth_TVD' (floating point) for this 'ESP_Pump_Details' row."),
    totalStages: z
      .float32()
      .nullish()
      .describe("Numeric value 'totalStages' (floating point) for this 'ESP_Pump_Details' row."),
    transformerA: z
      .float32()
      .nullish()
      .describe("Numeric value 'transformerA' (floating point) for this 'ESP_Pump_Details' row."),
    transformerComments: z
      .string()
      .nullish()
      .describe("Text attribute 'transformerComments' for this 'ESP_Pump_Details' row."),
    transformerKVA: z
      .float32()
      .nullish()
      .describe("Numeric value 'transformerKVA' (floating point) for this 'ESP_Pump_Details' row."),
    transformerTapSetting: z
      .string()
      .nullish()
      .describe("Text attribute 'transformerTapSetting' for this 'ESP_Pump_Details' row."),
    transformerVoltageRatio: z
      .float32()
      .nullish()
      .describe("Numeric value 'transformerVoltageRatio' (floating point) for this 'ESP_Pump_Details' row."),
    wellInstallationNumber: z
      .float32()
      .nullish()
      .describe("Numeric value 'wellInstallationNumber' (floating point) for this 'ESP_Pump_Details' row."),
    yTool: z.string().nullish().describe("Text attribute 'yTool' for this 'ESP_Pump_Details' row."),
  })
  .describe("View 'ESP_Pump_Details' in the iPSO production optimization solution data model.");

export const EspCurveDataStringAgentSchema: z.ZodObject<Properties<EspCurveDataStringAgent>> = z
  .object({
    __typename: z.literal('ESPCurveData_String_Agent').optional(),
    wellString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe('Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context.'),
  })
  .describe(
    'JSON plot/curve file references per well string from WF12.\n\nContains file pointers to specialised JSON curve outputs generated during\nESP and motor performance diagnostics (WF12). Covers the gradient plot\n(pressure vs depth) produced by the ESP model run. All files are JSON and\ncannot be represented as scalar timeseries values.\n\nUse with ESPMeasurements_String_Agent and ESPCalculations_String_Agent for\nfull WF12 ESP diagnostics including live sensor data and calculated outputs.\n\nUse for: ESP and Motor Performance and Diagnostics (WF12).\n\n@name ESP Curve Data - String (Agent)',
  );

export const EspAlarmsAgentSchema: z.ZodObject<Properties<EspAlarmsAgent>> = z
  .object({
    __typename: z.literal('ESPAlarms_Agent').optional(),
    alarmCategory: z.string().nullish().describe('Alarm category (ESP).'),
    alarmCode: z.json().nullish().describe('Reference to AlarmDefinition node.'),
    alarmCodeExternalId: z.string().nullish().describe('Alarm code identifier (WF12-001, WF12-002, etc.).'),
    alarmCounter: z.number().nullish().describe('Count of how many times this alarm has occurred.'),
    alarmCriticality: z.string().nullish().describe('Alarm criticality level. Pre-filtered to 2 and 3.'),
    alarmFlags: z.string().nullish().describe("Alarm validity flag. Pre-filtered to 'Valid'."),
    alarmName: z.string().nullish().describe('Human-readable alarm name from AlarmDefinition.'),
    alarmPriority: z.string().nullish().describe('Alarm priority level. Pre-filtered to Medium and High.'),
    customWorkflowAlarmMessage: z
      .string()
      .nullish()
      .describe('Detailed alarm message with specific conditions that triggered it.'),
    endDateTime: z.coerce
      .date<Date>()
      .nullish()
      .describe('When the alarm was cleared. Null means alarm is still active.'),
    entityExternalId: z.string().describe('External ID of the entity for joining to other views.'),
    entityName: z.string().describe('Display name of the entity (well, string) with the alarm.'),
    entityType: z.string().describe('Type of entity (string, well, field).'),
    startDateTime: z.coerce.date<Date>().describe('When the alarm was triggered.'),
    subCategory: z.string().nullish().describe('Alarm sub-category for domain filtering.'),
    subWorkflowName: z.string().nullish().describe('Sub-workflow that generated the alarm.'),
    ticketId: z.string().nullish().describe('Associated troubleshooting ticket ID if one was created.'),
    wellString: z.lazy(() => StringAssetSchema.nullish()),
    workflowCode: z.string().nullish().describe('Workflow code (WF12 for ESP).'),
    workflowName: z.string().nullish().describe('Workflow name from AlarmDefinition.'),
  })
  .describe(
    'ESP and motor performance alarms (WF12) with medium or high priority.\n\nContains alarms generated by Electric Submersible Pumps (ESPs) and associated\nmotors, medium and high-priority alarms as part of the WF12 workflow. Sourced\nfrom operational monitoring systems that track ESP performance and\ndiagnostics, to analyze alarm occurrences, their severity, and potential\nimpacts on production. It can answer questions regarding the frequency and\ntypes of alarms, trends in alarm priorities, and the relationship between\nalarm occurrences and operational performance. Excludes low-priority or non-WF12 alarms.\n\nUse for: ESP and Motor Performance and Diagnostics (WF12), Real-Time Surveillance (WF18).\n\n@name ESP Alarms (Agent)',
  );

export const TimeSeriesSchema: z.ZodObject<Properties<TimeSeries>> = z.object({
  __typename: z.literal('TimeSeries').optional(),
  externalId: z.string().nullish(),
  id: z.int32().nullish(),
});

export const Wf3OutputsStringSchema: z.ZodObject<Properties<Wf3OutputsString>> = z
  .object({
    __typename: z.literal('Wf3Outputs_String').optional(),
    calibrationAlarmCode: z.lazy(() => TimeSeriesSchema.nullish()),
    chokeBestGor: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of choke best gasâ€“oil ratio (GOR) for this well string as estimated by the WF3 well model.',
      ),
    chokeBestWc: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of choke best wc for this well string as estimated by the WF3 well model.'),
    chokeBestWgr: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of choke best wgr for this well string as estimated by the WF3 well model.'),
    entityName: z
      .lazy(() => StringAssetSchema.nullish())
      .describe(
        "Name of the well string (completion) for which WF3 model outputs are generated, sourced from the 'String_asset' view.",
      ),
    modelEspWf: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of model electric submersible pump (ESP) wf for this well string as estimated by the WF3 well model.',
      ),
    modelEspWfPercentChange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of model electric submersible pump (ESP) wf percent change for this well string as estimated by the WF3 well model.',
      ),
    modelEstimatedFbhp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of model estimated flowing bottom-hole pressure (FBHP) for this well string as estimated by the WF3 well model.',
      ),
    modelEstimatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of model estimated gas rate for this well string as estimated by the WF3 well model.'),
    modelEstimatedLiquidRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of model estimated liquid rate for this well string as estimated by the WF3 well model.'),
    modelEstimatedOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of model estimated oil rate for this well string as estimated by the WF3 well model.'),
    modelEstimatedPdgPress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of model estimated pdg press for this well string as estimated by the WF3 well model.'),
    modelEstimatedPdp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of model estimated pdp for this well string as estimated by the WF3 well model.'),
    modelEstimatedPip: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of model estimated pip for this well string as estimated by the WF3 well model.'),
    modelEstimatedWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of model estimated water rate for this well string as estimated by the WF3 well model.'),
    modelGlOrificeSize: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of model gas lift (GL) orifice size for this well string as estimated by the WF3 well model.',
      ),
    modelGlOrificeSizePercentChange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of model gas lift (GL) orifice size percent change for this well string as estimated by the WF3 well model.',
      ),
    modelInjectivityIndex: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of modelled well injectivity index for this string as estimated in WF3.'),
    modelInjectivityIndexPercentChange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of model injectivity index percent change for this well string as estimated by the WF3 well model.',
      ),
    modelIprC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of model inflow performance relationship (IPR) c for this well string as estimated by the WF3 well model.',
      ),
    modelIprN: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of model inflow performance relationship (IPR) n for this well string as estimated by the WF3 well model.',
      ),
    modelMatchStatus: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of model match status for this well string as estimated by the WF3 well model.'),
    modelMinStableRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of minimum stable liquid production rate for which the WF3 model predicts stable operation for this string.',
      ),
    modelNewFileId: z
      .int64()
      .nullish()
      .describe('Identifier of the updated or calibrated model file produced by WF3 for this string.'),
    modelOriginalFileId: z
      .int64()
      .nullish()
      .describe('Identifier of the original input model file used for WF3 simulations for this string.'),
    modelProductivityIndex: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of modelled well productivity index (PI) for this string as estimated in WF3.'),
    modelProductivityIndexPercentChange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of model productivity index percent change for this well string as estimated by the WF3 well model.',
      ),
    modelReservoirModel: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series reference to the selected reservoir model or scenario used in WF3 for this string.'),
    modelReservoirPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of modelled average reservoir pressure used in WF3 computations for this string.'),
    modelReservoirPressurePercentChange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of model reservoir pressure percent change for this well string as estimated by the WF3 well model.',
      ),
    modelRevisionExternalId: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of model revision external id for this well string as estimated by the WF3 well model.'),
    modelRevisionNumber: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of model revision number for this well string as estimated by the WF3 well model.'),
    modelStabilityFlag: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series flag indicating stability of the WF3 solution for this string (for example stable versus unstable operating point).',
      ),
    modelStatus: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of model status for this well string as estimated by the WF3 well model.'),
    modelUval: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of overall heat-transfer coefficient (U-value) or similar model parameter used in WF3 for this string.',
      ),
    modelVlpCorrelation: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of model vertical lift performance (VLP) correlation for this well string as estimated by the WF3 well model.',
      ),
    modelVlpModel: z.coerce
      .date<Date>()
      .nullish()
      .describe(
        'Timestamp or identifier associated with the vertical lift performance (VLP) model version used in WF3 for this string.',
      ),
    modelVlpParameter1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of model vertical lift performance (VLP) parameter1 for this well string as estimated by the WF3 well model.',
      ),
    modelVlpParameter1PercentChange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of model vertical lift performance (VLP) parameter1 percent change for this well string as estimated by the WF3 well model.',
      ),
    modelVlpParameter2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of model vertical lift performance (VLP) parameter2 for this well string as estimated by the WF3 well model.',
      ),
    modelVlpParameter2PercentChange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of model vertical lift performance (VLP) parameter2 percent change for this well string as estimated by the WF3 well model.',
      ),
    modelWellTestChp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of model well test chp for this well string as estimated by the WF3 well model.'),
    modelWellTestEspFrequency: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of model well test electric submersible pump (ESP) frequency for this well string as estimated by the WF3 well model.',
      ),
    modelWellTestGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of model well test gas rate for this well string as estimated by the WF3 well model.'),
    modelWellTestGlInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of model well test gas lift (GL) injection for this well string as estimated by the WF3 well model.',
      ),
    modelWellTestGor: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of model well test gasâ€“oil ratio (GOR) for this well string as estimated by the WF3 well model.',
      ),
    modelWellTestLiquidRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of model well test liquid rate for this well string as estimated by the WF3 well model.'),
    modelWellTestPdgPress: z.lazy(() => TimeSeriesSchema.nullish()).describe('PDG - permanent downhole gauge'),
    modelWellTestTimestamp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of model well test timestamp for this well string as estimated by the WF3 well model.'),
    modelWellTestWc: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of model well test wc for this well string as estimated by the WF3 well model.'),
    modelWellTestWhp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of model well test whp for this well string as estimated by the WF3 well model.'),
    newFileId: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of new file id for this well string as estimated by the WF3 well model.'),
    originalFileId: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of original file id for this well string as estimated by the WF3 well model.'),
    vlpBestGor: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of vertical lift performance (VLP) best gasâ€“oil ratio (GOR) for this well string as estimated by the WF3 well model.',
      ),
    vlpBestWc: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of vertical lift performance (VLP) best wc for this well string as estimated by the WF3 well model.',
      ),
    vlpBestWgr: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of vertical lift performance (VLP) best wgr for this well string as estimated by the WF3 well model.',
      ),
  })
  .describe(
    'WF3 well string model outputs and configuration identifiers, including productivity and injectivity indices, modelled reservoir pressures, minimum stable rates and links to the underlying reservoir and VLP model versions used for simulation and calibration.',
  );

export const WellChokeMappingSchema: z.ZodObject<Properties<WellChokeMapping>> = z
  .object({
    __typename: z.literal('Well_Choke_Mapping').optional(),
    choketype: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'choketype' in this 'Well_Choke_Mapping' view."),
    entityName: z
      .lazy(() => StringAssetSchema.nullish())
      .describe("Reference to the related 'String_asset' entity for this 'Well_Choke_Mapping' row."),
    gasLiftChokeType: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gasLiftChokeType' in this 'Well_Choke_Mapping' view."),
  })
  .describe("View 'Well_Choke_Mapping' in the iPSO production optimization solution data model.");

export const WellTestReservoirAnalysisAgentSchema: z.ZodObject<Properties<WellTestReservoirAnalysisAgent>> = z
  .object({
    __typename: z.literal('WellTest_ReservoirAnalysis_Agent').optional(),
    modelInjectivityIndex: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        '  Injectivity Index - II (bbl/d/psi, TS). For water/gas injectors.\n  II = Qinj / (Pwf - Pr). HIGHER II = better injection efficiency.\n\n@name injectivityIndex',
      ),
    modelInjectivityIndexPercentChange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        '  Percent change in II from previous test (%, TS).\n  Declining II may indicate: formation damage, scale, or plugging.\n\n@name iiPercentChange',
      ),
    modelMinStableRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('  Minimum rate for stable flow (stb/d, TS). Below this = slugging risk.\n\n@name minimumStableRate'),
    modelProductivityIndex: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        '  Productivity Index - PI (stb/d/psi, TS). \n  PI = Q / (Pr - Pwf) where Q=liquid rate, Pr=reservoir pressure, Pwf=flowing BHP.\n  HIGHER PI = better reservoir deliverability.\n  Compare across wells in same reservoir for benchmarking.\n\n@name productivityIndex',
      ),
    modelProductivityIndexPercentChange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        '  Percent change in PI from previous accepted test (%, TS).\n  NEGATIVE = PI declined (possible causes: scale, skin, depletion).\n  > -20% decline warrants investigation.\n\n@name piPercentChange',
      ),
    modelReservoirPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        '  Static reservoir pressure from analysis (psia, TS).\n  Declining Pres = depletion. Compare to neighboring wells for aquifer/pressure support.\n\n@name reservoirPressure',
      ),
    modelReservoirPressurePercentChange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        '  Percent change in reservoir pressure (%, TS).\n  Rapid decline may indicate: poor sweep, inadequate injection support.\n\n@name reservoirPressureChange',
      ),
    modelStabilityFlag: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        '  Is well operating in stable regime? (TS). STABLE, UNSTABLE, TRANSIENT.\n  Unstable wells may have PI calculation issues.\n\n@name stabilityFlag',
      ),
    modelStatus: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        '  Status of analysis result (TS). ACCEPTED, PENDING, REJECTED.\n  Only use ACCEPTED results for reservoir surveillance.\n\n@name analysisStatus',
      ),
    modelWellTestTimestamp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('  When this analysis was performed (TS). Use to check analysis freshness.\n\n@name analysisTimestamp'),
    wellString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe('Reference to well string. Join to FlatHierarchy_Agent for reservoir grouping.'),
  })
  .describe(
    'Reservoir performance from well test analysis including PI, II, and reservoir\npressure.\n\nContains data derived from well test analyses, focusing on key performance\nindicators such as the Productivity Index (PI), Injectivity Index (II), and\nreservoir pressure metrics. Sourced from field tests conducted on production\nand injection wells, allowing for the assessment of reservoir deliverability\nand performance over time. It answers critical questions regarding changes in\nPI, reservoir pressure trends, and the efficiency of reservoir depletion, but\nexcludes detailed geological data or historical production rates found in\nother views. Use cases: monitoring reservoir performance, identifying wells\nwith declining efficiency, and comparing performance across different fields.\n\n@name Well Test Reservoir Analysis (Agent)',
  );

export const WellTestRawSchema: z.ZodObject<Properties<WellTestRaw>> = z
  .object({
    __typename: z.literal('WellTest_Raw').optional(),
    comments: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'comments' in this 'WellTest_Raw' view."),
    composition: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'composition' in this 'WellTest_Raw' view."),
    entityName: z
      .lazy(() => StringAssetSchema.nullish())
      .describe("Reference to the related 'String_asset' entity for this 'WellTest_Raw' row."),
    fluidProperties: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fluidProperties' in this 'WellTest_Raw' view."),
    modelComposition: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelComposition' in this 'WellTest_Raw' view."),
    ptsDateTime: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'ptsDateTime' in this 'WellTest_Raw' view."),
    sampleDateTime: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'sampleDateTime' in this 'WellTest_Raw' view."),
    stablePeriodEndDate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'stablePeriodEndDate' in this 'WellTest_Raw' view."),
    stablePeriodStartDate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'stablePeriodStartDate' in this 'WellTest_Raw' view."),
    validatedBy: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'validatedBy' in this 'WellTest_Raw' view."),
    wellTestApprovedAllocationFlag: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestApprovedAllocationFlag' in this 'WellTest_Raw' view."),
    wellTestArtificialLiftType: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestArtificialLiftType' in this 'WellTest_Raw' view."),
    wellTestBottomHolePressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestBottomHolePressure' in this 'WellTest_Raw' view."),
    wellTestBottomHoleTemperature: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestBottomHoleTemperature' in this 'WellTest_Raw' view."),
    wellTestCGR: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestCGR' in this 'WellTest_Raw' view."),
    wellTestCasingHeadPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestCasingHeadPressure' in this 'WellTest_Raw' view."),
    wellTestCasingHeadTemperature: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestCasingHeadTemperature' in this 'WellTest_Raw' view."),
    wellTestChokeOpening: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestChokeOpening' in this 'WellTest_Raw' view."),
    wellTestChokeSize: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestChokeSize' in this 'WellTest_Raw' view."),
    wellTestDuration: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestDuration' in this 'WellTest_Raw' view."),
    wellTestEgorVendorStdGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestEgorVendorStdGasRate' in this 'WellTest_Raw' view."),
    wellTestEgorVendorStdOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestEgorVendorStdOilRate' in this 'WellTest_Raw' view."),
    wellTestEgorVendorStdWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestEgorVendorStdWaterRate' in this 'WellTest_Raw' view."),
    wellTestEndDate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestEndDate' in this 'WellTest_Raw' view."),
    wellTestEspMotorCurrent: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestEspMotorCurrent' in this 'WellTest_Raw' view."),
    wellTestEspMotorPower: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestEspMotorPower' in this 'WellTest_Raw' view."),
    wellTestEspMotorVoltage: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestEspMotorVoltage' in this 'WellTest_Raw' view."),
    wellTestEspPumpDischargePressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestEspPumpDischargePressure' in this 'WellTest_Raw' view."),
    wellTestEspPumpFrequency: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestEspPumpFrequency' in this 'WellTest_Raw' view."),
    wellTestEspPumpIntakePressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestEspPumpIntakePressure' in this 'WellTest_Raw' view."),
    wellTestEspPumpIntakeTemperature: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestEspPumpIntakeTemperature' in this 'WellTest_Raw' view."),
    wellTestFlowlinePressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestFlowlinePressure' in this 'WellTest_Raw' view."),
    wellTestFlowlineTemperature: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestFlowlineTemperature' in this 'WellTest_Raw' view."),
    wellTestGOR: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGOR' in this 'WellTest_Raw' view."),
    wellTestGasDensityInSitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGasDensityInSitu' in this 'WellTest_Raw' view."),
    wellTestGasLiftVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGasLiftVolume' in this 'WellTest_Raw' view."),
    wellTestGasRateInsitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGasRateInsitu' in this 'WellTest_Raw' view."),
    wellTestGasRatePts: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGasRatePts' in this 'WellTest_Raw' view."),
    wellTestGasRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGasRateStd' in this 'WellTest_Raw' view."),
    wellTestGlFlControlValvOutletPres: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGlFlControlValvOutletPres' in this 'WellTest_Raw' view."),
    wellTestGlFlControlValveInletPres: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGlFlControlValveInletPres' in this 'WellTest_Raw' view."),
    wellTestGlFlControlValveInletTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGlFlControlValveInletTemp' in this 'WellTest_Raw' view."),
    wellTestGlInjectionChokeOpening: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGlInjectionChokeOpening' in this 'WellTest_Raw' view."),
    wellTestGorInsitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGorInsitu' in this 'WellTest_Raw' view."),
    wellTestGorPts: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGorPts' in this 'WellTest_Raw' view."),
    wellTestLiquidRatePts: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestLiquidRatePts' in this 'WellTest_Raw' view."),
    wellTestMpfmName: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestMpfmName' in this 'WellTest_Raw' view."),
    wellTestOilDensityInSitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestOilDensityInSitu' in this 'WellTest_Raw' view."),
    wellTestOilRateInsitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestOilRateInsitu' in this 'WellTest_Raw' view."),
    wellTestOilRatePts: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestOilRatePts' in this 'WellTest_Raw' view."),
    wellTestOilRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestOilRateStd' in this 'WellTest_Raw' view."),
    wellTestStartDate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestStartDate' in this 'WellTest_Raw' view."),
    wellTestStringFunction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestStringFunction' in this 'WellTest_Raw' view."),
    wellTestTestMethod: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestTestMethod' in this 'WellTest_Raw' view."),
    wellTestTestSeparatorLinePressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestTestSeparatorLinePressure' in this 'WellTest_Raw' view."),
    wellTestTestSeparatorLineTemperature: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestTestSeparatorLineTemperature' in this 'WellTest_Raw' view."),
    wellTestTestType: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestTestType' in this 'WellTest_Raw' view."),
    wellTestTestTypeDesc: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestTestTypeDesc' in this 'WellTest_Raw' view."),
    wellTestTotalGorStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestTotalGorStd' in this 'WellTest_Raw' view."),
    wellTestTotalMassFlowRateGas: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestTotalMassFlowRateGas' in this 'WellTest_Raw' view."),
    wellTestTotalMassFlowRateOil: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestTotalMassFlowRateOil' in this 'WellTest_Raw' view."),
    wellTestTotalMassFlowRateWater: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestTotalMassFlowRateWater' in this 'WellTest_Raw' view."),
    wellTestValidationFlag: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestValidationFlag' in this 'WellTest_Raw' view."),
    wellTestWGR: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestWGR' in this 'WellTest_Raw' view."),
    wellTestWaterCut: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestWaterCut' in this 'WellTest_Raw' view."),
    wellTestWaterCutInsitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestWaterCutInsitu' in this 'WellTest_Raw' view."),
    wellTestWaterCutPts: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestWaterCutPts' in this 'WellTest_Raw' view."),
    wellTestWaterRateInsitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestWaterRateInsitu' in this 'WellTest_Raw' view."),
    wellTestWaterRatePts: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestWaterRatePts' in this 'WellTest_Raw' view."),
    wellTestWaterRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestWaterRateStd' in this 'WellTest_Raw' view."),
    wellTestWellheadPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestWellheadPressure' in this 'WellTest_Raw' view."),
    wellTestWellheadTemperature: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestWellheadTemperature' in this 'WellTest_Raw' view."),
  })
  .describe("View 'WellTest_Raw' in the iPSO production optimization solution data model.");

export const WellTestModelParametersAgentSchema: z.ZodObject<Properties<WellTestModelParametersAgent>> = z
  .object({
    __typename: z.literal('WellTest_ModelParameters_Agent').optional(),
    hasProsperModel: z
      .boolean()
      .nullish()
      .describe(
        'Flag indicating this string has an active Prosper model. True = model exists and\ncalibration outputs are available.',
      ),
    modelEspWf: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        '  ESP pump wear factor (TS). 1.0 = new pump performance.\n  < 0.7 indicates significant pump degradation - consider workover.\n  Track trend over time for predictive maintenance.\n\n@name espWearFactor',
      ),
    modelEspWfPercentChange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        '  Percent change in ESP wear factor (%, TS). Declining WF = pump wearing.\n\n@name espWearFactorChange',
      ),
    modelGlOrificeSize: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        '  Gas lift orifice size from model (inches, TS). Should match actual installed size.\n\n@name glOrificeSize',
      ),
    modelGlOrificeSizePercentChange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        '  Percent change in orifice size (%, TS). Large change may indicate multipoint issue.\n\n@name glOrificeSizeChange',
      ),
    modelIprC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        '  IPR C coefficient (TS). From backpressure equation: Q = C * (Pr² - Pwf²)^n.\n  Related to deliverability - higher C = better inflow.\n\n@name iprCoefficientC',
      ),
    modelIprN: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        '  IPR n exponent (TS). Typically 0.5 to 1.0.\n  n=1 = Darcy flow (linear). n<1 = non-Darcy/turbulent near wellbore.\n\n@name iprExponentN',
      ),
    modelMatchStatus: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        '  Indicates whether the well test rate was matched during the WF03 calibration process (TS).\n  Values: MATCHED, FAILED, MANUAL. Use to filter for successfully calibrated well tests.\n\n@name matchStatus',
      ),
    modelReservoirModel: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("  Reservoir model type used (TS). E.g., 'Vogel', 'Fetkovitch', 'Jones'.\n\n@name reservoirModelType"),
    modelRevisionNumber: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('  Prosper model revision number (TS). Track model updates.\n\n@name modelRevision'),
    modelUval: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        '  Overall heat transfer coefficient U-value (BTU/hr/ft2/degF, TS). Affects\n  temperature profile and flow assurance calculations.\n\n@name overallHeatTransferCoeff',
      ),
    modelVlpCorrelation: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "  VLP correlation used (TS). E.g., 'Beggs and Brill', 'Hagedorn Brown', 'Petroleum Experts'.\n  Different correlations work better for different conditions.\n\n@name vlpCorrelation",
      ),
    modelVlpParameter1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        '  VLP tuning parameter 1 (TS). Typically friction factor multiplier.\n  Together with modelMatchStatus, indicates whether the well test rate was successfully\n  matched during WF03 calibration. Values > 1.5 or < 0.5 may indicate model issues.\n\n@name vlpParameter1',
      ),
    modelVlpParameter1PercentChange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        '  Percent change in VLP parameter 1 (%, TS). Large changes may indicate tubing issues.\n\n@name vlpParam1Change',
      ),
    modelVlpParameter2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('  VLP tuning parameter 2 (TS). Typically holdup factor multiplier.\n\n@name vlpParameter2'),
    modelVlpParameter2PercentChange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('  Percent change in VLP parameter 2 (%, TS).\n\n@name vlpParam2Change'),
    modelWellTestEspFrequency: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('  ESP frequency during model match (Hz, TS). Reference point for analysis.\n\n@name espTestFrequency'),
    modelWellTestGlInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('  Gas lift injection rate used in model (MMscfd, TS).\n\n@name glInjectionRate'),
    prosperModelExternalId: z
      .string()
      .nullish()
      .describe(
        'External ID of the associated ProsperModel instance. Use to cross-reference with\nProsperModel_Agent for model metadata.',
      ),
    wellString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe('Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context.'),
  })
  .describe(
    'Prosper model tuning parameters from well test analysis including VLP, IPR,\nand ESP wear.\n\nContains detailed parameters derived from well test analysis, focusing on the\ntuning of Prosper models for various well types, including vertical lift\nperformance (VLP), inflow performance relationship (IPR), and electrical\nsubmersible pump (ESP) wear factors. Sourced from well test results and model\ncalibration processes, enabling production specialists to assess and optimize\nwell performance. It answers specific questions regarding the correlations and\nparameters used in VLP and IPR models, as well as the wear factors for ESP\nsystems, while it excludes raw test data or historical performance metrics\nfound in other views. Use cases: quality control of models, trend analysis for\nperformance optimization, and tracking pump degradation over time.\n\n@name Well Test Model Parameters (Agent)',
  );

export const WellTestOutputsStringSchema: z.ZodObject<Properties<WellTestOutputsString>> = z
  .object({
    __typename: z.literal('WellTestOutputs_String').optional(),
    cdValue: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'cdValue' in this 'WellTestOutputs_String' view."),
    cgrLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'cgrLC' in this 'WellTestOutputs_String' view."),
    cgrSC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'cgrSC' in this 'WellTestOutputs_String' view."),
    chokeAlarms: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'chokeAlarms' in this 'WellTestOutputs_String' view."),
    chokeAlarmsCode: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'chokeAlarmsCode' in this 'WellTestOutputs_String' view."),
    chokeMatchedgasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'chokeMatchedgasRate' in this 'WellTestOutputs_String' view."),
    chokeMatchedliquidRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'chokeMatchedliquidRate' in this 'WellTestOutputs_String' view."),
    chokeSize: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'chokeSize' in this 'WellTestOutputs_String' view."),
    chokeSizeInch: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'chokeSizeInch' in this 'WellTestOutputs_String' view."),
    chp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'chp' in this 'WellTestOutputs_String' view."),
    dhgp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'dhgp' in this 'WellTestOutputs_String' view."),
    dhgt: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'dhgt' in this 'WellTestOutputs_String' view."),
    entityName: z
      .lazy(() => StringAssetSchema.nullish())
      .describe(
        "Name of the well string (completion) for which well test results are stored in this view, sourced from the 'String_asset' view.",
      ),
    espwear: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'espwear' in this 'WellTestOutputs_String' view."),
    flp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'flp' in this 'WellTestOutputs_String' view."),
    flt: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'flt' in this 'WellTestOutputs_String' view."),
    gasDensityLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gasDensityLC' in this 'WellTestOutputs_String' view."),
    gasDensitySC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gasDensitySC' in this 'WellTestOutputs_String' view."),
    gasMassFlowRateLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gasMassFlowRateLC' in this 'WellTestOutputs_String' view."),
    gasMassFlowRateSC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gasMassFlowRateSC' in this 'WellTestOutputs_String' view."),
    gasRateLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gasRateLC' in this 'WellTestOutputs_String' view."),
    gasRateSC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of measured gas production rate at standard conditions during the well test.'),
    gasVolumeFractionLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gasVolumeFractionLC' in this 'WellTestOutputs_String' view."),
    glFcvChokeSize: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'glFcvChokeSize' in this 'WellTestOutputs_String' view."),
    glFcvInletPress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'glFcvInletPress' in this 'WellTestOutputs_String' view."),
    glFcvInletTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'glFcvInletTemp' in this 'WellTestOutputs_String' view."),
    glFcvOutletPress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'glFcvOutletPress' in this 'WellTestOutputs_String' view."),
    glFcvOutletTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'glFcvOutletTemp' in this 'WellTestOutputs_String' view."),
    glinjectionRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'glinjectionRate' in this 'WellTestOutputs_String' view."),
    gorLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gorLC' in this 'WellTestOutputs_String' view."),
    historicalAlarms: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'historicalAlarms' in this 'WellTestOutputs_String' view."),
    historicalAlarmsCode: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'historicalAlarmsCode' in this 'WellTestOutputs_String' view."),
    liquidRateLc: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'liquidRateLc' in this 'WellTestOutputs_String' view."),
    liquidRateSc: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'liquidRateSc' in this 'WellTestOutputs_String' view."),
    modelAlarms: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelAlarms' in this 'WellTestOutputs_String' view."),
    modelAlarmsCode: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelAlarmsCode' in this 'WellTestOutputs_String' view."),
    modelMatchedBHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelMatchedBHP' in this 'WellTestOutputs_String' view."),
    modelMatchedgasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelMatchedgasRate' in this 'WellTestOutputs_String' view."),
    modelMatchedliquidRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelMatchedliquidRate' in this 'WellTestOutputs_String' view."),
    modelMatchedoilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelMatchedoilRate' in this 'WellTestOutputs_String' view."),
    modelMatchedwaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelMatchedwaterRate' in this 'WellTestOutputs_String' view."),
    modelMinStableRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelMinStableRate' in this 'WellTestOutputs_String' view."),
    modelProductivityIndex: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelProductivityIndex' in this 'WellTestOutputs_String' view."),
    modelReservoirModel: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelReservoirModel' in this 'WellTestOutputs_String' view."),
    modelReservoirPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelReservoirPressure' in this 'WellTestOutputs_String' view."),
    modelStabilityFlag: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelStabilityFlag' in this 'WellTestOutputs_String' view."),
    modelVlpModel: z.coerce
      .date<Date>()
      .nullish()
      .describe("Timestamp 'modelVlpModel' associated with this 'WellTestOutputs_String' row."),
    modelWellTestTimestamp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelWellTestTimestamp' in this 'WellTestOutputs_String' view."),
    mpfm: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series flag or identifier indicating that the test was performed using a multiphase flow meter (MPFM).',
      ),
    mpfmAlarms: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmAlarms' in this 'WellTestOutputs_String' view."),
    mpfmDifferentialPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmDifferentialPressure' in this 'WellTestOutputs_String' view."),
    mpfmLinePressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmLinePressure' in this 'WellTestOutputs_String' view."),
    mpfmLineTemperature: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmLineTemperature' in this 'WellTestOutputs_String' view."),
    oilDensityLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'oilDensityLC' in this 'WellTestOutputs_String' view."),
    oilDensitySC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'oilDensitySC' in this 'WellTestOutputs_String' view."),
    oilMassFlowRateLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'oilMassFlowRateLC' in this 'WellTestOutputs_String' view."),
    oilMassFlowRateSC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'oilMassFlowRateSC' in this 'WellTestOutputs_String' view."),
    oilRateLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'oilRateLC' in this 'WellTestOutputs_String' view."),
    oilRateSC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of measured oil production rate at standard conditions during the well test.'),
    oilVolumeFractionLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'oilVolumeFractionLC' in this 'WellTestOutputs_String' view."),
    pumpCurrent: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'pumpCurrent' in this 'WellTestOutputs_String' view."),
    pumpDischargePress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'pumpDischargePress' in this 'WellTestOutputs_String' view."),
    pumpDischargeTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'pumpDischargeTemp' in this 'WellTestOutputs_String' view."),
    pumpFrequency: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'pumpFrequency' in this 'WellTestOutputs_String' view."),
    pumpIntakePress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'pumpIntakePress' in this 'WellTestOutputs_String' view."),
    pumpIntakeTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'pumpIntakeTemp' in this 'WellTestOutputs_String' view."),
    pumpMotorTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'pumpMotorTemp' in this 'WellTestOutputs_String' view."),
    pumpPower: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'pumpPower' in this 'WellTestOutputs_String' view."),
    pumpVibration: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'pumpVibration' in this 'WellTestOutputs_String' view."),
    pumpVoltage: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'pumpVoltage' in this 'WellTestOutputs_String' view."),
    pvtAlarms: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'pvtAlarms' in this 'WellTestOutputs_String' view."),
    pvtAlarmsCode: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'pvtAlarmsCode' in this 'WellTestOutputs_String' view."),
    stablePeriodEndDate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of timestamps indicating when the stable measurement period of each well test ends.'),
    stablePeriodStartDate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of timestamps indicating when the stable measurement period of each well test begins.'),
    totalGorSC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of total gasâ€“oil ratio (GOR) at standard conditions derived from well test measurements.',
      ),
    waterCutLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'waterCutLC' in this 'WellTestOutputs_String' view."),
    waterCutSC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of water cut at standard conditions (water fraction of liquid rate) derived from well test measurements.',
      ),
    waterDensityLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'waterDensityLC' in this 'WellTestOutputs_String' view."),
    waterDensitySC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'waterDensitySC' in this 'WellTestOutputs_String' view."),
    waterMassFlowRateLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'waterMassFlowRateLC' in this 'WellTestOutputs_String' view."),
    waterMassFlowRateSC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'waterMassFlowRateSC' in this 'WellTestOutputs_String' view."),
    waterRateLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'waterRateLC' in this 'WellTestOutputs_String' view."),
    waterRateSC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of measured water production rate at standard conditions during the well test.'),
    waterVolumeFractionLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'waterVolumeFractionLC' in this 'WellTestOutputs_String' view."),
    wellTestEndDate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of timestamps marking the end of each well test for this string.'),
    wellTestStartDate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of timestamps marking the start of each well test for this string.'),
    wellTestStartDateDH: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestStartDateDH' in this 'WellTestOutputs_String' view."),
    wf01ExecutedBy: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wf01ExecutedBy' in this 'WellTestOutputs_String' view."),
    wf01ExecutionTime: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wf01ExecutionTime' in this 'WellTestOutputs_String' view."),
    wf01Status: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wf01Status' in this 'WellTestOutputs_String' view."),
    wf01StatusDescription: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wf01StatusDescription' in this 'WellTestOutputs_String' view."),
    wf02ExecutedBy: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wf02ExecutedBy' in this 'WellTestOutputs_String' view."),
    wf02ExecutionTime: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wf02ExecutionTime' in this 'WellTestOutputs_String' view."),
    wf02Status: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wf02Status' in this 'WellTestOutputs_String' view."),
    wf02StatusDescription: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wf02StatusDescription' in this 'WellTestOutputs_String' view."),
    wf03ExecutedBy: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wf03ExecutedBy' in this 'WellTestOutputs_String' view."),
    wf03ExecutionTime: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wf03ExecutionTime' in this 'WellTestOutputs_String' view."),
    wf03Status: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wf03Status' in this 'WellTestOutputs_String' view."),
    wf03StatusDescription: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wf03StatusDescription' in this 'WellTestOutputs_String' view."),
    wf04ExecutedBy: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wf04ExecutedBy' in this 'WellTestOutputs_String' view."),
    wf04ExecutionTime: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wf04ExecutionTime' in this 'WellTestOutputs_String' view."),
    wf04Status: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wf04Status' in this 'WellTestOutputs_String' view."),
    wf04StatusDescription: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wf04StatusDescription' in this 'WellTestOutputs_String' view."),
    wgrLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wgrLC' in this 'WellTestOutputs_String' view."),
    wgrSC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wgrSC' in this 'WellTestOutputs_String' view."),
    whp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'whp' in this 'WellTestOutputs_String' view."),
    wht: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wht' in this 'WellTestOutputs_String' view."),
  })
  .describe(
    'Aggregated outputs from individual well tests for each well string, including test timing, multiphase rates at standard and line conditions, derived ratios (GOR, WCT), phase densities and mass flow rates used for well performance and model calibration.',
  );

export const WellTestInputsStringSchema: z.ZodObject<Properties<WellTestInputsString>> = z
  .object({
    __typename: z.literal('WellTestInputs_String').optional(),
    cgrLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'cgrLC' in this 'WellTestInputs_String' view."),
    chokeAlarms: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'chokeAlarms' in this 'WellTestInputs_String' view."),
    chokeAlarmsCode: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'chokeAlarmsCode' in this 'WellTestInputs_String' view."),
    chokeMatchedliquidRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'chokeMatchedliquidRate' in this 'WellTestInputs_String' view."),
    comments: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'comments' in this 'WellTestInputs_String' view."),
    composition: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'composition' in this 'WellTestInputs_String' view."),
    entityName: z
      .lazy(() => StringAssetSchema.nullish())
      .describe("Reference to the related 'String_asset' entity for this 'WellTestInputs_String' row."),
    espwear: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'espwear' in this 'WellTestInputs_String' view."),
    fluidProperties: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fluidProperties' in this 'WellTestInputs_String' view."),
    formationGOR: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'formationGOR' in this 'WellTestInputs_String' view."),
    gasDensityLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gasDensityLC' in this 'WellTestInputs_String' view."),
    gasDensitySC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gasDensitySC' in this 'WellTestInputs_String' view."),
    gasMassFlowRateLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gasMassFlowRateLC' in this 'WellTestInputs_String' view."),
    gasMassFlowRateSC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gasMassFlowRateSC' in this 'WellTestInputs_String' view."),
    gasVolumeFractionLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gasVolumeFractionLC' in this 'WellTestInputs_String' view."),
    glFcvOutletTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'glFcvOutletTemp' in this 'WellTestInputs_String' view."),
    glinjectionRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'glinjectionRate' in this 'WellTestInputs_String' view."),
    historicalAlarms: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'historicalAlarms' in this 'WellTestInputs_String' view."),
    historicalAlarmsCode: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'historicalAlarmsCode' in this 'WellTestInputs_String' view."),
    lastUpdatedByStablePeriod: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'lastUpdatedByStablePeriod' in this 'WellTestInputs_String' view."),
    lastUpdatedByWellTest: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'lastUpdatedByWellTest' in this 'WellTestInputs_String' view."),
    liquidRateLc: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'liquidRateLc' in this 'WellTestInputs_String' view."),
    liquidRateSc: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'liquidRateSc' in this 'WellTestInputs_String' view."),
    modelAlarms: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelAlarms' in this 'WellTestInputs_String' view."),
    modelAlarmsCode: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelAlarmsCode' in this 'WellTestInputs_String' view."),
    modelComposition: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelComposition' in this 'WellTestInputs_String' view."),
    modelMatchedBHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelMatchedBHP' in this 'WellTestInputs_String' view."),
    modelMatchedgasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelMatchedgasRate' in this 'WellTestInputs_String' view."),
    modelMatchedliquidRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelMatchedliquidRate' in this 'WellTestInputs_String' view."),
    modelMatchedoilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelMatchedoilRate' in this 'WellTestInputs_String' view."),
    modelMatchedwaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelMatchedwaterRate' in this 'WellTestInputs_String' view."),
    modelMinStableRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelMinStableRate' in this 'WellTestInputs_String' view."),
    modelProductivityIndex: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelProductivityIndex' in this 'WellTestInputs_String' view."),
    modelReservoirModel: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelReservoirModel' in this 'WellTestInputs_String' view."),
    modelReservoirPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelReservoirPressure' in this 'WellTestInputs_String' view."),
    modelStabilityFlag: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelStabilityFlag' in this 'WellTestInputs_String' view."),
    modelVlpModel: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelVlpModel' in this 'WellTestInputs_String' view."),
    modelWellTestTimestamp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelWellTestTimestamp' in this 'WellTestInputs_String' view."),
    mpfmAlarms: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmAlarms' in this 'WellTestInputs_String' view."),
    mpfmDifferentialPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmDifferentialPressure' in this 'WellTestInputs_String' view."),
    mpfmLinePressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmLinePressure' in this 'WellTestInputs_String' view."),
    mpfmLineTemperature: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmLineTemperature' in this 'WellTestInputs_String' view."),
    oilDensityLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'oilDensityLC' in this 'WellTestInputs_String' view."),
    oilDensitySC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'oilDensitySC' in this 'WellTestInputs_String' view."),
    oilMassFlowRateLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'oilMassFlowRateLC' in this 'WellTestInputs_String' view."),
    oilMassFlowRateSC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'oilMassFlowRateSC' in this 'WellTestInputs_String' view."),
    oilVolumeFractionLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'oilVolumeFractionLC' in this 'WellTestInputs_String' view."),
    optionalComments: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'optionalComments' in this 'WellTestInputs_String'"),
    ptsDateTime: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'ptsDateTime' in this 'WellTestInputs_String' view."),
    pumpDischargeTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'pumpDischargeTemp' in this 'WellTestInputs_String' view."),
    pumpMotorTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'pumpMotorTemp' in this 'WellTestInputs_String' view."),
    pumpPower: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'pumpPower' in this 'WellTestInputs_String' view."),
    pumpVibration: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'pumpVibration' in this 'WellTestInputs_String' view."),
    pvtAlarms: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'pvtAlarms' in this 'WellTestInputs_String' view."),
    rejectionCategory: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'rejectionCategory' in this 'WellTestInputs_String' view."),
    sampleDateTime: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'sampleDateTime' in this 'WellTestInputs_String' view."),
    stablePeriodEndDate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'stablePeriodEndDate' in this 'WellTestInputs_String' view."),
    stablePeriodStartDate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'stablePeriodStartDate' in this 'WellTestInputs_String' view."),
    validatedBy: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'validatedBy' in this 'WellTestInputs_String' view."),
    waterDensityLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'waterDensityLC' in this 'WellTestInputs_String' view."),
    waterDensitySC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'waterDensitySC' in this 'WellTestInputs_String' view."),
    waterMassFlowRateLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'waterMassFlowRateLC' in this 'WellTestInputs_String' view."),
    waterMassFlowRateSC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'waterMassFlowRateSC' in this 'WellTestInputs_String' view."),
    waterVolumeFractionLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'waterVolumeFractionLC' in this 'WellTestInputs_String' view."),
    wellTestApprovedAllocationFlag: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'wellTestApprovedAllocationFlag' in this 'WellTestInputs_String' view.",
      ),
    wellTestArtificialLiftType: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestArtificialLiftType' in this 'WellTestInputs_String' view."),
    wellTestBottomHolePressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestBottomHolePressure' in this 'WellTestInputs_String' view."),
    wellTestBottomHoleTemperature: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestBottomHoleTemperature' in this 'WellTestInputs_String' view."),
    wellTestCGR: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestCGR' in this 'WellTestInputs_String' view."),
    wellTestCasingHeadPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestCasingHeadPressure' in this 'WellTestInputs_String' view."),
    wellTestCasingHeadTemperature: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestCasingHeadTemperature' in this 'WellTestInputs_String' view."),
    wellTestChokeOpening: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestChokeOpening' in this 'WellTestInputs_String' view."),
    wellTestChokeSize: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestChokeSize' in this 'WellTestInputs_String' view."),
    wellTestCreatedBy: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestCreatedBy' in this 'WellTestInputs_String'"),
    wellTestCreatedDateTime: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestCreatedDateTime' in this 'WellTestInputs_String'"),
    wellTestDuration: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestDuration' in this 'WellTestInputs_String' view."),
    wellTestEgorVendorStdGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestEgorVendorStdGasRate' in this 'WellTestInputs_String' view."),
    wellTestEgorVendorStdOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestEgorVendorStdOilRate' in this 'WellTestInputs_String' view."),
    wellTestEgorVendorStdWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'wellTestEgorVendorStdWaterRate' in this 'WellTestInputs_String' view.",
      ),
    wellTestEndDate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestEndDate' in this 'WellTestInputs_String' view."),
    wellTestEspMotorCurrent: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestEspMotorCurrent' in this 'WellTestInputs_String' view."),
    wellTestEspMotorPower: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestEspMotorPower' in this 'WellTestInputs_String' view."),
    wellTestEspMotorVoltage: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestEspMotorVoltage' in this 'WellTestInputs_String' view."),
    wellTestEspPumpDischargePressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'wellTestEspPumpDischargePressure' in this 'WellTestInputs_String' view.",
      ),
    wellTestEspPumpFrequency: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestEspPumpFrequency' in this 'WellTestInputs_String' view."),
    wellTestEspPumpIntakePressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestEspPumpIntakePressure' in this 'WellTestInputs_String' view."),
    wellTestEspPumpIntakeTemperature: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'wellTestEspPumpIntakeTemperature' in this 'WellTestInputs_String' view.",
      ),
    wellTestFlowlinePressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestFlowlinePressure' in this 'WellTestInputs_String' view."),
    wellTestFlowlineTemperature: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestFlowlineTemperature' in this 'WellTestInputs_String' view."),
    wellTestGOR: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGOR' in this 'WellTestInputs_String' view."),
    wellTestGasDensityInSitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGasDensityInSitu' in this 'WellTestInputs_String' view."),
    wellTestGasLiftVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGasLiftVolume' in this 'WellTestInputs_String' view."),
    wellTestGasRateInsitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGasRateInsitu' in this 'WellTestInputs_String' view."),
    wellTestGasRatePts: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGasRatePts' in this 'WellTestInputs_String' view."),
    wellTestGasRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGasRateStd' in this 'WellTestInputs_String' view."),
    wellTestGlFlControlValvOutletPres: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'wellTestGlFlControlValvOutletPres' in this 'WellTestInputs_String' view.",
      ),
    wellTestGlFlControlValveInletPres: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'wellTestGlFlControlValveInletPres' in this 'WellTestInputs_String' view.",
      ),
    wellTestGlFlControlValveInletTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'wellTestGlFlControlValveInletTemp' in this 'WellTestInputs_String' view.",
      ),
    wellTestGlInjectionChokeOpening: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'wellTestGlInjectionChokeOpening' in this 'WellTestInputs_String' view.",
      ),
    wellTestGlInjectionChokeSize: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGlInjectionChokeSize' in this 'WellTestInputs_String' view."),
    wellTestGorInsitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGorInsitu' in this 'WellTestInputs_String' view."),
    wellTestGorPts: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGorPts' in this 'WellTestInputs_String' view."),
    wellTestLiquidRateLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestLiquidRateLC' in this 'WellTestInputs_String' view."),
    wellTestLiquidRatePts: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestLiquidRatePts' in this 'WellTestInputs_String' view."),
    wellTestLiquidRateSC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestLiquidRateSC' in this 'WellTestInputs_String' view."),
    wellTestMpfmName: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestMpfmName' in this 'WellTestInputs_String' view."),
    wellTestOilDensityInSitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestOilDensityInSitu' in this 'WellTestInputs_String' view."),
    wellTestOilRateInsitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestOilRateInsitu' in this 'WellTestInputs_String' view."),
    wellTestOilRatePts: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestOilRatePts' in this 'WellTestInputs_String' view."),
    wellTestOilRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestOilRateStd' in this 'WellTestInputs_String' view."),
    wellTestStartDate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestStartDate' in this 'WellTestInputs_String' view."),
    wellTestStartDateDH: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestStartDateDH' in this 'WellTestInputs_String' view."),
    wellTestStatusDetails: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestStatusDetails' in this 'WellTestInputs_String'"),
    wellTestStringFunction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestStringFunction' in this 'WellTestInputs_String' view."),
    wellTestTestMethod: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestTestMethod' in this 'WellTestInputs_String' view."),
    wellTestTestSeparatorLinePressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'wellTestTestSeparatorLinePressure' in this 'WellTestInputs_String' view.",
      ),
    wellTestTestSeparatorLineTemperature: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'wellTestTestSeparatorLineTemperature' in this 'WellTestInputs_String' view.",
      ),
    wellTestTestType: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestTestType' in this 'WellTestInputs_String' view."),
    wellTestTestTypeDesc: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestTestTypeDesc' in this 'WellTestInputs_String' view."),
    wellTestTotalGorStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestTotalGorStd' in this 'WellTestInputs_String' view."),
    wellTestTotalMassFlowRateGas: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestTotalMassFlowRateGas' in this 'WellTestInputs_String' view."),
    wellTestTotalMassFlowRateOil: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestTotalMassFlowRateOil' in this 'WellTestInputs_String' view."),
    wellTestTotalMassFlowRateWater: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'wellTestTotalMassFlowRateWater' in this 'WellTestInputs_String' view.",
      ),
    wellTestValidationFlag: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestValidationFlag' in this 'WellTestInputs_String' view."),
    wellTestValidationTime: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestValidationTime' in this 'WellTestInputs_String'"),
    wellTestWGR: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestWGR' in this 'WellTestInputs_String' view."),
    wellTestWaterCut: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestWaterCut' in this 'WellTestInputs_String' view."),
    wellTestWaterCutInsitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestWaterCutInsitu' in this 'WellTestInputs_String' view."),
    wellTestWaterCutPts: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestWaterCutPts' in this 'WellTestInputs_String' view."),
    wellTestWaterRateInsitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestWaterRateInsitu' in this 'WellTestInputs_String' view."),
    wellTestWaterRatePts: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestWaterRatePts' in this 'WellTestInputs_String' view."),
    wellTestWaterRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestWaterRateStd' in this 'WellTestInputs_String' view."),
    wellTestWellheadPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestWellheadPressure' in this 'WellTestInputs_String' view."),
    wellTestWellheadTemperature: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestWellheadTemperature' in this 'WellTestInputs_String' view."),
    wgrLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wgrLC' in this 'WellTestInputs_String' view."),
    wlrLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wlrLC' in this 'WellTestInputs_String' view."),
  })
  .describe("View 'WellTestInputs_String' in the iPSO production optimization solution data model.");

export const WellTestGaugeStringSchema: z.ZodObject<Properties<WellTestGaugeString>> = z
  .object({
    __typename: z.literal('WellTestGauge_String').optional(),
    entityName: z
      .lazy(() => StringAssetSchema.nullish())
      .describe("Reference to the related 'String_asset' entity for this 'WellTestGauge_String' row."),
    lowerDatumDepth: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'lowerDatumDepth' in this 'WellTestGauge_String' view."),
    lowerGaugeDepth: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'lowerGaugeDepth' in this 'WellTestGauge_String' view."),
    lowerGaugePosition: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'lowerGaugePosition' in this 'WellTestGauge_String' view."),
    lowerProductivityIndex: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'lowerProductivityIndex' in this 'WellTestGauge_String' view."),
    lowerProductivityIndexSS: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'lowerProductivityIndexSS' in this 'WellTestGauge_String' view."),
    lowerResPressAtDatum: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'lowerResPressAtDatum' in this 'WellTestGauge_String' view."),
    lowerResPressAtGauge: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'lowerResPressAtGauge' in this 'WellTestGauge_String' view."),
    lowerSelectedGradient: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'lowerSelectedGradient' in this 'WellTestGauge_String' view."),
    lowerTestType: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'lowerTestType' in this 'WellTestGauge_String' view."),
    naDatumDepth: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'naDatumDepth' in this 'WellTestGauge_String' view."),
    naGaugeDepth: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'naGaugeDepth' in this 'WellTestGauge_String' view."),
    naGaugePosition: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'naGaugePosition' in this 'WellTestGauge_String' view."),
    naProductivityIndex: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'naProductivityIndex' in this 'WellTestGauge_String' view."),
    naProductivityIndexSS: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'naProductivityIndexSS' in this 'WellTestGauge_String' view."),
    naResPressAtDatum: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'naResPressAtDatum' in this 'WellTestGauge_String' view."),
    naResPressAtGauge: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'naResPressAtGauge' in this 'WellTestGauge_String' view."),
    naSelectedGradient: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'naSelectedGradient' in this 'WellTestGauge_String' view."),
    naTestType: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'naTestType' in this 'WellTestGauge_String' view."),
    upperDatumDepth: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'upperDatumDepth' in this 'WellTestGauge_String' view."),
    upperGaugeDepth: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'upperGaugeDepth' in this 'WellTestGauge_String' view."),
    upperGaugePosition: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'upperGaugePosition' in this 'WellTestGauge_String' view."),
    upperProductivityIndex: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'upperProductivityIndex' in this 'WellTestGauge_String' view."),
    upperProductivityIndexSS: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'upperProductivityIndexSS' in this 'WellTestGauge_String' view."),
    upperResPressAtDatum: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'upperResPressAtDatum' in this 'WellTestGauge_String' view."),
    upperResPressAtGauge: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'upperResPressAtGauge' in this 'WellTestGauge_String' view."),
    upperSelectedGradient: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'upperSelectedGradient' in this 'WellTestGauge_String' view."),
    upperTestType: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'upperTestType' in this 'WellTestGauge_String' view."),
  })
  .describe("View 'WellTestGauge_String' in the iPSO production optimization solution data model.");

export const WellTestAnalysisAgentSchema: z.ZodObject<Properties<WellTestAnalysisAgent>> = z
  .object({
    __typename: z.literal('WellTestAnalysis_Agent').optional(),
    modelEstimatedFbhp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Current model-estimated flowing bottomhole pressure (psia).'),
    modelEstimatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Current model-estimated gas rate (Mscf/d).'),
    modelEstimatedLiquidRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Current model-estimated total liquid rate (oil + water) (stb/d).'),
    modelEstimatedOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Current model-estimated oil rate (stb/d).'),
    modelEstimatedWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Current model-estimated water rate (stb/d).'),
    modelInjectivityIndex: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Injectivity Index for injection wells from the well test model (stb/d/psi).'),
    modelInjectivityIndexPercentChange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Percent change in injectivity index versus the previous accepted well test (%).'),
    modelProductivityIndex: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Productivity Index from the well test model (stb/d/psi).'),
    modelProductivityIndexPercentChange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Percent change in productivity index versus the previous accepted well test (%).'),
    modelReservoirPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Reservoir pressure from the well test model (psia).'),
    modelReservoirPressurePercentChange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Percent change in reservoir pressure versus the previous accepted well test (%).'),
    modelWellTestChp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Casing head pressure during the last accepted well test (psia).'),
    modelWellTestGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Gas rate measured at the last accepted well test (Mscf/d).'),
    modelWellTestGor: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Gas-Oil Ratio measured at the last accepted well test (scf/stb).'),
    modelWellTestLiquidRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Total liquid rate (oil + water) measured at the last accepted well test (stb/d).'),
    modelWellTestPdgPress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Permanent downhole gauge pressure during the last accepted well test (psia).'),
    modelWellTestTimestamp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Timestamp of the last accepted well test.'),
    modelWellTestWc: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Water cut (water / total liquid) measured at the last accepted well test (%).'),
    modelWellTestWhp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Wellhead pressure during the last accepted well test (psia).'),
    wellString: z.lazy(() => StringAssetSchema.nullish()).describe('Reference to the well string entity.'),
  })
  .describe(
    'Per-string well test analysis outputs — productivity and injectivity\nindices, reservoir pressure, last-test rates and pressures, and current\nmodel estimates.\n\nString-level outputs from the well test analysis workflow (WF03).\nProductivity and injectivity indices with percent change versus the\nprevious accepted test, reservoir pressure with percent change, timestamp\nand measured rates and pressures from the last accepted test, and current\nreal-time model estimates of rates and flowing bottomhole pressure.\nExcludes raw measurement curves and detailed completion or geological\ncontext.\n\nUse for: Well Test Analysis (WF03), Real-Time Surveillance (WF18).\n\n@name Well Test Analysis (Agent)',
  );

export const WellStatusStringAgentSchema: z.ZodObject<Properties<WellStatusStringAgent>> = z
  .object({
    __typename: z.literal('WellStatus_String_Agent').optional(),
    hoursOnline: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Hours online since midnight UTC+04:00, derived from onlineStatus (max 24).'),
    instrumented: z
      .float32()
      .nullish()
      .describe('Downhole instrumentation flag, numeric. 1 = real-time P/T gauges present, 0 = not instrumented.'),
    liftType: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Artificial lift method. Values are NATURAL_FLOW, ESP, GAS_LIFT, ROD_PUMP, JET_PUMP, PCP. String Time Series.',
      ),
    onlineStatus: z.lazy(() => TimeSeriesSchema.nullish()).describe('Online state, numeric. 0 = shut-in, 1 = flowing.'),
    onlineStatusReason: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Reasons recorded at shut-in start that triggered the shut-in detection. String Time Series.'),
    pressureCompliance: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Pressure compliance status. Values are COMPLIANT, NON_COMPLIANT, WARNING. String Time Series.'),
    pressureSource: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Source method used to derive reservoir pressure. String Time Series.'),
    product: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Primary product type. Values are OIL, GAS, CONDENSATE, WATER. String Time Series.'),
    reservoirPressureDatum: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Estimated reservoir pressure at datum depth (psi).'),
    reservoirPressureMidPerforation: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Estimated reservoir pressure at mid-perforation depth (psi).'),
    sluggingStatus: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Hydrodynamic slug-flow indicator, numeric. 0 = not slugging, 1 = slugging.'),
    steadyStateStatus: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Flow stability, numeric. 0 = transient or shut-in, 1 = quasi-steady-state flowing.'),
    subSurfaceSafetyValveCloseState: z
      .number()
      .nullish()
      .describe('Subsurface safety valve (SSSV) state, numeric. 0 = OPEN, 1 = CLOSED.'),
    surfaceSafetyValveCloseState: z
      .number()
      .nullish()
      .describe('Surface safety valve (SSV) state, numeric. 0 = OPEN, 1 = CLOSED.'),
    wag: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Water-alternating-gas injection flag. Values are YES, NO. String Time Series.'),
    wellString: z.lazy(() => StringAssetSchema.nullish()).describe('Reference to the well string entity.'),
    wellTestValidation: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Validation status of the most recent well test. Values are VALID, INVALID, PENDING_REVIEW. String Time Series.',
      ),
    wellType: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Well classification. Values are PRODUCTION, INJECTION, OBSERVATION, DISPOSAL, WAG. String Time Series.',
      ),
    wingValveCloseState: z.number().nullish().describe('Wing valve state, numeric. 0 = OPEN, 1 = CLOSED.'),
  })
  .describe(
    'Per-string operational status — lift type, well type, online state, valve\nstates, and reservoir pressure estimates.\n\nString-level state attributes sourced from field sensors and monitoring\nsystems, covering online, flow stability, and slugging indicators, surface\nand subsurface valve positions, well classification (lift type, product,\nWAG), and current reservoir pressure estimates. Distinct from\nInactiveString_Agent, which classifies long-term inactivity. Excludes\nhistorical performance and detailed production rates.\n\nUse for: Well Status Detection (WF25), Real-Time Surveillance (WF18).',
  );

export const WellPotentialStringAgentSchema: z.ZodObject<Properties<WellPotentialStringAgent>> = z
  .object({
    __typename: z.literal('WellPotential_String_Agent').optional(),
    potentialGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Unconstrained gas injection potential (TS). Compare to giRate, giTargetRate, or\nMeasuredInjection_String_Agent gasInjRate.',
      ),
    potentialGasProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Unconstrained gas production potential / technical producer gas rate (TS). IPSO mapping\nfor technical gas rate. Compare to priorityGasRateStd or EstimatedRates.',
      ),
    potentialOilProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Unconstrained oil production potential (stb/d, TS). Compare to priorityOilRateStd\nor EstimatedRates for underperformance on producers.',
      ),
    potentialWaterInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Unconstrained water injection potential (stb/d, TS). Compare to wiRate, wiTargetRate,\nor MeasuredInjection_String_Agent waterInjRate.',
      ),
    potentialWaterProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Unconstrained water production potential (stb/d, TS). Compare to priorityWaterRateStd\nor EstimatedRates.',
      ),
    wellString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe('Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context.'),
  })
  .describe(
    'Unconstrained production and injection potential time series per well string (WellInputs_String).\n\nAll potential* rates: oil, gas, water production and water/gas injection. Compare to\nPriorityRates_String_Agent or EstimatedRates_String_Agent for producers, and measured or\nallocated injection views for injectors. Pair with Prodplan_String_Agent for allowable\nand prodplan technical limits (separate container).\n\nUse for: potential vs estimated rate checks, underperforming wells (WF10/WF19).\n\n@name Well Potential — String (Agent)',
  );

export const WellOutputsStringSchema: z.ZodObject<Properties<WellOutputsString>> = z
  .object({
    __typename: z.literal('WellOutputs_String').optional(),
    calcFVF: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calcFVF' in this 'WellOutputs_String' view."),
    calcGasFVF: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calcGasFVF' in this 'WellOutputs_String' view."),
    calcGasViscosity: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calcGasViscosity' in this 'WellOutputs_String' view."),
    chokeAnalysisFbhp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of flowing bottom-hole pressure corresponding to choke analysis results for this string.'),
    chokeAnalysisGasRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of gas production rate at standard conditions obtained from choke analysis for this string.',
      ),
    chokeAnalysisLiquidRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of total liquid production rate at standard conditions obtained from choke analysis for this string.',
      ),
    chokeAnalysisOilRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of oil production rate at standard conditions obtained from choke analysis for this string.',
      ),
    chokeAnalysisStatus: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'chokeAnalysisStatus' in this 'WellOutputs_String' view."),
    chokeAnalysisWaterRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of water production rate at standard conditions obtained from choke analysis for this string.',
      ),
    chokeCdCalc: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'chokeCdCalc' in this 'WellOutputs_String' view."),
    chokeSizeCalc: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'chokeSizeCalc' in this 'WellOutputs_String' view."),
    cumulativeGasInjPress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'cumulativeGasInjPress' in this 'WellOutputs_String' view."),
    cumulativeGasInjVol: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'cumulativeGasInjVol' in this 'WellOutputs_String' view."),
    cumulativeWaterInjPress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'cumulativeWaterInjPress' in this 'WellOutputs_String' view."),
    cumulativeWaterInjVol: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'cumulativeWaterInjVol' in this 'WellOutputs_String' view."),
    curveAnalysisFbhp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'curveAnalysisFbhp' in this 'WellOutputs_String' view."),
    curveAnalysisGasRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'curveAnalysisGasRateStd' in this 'WellOutputs_String' view."),
    curveAnalysisLiquidRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'curveAnalysisLiquidRateStd' in this 'WellOutputs_String' view."),
    curveAnalysisOilRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'curveAnalysisOilRateStd' in this 'WellOutputs_String' view."),
    curveAnalysisStatus: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Calculation status as a string for every run of the ESP curve method'),
    curveAnalysisWaterRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'curveAnalysisWaterRateStd' in this 'WellOutputs_String' view."),
    dataAnalysisFbhp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'dataAnalysisFbhp' in this 'WellOutputs_String' view."),
    dataAnalysisGasRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'dataAnalysisGasRateStd' in this 'WellOutputs_String' view."),
    dataAnalysisLiquidRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'dataAnalysisLiquidRateStd' in this 'WellOutputs_String' view."),
    dataAnalysisOilRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'dataAnalysisOilRateStd' in this 'WellOutputs_String' view."),
    dataAnalysisStatus: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Calculation status as a string for every run of the data driven VFM method'),
    dataAnalysisWaterRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'dataAnalysisWaterRateStd' in this 'WellOutputs_String' view."),
    downholeFluidFlowRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'downholeFluidFlowRate' in this 'WellOutputs_String' view."),
    downholeFluidVelocity: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'downholeFluidVelocity' in this 'WellOutputs_String' view."),
    downholeGasInjectionVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'downholeGasInjectionVolume' in this 'WellOutputs_String' view."),
    downholeGasProductionVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'downholeGasProductionVolume' in this 'WellOutputs_String' view."),
    downholeOilProductionVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'downholeOilProductionVolume' in this 'WellOutputs_String' view."),
    downholeWaterInjectionVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'downholeWaterInjectionVolume' in this 'WellOutputs_String' view."),
    downholeWaterProductionVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'downholeWaterProductionVolume' in this 'WellOutputs_String' view."),
    entityName: z
      .lazy(() => StringAssetSchema.nullish())
      .describe(
        "Name of the well string (completion) for which modelled and calculated well outputs are provided, sourced from the 'String_asset' view.",
      ),
    espqlAnalysisStatus: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'espqlAnalysisStatus' in this 'WellOutputs_String' view."),
    giBHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'giBHP' in this 'WellOutputs_String' view."),
    giRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'giRate' in this 'WellOutputs_String' view."),
    giTargetRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'giTargetRate' in this 'WellOutputs_String' view."),
    giTechnicalRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'giTechnicalRate' in this 'WellOutputs_String' view."),
    giWHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'giWHP' in this 'WellOutputs_String' view."),
    glChokeCdCalc: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'glChokeCdCalc' in this 'WellOutputs_String' view."),
    glChokeSizeCalc: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'glChokeSizeCalc' in this 'WellOutputs_String' view."),
    glirAllocated: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'glirAllocated' in this 'WellOutputs_String' view."),
    glirChokeEquation: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'glirChokeEquation' in this 'WellOutputs_String' view."),
    glirMeasured: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'glirMeasured' in this 'WellOutputs_String' view."),
    glirNetworkSimulation: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'glirNetworkSimulation' in this 'WellOutputs_String' view."),
    glirSelected: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'glirSelected' in this 'WellOutputs_String' view."),
    glirSelectedType: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'glirSelectedType' in this 'WellOutputs_String' view."),
    glqlAnalysisStatus: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'glqlAnalysisStatus' in this 'WellOutputs_String' view."),
    grdAnalysisStatus: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'grdAnalysisStatus' in this 'WellOutputs_String' view."),
    hallInterpretation: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'hallInterpretation' in this 'WellOutputs_String' view."),
    hallLine: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'hallLine' in this 'WellOutputs_String' view."),
    hoursOnline: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Hours online since midnight UTC+04:00. Calculated from the onlineStatus property.'),
    injectionEfficiency: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'injectionEfficiency' in this 'WellOutputs_String' view."),
    injectionEfficiencyFlag: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'injectionEfficiencyFlag' in this 'WellOutputs_String' view."),
    injectionEfficiencyRank: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'injectionEfficiencyRank' in this 'WellOutputs_String' view."),
    injectivityIndex: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'injectivityIndex' in this 'WellOutputs_String' view."),
    instrumented: z
      .float32()
      .nullish()
      .describe("Numeric value 'instrumented' (floating point) for this 'WellOutputs_String' row."),
    iprAnalysisFbhp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'iprAnalysisFbhp' in this 'WellOutputs_String' view."),
    iprAnalysisGasRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'iprAnalysisGasRateStd' in this 'WellOutputs_String' view."),
    iprAnalysisLiquidRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'iprAnalysisLiquidRateStd' in this 'WellOutputs_String' view."),
    iprAnalysisOilRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'iprAnalysisOilRateStd' in this 'WellOutputs_String' view."),
    iprAnalysisStatus: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Calculation status as a string for every run of the IPR method'),
    iprAnalysisWaterRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'iprAnalysisWaterRateStd' in this 'WellOutputs_String' view."),
    liftType: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'liftType' in this 'WellOutputs_String' view."),
    motorEfficiency: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'motorEfficiency' in this 'WellOutputs_String' view."),
    motorLoad: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'motorLoad' in this 'WellOutputs_String' view."),
    onlineStatus: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('0 indicates the well string is shut-in, 1 indicates the well string is flowing'),
    onlineStatusReason: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'The reason for a shut-in detection is saved at the shut-in start time as a string of comma seperated criteria that were satisfied during the shut-in.',
      ),
    pressureCompliance: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'pressureCompliance' in this 'WellOutputs_String' view."),
    pressureSource: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'pressureSource' in this 'WellOutputs_String' view."),
    priorityFbhp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'priorityFbhp' in this 'WellOutputs_String' view."),
    priorityGasRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'priorityGasRateStd' in this 'WellOutputs_String' view."),
    priorityLiquidRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'priorityLiquidRateStd' in this 'WellOutputs_String' view."),
    priorityMethod: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'priorityMethod' in this 'WellOutputs_String' view."),
    priorityOilRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'priorityOilRateStd' in this 'WellOutputs_String' view."),
    priorityWaterRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'priorityWaterRateStd' in this 'WellOutputs_String' view."),
    priotiryWaterRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'priotiryWaterRateStd' in this 'WellOutputs_String' view."),
    product: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'product' in this 'WellOutputs_String' view."),
    productivityIndex: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'productivityIndex' in this 'WellOutputs_String' view."),
    prosperLiftType: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'prosperLiftType' in this 'WellOutputs_String' view."),
    prosperProduct: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'prosperProduct' in this 'WellOutputs_String' view."),
    prosperWag: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'prosperWag' in this 'WellOutputs_String' view."),
    prosperWellType: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'prosperWellType' in this 'WellOutputs_String' view."),
    pumpAvgRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'pumpAvgRate' in this 'WellOutputs_String' view."),
    pumpHead: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'pumpHead' in this 'WellOutputs_String' view."),
    pvt_AlarmCode: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'pvt_AlarmCode' in this 'WellOutputs_String' view."),
    qliqDelta: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'qliqDelta' in this 'WellOutputs_String' view."),
    reservoirPressureDatum: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'reservoirPressureDatum' in this 'WellOutputs_String' view."),
    reservoirPressureMidPerforation: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'reservoirPressureMidPerforation' in this 'WellOutputs_String' view."),
    simulationChokeId: z.lazy(() => TimeSeriesSchema.nullish()).describe('CH simulation run ID history'),
    simulationCurveInput: z.lazy(() => TimeSeriesSchema.nullish()).describe('ESP Curve inputs history'),
    simulationId: z.lazy(() => TimeSeriesSchema.nullish()).describe('SA simulation run ID history'),
    simulationIprInput: z.lazy(() => TimeSeriesSchema.nullish()).describe('IPR inputs history'),
    simulationVlpInput: z.lazy(() => TimeSeriesSchema.nullish()).describe('VLP inputs history'),
    sluggingStatus: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('1 indicates hydrodynamic slug flow in the well string, 0 indicates the opposite.'),
    steadyStateStatus: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        '0 indicates well string is in a transient state or shut-in, 1 indicates the well string is in a flowing quasi-steady state',
      ),
    subSurfaceSafetyValveCloseState: z
      .number()
      .nullish()
      .describe(
        'Which number in the subsurface safety valve time series for the well string corresponds to the closed state. Based on statistical analysis. To be removed when extractor is able to retreive the subsurface safety valve position.',
      ),
    surfaceSafetyValveCloseState: z
      .number()
      .nullish()
      .describe(
        'Which number in the surface safety valve time series for the well string corresponds to the closed state. Based on statistical analysis. To be removed when extractor is able to retreive the surface safety valve position.',
      ),
    systemAnalysisFbhp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of flowing bottom-hole pressure (FBHP) from system analysis for this string.'),
    systemAnalysisGasRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of gas production rate at standard conditions from system analysis for this string.'),
    systemAnalysisLiquidRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of total liquid production rate at standard conditions from system analysis for this string.',
      ),
    systemAnalysisOilRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of oil production rate at standard conditions from system analysis for this string.'),
    systemAnalysisPdp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('PROSPER system analysis output of pump discharge pressure'),
    systemAnalysisPip: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('PROSPER system analysis output of pump intake pressure'),
    systemAnalysisStatus: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'systemAnalysisStatus' in this 'WellOutputs_String' view."),
    systemAnalysisWaterRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of water production rate at standard conditions from system analysis for this string.'),
    vlpAnalysisFbhp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'vlpAnalysisFbhp' in this 'WellOutputs_String' view."),
    vlpAnalysisGasRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'vlpAnalysisGasRateStd' in this 'WellOutputs_String' view."),
    vlpAnalysisLiquidRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'vlpAnalysisLiquidRateStd' in this 'WellOutputs_String' view."),
    vlpAnalysisOilRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'vlpAnalysisOilRateStd' in this 'WellOutputs_String' view."),
    vlpAnalysisStatus: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Calculation status as a string for every run of the VLP method'),
    vlpAnalysisWaterRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'vlpAnalysisWaterRateStd' in this 'WellOutputs_String' view."),
    wag: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wag' in this 'WellOutputs_String' view."),
    wellPerformance: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellPerformance' in this 'WellOutputs_String' view."),
    wellSepDP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellSepDP' in this 'WellOutputs_String' view."),
    wellSepDT: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellSepDT' in this 'WellOutputs_String' view."),
    wellTestValidation: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestValidation' in this 'WellOutputs_String' view."),
    wellType: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellType' in this 'WellOutputs_String' view."),
    wiBHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wiBHP' in this 'WellOutputs_String' view."),
    wiRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wiRate' in this 'WellOutputs_String' view."),
    wiTargetRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wiTargetRate' in this 'WellOutputs_String' view."),
    wiTechnicalRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wiTechnicalRate' in this 'WellOutputs_String' view."),
    wiWHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wiWHP' in this 'WellOutputs_String' view."),
    wingValveCloseState: z
      .number()
      .nullish()
      .describe(
        'Which number in the wing valve time series for the well string corresponds to the closed state. Based on statistical analysis. To be removed when extractor is able to retreive the wing valve position.',
      ),
  })
  .describe("View 'WellOutputs_String' in the iPSO production optimization solution data model.");

export const WellOutputsExt_1StringSchema: z.ZodObject<Properties<WellOutputsExt_1String>> = z
  .object({
    __typename: z.literal('WellOutputs_Ext_1_String').optional(),
    dataDrivenGasRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'dataDrivenGasRateStd' in this 'WellOutputs_Ext_1_String' view."),
    dataDrivenLiquidRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'dataDrivenLiquidRateStd' in this 'WellOutputs_Ext_1_String' view."),
    dataDrivenOilRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'dataDrivenOilRateStd' in this 'WellOutputs_Ext_1_String' view."),
    dataDrivenWaterRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'dataDrivenWaterRateStd' in this 'WellOutputs_Ext_1_String' view."),
    entityName: z
      .lazy(() => StringAssetSchema.nullish())
      .describe("Reference to the related 'String_asset' entity for this 'WellOutputs_Ext_1_String' row."),
    giBHPCompliance: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'giBHPCompliance' in this 'WellOutputs_Ext_1_String' view."),
    giTargetRateCompliance: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'giTargetRateCompliance' in this 'WellOutputs_Ext_1_String' view."),
    giTechnicalRateCompliance: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'giTechnicalRateCompliance' in this 'WellOutputs_Ext_1_String' view."),
    giWHPCompliance: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'giWHPCompliance' in this 'WellOutputs_Ext_1_String' view."),
    wiBHPCompliance: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wiBHPCompliance' in this 'WellOutputs_Ext_1_String' view."),
    wiTargetRateCompliance: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wiTargetRateCompliance' in this 'WellOutputs_Ext_1_String' view."),
    wiTechnicalRateCompliance: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wiTechnicalRateCompliance' in this 'WellOutputs_Ext_1_String' view."),
    wiWHPCompliance: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wiWHPCompliance' in this 'WellOutputs_Ext_1_String' view."),
  })
  .describe("View 'WellOutputs_Ext_1_String' in the iPSO production optimization solution data model.");

export const WellInputsStringReverseSchema: z.ZodObject<Properties<WellInputsStringReverse>> = z
  .object({
    __typename: z.literal('WellInputs_String_Reverse').optional(),
    annulusPress: z.lazy(() => TimeSeriesSchema.nullish()).describe('Time series of annulus pressure for this string.'),
    bottomHolePress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of bottom-hole flowing pressure (for example from PDG or modeled) for this string.'),
    bottomHoleTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of bottom-hole temperature for this string.'),
    casingHeadPress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of casing head pressure for this string.'),
    chokeDownstreamPressure1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'chokeDownstreamPressure1' in this 'WellInputs_String_Reverse' view."),
    chokeDownstreamPressure2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'chokeDownstreamPressure2' in this 'WellInputs_String_Reverse' view."),
    chokeOpening: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'chokeOpening' in this 'WellInputs_String_Reverse' view."),
    chokeSize: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of surface choke opening or size setting for this string.'),
    controlValve: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series representing the position or status of the surface control valve associated with this string.',
      ),
    depthSensor: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'depthSensor' in this 'WellInputs_String_Reverse' view."),
    downstreamPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of pressure measured downstream of the well control valve for this string.'),
    entityName: z
      .lazy(() => StringAssetSchema.nullish())
      .describe(
        "Name of the well string (completion) for which well input measurements are captured, sourced from the 'String_asset' view.",
      ),
    flowLinePress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of flowline pressure downstream of the wellhead for this string.'),
    flowLineTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of flowline temperature downstream of the wellhead for this string.'),
    gasInjChokeOpening: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gasInjChokeOpening' in this 'WellInputs_String_Reverse' view."),
    gasInjRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gasInjRate' in this 'WellInputs_String_Reverse' view."),
    gasInjWellheadPress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gasInjWellheadPress' in this 'WellInputs_String_Reverse' view."),
    gasLiftFlowCVInletPress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of inlet pressure at the gas lift flow control valve for this string.'),
    gasLiftFlowCVInletTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gasLiftFlowCVInletTemp' in this 'WellInputs_String_Reverse' view."),
    gasLiftFlowCVSize: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of effective orifice/trim size of the gas lift flow control valve for this string.'),
    gasLiftInjRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of gas lift injection rate into this string.'),
    gasLiftInjTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of gas lift injection temperature for this string.'),
    gasRateFlow: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gasRateFlow' in this 'WellInputs_String_Reverse' view."),
    giHeaderPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'giHeaderPressure' in this 'WellInputs_String_Reverse' view."),
    giHeaderTemperature: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'giHeaderTemperature' in this 'WellInputs_String_Reverse' view."),
    liftType: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series indicating the artificial lift type currently applied to this string (for example natural flow, gas lift, ESP).',
      ),
    modelComposition: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelComposition' in this 'WellInputs_String_Reverse' view."),
    potentialGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialGasInjection' in this 'WellInputs_String_Reverse' view."),
    potentialGasProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialGasProduction' in this 'WellInputs_String_Reverse' view."),
    potentialOilProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialOilProduction' in this 'WellInputs_String_Reverse' view."),
    potentialWaterInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialWaterInjection' in this 'WellInputs_String_Reverse' view."),
    potentialWaterProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialWaterProduction' in this 'WellInputs_String_Reverse' view."),
    pumpCurrent: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of electrical current drawn by the pump motor for this string.'),
    pumpDischargePress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of pump discharge pressure at the pump outlet for this string.'),
    pumpDischargeTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of fluid temperature at the pump discharge for this string.'),
    pumpFrequency: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of downhole pump operating frequency (for example ESP motor frequency in Hz) for this string.',
      ),
    pumpIntakePress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of pump intake pressure at the pump suction for this string.'),
    pumpIntakeTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of fluid temperature at the pump intake for this string.'),
    pumpMotorTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of downhole pump motor temperature for this string.'),
    pumpVibration: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of vibration level measured on the downhole pump or completion for this string.'),
    pumpVoltage: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of electrical voltage supplied to the pump motor for this string.'),
    sPress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'sPress' in this 'WellInputs_String_Reverse' view."),
    subSurfaceSafetyValve: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'subSurfaceSafetyValve' in this 'WellInputs_String_Reverse' view."),
    surfaceSafetyValve: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'surfaceSafetyValve' in this 'WellInputs_String_Reverse' view."),
    targetGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetGasInjection' in this 'WellInputs_String_Reverse' view."),
    targetGasProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetGasProduction' in this 'WellInputs_String_Reverse' view."),
    targetOilProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetOilProduction' in this 'WellInputs_String_Reverse' view."),
    targetWaterInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetWaterInjection' in this 'WellInputs_String_Reverse' view."),
    targetWaterProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetWaterProduction' in this 'WellInputs_String_Reverse' view."),
    toProdHeader: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'toProdHeader' in this 'WellInputs_String_Reverse' view."),
    toTestHeader: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'toTestHeader' in this 'WellInputs_String_Reverse' view."),
    waterHeaderPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'waterHeaderPressure' in this 'WellInputs_String_Reverse' view."),
    waterInjChokeOpening: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'waterInjChokeOpening' in this 'WellInputs_String_Reverse' view."),
    waterInjRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'waterInjRate' in this 'WellInputs_String_Reverse' view."),
    waterInjWellheadPress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'waterInjWellheadPress' in this 'WellInputs_String_Reverse' view."),
    wellHeadPress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of wellhead pressure measured at the tree for this string.'),
    wellHeadTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of wellhead temperature measured at the tree for this string.'),
    wingValve: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series representing the status or opening of the wing valve on this string.'),
  })
  .describe(
    'High-frequency well string input measurements used as boundary conditions for modelling and optimization, including ESP pump parameters, gas lift injection conditions, wellhead and flowline pressures and temperatures, choke settings and key valve statuses.',
  );

export const WellInputsStringSchema: z.ZodObject<Properties<WellInputsString>> = z
  .object({
    __typename: z.literal('WellInputs_String').optional(),
    annulusPress: z.lazy(() => TimeSeriesSchema.nullish()).describe('Time series of annulus pressure for this string.'),
    bottomHolePress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of bottom-hole flowing pressure (for example from PDG or modeled) for this string.'),
    bottomHoleTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of bottom-hole temperature for this string.'),
    casingHeadPress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of casing head pressure for this string.'),
    chokeDownstreamPressure1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'chokeDownstreamPressure1' in this 'WellInputs_String' view."),
    chokeDownstreamPressure2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'chokeDownstreamPressure2' in this 'WellInputs_String' view."),
    chokeOpening: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'chokeOpening' in this 'WellInputs_String' view."),
    chokeSize: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of surface choke opening or size setting for this string.'),
    controlValve: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series representing the position or status of the surface control valve associated with this string.',
      ),
    depthSensor: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'depthSensor' in this 'WellInputs_String' view."),
    downstreamPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of pressure measured downstream of the well control valve for this string.'),
    entityName: z
      .lazy(() => StringAssetSchema.nullish())
      .describe(
        "Name of the well string (completion) for which well input measurements are captured, sourced from the 'String_asset' view.",
      ),
    flowLinePress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of flowline pressure downstream of the wellhead for this string.'),
    flowLineTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of flowline temperature downstream of the wellhead for this string.'),
    gasInjChokeOpening: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gasInjChokeOpening' in this 'WellInputs_String' view."),
    gasInjRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gasInjRate' in this 'WellInputs_String' view."),
    gasInjWellheadPress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gasInjWellheadPress' in this 'WellInputs_String' view."),
    gasLiftFlowCVInletPress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of inlet pressure at the gas lift flow control valve for this string.'),
    gasLiftFlowCVInletTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gasLiftFlowCVInletTemp' in this 'WellInputs_String' view."),
    gasLiftFlowCVSize: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of effective orifice/trim size of the gas lift flow control valve for this string.'),
    gasLiftInjRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of gas lift injection rate into this string.'),
    gasLiftInjTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of gas lift injection temperature for this string.'),
    gasRateFlow: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gasRateFlow' in this 'WellInputs_String' view."),
    giHeaderPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'giHeaderPressure' in this 'WellInputs_String' view."),
    giHeaderTemperature: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'giHeaderTemperature' in this 'WellInputs_String' view."),
    liftType: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series indicating the artificial lift type currently applied to this string (for example natural flow, gas lift, ESP).',
      ),
    modelComposition: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelComposition' in this 'WellInputs_String' view."),
    potentialGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialGasInjection' in this 'WellInputs_String' view."),
    potentialGasProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialGasProduction' in this 'WellInputs_String' view."),
    potentialOilProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialOilProduction' in this 'WellInputs_String' view."),
    potentialWaterInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialWaterInjection' in this 'WellInputs_String' view."),
    potentialWaterProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialWaterProduction' in this 'WellInputs_String' view."),
    productionHeaderPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'productionHeaderPressure' in this 'WellInputs_String' view."),
    pumpCurrent: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of electrical current drawn by the pump motor for this string.'),
    pumpDischargePress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of pump discharge pressure at the pump outlet for this string.'),
    pumpDischargeTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of fluid temperature at the pump discharge for this string.'),
    pumpFrequency: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of downhole pump operating frequency (for example ESP motor frequency in Hz) for this string.',
      ),
    pumpIntakePress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of pump intake pressure at the pump suction for this string.'),
    pumpIntakeTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of fluid temperature at the pump intake for this string.'),
    pumpMotorTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of downhole pump motor temperature for this string.'),
    pumpVibration: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of vibration level measured on the downhole pump or completion for this string.'),
    pumpVoltage: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of electrical voltage supplied to the pump motor for this string.'),
    sPress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'sPress' in this 'WellInputs_String' view."),
    subSurfaceSafetyValve: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'subSurfaceSafetyValve' in this 'WellInputs_String' view."),
    surfaceSafetyValve: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'surfaceSafetyValve' in this 'WellInputs_String' view."),
    targetGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetGasInjection' in this 'WellInputs_String' view."),
    targetGasProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetGasProduction' in this 'WellInputs_String' view."),
    targetOilProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetOilProduction' in this 'WellInputs_String' view."),
    targetWaterInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetWaterInjection' in this 'WellInputs_String' view."),
    targetWaterProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetWaterProduction' in this 'WellInputs_String' view."),
    toProdHeader: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'toProdHeader' in this 'WellInputs_String' view."),
    toTestHeader: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'toTestHeader' in this 'WellInputs_String' view."),
    waterHeaderPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'waterHeaderPressure' in this 'WellInputs_String' view."),
    waterInjChokeOpening: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'waterInjChokeOpening' in this 'WellInputs_String' view."),
    waterInjRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'waterInjRate' in this 'WellInputs_String' view."),
    waterInjWellheadPress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'waterInjWellheadPress' in this 'WellInputs_String' view."),
    wellHeadPress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of wellhead pressure measured at the tree for this string.'),
    wellHeadTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of wellhead temperature measured at the tree for this string.'),
    wingValve: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series representing the status or opening of the wing valve on this string.'),
  })
  .describe(
    'High-frequency well string input measurements used as boundary conditions for modelling and optimization, including ESP pump parameters, gas lift injection conditions, wellhead and flowline pressures and temperatures, choke settings and key valve statuses.',
  );

export const WaterAnalysisSchema: z.ZodObject<Properties<WaterAnalysis>> = z
  .object({
    __typename: z.literal('Water_Analysis').optional(),
    analysisDate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'analysisDate' in this 'Water_Analysis' view."),
    barium: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'barium' in this 'Water_Analysis' view."),
    bicarbonate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'bicarbonate' in this 'Water_Analysis' view."),
    boron: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'boron' in this 'Water_Analysis' view."),
    bsw: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'bsw' in this 'Water_Analysis' view."),
    calcium: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calcium' in this 'Water_Analysis' view."),
    calculatedTotalDisolvedSolids: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calculatedTotalDisolvedSolids' in this 'Water_Analysis' view."),
    carbonate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'carbonate' in this 'Water_Analysis' view."),
    chloride: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'chloride' in this 'Water_Analysis' view."),
    companyProgramRef: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'companyProgramRef' in this 'Water_Analysis' view."),
    companySampleNo: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'companySampleNo' in this 'Water_Analysis' view."),
    dissolvedIron: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'dissolvedIron' in this 'Water_Analysis' view."),
    entityName: z
      .lazy(() => StringAssetSchema.nullish())
      .describe("Reference to the related 'String_asset' entity for this 'Water_Analysis' row."),
    h2s: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'h2s' in this 'Water_Analysis' view."),
    hydroxide: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'hydroxide' in this 'Water_Analysis' view."),
    id: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'id' in this 'Water_Analysis' view."),
    iron: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'iron' in this 'Water_Analysis' view."),
    magnesium: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'magnesium' in this 'Water_Analysis' view."),
    measuredTotalDisolvedSolids: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'measuredTotalDisolvedSolids' in this 'Water_Analysis' view."),
    oilContentVol: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'oilContentVol' in this 'Water_Analysis' view."),
    ph: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'ph' in this 'Water_Analysis' view."),
    phTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'phTemp' in this 'Water_Analysis' view."),
    phosphorous: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'phosphorous' in this 'Water_Analysis' view."),
    potassium: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potassium' in this 'Water_Analysis' view."),
    remarks: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'remarks' in this 'Water_Analysis' view."),
    reportRef: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'reportRef' in this 'Water_Analysis' view."),
    resistivity: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'resistivity' in this 'Water_Analysis' view."),
    resistivityTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'resistivityTemp' in this 'Water_Analysis' view."),
    salinity: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'salinity' in this 'Water_Analysis' view."),
    sampleDate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'sampleDate' in this 'Water_Analysis' view."),
    sampleType: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'sampleType' in this 'Water_Analysis' view."),
    sgTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'sgTemp' in this 'Water_Analysis' view."),
    sodium: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'sodium' in this 'Water_Analysis' view."),
    solubility: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'solubility' in this 'Water_Analysis' view."),
    specificGravity: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'specificGravity' in this 'Water_Analysis' view."),
    strontium: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'strontium' in this 'Water_Analysis' view."),
    sulphate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'sulphate' in this 'Water_Analysis' view."),
    temperature: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'temperature' in this 'Water_Analysis' view."),
    totalIron: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'totalIron' in this 'Water_Analysis' view."),
    totalSuspendedSolids: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'totalSuspendedSolids' in this 'Water_Analysis' view."),
  })
  .describe("View 'Water_Analysis' in the iPSO production optimization solution data model.");

export const Wf05StringReservoirOutputsSchema: z.ZodObject<Properties<Wf05StringReservoirOutputs>> = z
  .object({
    __typename: z.literal('WF05_String_Reservoir_Outputs').optional(),
    allocatedWellInjectionGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    allocatedWellInjectionGasVolume: z.lazy(() => TimeSeriesSchema.nullish()),
    allocatedWellInjectionWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    allocatedWellInjectionWaterVolume: z.lazy(() => TimeSeriesSchema.nullish()),
    entityName: z
      .lazy(() => StringAssetSchema.nullish())
      .describe(
        "Name of the well string (completion) for which WF05 reservoir-level string outputs are reported in this view, sourced from the 'String_asset' view.",
      ),
    executionType: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of execution type flag for this string-reservoir combination in the WF05 reservoir-level string workflow output (for example scheduled run, manual run).',
      ),
    fieldName: z
      .lazy(() => FieldSchema.nullish())
      .describe("Name of the field in which this reservoir and string are located, sourced from the 'Field' view."),
    linkString: z
      .string()
      .nullish()
      .describe("Text attribute 'linkString' for this 'WF05_String_Reservoir_Outputs' row."),
    normalizedWeightFactorChoke: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of normalized weight factor choke for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    normalizedWeightFactorDataDriven: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of normalized weight factor data-driven for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    normalizedWeightFactorESP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of normalized weight factor electric submersible pump (ESP) for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    normalizedWeightFactorIPR: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of normalized weight factor inflow performance relationship (IPR) for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    normalizedWeightFactorSystemAnalysis: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of normalized weight factor system analysis for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    normalizedWeightFactorVLP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of normalized weight factor vertical lift performance (VLP) for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    preferredVFMAllocatedWellAssociatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    preferredVFMAllocatedWellAssociatedGasVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of preferred VFM allocated well associated gas volume for this string-reservoir combination in the WF05 reservoir-level string workflow output. Represents the portion of associated gas volume allocated to this string when using the preferred VFM method.',
      ),
    preferredVFMAllocatedWellNonAssociatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    preferredVFMAllocatedWellNonAssociatedGasVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of preferred VFM allocated well non-associated gas volume for this string-reservoir combination in the WF05 reservoir-level string workflow output. Represents the portion of non-associated gas volume allocated to this string when using the preferred VFM method.',
      ),
    preferredVFMAllocatedWellOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    preferredVFMAllocatedWellOilVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of preferred VFM allocated well oil volume for this string-reservoir combination in the WF05 reservoir-level string workflow output. Represents the portion of reservoir oil volume allocated to this string when using the preferred VFM method.',
      ),
    preferredVFMAllocatedWellWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    preferredVFMAllocatedWellWaterVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of preferred VFM allocated well water volume for this string-reservoir combination in the WF05 reservoir-level string workflow output. Represents the portion of produced water volume allocated to this string when using the preferred VFM method.',
      ),
    preferredVFMAverageAssociatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of preferred VFM average associated gas production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    preferredVFMAverageNonAssociatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of preferred VFM average non-associated gas production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    preferredVFMAverageOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of preferred VFM average oil production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    preferredVFMAverageWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of preferred VFM average water production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    preferredVFMDataSourceFlag: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of preferred VFM data source flag for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    preferredVFMEstimatedWellAssociatedGasVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of preferred VFM estimated well associated gas volume for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    preferredVFMEstimatedWellNonAssociatedGasVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of preferred VFM estimated well non-associated gas volume for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    preferredVFMEstimatedWellOilVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of preferred VFM estimated well oil volume for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    preferredVFMEstimatedWellWaterVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of preferred VFM estimated well water volume for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    reservoirName: z
      .lazy(() => ReservoirSchema.nullish())
      .describe("Name of the reservoir to which this string's WF05 outputs apply, sourced from the 'Reservoir' view."),
    vfmChokeAverageAssociatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) choke average associated gas rate for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    vfmChokeAverageNonAssociatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) choke-based average non-associated gas production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    vfmChokeAverageOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) choke average oil rate for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    vfmChokeAverageWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) choke-based average water production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    vfmDataDrivenAverageAssociatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) data-driven average associated gas production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    vfmDataDrivenAverageNonAssociatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) data-driven average non-associated gas production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    vfmDataDrivenAverageOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) data-driven average oil rate for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    vfmDataDrivenAverageWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) data-driven average water production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    vfmESPAverageAssociatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) ESP-based average associated gas production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    vfmESPAverageNonAssociatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) ESP-based average non-associated gas production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    vfmESPAverageOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) ESP-based average oil production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    vfmESPAverageWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) ESP-based average water production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    vfmIPRAverageAssociatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) IPR-based average associated gas production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    vfmIPRAverageNonAssociatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) IPR-based average non-associated gas production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    vfmIPRAverageOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) IPR-based average oil production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    vfmIPRAverageWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) IPR-based average water production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    vfmSystemAnalysisAverageAssociatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) system analysis average associated gas rate for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    vfmSystemAnalysisAverageAssociatedNonAssociatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) system-analysis average combined associated and non-associated gas production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    vfmSystemAnalysisAverageOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) system analysis average oil rate for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    vfmSystemAnalysisAverageWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) system-analysis average water production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    vfmVLPAverageAssociatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) VLP-based average associated gas production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    vfmVLPAverageNonAssociatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) VLP-based average non-associated gas production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    vfmVLPAverageOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) VLP-based average oil production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    vfmVLPAverageWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) VLP-based average water production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    weightedAverageDataSourceFlag: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of weighted average data source flag for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    weightedAverageVFMAllocatedWellAssociatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    weightedAverageVFMAllocatedWellAssociatedGasVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of weighted average VFM allocated well associated gas volume for this string-reservoir combination in the WF05 reservoir-level string workflow output. Combines multiple VFM methods using their normalized weights to produce a single allocated associated gas volume per string.',
      ),
    weightedAverageVFMAllocatedWellNonAssociatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    weightedAverageVFMAllocatedWellNonAssociatedGasVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of weighted average VFM allocated well non-associated gas volume for this string-reservoir combination in the WF05 reservoir-level string workflow output. Combines multiple VFM methods using their normalized weights to produce a single allocated non-associated gas volume per string.',
      ),
    weightedAverageVFMAllocatedWellOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    weightedAverageVFMAllocatedWellOilVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of weighted average VFM allocated well oil volume for this string-reservoir combination in the WF05 reservoir-level string workflow output. Combines multiple VFM methods using their normalized weights to produce a single allocated oil volume per string.',
      ),
    weightedAverageVFMAllocatedWellWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    weightedAverageVFMAllocatedWellWaterVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of weighted average VFM allocated well water volume for this string-reservoir combination in the WF05 reservoir-level string workflow output. Combines multiple VFM methods using their normalized weights to produce a single allocated water volume per string.',
      ),
    weightedAverageVFMAssociatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of weighted average VFM associated gas production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    weightedAverageVFMEstimatedWellAssociatedGasVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of weighted average VFM estimated well associated gas volume for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    weightedAverageVFMEstimatedWellNonAssociatedGasVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of weighted average VFM estimated well non-associated gas volume for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    weightedAverageVFMEstimatedWellOilVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of weighted average VFM estimated well oil volume for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    weightedAverageVFMEstimatedWellWaterVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of weighted average VFM estimated well water volume for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    weightedAverageVFMNonAssociatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of weighted average VFM non-associated gas production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    weightedAverageVFMOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of weighted average VFM oil production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    weightedAverageVFMWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of weighted average VFM water production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
    wellUptime: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of well uptime for this string-reservoir combination in the WF05 reservoir-level string workflow output.',
      ),
  })
  .describe(
    'String-reservoir level outputs from the WF05 workflow, providing virtual flow meter (VFM) based oil, gas and water rates, estimated well volumes, method-specific VFM rates and diagnostics used for allocation and well performance evaluation at the reservoir sector level.',
  );

export const Wf05StringOutputsSchema: z.ZodObject<Properties<Wf05StringOutputs>> = z
  .object({
    __typename: z.literal('WF05_String_Outputs').optional(),
    agProductionAllocationStatus: z.lazy(() => TimeSeriesSchema.nullish()),
    allocatedWellInjectionGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    allocatedWellInjectionGasVolume: z.lazy(() => TimeSeriesSchema.nullish()),
    allocatedWellInjectionWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    allocatedWellInjectionWaterVolume: z.lazy(() => TimeSeriesSchema.nullish()),
    averageGasInjectionRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of average gas injection rate for this well string in the WF05 string-level workflow output.',
      ),
    averageWaterInjectionRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of average water injection rate for this well string in the WF05 string-level workflow output.',
      ),
    chokeAnalysisWeightFactor: z.lazy(() => TimeSeriesSchema.nullish()),
    dataDrivenAnalysisWeightFactor: z.lazy(() => TimeSeriesSchema.nullish()),
    entityName: z
      .lazy(() => StringAssetSchema.nullish())
      .describe(
        'Name of the well string (completion) for which WF05 workflow VFM-based rates, volumes and diagnostics are reported in this view.',
      ),
    espAnalysisWeightFactor: z.lazy(() => TimeSeriesSchema.nullish()),
    executionType: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of execution type for this well string in the WF05 string-level workflow output.'),
    gasInjectioAllocationStatus: z.lazy(() => TimeSeriesSchema.nullish()),
    gasProductionAllocationStatus: z.lazy(() => TimeSeriesSchema.nullish()),
    injectionRateDataSourceFlag: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of injection rate data source flag for this well string in the WF05 string-level workflow output.',
      ),
    iprAnalysisWeightFactor: z.lazy(() => TimeSeriesSchema.nullish()),
    isWag: z.lazy(() => TimeSeriesSchema.nullish()),
    nagProductionAllocationStatus: z.lazy(() => TimeSeriesSchema.nullish()),
    normalizedWeightFactorChoke: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of normalized weight factor choke for this well string in the WF05 string-level workflow output.',
      ),
    normalizedWeightFactorDataDriven: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of normalized weight factor data driven for this well string in the WF05 string-level workflow output.',
      ),
    normalizedWeightFactorESP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of normalized weight factor electric submersible pump (ESP) for this well string in the WF05 string-level workflow output.',
      ),
    normalizedWeightFactorIPR: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of normalized weight factor inflow performance relationship (IPR) for this well string in the WF05 string-level workflow output.',
      ),
    normalizedWeightFactorSystemAnalysis: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of normalized weight factor system analysis for this well string in the WF05 string-level workflow output.',
      ),
    normalizedWeightFactorVLP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of normalized weight factor vertical lift performance (VLP) for this well string in the WF05 string-level workflow output.',
      ),
    oilProductionAllocationStatus: z.lazy(() => TimeSeriesSchema.nullish()),
    preferredVFMAllocatedWellAssociatedGasVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of preferred vfmallocated well associated gas volume for this well string in the WF05 string-level workflow output.',
      ),
    preferredVFMAllocatedWellNonAssociatedGasVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of preferred vfmallocated well non-associated gas volume for this well string in the WF05 string-level workflow output.',
      ),
    preferredVFMAllocatedWellOilVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of preferred vfmallocated well oil volume for this well string in the WF05 string-level workflow output.',
      ),
    preferredVFMAllocatedWellWaterVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of preferred vfmallocated well water volume for this well string in the WF05 string-level workflow output.',
      ),
    preferredVFMAverageAssociatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of preferred vfmaverage associated gas rate for this well string in the WF05 string-level workflow output.',
      ),
    preferredVFMAverageNonAssociatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of preferred vfmaverage non-associated gas rate for this well string in the WF05 string-level workflow output.',
      ),
    preferredVFMAverageOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of preferred vfmaverage oil rate for this well string in the WF05 string-level workflow output.',
      ),
    preferredVFMAverageWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of preferred vfmaverage water rate for this well string in the WF05 string-level workflow output.',
      ),
    preferredVFMDataSourceFlag: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of preferred vfmdata source flag for this well string in the WF05 string-level workflow output.',
      ),
    preferredVFMEstimatedWellAssociatedGasVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of preferred vfmestimated well associated gas volume for this well string in the WF05 string-level workflow output.',
      ),
    preferredVFMEstimatedWellNonAssociatedGasVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of preferred vfmestimated well non-associated gas volume for this well string in the WF05 string-level workflow output.',
      ),
    preferredVFMEstimatedWellOilVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of preferred vfmestimated well oil volume for this well string in the WF05 string-level workflow output.',
      ),
    preferredVFMEstimatedWellWaterVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of preferred vfmestimated well water volume for this well string in the WF05 string-level workflow output.',
      ),
    systemAnalysisWeightFactor: z.lazy(() => TimeSeriesSchema.nullish()),
    vfmChokeAverageAssociatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) choke average associated gas rate for this well string in the WF05 string-level workflow output.',
      ),
    vfmChokeAverageNonAssociatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) choke average non-associated gas rate for this well string in the WF05 string-level workflow output.',
      ),
    vfmChokeAverageOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) choke average oil rate for this well string in the WF05 string-level workflow output.',
      ),
    vfmChokeAverageWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) choke average water rate for this well string in the WF05 string-level workflow output.',
      ),
    vfmDataDrivenAverageAssociatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) data driven average associated gas rate for this well string in the WF05 string-level workflow output.',
      ),
    vfmDataDrivenAverageNonAssociatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) data driven average non-associated gas rate for this well string in the WF05 string-level workflow output.',
      ),
    vfmDataDrivenAverageOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) data driven average oil rate for this well string in the WF05 string-level workflow output.',
      ),
    vfmDataDrivenAverageWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) data driven average water rate for this well string in the WF05 string-level workflow output.',
      ),
    vfmESPAverageAssociatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) espaverage associated gas rate for this well string in the WF05 string-level workflow output.',
      ),
    vfmESPAverageNonAssociatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) espaverage non-associated gas rate for this well string in the WF05 string-level workflow output.',
      ),
    vfmESPAverageOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) espaverage oil rate for this well string in the WF05 string-level workflow output.',
      ),
    vfmESPAverageWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) espaverage water rate for this well string in the WF05 string-level workflow output.',
      ),
    vfmIPRAverageAssociatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) ipraverage associated gas rate for this well string in the WF05 string-level workflow output.',
      ),
    vfmIPRAverageNonAssociatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) ipraverage non-associated gas rate for this well string in the WF05 string-level workflow output.',
      ),
    vfmIPRAverageOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) ipraverage oil rate for this well string in the WF05 string-level workflow output.',
      ),
    vfmIPRAverageWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) ipraverage water rate for this well string in the WF05 string-level workflow output.',
      ),
    vfmPreferredMethodAssociatedGasAllocationRate: z.lazy(() => TimeSeriesSchema.nullish()),
    vfmPreferredMethodNonAssociatedGasAllocationRate: z.lazy(() => TimeSeriesSchema.nullish()),
    vfmPreferredMethodOilAllocationRate: z.lazy(() => TimeSeriesSchema.nullish()),
    vfmPreferredMethodWaterAllocationRate: z.lazy(() => TimeSeriesSchema.nullish()),
    vfmSystemAnalysisAverageAssociatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) system analysis average associated gas rate for this well string in the WF05 string-level workflow output.',
      ),
    vfmSystemAnalysisAverageAssociatedNonAssociatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) system analysis average associated non-associated gas rate for this well string in the WF05 string-level workflow output.',
      ),
    vfmSystemAnalysisAverageOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) system analysis average oil rate for this well string in the WF05 string-level workflow output.',
      ),
    vfmSystemAnalysisAverageWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) system analysis average water rate for this well string in the WF05 string-level workflow output.',
      ),
    vfmVLPAverageAssociatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) vlpaverage associated gas rate for this well string in the WF05 string-level workflow output.',
      ),
    vfmVLPAverageNonAssociatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) vlpaverage non-associated gas rate for this well string in the WF05 string-level workflow output.',
      ),
    vfmVLPAverageOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) vlpaverage oil rate for this well string in the WF05 string-level workflow output.',
      ),
    vfmVLPAverageWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of virtual flow meter (VFM) vlpaverage water rate for this well string in the WF05 string-level workflow output.',
      ),
    vfmWeightedAverageAssociatedGasAllocationRate: z.lazy(() => TimeSeriesSchema.nullish()),
    vfmWeightedAverageMethodOilAllocationRate: z.lazy(() => TimeSeriesSchema.nullish()),
    vfmWeightedAverageNonAssociatedGasAllocationRate: z.lazy(() => TimeSeriesSchema.nullish()),
    vfmWeightedAverageWaterAllocationRate: z.lazy(() => TimeSeriesSchema.nullish()),
    vlpAnalysisWeightFactor: z.lazy(() => TimeSeriesSchema.nullish()),
    waterInjectionAllocationStatus: z.lazy(() => TimeSeriesSchema.nullish()),
    waterProductionAllocationStatus: z.lazy(() => TimeSeriesSchema.nullish()),
    weightedAverageDataSourceFlag: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of weighted average data source flag for this well string in the WF05 string-level workflow output.',
      ),
    weightedAverageVFMAllocatedWellAssociatedGasVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of weighted average vfmallocated well associated gas volume for this well string in the WF05 string-level workflow output.',
      ),
    weightedAverageVFMAllocatedWellNonAssociatedGasVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of weighted average vfmallocated well non-associated gas volume for this well string in the WF05 string-level workflow output.',
      ),
    weightedAverageVFMAllocatedWellOilVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of weighted average vfmallocated well oil volume for this well string in the WF05 string-level workflow output.',
      ),
    weightedAverageVFMAllocatedWellWaterVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of weighted average vfmallocated well water volume for this well string in the WF05 string-level workflow output.',
      ),
    weightedAverageVFMAssociatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of weighted average vfmassociated gas rate for this well string in the WF05 string-level workflow output.',
      ),
    weightedAverageVFMEstimatedWellAssociatedGasVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of weighted average vfmestimated well associated gas volume for this well string in the WF05 string-level workflow output.',
      ),
    weightedAverageVFMEstimatedWellNonAssociatedGasVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of weighted average vfmestimated well non-associated gas volume for this well string in the WF05 string-level workflow output.',
      ),
    weightedAverageVFMEstimatedWellOilVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of weighted average vfmestimated well oil volume for this well string in the WF05 string-level workflow output.',
      ),
    weightedAverageVFMEstimatedWellWaterVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of weighted average vfmestimated well water volume for this well string in the WF05 string-level workflow output.',
      ),
    weightedAverageVFMNonAssociatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of weighted average vfmnon-associated gas rate for this well string in the WF05 string-level workflow output.',
      ),
    weightedAverageVFMOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of weighted average vfmoil rate for this well string in the WF05 string-level workflow output.',
      ),
    weightedAverageVFMWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of weighted average vfmwater rate for this well string in the WF05 string-level workflow output.',
      ),
    wellGasInjectionVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of well gas injection volume for this well string in the WF05 string-level workflow output.',
      ),
    wellType: z.lazy(() => TimeSeriesSchema.nullish()),
    wellUptime: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of well uptime for this well string in the WF05 string-level workflow output.'),
    wellWaterInjectionVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of well water injection volume for this well string in the WF05 string-level workflow output.',
      ),
  })
  .describe(
    'String level outputs from the WF05 workflow, providing virtual flow meter (VFM) based oil, gas and water rates, estimated well volumes, method-specific VFM rates and diagnostics used for allocation and well performance evaluation.',
  );

export const Wf05FieldOutputsSchema: z.ZodObject<Properties<Wf05FieldOutputs>> = z
  .object({
    __typename: z.literal('WF05_Field_Outputs').optional(),
    agProductionAllocationStatus: z.lazy(() => TimeSeriesSchema.nullish()),
    calculatedTotalGasLiftInjRate: z.lazy(() => TimeSeriesSchema.nullish()),
    dailyActualGasInjection: z.lazy(() => TimeSeriesSchema.nullish()),
    dailyActualOilProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of daily actual oil production for the field in the WF05 field-level workflow output.'),
    dailyActualWaterInjection: z.lazy(() => TimeSeriesSchema.nullish()),
    dailyActualWaterProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of daily actual water production for the field in the WF05 field-level workflow output.'),
    dailyAssociatedGasProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of daily associated gas production for the field in the WF05 field-level workflow output.',
      ),
    dailyNonAssociatedGasProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of daily non-associated gas production for the field in the WF05 field-level workflow output.',
      ),
    entityName: z
      .lazy(() => FieldSchema.nullish())
      .describe(
        'Name of the field for which WF05 workflow outputs (VFM estimates, allocation errors and allocation factors) are reported in this view.',
      ),
    executionType: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of execution type for the field in the WF05 field-level workflow output.'),
    expansionFactorGasPtsRef: z.lazy(() => TimeSeriesSchema.nullish()),
    fieldAllocationVolumeSource: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of field allocation volume source for the field in the WF05 field-level workflow output.'),
    fieldAssociatedGasVolumePtsRef: z.lazy(() => TimeSeriesSchema.nullish()),
    fieldInjectionAllocationVolumeSource: z.lazy(() => TimeSeriesSchema.nullish()),
    fieldNonAssociatedGasVolumePtsRef: z.lazy(() => TimeSeriesSchema.nullish()),
    fieldOilVolumePtsRef: z.lazy(() => TimeSeriesSchema.nullish()),
    fieldWaterVolumePtsRef: z.lazy(() => TimeSeriesSchema.nullish()),
    formationGOR: z.lazy(() => TimeSeriesSchema.nullish()),
    fvfWaterPtsRef: z.lazy(() => TimeSeriesSchema.nullish()),
    gasInjectioAllocationStatus: z.lazy(() => TimeSeriesSchema.nullish()),
    gasInjectionAllocationFactor: z.lazy(() => TimeSeriesSchema.nullish()),
    gasProductionAllocationStatus: z.lazy(() => TimeSeriesSchema.nullish()),
    injectionWFExecutionType: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of injection wfexecution type for the field in the WF05 field-level workflow output.'),
    nagProductionAllocationStatus: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvMeasuredTotalGasLiftInjRate: z.lazy(() => TimeSeriesSchema.nullish()),
    oilProductionAllocationStatus: z.lazy(() => TimeSeriesSchema.nullish()),
    preferredVFMAssociatedGasAllocationFactor: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of preferred vfmassociated gas allocation factor for the field in the WF05 field-level workflow output.',
      ),
    preferredVFMNonAssociatedGasAllocationFactor: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of preferred vfmnon-associated gas allocation factor for the field in the WF05 field-level workflow output.',
      ),
    preferredVFMOilAllocationFactor: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of preferred vfmoil allocation factor for the field in the WF05 field-level workflow output.',
      ),
    preferredVFMRelativeFieldAssociatedGasVolumeError: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of preferred vfmrelative field associated gas volume error for the field in the WF05 field-level workflow output.',
      ),
    preferredVFMRelativeFieldNonAssociatedGasVolumeError: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of preferred vfmrelative field non-associated gas volume error for the field in the WF05 field-level workflow output.',
      ),
    preferredVFMRelativeFieldOilVolumeError: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of preferred vfmrelative field oil volume error for the field in the WF05 field-level workflow output.',
      ),
    preferredVFMRelativeFieldWaterVolumeError: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of preferred vfmrelative field water volume error for the field in the WF05 field-level workflow output.',
      ),
    preferredVFMTotalWellsEstimatedAssociatedGasVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of preferred vfmtotal wells estimated associated gas volume for the field in the WF05 field-level workflow output.',
      ),
    preferredVFMTotalWellsEstimatedNonAssociatedGasVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of preferred vfmtotal wells estimated non-associated gas volume for the field in the WF05 field-level workflow output.',
      ),
    preferredVFMTotalWellsEstimatedOilVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of preferred vfmtotal wells estimated oil volume for the field in the WF05 field-level workflow output.',
      ),
    preferredVFMTotalWellsEstimatedWaterVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of preferred vfmtotal wells estimated water volume for the field in the WF05 field-level workflow output.',
      ),
    preferredVFMWaterAllocationFactor: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of preferred vfmwater allocation factor for the field in the WF05 field-level workflow output.',
      ),
    prpFileId: z.lazy(() => TimeSeriesSchema.nullish()),
    relativeFieldGasVolumeError: z.lazy(() => TimeSeriesSchema.nullish()),
    relativeFieldWaterVolumeError: z.lazy(() => TimeSeriesSchema.nullish()),
    reservoirTemperature: z.lazy(() => TimeSeriesSchema.nullish()),
    shrinkageFactorGasPtsRef: z.lazy(() => TimeSeriesSchema.nullish()),
    shrinkageFactorOilPtsRef: z.lazy(() => TimeSeriesSchema.nullish()),
    specificGasGravity: z.lazy(() => TimeSeriesSchema.nullish()),
    specificOilGravity: z.lazy(() => TimeSeriesSchema.nullish()),
    surfaceGasVolumePtsRef: z.lazy(() => TimeSeriesSchema.nullish()),
    surfaceGasVolumeRealTime: z.lazy(() => TimeSeriesSchema.nullish()),
    surfaceOilVolumePtsRef: z.lazy(() => TimeSeriesSchema.nullish()),
    surfaceOilVolumeRealTime: z.lazy(() => TimeSeriesSchema.nullish()),
    totalWellsGasInjectionVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of total wells gas injection volume for the field in the WF05 field-level workflow output.',
      ),
    totalWellsWaterInjectionVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of total wells water injection volume for the field in the WF05 field-level workflow output.',
      ),
    waterInjectionAllocationFactor: z.lazy(() => TimeSeriesSchema.nullish()),
    waterInjectionAllocationStatus: z.lazy(() => TimeSeriesSchema.nullish()),
    waterProductionAllocationStatus: z.lazy(() => TimeSeriesSchema.nullish()),
    waterSalinity: z.lazy(() => TimeSeriesSchema.nullish()),
    weightedAverageVFMAssociatedGasAllocationFactor: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of weighted average vfmassociated gas allocation factor for the field in the WF05 field-level workflow output.',
      ),
    weightedAverageVFMNonAssociatedGasAllocationFactor: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of weighted average vfmnon-associated gas allocation factor for the field in the WF05 field-level workflow output.',
      ),
    weightedAverageVFMOilAllocationFactor: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of weighted average vfmoil allocation factor for the field in the WF05 field-level workflow output.',
      ),
    weightedAverageVFMRelativeFieldAssociatedGasVolumeError: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of weighted average vfmrelative field associated gas volume error for the field in the WF05 field-level workflow output.',
      ),
    weightedAverageVFMRelativeFieldNonAssociatedGasVolumeError: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of weighted average vfmrelative field non-associated gas volume error for the field in the WF05 field-level workflow output.',
      ),
    weightedAverageVFMRelativeFieldOilVolumeError: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of weighted average vfmrelative field oil volume error for the field in the WF05 field-level workflow output.',
      ),
    weightedAverageVFMRelativeFieldWaterVolumeError: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of weighted average vfmrelative field water volume error for the field in the WF05 field-level workflow output.',
      ),
    weightedAverageVFMTotalWellsEstimatedAssociatedGasVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of weighted average vfmtotal wells estimated associated gas volume for the field in the WF05 field-level workflow output.',
      ),
    weightedAverageVFMTotalWellsEstimatedNonAssociatedGasVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of weighted average vfmtotal wells estimated non-associated gas volume for the field in the WF05 field-level workflow output.',
      ),
    weightedAverageVFMTotalWellsEstimatedOilVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of weighted average vfmtotal wells estimated oil volume for the field in the WF05 field-level workflow output.',
      ),
    weightedAverageVFMTotalWellsEstimatedWaterVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of weighted average vfmtotal wells estimated water volume for the field in the WF05 field-level workflow output.',
      ),
    weightedAverageVFMWaterAllocationFactor: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of weighted average vfmwater allocation factor for the field in the WF05 field-level workflow output.',
      ),
  })
  .describe(
    'Field-level outputs from the WF05 workflow, summarizing virtual flow meter (VFM) estimates, actual daily production, allocation errors and allocation factors for oil, gas and water across all wells in the field.',
  );

export const ValueTrackingAgentSchema: z.ZodObject<Properties<ValueTrackingAgent>> = z
  .object({
    __typename: z.literal('ValueTracking_Agent').optional(),
    controlParameter: z.string().nullish(),
    controlParameterPostOptimizedValue: z.number().nullish(),
    controlParameterScenarioName: z.string().nullish(),
    endDate: z.coerce.date<Date>().nullish(),
    estimatedGasRate: z.number().nullish(),
    estimatedOilRate: z.number().nullish(),
    estimatedTargetGasGain: z.number().nullish(),
    estimatedTargetOilGain: z.number().nullish(),
    estimatedTargetTotalGain: z.number().nullish(),
    oilPrice: z.number().nullish(),
    realizedCumGasVolumeGain: z.lazy(() => TimeSeriesSchema.nullish()),
    realizedCumGasVolumeGainBOE: z.lazy(() => TimeSeriesSchema.nullish()),
    realizedCumOilVolumeGain: z.lazy(() => TimeSeriesSchema.nullish()),
    realizedDollarCumValueGain: z.lazy(() => TimeSeriesSchema.nullish()),
    realizedDollarValueGain: z.lazy(() => TimeSeriesSchema.nullish()),
    realizedGasPerformance: z.lazy(() => TimeSeriesSchema.nullish()),
    realizedGasRateGain: z.lazy(() => TimeSeriesSchema.nullish()),
    realizedGasVolumeGain: z.lazy(() => TimeSeriesSchema.nullish()),
    realizedOilPerformance: z.lazy(() => TimeSeriesSchema.nullish()),
    realizedOilRateGain: z.lazy(() => TimeSeriesSchema.nullish()),
    realizedOilVolumeGain: z.lazy(() => TimeSeriesSchema.nullish()),
    realizedTotalCumVolumeGainBOE: z.lazy(() => TimeSeriesSchema.nullish()),
    realizedTotalVolumeGainBOE: z.lazy(() => TimeSeriesSchema.nullish()),
    realizedWaterPerformance: z.lazy(() => TimeSeriesSchema.nullish()),
    realizedWaterRateGain: z.lazy(() => TimeSeriesSchema.nullish()),
    source: z.string().nullish(),
    startDate: z.coerce.date<Date>().nullish(),
    status: z.string().nullish(),
    wellName: z.string().nullish(),
    wellString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe('Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context.'),
    wellUptimeHours: z.lazy(() => TimeSeriesSchema.nullish()),
  })
  .describe(
    'Value realization tracking with production gain and cost saving records per\nopportunity.\n\nContains comprehensive data on value realization associated with production\ngains and cost savings in USD or barrel oil equivalent, derived from various\noptimization opportunities. Sourced from well performance metrics, ticketing\nsystems, and optimization records, allowing it to answer analytical questions\nregarding the effectiveness of specific interventions and their financial\nimpacts. It excludes raw production data or detailed operational metrics that\nmay be found in other views focused on real-time production tracking. Use\ncases: performance assessment of optimization strategies, financial\nforecasting, and operational efficiency analysis.\n\n@name Value Tracking (Agent)',
  );

export const VrrMonitoringSchema: z.ZodObject<Properties<VrrMonitoring>> = z
  .object({
    __typename: z.literal('VRR_Monitoring').optional(),
    allocGas: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'allocGas' in this 'VRR_Monitoring' row."),
    allocGasInj: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'allocGasInj' in this 'VRR_Monitoring' row."),
    allocOil: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'allocOil' in this 'VRR_Monitoring' row."),
    allocWater: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'allocWater' in this 'VRR_Monitoring' row."),
    allocWaterInj: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'allocWaterInj' in this 'VRR_Monitoring' row."),
    entityName: z
      .lazy(() => StringAssetSchema.nullish())
      .describe("Reference to the related 'String_asset' entity for this 'VRR_Monitoring' row."),
    reservoir: z
      .lazy(() => ReservoirSchema.nullish())
      .describe("Reference to the related 'Reservoir' entity for this 'VRR_Monitoring' row."),
    sector: z
      .lazy(() => SectorSchema.nullish())
      .describe("Reference to the related 'Sector' entity for this 'VRR_Monitoring' row."),
    secvGas: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'secvGas' in this 'VRR_Monitoring' row."),
    secvGasInj: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'secvGasInj' in this 'VRR_Monitoring' row."),
    secvOil: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'secvOil' in this 'VRR_Monitoring' row."),
    secvWater: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'secvWater' in this 'VRR_Monitoring' row."),
    secvWaterInj: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'secvWaterInj' in this 'VRR_Monitoring' row."),
  })
  .describe("View 'VRR_Monitoring' in the iPSO production optimization solution data model.");

export const StringReservoirInputsSchema: z.ZodObject<Properties<StringReservoirInputs>> = z.object({
  __typename: z.literal('String_Reservoir_Inputs').optional(),
  entityName: z.lazy(() => StringAssetSchema.nullish()),
  fieldName: z.lazy(() => FieldSchema.nullish()),
  reservoirName: z.lazy(() => ReservoirSchema.nullish()),
  stringReservoirInjectionAllocationFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  stringReservoirProductionAllocationFactor: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const StringOutputsNetworkAgentSchema: z.ZodObject<Properties<StringOutputsNetworkAgent>> = z
  .object({
    __typename: z.literal('StringOutputs_Network_Agent').optional(),
    network: z.lazy(() => NetworkSchema.nullish()),
    nmvAsphalteneFlag: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvCgr: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvChokeSize: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvConnectedManifoldId: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvDp: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvDpChoke: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvDrawdown: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvDt: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvErosionalVelocity: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvEspMotorLoad: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvEstimatedFlowlinePressure: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvFWhTemp: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvFrequency: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvGlChp: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvGlInjectionDepth: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvGlOrificeDiameter: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvGlValveCasingPress: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvGlValveTubingPress: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvGlr: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvGlrInjected: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvGor: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvHydrateFlag: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvInjectionGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvInjectionWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvMixtureVelocity: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvMotorCurrent: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvMotorEfficiency: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvMotorLoad: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvMotorPower: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvMotorRPM: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvPdown: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvPe5StabilityFlag: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvPmiFlpPercent: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvPmiWhpPercent: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvPressureMatchIndexFLP: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvPressureMatchIndexWHP: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvPumpEfficiency: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvPumpHead: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvPumpIntakePress: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvPumpOutletPress: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvPumpPower: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvPumpRate: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvReservoirPressure: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvScaleFlag: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvSurfaceKVA: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvTDown: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvTotalGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvTotalOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvTotalWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvWaterCut: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvWaxFlag: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvWellBHP: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvWellGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvWellLiquidRate: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvWellOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvWellSolverDifference: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvWellSolverDifferenceGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvWellSolverDifferenceLiquidRate: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvWellSolverDifferenceWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvWellSolverEstimatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvWellSolverEstimatedLiquidRate: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvWellSolverEstimatedOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvWellSolverEstimatedWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvWellSolverFBHP: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvWellSolverFWHT: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvWellSolverGor: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvWellSolverMeasuredGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvWellSolverMeasuredLiquidRate: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvWellSolverMeasuredOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvWellSolverMeasuredWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvWellSolverWHP: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvWellSolverWaterCut: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvWellViolatingConstraintsFlag: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvWellWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvWgr: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvWhp: z.lazy(() => TimeSeriesSchema.nullish()),
    nmvWht: z.lazy(() => TimeSeriesSchema.nullish()),
    wellString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe('Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context.'),
  })
  .describe(
    'Canonical per-network matched string outputs from the network solution model,\nkeyed by string and network (WF7/WF8/WF20).\n\nUses the nmv* ("network-matched variable") property family: matched oil, gas,\nwater, liquid rates, BHP/FWHP/FBHP pressures, ESP and pump metrics, choke and\ngas lift parameters, flow-assurance flags (PE5, hydrate, wax, scale,\nasphaltene, constraint). Includes explicit network reference to disambiguate\nstrings in multiple GAP networks. Use for per-network performance review,\ncross-network comparison, flow-assurance screening, broad string coverage.\nFor current-state string outputs see NetworkOutputs_String_Agent; for optimization\nscenario families (systemOptimized*, technical*, hydraulic*, fsopr*, adHoc*)\nsee OptimizedRates_Network_String_Agent.\n\nUse for: Network Surveillance (WF7), Network Model Validation (WF8),\nFlow Assurance Monitoring (WF20). Primary WF8 surface for nmv* matched outputs.\n\n@name Network-Matched String Outputs - by Network (Agent)',
  );

export const StringFluidCompositionAgentSchema: z.ZodObject<Properties<StringFluidCompositionAgent>> = z
  .object({
    __typename: z.literal('StringFluidComposition_Agent').optional(),
    c1: z.lazy(() => TimeSeriesSchema.nullish()),
    c2: z.lazy(() => TimeSeriesSchema.nullish()),
    c3: z.lazy(() => TimeSeriesSchema.nullish()),
    c6: z.lazy(() => TimeSeriesSchema.nullish()),
    cgr: z.lazy(() => TimeSeriesSchema.nullish()),
    co2: z.lazy(() => TimeSeriesSchema.nullish()),
    condensateGravity: z.lazy(() => TimeSeriesSchema.nullish()),
    fluidType: z.lazy(() => TimeSeriesSchema.nullish()),
    h2s: z.lazy(() => TimeSeriesSchema.nullish()),
    iC4: z.lazy(() => TimeSeriesSchema.nullish()),
    iC5: z.lazy(() => TimeSeriesSchema.nullish()),
    n2: z.lazy(() => TimeSeriesSchema.nullish()),
    nC4: z.lazy(() => TimeSeriesSchema.nullish()),
    nC5: z.lazy(() => TimeSeriesSchema.nullish()),
    specificGasGravity: z.lazy(() => TimeSeriesSchema.nullish()),
    waterSalinity: z.lazy(() => TimeSeriesSchema.nullish()),
    wellString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe('Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context.'),
    wgr: z.lazy(() => TimeSeriesSchema.nullish()),
  })
  .describe(
    'String-level fluid composition including oil, gas, and water fractions.\n\nContains detailed fluid composition data at the string level, including\nvarious gas and liquid fractions derived from well tests and production data.\nSourced from field measurements and laboratory analyses, enabling the\nresolution of analytical questions related to fluid behavior, phase\ninteractions, and reservoir performance. It excludes historical production\nrates or reservoir pressure data, which are available in other views. Use\ncases: optimizing production strategies, assessing flow assurance challenges,\nand conducting PVT studies for enhanced oil recovery.\n\n@name String Fluid Composition (Agent)',
  );

export const StringFluidCompositionSchema: z.ZodObject<Properties<StringFluidComposition>> = z
  .object({
    __typename: z.literal('StringFluidComposition').optional(),
    c1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'c1' in this 'StringFluidComposition' view."),
    c2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'c2' in this 'StringFluidComposition' view."),
    c3: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'c3' in this 'StringFluidComposition' view."),
    c6: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'c6' in this 'StringFluidComposition' view."),
    c7c10: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'c7c10' in this 'StringFluidComposition' view."),
    c7c13: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'c7c13' in this 'StringFluidComposition' view."),
    c7c14: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'c7c14' in this 'StringFluidComposition' view."),
    c7c15: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'c7c15' in this 'StringFluidComposition' view."),
    c7c16: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'c7c16' in this 'StringFluidComposition' view."),
    c7c18: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'c7c18' in this 'StringFluidComposition' view."),
    c11c16: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'c11c16' in this 'StringFluidComposition' view."),
    c14c23: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'c14c23' in this 'StringFluidComposition' view."),
    c14c28: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'c14c28' in this 'StringFluidComposition' view."),
    c14plus: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'c14plus' in this 'StringFluidComposition' view."),
    c15c25: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'c15c25' in this 'StringFluidComposition' view."),
    c16c25: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'c16c25' in this 'StringFluidComposition' view."),
    c16c26: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'c16c26' in this 'StringFluidComposition' view."),
    c17c24: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'c17c24' in this 'StringFluidComposition' view."),
    c17c25: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'c17c25' in this 'StringFluidComposition' view."),
    c17c29: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'c17c29' in this 'StringFluidComposition' view."),
    c17plus: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'c17plus' in this 'StringFluidComposition' view."),
    c24c73: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'c24c73' in this 'StringFluidComposition' view."),
    c25c80: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'c25c80' in this 'StringFluidComposition' view."),
    c25plus: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'c25plus' in this 'StringFluidComposition' view."),
    c26c80: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'c26c80' in this 'StringFluidComposition' view."),
    c27c80: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'c27c80' in this 'StringFluidComposition' view."),
    c28plus: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'c28plus' in this 'StringFluidComposition' view."),
    c30c18: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'c30c18' in this 'StringFluidComposition' view."),
    c30c80: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'c30c80' in this 'StringFluidComposition' view."),
    c74c80: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'c74c80' in this 'StringFluidComposition' view."),
    c74plus: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'c74plus' in this 'StringFluidComposition' view."),
    c80plus: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'c80plus' in this 'StringFluidComposition' view."),
    c81plus: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'c81plus' in this 'StringFluidComposition' view."),
    cgr: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'cgr' in this 'StringFluidComposition' view."),
    co2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'co2' in this 'StringFluidComposition' view."),
    condensateGravity: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'condensateGravity' in this 'StringFluidComposition' view."),
    entityName: z
      .lazy(() => StringAssetSchema.nullish())
      .describe("Reference to the related 'String_asset' entity for this 'StringFluidComposition' row."),
    fluidType: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fluidType' in this 'StringFluidComposition' view."),
    h2s: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'h2s' in this 'StringFluidComposition' view."),
    iC4: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'iC4' in this 'StringFluidComposition' view."),
    iC4plusnC4: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'iC4plusnC4' in this 'StringFluidComposition' view."),
    iC5: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'iC5' in this 'StringFluidComposition' view."),
    iC5plusnC5: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'iC5plusnC5' in this 'StringFluidComposition' view."),
    n2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'n2' in this 'StringFluidComposition' view."),
    nC4: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'nC4' in this 'StringFluidComposition' view."),
    nC5: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'nC5' in this 'StringFluidComposition' view."),
    specificGasGravity: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'specificGasGravity' in this 'StringFluidComposition' view."),
    waterSalinity: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'waterSalinity' in this 'StringFluidComposition' view."),
    wgr: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wgr' in this 'StringFluidComposition' view."),
  })
  .describe("View 'StringFluidComposition' in the iPSO production optimization solution data model.");

export const SeparatorOutputsNetworkAgentSchema: z.ZodObject<Properties<SeparatorOutputsNetworkAgent>> = z
  .object({
    __typename: z.literal('SeparatorOutputs_Network_Agent').optional(),
    entityName: z.json().nullish().describe('Separator entity name.'),
    network: z.lazy(() => NetworkSchema.nullish()).describe('Reference to parent network model.'),
    nmvCgr: z.lazy(() => TimeSeriesSchema.nullish()).describe('Condensate-gas ratio at separator (TS).'),
    nmvGasFMIPercent: z.lazy(() => TimeSeriesSchema.nullish()).describe('Gas facility max intake utilization (%, TS).'),
    nmvGlr: z.lazy(() => TimeSeriesSchema.nullish()).describe('Gas-liquid ratio at separator (TS).'),
    nmvGor: z.lazy(() => TimeSeriesSchema.nullish()).describe('Gas-oil ratio at separator (TS).'),
    nmvOilFMIPercent: z.lazy(() => TimeSeriesSchema.nullish()).describe('Oil facility max intake utilization (%, TS).'),
    nmvPressure: z.lazy(() => TimeSeriesSchema.nullish()).describe('Separator operating pressure (TS).'),
    nmvSeparatoMeasuredrWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Measured water rate at separator (TS).'),
    nmvSeparatorGasRate: z.lazy(() => TimeSeriesSchema.nullish()).describe('Gas rate at separator (TS).'),
    nmvSeparatorLimitingConstraintsFlag: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Separator at limiting constraint (0/1, TS).'),
    nmvSeparatorLiquidRate: z.lazy(() => TimeSeriesSchema.nullish()).describe('Total liquid rate at separator (TS).'),
    nmvSeparatorMeasuredGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Measured gas rate at separator (TS).'),
    nmvSeparatorMeasuredOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Measured oil rate at separator (TS).'),
    nmvSeparatorOilRate: z.lazy(() => TimeSeriesSchema.nullish()).describe('Oil rate at separator (TS).'),
    nmvSeparatorViolatingConstraintsFlag: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Separator operating outside constraints (0/1, TS).'),
    nmvSeparatorWaterRate: z.lazy(() => TimeSeriesSchema.nullish()).describe('Water rate at separator (TS).'),
    nmvTemperature: z.lazy(() => TimeSeriesSchema.nullish()).describe('Separator operating temperature (TS).'),
    nmvWaterCut: z.lazy(() => TimeSeriesSchema.nullish()).describe('Water cut at separator (TS).'),
    nmvWaterFMIPercent: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Water facility max intake utilization (%, TS).'),
    nmvWgr: z.lazy(() => TimeSeriesSchema.nullish()).describe('Water-gas ratio at separator (TS).'),
    separatorEntity: z.lazy(() => EntitySchema.nullish()).describe('Reference to separator entity.'),
  })
  .describe(
    'Separator-level outputs from WF7 GAP network simulation (WF7).\n\nSimulated oil, gas, and water rates, pressures, and temperatures per\nseparator. Use to assess separator efficiency, flag constraint violations,\nand evaluate the throughput impact of operational changes. Excludes historical\nperformance data and aggregate network metrics.\n\nUse for: Network Surveillance (WF7).\n\n@name Separator Outputs - Network (Agent)',
  );

export const SeparatorInputsSchema: z.ZodObject<Properties<SeparatorInputs>> = z
  .object({
    __typename: z.literal('SeparatorInputs').optional(),
    entityName: z
      .lazy(() => EntitySchema.nullish())
      .describe("Reference to the related 'Entity' entity for this 'SeparatorInputs' row."),
    separatorGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'separatorGasRate' in this 'SeparatorInputs' view."),
    separatorOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'separatorOilRate' in this 'SeparatorInputs' view."),
    separatorPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'separatorPressure' in this 'SeparatorInputs' view."),
    separatorRTGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    separatorRTOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    separatorRTWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    separatorTemperature: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'separatorTemperature' in this 'SeparatorInputs' view."),
    separatorWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'separatorWaterRate' in this 'SeparatorInputs' view."),
    stage1Pressure: z.lazy(() => TimeSeriesSchema.nullish()),
    stage1Temperature: z.lazy(() => TimeSeriesSchema.nullish()),
    stage2Pressure: z.lazy(() => TimeSeriesSchema.nullish()),
    stage2Temperature: z.lazy(() => TimeSeriesSchema.nullish()),
    stage3Pressure: z.lazy(() => TimeSeriesSchema.nullish()),
    stage3Temperature: z.lazy(() => TimeSeriesSchema.nullish()),
    stage4Pressure: z.lazy(() => TimeSeriesSchema.nullish()),
    stage4Temperature: z.lazy(() => TimeSeriesSchema.nullish()),
    stage5Pressure: z.lazy(() => TimeSeriesSchema.nullish()),
    stage5Temperature: z.lazy(() => TimeSeriesSchema.nullish()),
    stage6Pressure: z.lazy(() => TimeSeriesSchema.nullish()),
    stage6Temperature: z.lazy(() => TimeSeriesSchema.nullish()),
    stage7Pressure: z.lazy(() => TimeSeriesSchema.nullish()),
    stage7Temperature: z.lazy(() => TimeSeriesSchema.nullish()),
    stage8Pressure: z.lazy(() => TimeSeriesSchema.nullish()),
    stage8Temperature: z.lazy(() => TimeSeriesSchema.nullish()),
    stage9Pressure: z.lazy(() => TimeSeriesSchema.nullish()),
    stage9Temperature: z.lazy(() => TimeSeriesSchema.nullish()),
    stage10Pressure: z.lazy(() => TimeSeriesSchema.nullish()),
    stage10Temperature: z.lazy(() => TimeSeriesSchema.nullish()),
    trainStatus: z.lazy(() => TimeSeriesSchema.nullish()),
  })
  .describe("View 'SeparatorInputs' in the iPSO production optimization solution data model.");

export const SectorOutputsSchema: z.ZodObject<Properties<SectorOutputs>> = z
  .object({
    __typename: z.literal('SectorOutputs').optional(),
    downholeGasInjectionVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'downholeGasInjectionVolume' in this 'SectorOutputs' view."),
    downholeGasProductionVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'downholeGasProductionVolume' in this 'SectorOutputs' view."),
    downholeOilProductionVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'downholeOilProductionVolume' in this 'SectorOutputs' view."),
    downholeWaterInjectionVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'downholeWaterInjectionVolume' in this 'SectorOutputs' view."),
    downholeWaterProductionVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'downholeWaterProductionVolume' in this 'SectorOutputs' view."),
    entityName: z
      .lazy(() => SectorSchema.nullish())
      .describe(
        'Name of the sector for which aggregated well status, injection and voidage replacement outputs are reported in this view.',
      ),
    field: z
      .lazy(() => FieldSchema.nullish())
      .describe("Reference to the related 'Field' entity for this 'SectorOutputs' row."),
    giRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'giRate' in this 'SectorOutputs' view."),
    giTargetRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'giTargetRate' in this 'SectorOutputs' view."),
    giTargetRateCompliance: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'giTargetRateCompliance' in this 'SectorOutputs' view."),
    mtdVRR: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mtdVRR' in this 'SectorOutputs' view."),
    mtdVRRCompliance: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mtdVRRCompliance' in this 'SectorOutputs' view."),
    pressureCompliance: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'pressureCompliance' in this 'SectorOutputs' view."),
    regionPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'regionPressure' in this 'SectorOutputs' view."),
    reservoir: z
      .lazy(() => ReservoirSchema.nullish())
      .describe("Reference to the related 'Reservoir' entity for this 'SectorOutputs' row."),
    vrr: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'vrr' in this 'SectorOutputs' view."),
    vrrCompliance: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'vrrCompliance' in this 'SectorOutputs' view."),
    wellsActiveGi: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of the number of active gas injector wells (GI) within the sector.'),
    wellsActiveGpNf: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of the number of active producer wells flowing to gas plant (GP) or similar grouping while on natural flow (NF) within the sector.',
      ),
    wellsActiveOpEsp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of the number of active producer wells on ESP lift within the sector.'),
    wellsActiveOpGl: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of the number of active producer wells on gas lift (GL) within the sector.'),
    wellsActiveOpNf: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of the number of active producer wells on natural flow (NF) within the sector.'),
    wellsActiveWi: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of the number of active water injector wells (WI) within the sector.'),
    wellsInActiveGi: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of the number of inactive gas injector wells (GI) within the sector.'),
    wellsInActiveGpNf: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of the number of inactive producer wells flowing to gas plant (GP) or similar grouping while on natural flow (NF) within the sector.',
      ),
    wellsInActiveOpEsp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of the number of inactive producer wells on ESP lift within the sector.'),
    wellsInActiveOpGl: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of the number of inactive producer wells on gas lift (GL) within the sector.'),
    wellsInActiveOpNf: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of the number of inactive producer wells on natural flow (NF) within the sector.'),
    wellsInActiveWi: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of the number of inactive water injector wells (WI) within the sector.'),
    wiRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wiRate' in this 'SectorOutputs' view."),
    wiTargetRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wiTargetRate' in this 'SectorOutputs' view."),
    wiTargetRateCompliance: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wiTargetRateCompliance' in this 'SectorOutputs' view."),
    ytdVRR: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'ytdVRR' in this 'SectorOutputs' view."),
    ytdVRRCompliance: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'ytdVRRCompliance' in this 'SectorOutputs' view."),
  })
  .describe(
    'Aggregated sector-level outputs including counts of active and inactive wells, injection rates and downhole production/injection volumes, as well as voidage replacement ratio (VRR) and pressure compliance metrics for sector surveillance and optimization.',
  );

export const SrmSettingsSchema: z.ZodObject<Properties<SrmSettings>> = z
  .object({
    __typename: z.literal('SRMSettings').optional(),
    allocationFactorType: z.lazy(() => TimeSeriesSchema.nullish()),
    baseRateFactor: z.lazy(() => TimeSeriesSchema.nullish()),
    chokeCalculation: z.lazy(() => TimeSeriesSchema.nullish()),
    clusterLevelConstraint: z.lazy(() => TimeSeriesSchema.nullish()),
    entityName: z.lazy(() => FieldSchema.nullish()),
    facilityLevelConstraint: z.lazy(() => TimeSeriesSchema.nullish()),
    fieldLevelConstraint: z.lazy(() => TimeSeriesSchema.nullish()),
    gasInjectionWeight: z.lazy(() => TimeSeriesSchema.nullish()),
    gasLiftCapacity: z.lazy(() => TimeSeriesSchema.nullish()),
    gasProductionWeight: z.lazy(() => TimeSeriesSchema.nullish()),
    maxIterations: z.lazy(() => TimeSeriesSchema.nullish()),
    minNumberWellTests: z.lazy(() => TimeSeriesSchema.nullish()),
    minRatio: z.lazy(() => TimeSeriesSchema.nullish()),
    optAL: z.lazy(() => TimeSeriesSchema.nullish()),
    optChoke: z.lazy(() => TimeSeriesSchema.nullish()),
    overInjectionVRRComplianceThreshold: z.float32().nullish(),
    overInjectionVRRThreshold: z.lazy(() => TimeSeriesSchema.nullish()),
    rateConstraintOption: z.lazy(() => TimeSeriesSchema.nullish()),
    rateInjConstraintOption: z.lazy(() => TimeSeriesSchema.nullish()),
    reservoirLevelConstraint: z.lazy(() => TimeSeriesSchema.nullish()),
    sectorLevelConstraint: z.lazy(() => TimeSeriesSchema.nullish()),
    toleranceRate: z.lazy(() => TimeSeriesSchema.nullish()),
    underInjectionVRRComplianceThreshold: z.float32().nullish(),
    underInjectionVRRThreshold: z.lazy(() => TimeSeriesSchema.nullish()),
    vrrWeight: z.lazy(() => TimeSeriesSchema.nullish()),
    waterInjectionWeight: z.lazy(() => TimeSeriesSchema.nullish()),
    waterProductionWeight: z.lazy(() => TimeSeriesSchema.nullish()),
  })
  .describe("View 'SRMSettings' in the iPSO production optimization solution data model.");

export const SrmOutputsStringSchema: z.ZodObject<Properties<SrmOutputsString>> = z
  .object({
    __typename: z.literal('SRMOutputs_String').optional(),
    adHocGasInjRateFlag: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOilRateFlag: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimizedAllocInjRateGAPRes: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimizedGasInjRateGAPRes: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimizedGasInjRateResCond: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocOptimizedGasInjRateResCond' in this 'SRMOutputs_String' view."),
    adHocOptimizedGasInjRateSRM: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocOptimizedGasInjRateSRM' in this 'SRMOutputs_String' view."),
    adHocOptimizedGasRateSRM: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocOptimizedGasRateSRM' in this 'SRMOutputs_String' view."),
    adHocOptimizedInjRateResCond: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocOptimizedInjRateResCond' in this 'SRMOutputs_String' view."),
    adHocOptimizedOilRateSRM: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocOptimizedOilRateSRM' in this 'SRMOutputs_String' view."),
    adHocOptimizedPE5Flag: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimizedProdRateGAPRes: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimizedProdRateResCond: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocOptimizedProdRateResCond' in this 'SRMOutputs_String' view."),
    adHocOptimizedWHP: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimizedWatInjRateGAPRes: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimizedWaterInjRateResCond: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocOptimizedWaterInjRateResCond' in this 'SRMOutputs_String' view."),
    adHocOptimizedWaterInjRateSRM: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocOptimizedWaterInjRateSRM' in this 'SRMOutputs_String' view."),
    adHocOptimizedWaterRateSRM: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocOptimizedWaterRateSRM' in this 'SRMOutputs_String' view."),
    adHocWaterInjRateFlag: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocoptimizedBHFPGAP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocoptimizedBHFPGAP' in this 'SRMOutputs_String' view."),
    adHocoptimizedChokeSizeGAP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocoptimizedChokeSizeGAP' in this 'SRMOutputs_String' view."),
    adHocoptimizedESPFrequencyGAP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocoptimizedESPFrequencyGAP' in this 'SRMOutputs_String' view."),
    adHocoptimizedGasInjRateGAP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocoptimizedGasInjRateGAP' in this 'SRMOutputs_String' view."),
    adHocoptimizedGasLiftRateGAP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocoptimizedGasLiftRateGAP' in this 'SRMOutputs_String' view."),
    adHocoptimizedGasRateGAP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocoptimizedGasRateGAP' in this 'SRMOutputs_String' view."),
    adHocoptimizedOilRateGAP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocoptimizedOilRateGAP' in this 'SRMOutputs_String' view."),
    adHocoptimizedWaterInjRateGAP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocoptimizedWaterInjRateGAP' in this 'SRMOutputs_String' view."),
    adHocoptimizedWaterRateGAP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocoptimizedWaterRateGAP' in this 'SRMOutputs_String' view."),
    alOpt: z.lazy(() => TimeSeriesSchema.nullish()),
    allocationFactor: z.lazy(() => TimeSeriesSchema.nullish()),
    chokeOpt: z.lazy(() => TimeSeriesSchema.nullish()),
    createdDate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'createdDate' in this 'SRMOutputs_String' view."),
    entityName: z
      .lazy(() => StringAssetSchema.nullish())
      .describe("Reference to the related 'String_asset' entity for this 'SRMOutputs_String' row."),
    executionBy: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'executionBy' in this 'SRMOutputs_String' view."),
    executionDate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'executionDate' in this 'SRMOutputs_String' view."),
    gasInjRateFlag: z.lazy(() => TimeSeriesSchema.nullish()),
    hasGapWellName: z.lazy(() => TimeSeriesSchema.nullish()),
    isOfficial: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'isOfficial' in this 'SRMOutputs_String' view."),
    lastUpdatedDate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'lastUpdatedDate' in this 'SRMOutputs_String' view."),
    maxChokeSize: z.lazy(() => TimeSeriesSchema.nullish()),
    maxESPFreq: z.lazy(() => TimeSeriesSchema.nullish()),
    maxGLRate: z.lazy(() => TimeSeriesSchema.nullish()),
    maxGasInjRate: z.lazy(() => TimeSeriesSchema.nullish()),
    maxGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    maxOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    maxWaterInjRate: z.lazy(() => TimeSeriesSchema.nullish()),
    minChokeSize: z.lazy(() => TimeSeriesSchema.nullish()),
    minESPFreq: z.lazy(() => TimeSeriesSchema.nullish()),
    minGLRate: z.lazy(() => TimeSeriesSchema.nullish()),
    oilRateFlag: z.lazy(() => TimeSeriesSchema.nullish()),
    optimizeGasRateSRM: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'optimizeGasRateSRM' in this 'SRMOutputs_String' view."),
    optimizeWaterRateSRM: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'optimizeWaterRateSRM' in this 'SRMOutputs_String' view."),
    optimizedAllocInjRateGAPRes: z.lazy(() => TimeSeriesSchema.nullish()),
    optimizedBHFPGAP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'optimizedBHFPGAP' in this 'SRMOutputs_String' view."),
    optimizedCO2InjRateResCondSRM: z.lazy(() => TimeSeriesSchema.nullish()),
    optimizedCO2InjRateSRM: z.lazy(() => TimeSeriesSchema.nullish()),
    optimizedChokeSizeGAP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'optimizedChokeSizeGAP' in this 'SRMOutputs_String' view."),
    optimizedESPFrequencyGAP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'optimizedESPFrequencyGAP' in this 'SRMOutputs_String' view."),
    optimizedGasInjRateGAP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'optimizedGasInjRateGAP' in this 'SRMOutputs_String' view."),
    optimizedGasInjRateGAPRes: z.lazy(() => TimeSeriesSchema.nullish()),
    optimizedGasInjRateResCond: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'optimizedGasInjRateResCond' in this 'SRMOutputs_String' view."),
    optimizedGasInjRateSRM: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'optimizedGasInjRateSRM' in this 'SRMOutputs_String' view."),
    optimizedGasLiftRateGAP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'optimizedGasLiftRateGAP' in this 'SRMOutputs_String' view."),
    optimizedGasRateGAP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'optimizedGasRateGAP' in this 'SRMOutputs_String' view."),
    optimizedInjRateResCond: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'optimizedInjRateResCond' in this 'SRMOutputs_String' view."),
    optimizedOilRateGAP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'optimizedOilRateGAP' in this 'SRMOutputs_String' view."),
    optimizedOilRateSRM: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'optimizedOilRateSRM' in this 'SRMOutputs_String' view."),
    optimizedPE5Flag: z.lazy(() => TimeSeriesSchema.nullish()),
    optimizedProdRateGAPRes: z.lazy(() => TimeSeriesSchema.nullish()),
    optimizedProdRateResCond: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'optimizedProdRateResCond' in this 'SRMOutputs_String' view."),
    optimizedWHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'optimizedWHP' in this 'SRMOutputs_String' view."),
    optimizedWatInjRateGAPRes: z.lazy(() => TimeSeriesSchema.nullish()),
    optimizedWaterInjRateGAP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'optimizedWaterInjRateGAP' in this 'SRMOutputs_String' view."),
    optimizedWaterInjRateResCond: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'optimizedWaterInjRateResCond' in this 'SRMOutputs_String' view."),
    optimizedWaterInjRateSRM: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'optimizedWaterInjRateSRM' in this 'SRMOutputs_String' view."),
    optimizedWaterRateGAP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'optimizedWaterRateGAP' in this 'SRMOutputs_String' view."),
    scenario: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'scenario' in this 'SRMOutputs_String' view."),
    scenaroID: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'scenaroID' in this 'SRMOutputs_String' view."),
    waterInjRateFlag: z.lazy(() => TimeSeriesSchema.nullish()),
    wellType: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellType' in this 'SRMOutputs_String' view."),
  })
  .describe("View 'SRMOutputs_String' in the iPSO production optimization solution data model.");

export const SrmOutputsAllEntitiesSchema: z.ZodObject<Properties<SrmOutputsAllEntities>> = z
  .object({
    __typename: z.literal('SRMOutputs_All_Entities').optional(),
    adHocOptimizedGasInjRateGAPRes: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimizedProdRateGAPRes: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimizedVRRGAP: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimizedVRRSRM: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimizedWatInjRateGAPRes: z.lazy(() => TimeSeriesSchema.nullish()),
    allocFactorType: z.lazy(() => TimeSeriesSchema.nullish()),
    allocFactorVersion: z.lazy(() => TimeSeriesSchema.nullish()),
    createdDate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'createdDate' in this 'SRMOutputs_All_Entities' view."),
    entityName: z
      .lazy(() => EntitySchema.nullish())
      .describe("Reference to the related 'Entity' entity for this 'SRMOutputs_All_Entities' row."),
    entityType: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'entityType' in this 'SRMOutputs_All_Entities' view."),
    executionBy: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'executionBy' in this 'SRMOutputs_All_Entities' view."),
    executionDate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'executionDate' in this 'SRMOutputs_All_Entities' view."),
    gasInjCapacity: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gasInjCapacity' in this 'SRMOutputs_All_Entities' view."),
    gasInjWeight: z.lazy(() => TimeSeriesSchema.nullish()),
    gasLiftAvailability: z.lazy(() => TimeSeriesSchema.nullish()),
    gasProdCapacity: z.lazy(() => TimeSeriesSchema.nullish()),
    gasProdWeight: z.lazy(() => TimeSeriesSchema.nullish()),
    injRateOpt: z.lazy(() => TimeSeriesSchema.nullish()),
    isOfficial: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'isOfficial' in this 'SRMOutputs_All_Entities' view."),
    lastUpdatedDate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'lastUpdatedDate' in this 'SRMOutputs_All_Entities' view."),
    maxIterations: z.lazy(() => TimeSeriesSchema.nullish()),
    minProdRateRatio: z.lazy(() => TimeSeriesSchema.nullish()),
    oilProdCapacity: z.lazy(() => TimeSeriesSchema.nullish()),
    oilRateQuota: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'oilRateQuota' in this 'SRMOutputs_All_Entities' view."),
    optimizedCO2InjRateResCondSRM: z.lazy(() => TimeSeriesSchema.nullish()),
    optimizedCO2InjRateSRM: z.lazy(() => TimeSeriesSchema.nullish()),
    optimizedGasInjRateGAP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'optimizedGasInjRateGAP' in this 'SRMOutputs_All_Entities' view."),
    optimizedGasInjRateGAPRes: z.lazy(() => TimeSeriesSchema.nullish()),
    optimizedGasInjRateResCondSRM: z.lazy(() => TimeSeriesSchema.nullish()),
    optimizedGasInjRateSRM: z.lazy(() => TimeSeriesSchema.nullish()),
    optimizedGasRateGAP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'optimizedGasRateGAP' in this 'SRMOutputs_All_Entities' view."),
    optimizedGasRateSRM: z.lazy(() => TimeSeriesSchema.nullish()),
    optimizedOilRateGAP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'optimizedOilRateGAP' in this 'SRMOutputs_All_Entities' view."),
    optimizedOilRateSRM: z.lazy(() => TimeSeriesSchema.nullish()),
    optimizedProdRateGAPRes: z.lazy(() => TimeSeriesSchema.nullish()),
    optimizedProdRateResCondSRM: z.lazy(() => TimeSeriesSchema.nullish()),
    optimizedVRRGAP: z.lazy(() => TimeSeriesSchema.nullish()),
    optimizedVRRSRM: z.lazy(() => TimeSeriesSchema.nullish()),
    optimizedWatInjRateGAPRes: z.lazy(() => TimeSeriesSchema.nullish()),
    optimizedWaterInjRateGAP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'optimizedWaterInjRateGAP' in this 'SRMOutputs_All_Entities' view."),
    optimizedWaterInjRateResCondSRM: z.lazy(() => TimeSeriesSchema.nullish()),
    optimizedWaterInjRateSRM: z.lazy(() => TimeSeriesSchema.nullish()),
    optimizedWaterRateGAP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'optimizedWaterRateGAP' in this 'SRMOutputs_All_Entities' view."),
    optimizedWaterRateSRM: z.lazy(() => TimeSeriesSchema.nullish()),
    prodRateOpt: z.lazy(() => TimeSeriesSchema.nullish()),
    scenario: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'scenario' in this 'SRMOutputs_All_Entities' view."),
    scenaroID: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'scenaroID' in this 'SRMOutputs_All_Entities' view."),
    vrrTarget: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'vrrTarget' in this 'SRMOutputs_All_Entities' view."),
    vrrWeight: z.lazy(() => TimeSeriesSchema.nullish()),
    waterInjCapacity: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'waterInjCapacity' in this 'SRMOutputs_All_Entities' view."),
    waterInjWeight: z.lazy(() => TimeSeriesSchema.nullish()),
    waterProdCapacity: z.lazy(() => TimeSeriesSchema.nullish()),
    waterProdWeight: z.lazy(() => TimeSeriesSchema.nullish()),
  })
  .describe("View 'SRMOutputs_All_Entities' in the iPSO production optimization solution data model.");

export const ShgProductionSchema: z.ZodObject<Properties<ShgProduction>> = z
  .object({
    __typename: z.literal('SHG_PRODUCTION').optional(),
    entityName: z
      .lazy(() => StringAssetSchema.nullish())
      .describe("Reference to the related 'String_asset' entity for this 'SHG_PRODUCTION' row."),
    maxGOR: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series 'maxGOR' for this 'SHG_PRODUCTION' row."),
    maxLiquidRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series 'maxLiquidRate' for this 'SHG_PRODUCTION' row."),
    maxOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series 'maxOilRate' for this 'SHG_PRODUCTION' row."),
    minBHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series 'minBHP' for this 'SHG_PRODUCTION' row."),
    minWHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series 'minWHP' for this 'SHG_PRODUCTION' row."),
  })
  .describe("View 'SHG_PRODUCTION' in the iPSO production optimization solution data model.");

export const ShgInjectionSchema: z.ZodObject<Properties<ShgInjection>> = z
  .object({
    __typename: z.literal('SHG_INJECTION').optional(),
    entityName: z
      .lazy(() => StringAssetSchema.nullish())
      .describe("Reference to the related 'String_asset' entity for this 'SHG_INJECTION' row."),
    giMaxBHIP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series 'giMaxBHIP' for this 'SHG_INJECTION' row."),
    giMaxInjRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series 'giMaxInjRate'  for this 'SHG_INJECTION' row."),
    giMaxWHIP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series 'giMaxWHIP' for this 'SHG_INJECTION' row."),
    wiMaxBHIP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series 'wiMaxBHIP' for this 'SHG_INJECTION' row."),
    wiMaxInjRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series 'wiMaxInjRate' for this 'SHG_INJECTION' row."),
    wiMaxWHIP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series 'wiMaxWHIP' for this 'SHG_INJECTION' row."),
  })
  .describe("View 'SHG_INJECTION' in the iPSO production optimization solution data model.");

export const ReservoirOutputsAgentSchema: z.ZodObject<Properties<ReservoirOutputsAgent>> = z
  .object({
    __typename: z.literal('ReservoirOutputs_Agent').optional(),
    downholeGasInjectionVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Downhole gas injection volume at reservoir conditions (rb, TS).\nUsed in VRR numerator calculation.'),
    downholeGasProductionVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Downhole gas production volume at reservoir conditions (rb, TS).\nUsed in VRR denominator calculation.',
      ),
    downholeOilProductionVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Downhole oil production volume at reservoir conditions (rb, TS).\nUsed in VRR denominator calculation.',
      ),
    downholeWaterInjectionVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Downhole water injection volume at reservoir conditions (rb, TS).\nUsed in VRR numerator calculation.',
      ),
    downholeWaterProductionVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Downhole water production volume at reservoir conditions (rb, TS).\nUsed in VRR denominator calculation.',
      ),
    field: z
      .lazy(() => FieldSchema.nullish())
      .describe('Parent field containing this reservoir. Use for field-level aggregation.'),
    giRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Aggregated gas injection rate for the reservoir (MSCF/d, TS).'),
    giTargetRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Gas injection target rate from planning/optimization (MSCF/d, TS).\nCompare to giRate for performance gap.',
      ),
    giTargetRateCompliance: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Gas injection target rate compliance flag (TS). 1 = giRate meets target.'),
    mtdVRR: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Month-to-date VRR (TS). Cumulative VRR from start of current month.\nUse for monthly trend vs daily VRR.',
      ),
    mtdVRRCompliance: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Month-to-date VRR compliance flag (TS). 1 = within target band for the month.'),
    pressureCompliance: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Reservoir pressure compliance flag (TS). 1 = within expected range from\nReservoir_Guideline.expectedReservoirPressure.',
      ),
    regionPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Average reservoir region pressure (psi, TS). Compare to\nReservoir_Guideline.expectedReservoirPressure for compliance.',
      ),
    reservoir: z.lazy(() => ReservoirSchema.nullish()).describe('Reference to reservoir.'),
    vrr: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Daily voidage replacement ratio (TS). Ratio of injected volume to produced\nvolume at reservoir conditions. Target typically ~1.0 for pressure maintenance.',
      ),
    vrrCompliance: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily VRR compliance flag (TS). 1 = within target band, 0 = out of compliance.'),
    wellsActiveGi: z.lazy(() => TimeSeriesSchema.nullish()).describe('Count of active gas injector wells (TS).'),
    wellsActiveGpNf: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Count of active gas producer wells on natural flow (TS).'),
    wellsActiveOpEsp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Count of active oil producer wells on ESP (TS).'),
    wellsActiveOpGl: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Count of active oil producer wells on gas lift (TS).'),
    wellsActiveOpNf: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Count of active oil producer wells on natural flow (TS).'),
    wellsActiveWi: z.lazy(() => TimeSeriesSchema.nullish()).describe('Count of active water injector wells (TS).'),
    wellsInActiveGi: z.lazy(() => TimeSeriesSchema.nullish()).describe('Count of inactive gas injector wells (TS).'),
    wellsInActiveGpNf: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Count of inactive gas producer wells on natural flow (TS).'),
    wellsInActiveOpEsp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Count of inactive oil producer wells on ESP (TS).'),
    wellsInActiveOpGl: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Count of inactive oil producer wells on gas lift (TS).'),
    wellsInActiveOpNf: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Count of inactive oil producer wells on natural flow (TS).'),
    wellsInActiveWi: z.lazy(() => TimeSeriesSchema.nullish()).describe('Count of inactive water injector wells (TS).'),
    wiRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Aggregated water injection rate for the reservoir (stb/d, TS).'),
    wiTargetRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Water injection target rate from planning/optimization (stb/d, TS).\nCompare to wiRate for performance gap.',
      ),
    wiTargetRateCompliance: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Water injection target rate compliance flag (TS). 1 = wiRate meets target.'),
    ytdVRR: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Year-to-date VRR (TS). Cumulative VRR from start of current year.\nUse for long-term reservoir management assessment.',
      ),
    ytdVRRCompliance: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Year-to-date VRR compliance flag (TS). 1 = within target band for the year.'),
  })
  .describe(
    'Reservoir-level VRR metrics, compliance ratios, injection balance (WF16).\n\nReservoir output metrics for VRR compliance, injection strategies, well activity.\nUse to assess reservoir health and injection-related risks. Excludes geological or historical detail.\n\nUse for: VRR Monitoring and Surveillance (WF16).\n\n@name Reservoir Outputs (Agent)',
  );

export const ReservoirOutputsSchema: z.ZodObject<Properties<ReservoirOutputs>> = z
  .object({
    __typename: z.literal('ReservoirOutputs').optional(),
    downholeGasInjectionVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'downholeGasInjectionVolume' in this 'ReservoirOutputs' view."),
    downholeGasProductionVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'downholeGasProductionVolume' in this 'ReservoirOutputs' view."),
    downholeOilProductionVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'downholeOilProductionVolume' in this 'ReservoirOutputs' view."),
    downholeWaterInjectionVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'downholeWaterInjectionVolume' in this 'ReservoirOutputs' view."),
    downholeWaterProductionVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'downholeWaterProductionVolume' in this 'ReservoirOutputs' view."),
    entityName: z
      .lazy(() => ReservoirSchema.nullish())
      .describe(
        'Name of the reservoir for which aggregated well status, injection and voidage replacement outputs are reported in this view.',
      ),
    field: z.lazy(() => FieldSchema.nullish()).describe('Reference to the field in which this reservoir is located.'),
    giRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of total gas injection rate into the reservoir from all GI wells.'),
    giTargetRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of target gas injection rate for the reservoir.'),
    giTargetRateCompliance: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'giTargetRateCompliance' in this 'ReservoirOutputs' view."),
    mtdVRR: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mtdVRR' in this 'ReservoirOutputs' view."),
    mtdVRRCompliance: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mtdVRRCompliance' in this 'ReservoirOutputs' view."),
    pressureCompliance: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'pressureCompliance' in this 'ReservoirOutputs' view."),
    regionPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'regionPressure' in this 'ReservoirOutputs' view."),
    vrr: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'vrr' in this 'ReservoirOutputs' view."),
    vrrCompliance: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'vrrCompliance' in this 'ReservoirOutputs' view."),
    wellsActiveGi: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of the number of active gas injector wells (GI) targeting the reservoir.'),
    wellsActiveGpNf: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of the number of active producer wells flowing to gas plant (GP) or similar grouping while on natural flow (NF) in the reservoir.',
      ),
    wellsActiveOpEsp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of the number of active producer wells on ESP lift completed in the reservoir.'),
    wellsActiveOpGl: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of the number of active producer wells on gas lift (GL) completed in the reservoir.'),
    wellsActiveOpNf: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of the number of active producer wells on natural flow (NF) completed in the reservoir.'),
    wellsActiveWi: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of the number of active water injector wells (WI) targeting the reservoir.'),
    wellsInActiveGi: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of the number of inactive gas injector wells (GI) targeting the reservoir.'),
    wellsInActiveGpNf: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of the number of inactive producer wells flowing to gas plant (GP) or similar grouping while on natural flow (NF) in the reservoir.',
      ),
    wellsInActiveOpEsp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of the number of inactive producer wells on ESP lift completed in the reservoir.'),
    wellsInActiveOpGl: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of the number of inactive producer wells on gas lift (GL) completed in the reservoir.'),
    wellsInActiveOpNf: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of the number of inactive producer wells on natural flow (NF) completed in the reservoir.',
      ),
    wellsInActiveWi: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of the number of inactive water injector wells (WI) targeting the reservoir.'),
    wiRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of total water injection rate into the reservoir from all WI wells.'),
    wiTargetRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of target water injection rate for the reservoir.'),
    wiTargetRateCompliance: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wiTargetRateCompliance' in this 'ReservoirOutputs' view."),
    ytdVRR: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'ytdVRR' in this 'ReservoirOutputs' view."),
    ytdVRRCompliance: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'ytdVRRCompliance' in this 'ReservoirOutputs' view."),
  })
  .describe(
    'Aggregated reservoir-level outputs including counts of active and inactive wells, injection rates and downhole production/injection volumes, as well as voidage replacement ratio (VRR) and pressure compliance metrics for reservoir management and optimization.',
  );

export const ReservoirInputsAgentSchema: z.ZodObject<Properties<ReservoirInputsAgent>> = z
  .object({
    __typename: z.literal('ReservoirInputs_Agent').optional(),
    reservoir: z.lazy(() => ReservoirSchema.nullish()).describe('Reference to reservoir.'),
    reservoirInjectionAllocationFactor: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Combined injection allocation factor for this reservoir (fraction, TS).\nOverall share of total facility injection attributed to this reservoir.',
      ),
    reservoirInjectionAllocationGasFactor: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Gas injection allocation factor for this reservoir (fraction, TS).\nShare of facility gas injection attributed to this reservoir.',
      ),
    reservoirInjectionAllocationOilFactor: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Oil injection allocation factor for this reservoir (fraction, TS).\nUsed in WAG (Water-Alternating-Gas) injection schemes.',
      ),
    reservoirInjectionAllocationWaterFactor: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Water injection allocation factor for this reservoir (fraction, TS).\nShare of facility water injection attributed to this reservoir.',
      ),
    reservoirProductionAllocationFactor: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Combined production allocation factor for this reservoir (fraction, TS).\nOverall share of total facility production attributed to this reservoir.',
      ),
    reservoirProductionAllocationGasFactor: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Gas production allocation factor for this reservoir (fraction, TS).\nShare of facility gas production attributed to this reservoir.',
      ),
    reservoirProductionAllocationOilFactor: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Oil production allocation factor for this reservoir (fraction, TS).\nShare of facility oil production attributed to this reservoir.',
      ),
    reservoirProductionAllocationWaterFactor: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Water production allocation factor for this reservoir (fraction, TS).\nShare of facility water production attributed to this reservoir.',
      ),
  })
  .describe(
    'Reservoir-level allocation factors for production and injection (WF16).\n\nHow production and injection from facilities are distributed among reservoirs.\nUse for allocation share per reservoir and which reservoir has highest allocation. Excludes well connectivity or performance detail.\n\nUse for: VRR Monitoring and Surveillance (WF16).\n\n@name Reservoir Inputs - Allocation Factors (Agent)',
  );

export const ReservoirInputsSchema: z.ZodObject<Properties<ReservoirInputs>> = z.object({
  __typename: z.literal('ReservoirInputs').optional(),
  entityName: z.lazy(() => ReservoirSchema.nullish()),
  reservoirInjectionAllocationFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  reservoirInjectionAllocationGasFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  reservoirInjectionAllocationOilFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  reservoirInjectionAllocationWaterFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  reservoirProductionAllocationFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  reservoirProductionAllocationGasFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  reservoirProductionAllocationOilFactor: z.lazy(() => TimeSeriesSchema.nullish()),
  reservoirProductionAllocationWaterFactor: z.lazy(() => TimeSeriesSchema.nullish()),
});

export const RateDiagnosticsStringAgentSchema: z.ZodObject<Properties<RateDiagnosticsStringAgent>> = z
  .object({
    __typename: z.literal('RateDiagnostics_String_Agent').optional(),
    chokeCdCalc: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Calculated production choke discharge coefficient (Cd, TS). Typical range 0.6–0.9; deviations indicate restriction or erosion.',
      ),
    chokeSizeCalc: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Calculated production choke size implied by current rate and pressure conditions (64ths inch, TS).'),
    grdAnalysisStatus: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Status of Gas Rate Decline analysis. Values: SUCCESS, FAILED, INSUFFICIENT_DATA.'),
    qliqDelta: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Difference between current and reference liquid rate (stb/d, TS).\nPositive = above reference, negative = below. Used for rate-change\nmonitoring and alarm triggering.',
      ),
    wellPerformance: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Well performance indicator (dimensionless). Composite efficiency or\nhealth score vs theoretical potential.',
      ),
    wellString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe('Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context.'),
  })
  .describe(
    'Well performance scores, rate-change metrics, analysis status, choke/GL parameters per string.\n\nDiagnostic metadata about the estimation process (not rate values). Use for:\nwell performance vs potential, ESP/GL/GRD analysis success, rate change, or\nimplied choke size. For rate estimates use EstimatedRates_String_Agent; for\ndata-driven rates use DataDrivenRates_String_Agent.\n\nUse for: performance scores and analysis status (WF10).\n\n@name Rate Diagnostics - Well Performance and Analysis Status (Agent)',
  );

export const PumpOutputsNetworkAgentSchema: z.ZodObject<Properties<PumpOutputsNetworkAgent>> = z
  .object({
    __typename: z.literal('PumpOutputs_Network_Agent').optional(),
    entityName: z.lazy(() => EntitySchema.nullish()).describe('Pump entity name.'),
    network: z.lazy(() => NetworkSchema.nullish()).describe('Reference to parent network model.'),
    nmvPumpLiquidRate: z.lazy(() => TimeSeriesSchema.nullish()).describe('Liquid rate through pump (TS).'),
    nmvPumpViolatingConsraintsFlag: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Pump operating outside constraints (0/1, TS).'),
  })
  .describe(
    'Pump-level outputs from WF7 GAP network simulation (WF7).\n\nSimulated pump operating conditions: differential pressure, power draw, and\nthroughput per pump. Use to evaluate pump performance, flag constraint\nviolations, and compare across runs. Excludes historical performance data and\npump maintenance records.\n\nUse for: Network Surveillance (WF7).\n\n@name Pump Outputs - Network (Agent)',
  );

export const PtsOutputsStringAgentSchema: z.ZodObject<Properties<PtsOutputsStringAgent>> = z
  .object({
    __typename: z.literal('PtsOutputs_String_Agent').optional(),
    bgPts1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        '  Gas formation volume factor (Bg) from line conditions (PTS1/LC) to PTS reference conditions (TS).\n  Also referred to as gasExpansionFactorPTS1toPTSRef.\n\n@name gasExpansionFactorPTS1toPTSRef',
      ),
    bgPts2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        '  Gas formation volume factor (Bg) from standard conditions (PTS2/SC) to PTS reference conditions (TS).\n  Also referred to as gasExpansionFactorPTS2toPTSRef.\n\n@name gasExpansionFactorPTS2toPTSRef',
      ),
    boPts1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        '  Oil formation volume factor (Bo) from line conditions (PTS1/LC) to PTS reference conditions (res bbl/stb, TS).\n  Also referred to as oilShrinkageFactorPTS1toPTSRef.\n\n@name oilShrinkageFactorPTS1toPTSRef',
      ),
    boPts2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        '  Oil formation volume factor (Bo) from standard conditions (PTS2/SC) to PTS reference conditions (res bbl/stb, TS).\n  Also referred to as oilShrinkageFactorPTS2toPTSRef.\n\n@name oilShrinkageFactorPTS2toPTSRef',
      ),
    cO2: z.lazy(() => TimeSeriesSchema.nullish()),
    calcWellTestGOR: z.lazy(() => TimeSeriesSchema.nullish()),
    calcWellTestGORInSitu: z.lazy(() => TimeSeriesSchema.nullish()),
    calcWellTestTotalGOR: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Calculated total GOR based on vendor-reported rates (scf/stb, TS).\nCompare to wellTestGorPtsRef (WF01-transformed GOR at PTS reference conditions) to assess correction magnitude.',
      ),
    composition: z.lazy(() => TimeSeriesSchema.nullish()),
    estGasLiftInjectionRate: z.lazy(() => TimeSeriesSchema.nullish()),
    fluidCompositionPts1: z.lazy(() => TimeSeriesSchema.nullish()),
    freeCGRPtsRef: z.lazy(() => TimeSeriesSchema.nullish()),
    freeGORPtsRef: z.lazy(() => TimeSeriesSchema.nullish()),
    freeGORSC: z.lazy(() => TimeSeriesSchema.nullish()),
    gasDensityPts1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Gas density at PTS1 / line conditions (LC) (kg/m3, TS).'),
    gasDensityPts2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Gas density at PTS2 / standard conditions (SC) (kg/m3, TS).'),
    gasGravity: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Gas gravity at PTS reference conditions (relative to air, TS).'),
    h2S: z.lazy(() => TimeSeriesSchema.nullish()),
    n2: z.lazy(() => TimeSeriesSchema.nullish()),
    oilDensityPts1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Oil density at PTS1 / line conditions (LC) (kg/m3, TS).'),
    oilDensityPts2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Oil density at PTS2 / standard conditions (SC) (kg/m3, TS).'),
    sampleDateTime: z.lazy(() => TimeSeriesSchema.nullish()),
    saturationPressure: z.lazy(() => TimeSeriesSchema.nullish()),
    solutionCGR: z.lazy(() => TimeSeriesSchema.nullish()),
    solutionCGRPts1: z.lazy(() => TimeSeriesSchema.nullish()),
    solutionGOR: z.lazy(() => TimeSeriesSchema.nullish()),
    solutionGORPts1: z.lazy(() => TimeSeriesSchema.nullish()),
    specificGravityGasPts1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Specific gravity of gas at PTS1 / line conditions (LC) (TS).'),
    specificGravityGasPts2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Specific gravity of gas at PTS2 / standard conditions (SC) (TS).'),
    usedGasLiftInjectionRate: z.lazy(() => TimeSeriesSchema.nullish()),
    waterDensityPts1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Water density at PTS1 / line conditions (LC) (kg/m3, TS).'),
    waterDensityPts2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Water density at PTS2 / standard conditions (SC) (kg/m3, TS).'),
    waterSalinity: z.lazy(() => TimeSeriesSchema.nullish()),
    wellString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe('Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context.'),
    wellTestCGRPtsRef: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Condensate-gas ratio at PTS reference conditions (stb/MMscf, TS).'),
    wellTestEstimatedGLRate: z.lazy(() => TimeSeriesSchema.nullish()),
    wellTestGOR: z.lazy(() => TimeSeriesSchema.nullish()),
    wellTestGORPts1: z.lazy(() => TimeSeriesSchema.nullish()),
    wellTestGasRatePts1: z.lazy(() => TimeSeriesSchema.nullish()),
    wellTestGasRatePts2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Gas rate at PTS2 / standard conditions (MMscfd, TS).'),
    wellTestGorPts2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'GOR at PTS2 / standard conditions (scf/stb, TS).\nCompare to wellTestTotalGorStd (vendor) and calcWellTestTotalGOR (calculated) for validation.',
      ),
    wellTestGorPtsRef: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'GOR transformed by WF01 to PTS reference conditions (scf/stb, TS).\nUse together with calcWellTestTotalGOR (measured GOR based on vendor-reported rates) for comparison.\nUse to list wells above/below a GOR limit or above maxGOR from producer guidelines.',
      ),
    wellTestLiquidRatePts1: z.lazy(() => TimeSeriesSchema.nullish()),
    wellTestLiquidRatePts2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Liquid rate at PTS2 / standard conditions (stb/d, TS).'),
    wellTestLiquidRatePtsRef: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Total liquid rate at PTS reference conditions (stb/d, TS).'),
    wellTestOilRatePts1: z.lazy(() => TimeSeriesSchema.nullish()),
    wellTestOilRatePts2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Oil rate at PTS2 / standard conditions (stb/d, TS).'),
    wellTestOilRatePtsRef: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'PTS-corrected oil rate at reference conditions (stb/d, TS).\nCompare to wellTestOilRateStd (vendor-reported standard rate) to assess PTS correction impact.',
      ),
    wellTestUsedGLRate: z.lazy(() => TimeSeriesSchema.nullish()),
    wellTestWGRPts1: z.lazy(() => TimeSeriesSchema.nullish()),
    wellTestWaterCutPts1: z.lazy(() => TimeSeriesSchema.nullish()),
    wellTestWaterCutPts2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Water cut at PTS2 / standard conditions (%, TS).\nCompare to wellTestWaterCut (vendor-reported) to validate PTS calculation.',
      ),
    wellTestWaterCutPtsRef: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Water cut at PTS reference conditions (%, TS).\nUse to list wells above a water cut threshold or to track change between consecutive accepted well tests.',
      ),
    wellTestWaterRatePts1: z.lazy(() => TimeSeriesSchema.nullish()),
    wellTestWaterRatePts2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Water rate at PTS2 / standard conditions (stb/d, TS).'),
  })
  .describe(
    'Path-to-surface corrected rates, GOR, water cut at stock-tank conditions (WF10/WF19).\n\nWell performance from calibrated models and wellhead measurements. Use for well\nefficiency, production optimization, reservoir performance, and production trends. Excludes historical or geological detail.\n\nUse for: Rate and Pressure Estimation (WF10), Reservoir Pressure and PI (WF19).\n\n@name PTS Outputs - String (Agent)',
  );

export const PtsOutputsStringSchema: z.ZodObject<Properties<PtsOutputsString>> = z
  .object({
    __typename: z.literal('PtsOutputs_String').optional(),
    anchoringFluid: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'anchoringFluid' in this 'PtsOutputs_String' view."),
    bGLPts1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'bGLPts1' in this 'PtsOutputs_String' view."),
    bOil: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'bOil' in this 'PtsOutputs_String' view."),
    bOilRs: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'bOilRs' in this 'PtsOutputs_String' view."),
    bgPts1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'bgPts1' in this 'PtsOutputs_String' view."),
    blackOilPropModel: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'blackOilPropModel' in this 'PtsOutputs_String' view."),
    blackOilPropModelFileId: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'blackOilPropModelFileId' in this 'PtsOutputs_String' view."),
    boPts1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'boPts1' in this 'PtsOutputs_String' view."),
    bwPts1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'bwPts1' in this 'PtsOutputs_String' view."),
    cO2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'cO2' in this 'PtsOutputs_String' view."),
    cO2Rs: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'cO2Rs' in this 'PtsOutputs_String' view."),
    calcSaturationPress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calcSaturationPress' in this 'PtsOutputs_String' view."),
    calcTotalGORPvtRsPts2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calcTotalGORPvtRsPts2' in this 'PtsOutputs_String' view."),
    calcWellTestGOR: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calcWellTestGOR' in this 'PtsOutputs_String' view."),
    calcWellTestGORInSitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calcWellTestGORInSitu' in this 'PtsOutputs_String' view."),
    calcWellTestTotalGOR: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calcWellTestTotalGOR' in this 'PtsOutputs_String' view."),
    cgrPts1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'cgrPts1' in this 'PtsOutputs_String' view."),
    composition: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'composition' in this 'PtsOutputs_String' view."),
    entityName: z
      .lazy(() => StringAssetSchema.nullish())
      .describe("Reference to the related 'String_asset' entity for this 'PtsOutputs_String' row."),
    estGasLiftInjectionRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'estGasLiftInjectionRate' in this 'PtsOutputs_String' view."),
    fieldGLToleranceUpdate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fieldGLToleranceUpdate' in this 'PtsOutputs_String' view."),
    fluidCompModelPtsRef: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fluidCompModelPtsRef' in this 'PtsOutputs_String' view."),
    fluidCompModelPtsRefFileId: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fluidCompModelPtsRefFileId' in this 'PtsOutputs_String' view."),
    fluidCompModelPtsRefFreeGas: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fluidCompModelPtsRefFreeGas' in this 'PtsOutputs_String' view."),
    fluidCompModelPtsRefFreeGasFileId: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fluidCompModelPtsRefFreeGasFileId' in this 'PtsOutputs_String' view."),
    fluidCompModelPtsRefResult: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fluidCompModelPtsRefResult' in this 'PtsOutputs_String' view."),
    fluidCompModelPtsRefResultFileId: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fluidCompModelPtsRefResultFileId' in this 'PtsOutputs_String' view."),
    fluidCompModelWellTest: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fluidCompModelWellTest' in this 'PtsOutputs_String' view."),
    fluidCompModelWellTestFileId: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fluidCompModelWellTestFileId' in this 'PtsOutputs_String' view."),
    fluidCompositionPts1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fluidCompositionPts1' in this 'PtsOutputs_String' view."),
    fluidCompositionPts1FileId: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fluidCompositionPts1FileId' in this 'PtsOutputs_String' view."),
    fluidCompositionPts1FreeGas: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fluidCompositionPts1FreeGas' in this 'PtsOutputs_String' view."),
    fluidCompositionPts1FreeGasFileId: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fluidCompositionPts1FreeGasFileId' in this 'PtsOutputs_String' view."),
    fluidProperties: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fluidProperties' in this 'PtsOutputs_String' view."),
    freeCGRPtsRef: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'freeCGRPtsRef' in this 'PtsOutputs_String' view."),
    freeGORPtsRef: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'freeGORPtsRef' in this 'PtsOutputs_String' view."),
    freeGORSC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'freeGORSC' in this 'PtsOutputs_String' view."),
    gasDensityPts1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gasDensityPts1' in this 'PtsOutputs_String' view."),
    gasDensityPts2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gasDensityPts2' in this 'PtsOutputs_String' view."),
    gasExpansionFactorPTS1toPTSRef: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gasExpansionFactorPTS1toPTSRef' in this 'PtsOutputs_String' view."),
    gasExpansionFactorPTS2toPTSRef: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gasExpansionFactorPTS2toPTSRef' in this 'PtsOutputs_String' view."),
    gasGravity: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gasGravity' in this 'PtsOutputs_String' view."),
    gasRatePVTRsPts1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gasRatePVTRsPts1' in this 'PtsOutputs_String' view."),
    h2S: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'h2S' in this 'PtsOutputs_String' view."),
    h2SRs: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'h2SRs' in this 'PtsOutputs_String' view."),
    hydrateCurveTotalFluidPtsRef: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'hydrateCurveTotalFluidPtsRef' in this 'PtsOutputs_String' view."),
    hydrateCurveTotalFluidPtsRefFileId: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'hydrateCurveTotalFluidPtsRefFileId' in this 'PtsOutputs_String' view.",
      ),
    logPath: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'logPath' in this 'PtsOutputs_String' view."),
    massFlowRatioPts1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'massFlowRatioPts1' in this 'PtsOutputs_String' view."),
    massFlowRatioPts2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'massFlowRatioPts2' in this 'PtsOutputs_String' view."),
    massGasPts1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'massGasPts1' in this 'PtsOutputs_String' view."),
    massGasPts2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'massGasPts2' in this 'PtsOutputs_String' view."),
    massOilPts1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'massOilPts1' in this 'PtsOutputs_String' view."),
    massOilPts2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'massOilPts2' in this 'PtsOutputs_String' view."),
    matchingMethod: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'matchingMethod' in this 'PtsOutputs_String' view."),
    measuredMassFlowRatio: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'measuredMassFlowRatio' in this 'PtsOutputs_String' view."),
    modelRevisionExternalId: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelRevisionExternalId' in this 'PtsOutputs_String' view."),
    modelRevisionFileId: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelRevisionFileId' in this 'PtsOutputs_String' view."),
    modelRevisionId: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelRevisionId' in this 'PtsOutputs_String' view."),
    modelRevisionModelExternalId: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelRevisionModelExternalId' in this 'PtsOutputs_String' view."),
    n2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'n2' in this 'PtsOutputs_String' view."),
    n2Rs: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'n2Rs' in this 'PtsOutputs_String' view."),
    n2SRs: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'n2SRs' in this 'PtsOutputs_String' view."),
    oilAPIPts1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'oilAPIPts1' in this 'PtsOutputs_String' view."),
    oilAPIPts2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'oilAPIPts2' in this 'PtsOutputs_String' view."),
    oilDensityPts1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'oilDensityPts1' in this 'PtsOutputs_String' view."),
    oilDensityPts2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'oilDensityPts2' in this 'PtsOutputs_String' view."),
    oilGravity: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'oilGravity' in this 'PtsOutputs_String' view."),
    oilShrinkageFactorPTS1toPTSRef: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'oilShrinkageFactorPTS1toPTSRef' in this 'PtsOutputs_String' view."),
    oilShrinkageFactorPTS2toPTSRef: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'oilShrinkageFactorPTS2toPTSRef' in this 'PtsOutputs_String' view."),
    oilViscosity: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'oilViscosity' in this 'PtsOutputs_String' view."),
    oilViscosityRs: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'oilViscosityRs' in this 'PtsOutputs_String' view."),
    phaseEnvelopeConditionsModelPtsRef: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'phaseEnvelopeConditionsModelPtsRef' in this 'PtsOutputs_String' view.",
      ),
    phaseEnvelopeConditionsModelPtsRefFileId: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'phaseEnvelopeConditionsModelPtsRefFileId' in this 'PtsOutputs_String' view.",
      ),
    phaseEnvelopeConditionsModelPtsRefFreeGas: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'phaseEnvelopeConditionsModelPtsRefFreeGas' in this 'PtsOutputs_String' view.",
      ),
    phaseEnvelopeConditionsModelPtsRefFreeGasFileId: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'phaseEnvelopeConditionsModelPtsRefFreeGasFileId' in this 'PtsOutputs_String' view.",
      ),
    phaseEnvelopeConditionsModelPtsRefResult: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'phaseEnvelopeConditionsModelPtsRefResult' in this 'PtsOutputs_String' view.",
      ),
    phaseEnvelopeConditionsModelPtsRefResultFileId: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'phaseEnvelopeConditionsModelPtsRefResultFileId' in this 'PtsOutputs_String' view.",
      ),
    phaseEnvelopeConditionsModelPtsRs: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'phaseEnvelopeConditionsModelPtsRs' in this 'PtsOutputs_String' view."),
    phaseEnvelopeConditionsModelPtsRsFileId: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'phaseEnvelopeConditionsModelPtsRsFileId' in this 'PtsOutputs_String' view.",
      ),
    phaseEnvelopeConditionsModelWellTest: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'phaseEnvelopeConditionsModelWellTest' in this 'PtsOutputs_String' view.",
      ),
    phaseEnvelopeConditionsModelWellTestFileId: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'phaseEnvelopeConditionsModelWellTestFileId' in this 'PtsOutputs_String' view.",
      ),
    phaseEnvelopeRecordsModelPtsRef: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'phaseEnvelopeRecordsModelPtsRef' in this 'PtsOutputs_String' view."),
    phaseEnvelopeRecordsModelPtsRefFileId: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'phaseEnvelopeRecordsModelPtsRefFileId' in this 'PtsOutputs_String' view.",
      ),
    phaseEnvelopeRecordsModelPtsRefFreeGas: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'phaseEnvelopeRecordsModelPtsRefFreeGas' in this 'PtsOutputs_String' view.",
      ),
    phaseEnvelopeRecordsModelPtsRefFreeGasFileId: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'phaseEnvelopeRecordsModelPtsRefFreeGasFileId' in this 'PtsOutputs_String' view.",
      ),
    phaseEnvelopeRecordsModelPtsRefResult: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'phaseEnvelopeRecordsModelPtsRefResult' in this 'PtsOutputs_String' view.",
      ),
    phaseEnvelopeRecordsModelPtsRefResultFileId: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'phaseEnvelopeRecordsModelPtsRefResultFileId' in this 'PtsOutputs_String' view.",
      ),
    phaseEnvelopeRecordsModelPtsRefRs: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'phaseEnvelopeRecordsModelPtsRefRs' in this 'PtsOutputs_String' view."),
    phaseEnvelopeRecordsModelPtsRefRsFileId: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'phaseEnvelopeRecordsModelPtsRefRsFileId' in this 'PtsOutputs_String' view.",
      ),
    phaseEnvelopeRecordsModelWellTest: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'phaseEnvelopeRecordsModelWellTest' in this 'PtsOutputs_String' view."),
    phaseEnvelopeRecordsModelWellTestFileId: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'phaseEnvelopeRecordsModelWellTestFileId' in this 'PtsOutputs_String' view.",
      ),
    ptsExecutedBy: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'ptsExecutedBy' in this 'PtsOutputs_String' view."),
    ptsExecutionDate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'ptsExecutionDate' in this 'PtsOutputs_String' view."),
    ptsExecutionStatus: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'ptsExecutionStatus' in this 'PtsOutputs_String' view."),
    pvtInfo: z.string().nullish().describe("Text attribute 'pvtInfo' for this 'PtsOutputs_String' row."),
    pvtInfoFileId: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'pvtInfoFileId' in this 'PtsOutputs_String' view."),
    sampleComposition: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'sampleComposition' in this 'PtsOutputs_String' view."),
    sampleCompositionFileId: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'sampleCompositionFileId' in this 'PtsOutputs_String' view."),
    sampleDateTime: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'sampleDateTime' in this 'PtsOutputs_String' view."),
    saturationPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'saturationPressure' in this 'PtsOutputs_String' view."),
    saturationPressureRs: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'saturationPressureRs' in this 'PtsOutputs_String' view."),
    solutionCGR: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'solutionCGR' in this 'PtsOutputs_String' view."),
    solutionCGRPts1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'solutionCGRPts1' in this 'PtsOutputs_String' view."),
    solutionGOR: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'solutionGOR' in this 'PtsOutputs_String' view."),
    solutionGORPts1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'solutionGORPts1' in this 'PtsOutputs_String' view."),
    solutionGORRs: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'solutionGORRs' in this 'PtsOutputs_String' view."),
    solutionGORRsPts1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'solutionGORRsPts1' in this 'PtsOutputs_String' view."),
    solutionGORRsPts1scfbbl: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'solutionGORRsPts1scfbbl' in this 'PtsOutputs_String' view."),
    specificGasGravityRs: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'specificGasGravityRs' in this 'PtsOutputs_String' view."),
    specificGravityGasPts1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'specificGravityGasPts1' in this 'PtsOutputs_String' view."),
    specificGravityGasPts2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'specificGravityGasPts2' in this 'PtsOutputs_String' view."),
    specificGravityOilPts1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'specificGravityOilPts1' in this 'PtsOutputs_String' view."),
    specificGravityOilPts2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'specificGravityOilPts2' in this 'PtsOutputs_String' view."),
    specificOilGravityRs: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'specificOilGravityRs' in this 'PtsOutputs_String' view."),
    totalCGRPts2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'totalCGRPts2' in this 'PtsOutputs_String' view."),
    totalGORPvtRsPts2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'totalGORPvtRsPts2' in this 'PtsOutputs_String' view."),
    triggeredWf02Status: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'triggeredWf02Status' in this 'PtsOutputs_String' view."),
    triggeredWf03Status: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'triggeredWf03Status' in this 'PtsOutputs_String' view."),
    triggeredWf04Status: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'triggeredWf04Status' in this 'PtsOutputs_String' view."),
    usedGasLiftInjectionRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'usedGasLiftInjectionRate' in this 'PtsOutputs_String' view."),
    usedGasLiftInjectionRateLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'usedGasLiftInjectionRateLC' in this 'PtsOutputs_String' view."),
    waterDensityPts1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'waterDensityPts1' in this 'PtsOutputs_String' view."),
    waterDensityPts2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'waterDensityPts2' in this 'PtsOutputs_String' view."),
    waterSalinity: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'waterSalinity' in this 'PtsOutputs_String' view."),
    wellTestApprovedAllocationFlag: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestApprovedAllocationFlag' in this 'PtsOutputs_String' view."),
    wellTestCGRPts: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestCGRPts' in this 'PtsOutputs_String' view."),
    wellTestCGRPts1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestCGRPts1' in this 'PtsOutputs_String' view."),
    wellTestCGRPts2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestCGRPts2' in this 'PtsOutputs_String' view."),
    wellTestCGRPtsRef: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestCGRPtsRef' in this 'PtsOutputs_String' view."),
    wellTestEstimatedGLRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestEstimatedGLRate' in this 'PtsOutputs_String' view."),
    wellTestGLMassFlowRatePts1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGLMassFlowRatePts1' in this 'PtsOutputs_String' view."),
    wellTestGLMassFlowRatePts2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGLMassFlowRatePts2' in this 'PtsOutputs_String' view."),
    wellTestGOR: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGOR' in this 'PtsOutputs_String' view."),
    wellTestGORPts1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGORPts1' in this 'PtsOutputs_String' view."),
    wellTestGasMassFlowRatePts1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGasMassFlowRatePts1' in this 'PtsOutputs_String' view."),
    wellTestGasMassFlowRatePts2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGasMassFlowRatePts2' in this 'PtsOutputs_String' view."),
    wellTestGasMassFlowRatePtsRef: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGasMassFlowRatePtsRef' in this 'PtsOutputs_String' view."),
    wellTestGasRatePts1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGasRatePts1' in this 'PtsOutputs_String' view."),
    wellTestGasRatePts2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGasRatePts2' in this 'PtsOutputs_String' view."),
    wellTestGasRatePtsRef: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGasRatePtsRef' in this 'PtsOutputs_String' view."),
    wellTestGorPts2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGorPts2' in this 'PtsOutputs_String' view."),
    wellTestGorPtsRef: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGorPtsRef' in this 'PtsOutputs_String' view."),
    wellTestGorPtsRefWithUnitID: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGorPtsRefWithUnitID' in this 'PtsOutputs_String' view."),
    wellTestHCMassFlowRatePts1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestHCMassFlowRatePts1' in this 'PtsOutputs_String' view."),
    wellTestHCMassFlowRatePts2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestHCMassFlowRatePts2' in this 'PtsOutputs_String' view."),
    wellTestHCMassFlowRatePtsRef: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestHCMassFlowRatePtsRef' in this 'PtsOutputs_String' view."),
    wellTestLiquidRatePts1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestLiquidRatePts1' in this 'PtsOutputs_String' view."),
    wellTestLiquidRatePts2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestLiquidRatePts2' in this 'PtsOutputs_String' view."),
    wellTestLiquidRatePtsRef: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestLiquidRatePtsRef' in this 'PtsOutputs_String' view."),
    wellTestOilMassFlowRatePts1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestOilMassFlowRatePts1' in this 'PtsOutputs_String' view."),
    wellTestOilMassFlowRatePts2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestOilMassFlowRatePts2' in this 'PtsOutputs_String' view."),
    wellTestOilMassFlowRatePtsRef: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestOilMassFlowRatePtsRef' in this 'PtsOutputs_String' view."),
    wellTestOilRatePts1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestOilRatePts1' in this 'PtsOutputs_String' view."),
    wellTestOilRatePts2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestOilRatePts2' in this 'PtsOutputs_String' view."),
    wellTestOilRatePtsRef: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestOilRatePtsRef' in this 'PtsOutputs_String' view."),
    wellTestSGVPts1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestSGVPts1' in this 'PtsOutputs_String' view."),
    wellTestSGVPts2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestSGVPts2' in this 'PtsOutputs_String' view."),
    wellTestSOVPts1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestSOVPts1' in this 'PtsOutputs_String' view."),
    wellTestSOVPts2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestSOVPts2' in this 'PtsOutputs_String' view."),
    wellTestTotalMassFlowRatePts1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestTotalMassFlowRatePts1' in this 'PtsOutputs_String' view."),
    wellTestTotalMassFlowRatePts2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestTotalMassFlowRatePts2' in this 'PtsOutputs_String' view."),
    wellTestTotalMassFlowRatePtsRef: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestTotalMassFlowRatePtsRef' in this 'PtsOutputs_String' view."),
    wellTestUsedGLRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestUsedGLRate' in this 'PtsOutputs_String' view."),
    wellTestWGRPts: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestWGRPts' in this 'PtsOutputs_String' view."),
    wellTestWGRPts1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestWGRPts1' in this 'PtsOutputs_String' view."),
    wellTestWGRPts2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestWGRPts2' in this 'PtsOutputs_String' view."),
    wellTestWGRPtsRef: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestWGRPtsRef' in this 'PtsOutputs_String' view."),
    wellTestWaterCutPts1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestWaterCutPts1' in this 'PtsOutputs_String' view."),
    wellTestWaterCutPts2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestWaterCutPts2' in this 'PtsOutputs_String' view."),
    wellTestWaterCutPtsRef: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestWaterCutPtsRef' in this 'PtsOutputs_String' view."),
    wellTestWaterMassFlowRatePts1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestWaterMassFlowRatePts1' in this 'PtsOutputs_String' view."),
    wellTestWaterMassFlowRatePts2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestWaterMassFlowRatePts2' in this 'PtsOutputs_String' view."),
    wellTestWaterMassFlowRatePtsRef: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestWaterMassFlowRatePtsRef' in this 'PtsOutputs_String' view."),
    wellTestWaterRatePts1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestWaterRatePts1' in this 'PtsOutputs_String' view."),
    wellTestWaterRatePts2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestWaterRatePts2' in this 'PtsOutputs_String' view."),
    wellTestWaterRatePtsRef: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestWaterRatePtsRef' in this 'PtsOutputs_String' view."),
    wf01ReprocessFlag: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wf01ReprocessFlag' in this 'PtsOutputs_String' view."),
  })
  .describe("View 'PtsOutputs_String' in the iPSO production optimization solution data model.");

export const ProsperModelMetricsSchema: z.ZodObject<Properties<ProsperModelMetrics>> = z
  .object({
    __typename: z.literal('ProsperModelMetrics').optional(),
    entityName: z
      .lazy(() => StringAssetSchema.nullish())
      .describe("Reference to the related 'String_asset' entity for this 'ProsperModelMetrics' row."),
    field: z
      .lazy(() => FieldSchema.nullish())
      .describe("Reference to the related 'Field' entity for this 'ProsperModelMetrics' row."),
    modelAvailability: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelAvailability' in this 'ProsperModelMetrics' view."),
  })
  .describe("View 'ProsperModelMetrics' in the iPSO production optimization solution data model.");

export const ProdplanStringReservoirSectorSchema: z.ZodObject<Properties<ProdplanStringReservoirSector>> = z
  .object({
    __typename: z.literal('Prodplan_String_Reservoir_Sector').optional(),
    entityName: z
      .lazy(() => StringAssetSchema.nullish())
      .describe("Reference to the related 'String_asset' entity for this 'Prodplan_String_Reservoir_Sector' row."),
    fmoprContr: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fmoprContr' in this 'Prodplan_String_Reservoir_Sector' view."),
    fmoprWater: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fmoprWater' in this 'Prodplan_String_Reservoir_Sector' view."),
    giAllowableContr: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'giAllowableContr' in this 'Prodplan_String_Reservoir_Sector' view."),
    giAllowableRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'giAllowableRate' in this 'Prodplan_String_Reservoir_Sector' view."),
    giAvailableContr: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'giAvailableContr' in this 'Prodplan_String_Reservoir_Sector' view."),
    giSubmittedMonth: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'giSubmittedMonth' in this 'Prodplan_String_Reservoir_Sector' view."),
    giSustainableContr: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'giSustainableContr' in this 'Prodplan_String_Reservoir_Sector' view."),
    giSustainableRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'giSustainableRate' in this 'Prodplan_String_Reservoir_Sector' view."),
    giTechnicalRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'giTechnicalRate' in this 'Prodplan_String_Reservoir_Sector' view."),
    giWellAvailability: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'giWellAvailability' in this 'Prodplan_String_Reservoir_Sector' view."),
    opBg: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'opBg' in this 'Prodplan_String_Reservoir_Sector' view."),
    opBo: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'opBo' in this 'Prodplan_String_Reservoir_Sector' view."),
    opBw: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'opBw' in this 'Prodplan_String_Reservoir_Sector' view."),
    opRs: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'opRs' in this 'Prodplan_String_Reservoir_Sector' view."),
    opSubmittedMonth: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'opSubmittedMonth' in this 'Prodplan_String_Reservoir_Sector' view."),
    opVrrAdjustment: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'opVrrAdjustment' in this 'Prodplan_String_Reservoir_Sector' view."),
    opWar: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'opWar' in this 'Prodplan_String_Reservoir_Sector' view."),
    opWarVrr: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'opWarVrr' in this 'Prodplan_String_Reservoir_Sector' view."),
    opWpr: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'opWpr' in this 'Prodplan_String_Reservoir_Sector' view."),
    opWprFlowAssurance: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'opWprFlowAssurance' in this 'Prodplan_String_Reservoir_Sector' view."),
    opWprIntegrity: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'opWprIntegrity' in this 'Prodplan_String_Reservoir_Sector' view."),
    opWprManPress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'opWprManPress' in this 'Prodplan_String_Reservoir_Sector' view."),
    opWsopr: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'opWsopr' in this 'Prodplan_String_Reservoir_Sector' view."),
    opWtr: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'opWtr' in this 'Prodplan_String_Reservoir_Sector' view."),
    quotaContr: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'quotaContr' in this 'Prodplan_String_Reservoir_Sector' view."),
    reservoirName: z
      .string()
      .nullish()
      .describe("Text attribute 'reservoirName' for this 'Prodplan_String_Reservoir_Sector' row."),
    sectorName: z
      .string()
      .nullish()
      .describe("Text attribute 'sectorName' for this 'Prodplan_String_Reservoir_Sector' row."),
    wiAllowableContr: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wiAllowableContr' in this 'Prodplan_String_Reservoir_Sector' view."),
    wiAllowableRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wiAllowableRate' in this 'Prodplan_String_Reservoir_Sector' view."),
    wiAvailableContr: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wiAvailableContr' in this 'Prodplan_String_Reservoir_Sector' view."),
    wiSubmittedMonth: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wiSubmittedMonth' in this 'Prodplan_String_Reservoir_Sector' view."),
    wiSustainableContr: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wiSustainableContr' in this 'Prodplan_String_Reservoir_Sector' view."),
    wiSustainableRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wiSustainableRate' in this 'Prodplan_String_Reservoir_Sector' view."),
    wiTechnicalRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wiTechnicalRate' in this 'Prodplan_String_Reservoir_Sector' view."),
    wiWellAvailability: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wiWellAvailability' in this 'Prodplan_String_Reservoir_Sector' view."),
    wsoprTotalGas: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wsoprTotalGas' in this 'Prodplan_String_Reservoir_Sector' view."),
  })
  .describe("View 'Prodplan_String_Reservoir_Sector' in the iPSO production optimization solution data model.");

export const ProdplanStringAgentSchema: z.ZodObject<Properties<ProdplanStringAgent>> = z
  .object({
    __typename: z.literal('Prodplan_String_Agent').optional(),
    giAllowableContr: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Allowable gas injection contribution share (TS).'),
    giAllowableRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Allowable gas injection rate (MSCF/d or model units, TS).'),
    giTechnicalRate: z.lazy(() => TimeSeriesSchema.nullish()).describe('Technical gas injection rate limit (TS).'),
    opWpr: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Technical oil rate / oil potential from production plan (stb/d, TS). IPSO mapping — technical oil rate.',
      ),
    quotaContr: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Allowable oil-related quota / contribution limit (stb/d, TS). IPSO mapping — allowable oil rate context.',
      ),
    wellString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe('Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context.'),
    wiAllowableContr: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Allowable water injection contribution share (TS). Use when allocation splits injection allowable.'),
    wiAllowableRate: z.lazy(() => TimeSeriesSchema.nullish()).describe('Allowable water injection rate (stb/d, TS).'),
    wiTechnicalRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Technical water injection rate limit (stb/d, TS).'),
    wsoprTotalGas: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Allowable total gas rate (WSOPR gas, TS). IPSO mapping — allowable gas rate.'),
  })
  .describe(
    'IPSO production-plan allowable and technical rate time series per well string.\n\nMaps to solution Prodplan_String: oil/gas allowable (quota and gas totals), water/gas\ninjection allowable and technical limits, and technical oil rate (opWpr). Compare\nagainst PriorityRates_String_Agent / EstimatedRates_String_Agent for underperformance.\nFor WellInputs unconstrained potentials use WellPotential_String_Agent.\n\nUse for: allowable vs estimated rate checks (WF10/WF19), complement to WF6 guidelines.\n\n@name Production Plan Limits — String (Agent)',
  );

export const ProdplanStringSchema: z.ZodObject<Properties<ProdplanString>> = z
  .object({
    __typename: z.literal('Prodplan_String').optional(),
    entityName: z
      .lazy(() => StringAssetSchema.nullish())
      .describe("Reference to the related 'String_asset' entity for this 'Prodplan_String' row."),
    fmoprContr: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fmoprContr' in this 'Prodplan_String' view."),
    fmoprWater: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fmoprWater' in this 'Prodplan_String' view."),
    giAllowableContr: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'giAllowableContr' in this 'Prodplan_String' view."),
    giAllowableRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'giAllowableRate' in this 'Prodplan_String' view."),
    giAvailableContr: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'giAvailableContr' in this 'Prodplan_String' view."),
    giSubmittedMonth: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'giSubmittedMonth' in this 'Prodplan_String' view."),
    giSustainableContr: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'giSustainableContr' in this 'Prodplan_String' view."),
    giSustainableRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'giSustainableRate' in this 'Prodplan_String' view."),
    giTechnicalRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'giTechnicalRate' in this 'Prodplan_String' view."),
    giWellAvailability: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'giWellAvailability' in this 'Prodplan_String' view."),
    opBg: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'opBg' in this 'Prodplan_String' view."),
    opBo: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'opBo' in this 'Prodplan_String' view."),
    opBw: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'opBw' in this 'Prodplan_String' view."),
    opRs: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'opRs' in this 'Prodplan_String' view."),
    opSubmittedMonth: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'opSubmittedMonth' in this 'Prodplan_String' view."),
    opVrrAdjustment: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'opVrrAdjustment' in this 'Prodplan_String' view."),
    opWar: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'opWar' in this 'Prodplan_String' view."),
    opWarVrr: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'opWarVrr' in this 'Prodplan_String' view."),
    opWpr: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'opWpr' in this 'Prodplan_String' view."),
    opWprFlowAssurance: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'opWprFlowAssurance' in this 'Prodplan_String' view."),
    opWprIntegrity: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'opWprIntegrity' in this 'Prodplan_String' view."),
    opWprManPress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'opWprManPress' in this 'Prodplan_String' view."),
    opWsopr: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'opWsopr' in this 'Prodplan_String' view."),
    opWtr: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'opWtr' in this 'Prodplan_String' view."),
    quotaContr: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'quotaContr' in this 'Prodplan_String' view."),
    wiAllowableContr: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wiAllowableContr' in this 'Prodplan_String' view."),
    wiAllowableRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wiAllowableRate' in this 'Prodplan_String' view."),
    wiAvailableContr: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wiAvailableContr' in this 'Prodplan_String' view."),
    wiSubmittedMonth: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wiSubmittedMonth' in this 'Prodplan_String' view."),
    wiSustainableContr: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wiSustainableContr' in this 'Prodplan_String' view."),
    wiSustainableRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wiSustainableRate' in this 'Prodplan_String' view."),
    wiTechnicalRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wiTechnicalRate' in this 'Prodplan_String' view."),
    wiWellAvailability: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wiWellAvailability' in this 'Prodplan_String' view."),
    wsoprTotalGas: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wsoprTotalGas' in this 'Prodplan_String' view."),
  })
  .describe("View 'Prodplan_String' in the iPSO production optimization solution data model.");

export const PriorityRatesStringAgentSchema: z.ZodObject<Properties<PriorityRatesStringAgent>> = z
  .object({
    __typename: z.literal('PriorityRates_String_Agent').optional(),
    priorityFbhp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Best-available flowing bottom-hole pressure (psi, TS).'),
    priorityGasRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Best-available estimated gas rate (MSCF/d, TS).'),
    priorityLiquidRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Best-available estimated total liquid rate, oil + water (stb/d, TS).'),
    priorityMethod: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Analysis method that produced the priority rates. Values: SYSTEM_ANALYSIS, CHOKE_ANALYSIS, ALLOCATION, WELL_TEST, DATA_ANALYSIS.',
      ),
    priorityOilRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Best-available estimated oil rate (stb/d, TS).'),
    priorityWaterRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Best-available estimated water rate (stb/d, TS).'),
    wellString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe('Well string identifier. Join to FlatHierarchy_Agent for field/reservoir context.'),
  })
  .describe(
    'Best-available rate and pressure estimates per well string — default for simple rate lookups.\n\nPriority (best-available) oil, gas, water, liquid rates, flowing BHP, and\nsource method. Use for "what is the current rate for well X?" or "show\nproduction figures for field X". For method-comparison use EstimatedRates_String_Agent.\n\nUse for: Real-Time Well Rate and Pressure Estimation (WF10).\n\n@name Priority Rates - Best Available Estimates (Agent)',
  );

export const PvtAnalysisStringAgentSchema: z.ZodObject<Properties<PvtAnalysisStringAgent>> = z
  .object({
    __typename: z.literal('PVTAnalysis_String_Agent').optional(),
    salinity: z.lazy(() => TimeSeriesSchema.nullish()),
    sampleDate: z.lazy(() => TimeSeriesSchema.nullish()),
    sampleType: z.lazy(() => TimeSeriesSchema.nullish()),
    waterCut: z.lazy(() => TimeSeriesSchema.nullish()),
    wellString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe('Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context.'),
  })
  .describe(
    'PVT analysis results and fluid property measurements per well string.\n\nContains PVT sample analysis reference data, fluid type, sample date, and\nanalysis quality indicators for each well string. Sourced from laboratory\nanalyses of fluid samples collected from wells, to address analytical\nquestions regarding fluid characteristics and behavior under varying\nconditions. It excludes production data or reservoir performance metrics (see\nother views). Use cases: evaluating fluid properties for reservoir simulations\nand optimizing production strategies based on sample quality and composition.\n\n@name PVT Analysis - String (Agent)',
  );

export const PvtAnalysisStringSchema: z.ZodObject<Properties<PvtAnalysisString>> = z
  .object({
    __typename: z.literal('PVTAnalysis_String').optional(),
    entityName: z
      .lazy(() => StringAssetSchema.nullish())
      .describe("Reference to the related 'String_asset' entity for this 'PVTAnalysis_String' row."),
    salinity: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'salinity' in this 'PVTAnalysis_String' view."),
    sampleDate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'sampleDate' in this 'PVTAnalysis_String' view."),
    sampleType: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'sampleType' in this 'PVTAnalysis_String' view."),
    waterCut: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'waterCut' in this 'PVTAnalysis_String' view."),
  })
  .describe("View 'PVTAnalysis_String' in the iPSO production optimization solution data model.");

export const OptimizedRatesSrmStringAgentSchema: z.ZodObject<Properties<OptimizedRatesSrmStringAgent>> = z
  .object({
    __typename: z.literal('OptimizedRates_SRM_String_Agent').optional(),
    executionDate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('When this optimization scenario was executed (TS).'),
    isOfficial: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Whether this is the official approved scenario (boolean flag).\n1 = approved for execution, 0 = exploratory/what-if scenario.',
      ),
    optimizeGasRateSRM: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('SRM-optimized gas production rate (MSCF/d, TS).'),
    optimizeWaterRateSRM: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('SRM-optimized water production rate (stb/d, TS).'),
    optimizedBHFPGAP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('GAP-optimized bottomhole flowing pressure (psia, TS). Target drawdown\nfor production optimization.'),
    optimizedChokeSizeGAP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('GAP-optimized choke size setting (TS). Recommended choke opening\nfor production optimization.'),
    optimizedESPFrequencyGAP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('GAP-optimized ESP pump frequency (Hz, TS). Recommended VSD frequency\nfor optimal pump performance.'),
    optimizedGasInjRateGAP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('GAP network-optimized gas injection rate (MSCF/d, TS).'),
    optimizedGasInjRateSRM: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('SRM-optimized gas injection rate (MSCF/d, TS). Target injection rate\nfor VRR optimization.'),
    optimizedGasLiftRateGAP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'GAP-optimized gas lift injection rate (MSCF/d, TS). Recommended GL\nrate for maximum oil production with minimum gas usage.',
      ),
    optimizedGasRateGAP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('GAP network-optimized gas production rate (MSCF/d, TS).'),
    optimizedInjRateResCond: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Optimized injection rate at reservoir conditions (rb/d, TS).\nUsed for VRR calculation at reservoir conditions.',
      ),
    optimizedOilRateGAP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'GAP network-optimized oil production rate (stb/d, TS). Accounts for\nnetwork constraints (manifold pressure, pipeline capacity).',
      ),
    optimizedOilRateSRM: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'SRM-optimized oil production rate (stb/d, TS). Compare to current\nproduction to identify uplift potential.',
      ),
    optimizedProdRateResCond: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Optimized production rate at reservoir conditions (rb/d, TS).\nUsed for VRR calculation at reservoir conditions.',
      ),
    optimizedWHP: z.lazy(() => TimeSeriesSchema.nullish()).describe('Optimized wellhead pressure (psia, TS).'),
    optimizedWaterInjRateGAP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('GAP network-optimized water injection rate (stb/d, TS).'),
    optimizedWaterInjRateSRM: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('SRM-optimized water injection rate (stb/d, TS). Target injection rate\nfor VRR optimization.'),
    optimizedWaterRateGAP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('GAP network-optimized water production rate (stb/d, TS).'),
    scenario: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Optimization scenario name/identifier (TS). Groups results from the\nsame optimization run.'),
    wellString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe('Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context.'),
  })
  .describe(
    'SRM/GAP optimization results per well string (WF17).\n\nOptimized rates and setpoints from Sector Reservoir Model and GAP; well-string\nperformance across optimization scenarios. Use for optimal production rates and gas lift optimization potential.\n\nUse for: VRR Optimization (WF17).\n\n@name Optimized Rates - SRM (Agent)',
  );

export const OptimizedRatesNetworkStringAgentSchema: z.ZodObject<Properties<OptimizedRatesNetworkStringAgent>> = z
  .object({
    __typename: z.literal('OptimizedRates_Network_String_Agent').optional(),
    adHocOptimization1ChokeBeanSize: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocOptimization1ChokeBeanSize from GAP network optimization (TS).'),
    adHocOptimization1ChokeOpening: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocOptimization1ChokeOpening from GAP network optimization (TS).'),
    adHocOptimization1Comment: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocOptimization1Comment from GAP network optimization (TS).'),
    adHocOptimization1EspFrequency: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocOptimization1EspFrequency from GAP network optimization (TS).'),
    adHocOptimization1ExecutedBy: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocOptimization1ExecutedBy from GAP network optimization (TS).'),
    adHocOptimization1FBHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocOptimization1FBHP from GAP network optimization (TS).'),
    adHocOptimization1FWHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocOptimization1FWHP from GAP network optimization (TS).'),
    adHocOptimization1GasLiftRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocOptimization1GasLiftRate from GAP network optimization (TS).'),
    adHocOptimization1GasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocOptimization1GasRate from GAP network optimization (TS).'),
    adHocOptimization1OilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocOptimization1OilRate from GAP network optimization (TS).'),
    adHocOptimization1OptimizedParameter: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocOptimization1OptimizedParameter from GAP network optimization (TS).'),
    adHocOptimization1Power: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocOptimization1Power from GAP network optimization (TS).'),
    adHocOptimization1RunID: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocOptimization1RunID from GAP network optimization (TS).'),
    adHocOptimization1WaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocOptimization1WaterRate from GAP network optimization (TS).'),
    adHocOptimization2ChokeBeanSize: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocOptimization2ChokeBeanSize from GAP network optimization (TS).'),
    adHocOptimization2ChokeOpening: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocOptimization2ChokeOpening from GAP network optimization (TS).'),
    adHocOptimization2Comment: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocOptimization2Comment from GAP network optimization (TS).'),
    adHocOptimization2EspFrequency: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocOptimization2EspFrequency from GAP network optimization (TS).'),
    adHocOptimization2ExecutedBy: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocOptimization2ExecutedBy from GAP network optimization (TS).'),
    adHocOptimization2FBHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocOptimization2FBHP from GAP network optimization (TS).'),
    adHocOptimization2FWHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocOptimization2FWHP from GAP network optimization (TS).'),
    adHocOptimization2GasLiftRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocOptimization2GasLiftRate from GAP network optimization (TS).'),
    adHocOptimization2GasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocOptimization2GasRate from GAP network optimization (TS).'),
    adHocOptimization2OilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocOptimization2OilRate from GAP network optimization (TS).'),
    adHocOptimization2OptimizedParameter: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocOptimization2OptimizedParameter from GAP network optimization (TS).'),
    adHocOptimization2Power: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocOptimization2Power from GAP network optimization (TS).'),
    adHocOptimization2RunID: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocOptimization2RunID from GAP network optimization (TS).'),
    adHocOptimization2WaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocOptimization2WaterRate from GAP network optimization (TS).'),
    adHocSimulation1ChokeBeanSize: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocSimulation1ChokeBeanSize from GAP network optimization (TS).'),
    adHocSimulation1ChokeOpening: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocSimulation1ChokeOpening from GAP network optimization (TS).'),
    adHocSimulation1Comment: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocSimulation1Comment from GAP network optimization (TS).'),
    adHocSimulation1EspFrequency: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocSimulation1EspFrequency from GAP network optimization (TS).'),
    adHocSimulation1ExecutedBy: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocSimulation1ExecutedBy from GAP network optimization (TS).'),
    adHocSimulation1FBHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocSimulation1FBHP from GAP network optimization (TS).'),
    adHocSimulation1FWHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocSimulation1FWHP from GAP network optimization (TS).'),
    adHocSimulation1GasLiftRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocSimulation1GasLiftRate from GAP network optimization (TS).'),
    adHocSimulation1GasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocSimulation1GasRate from GAP network optimization (TS).'),
    adHocSimulation1OilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocSimulation1OilRate from GAP network optimization (TS).'),
    adHocSimulation1OptimizedParameter: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocSimulation1OptimizedParameter from GAP network optimization (TS).'),
    adHocSimulation1Power: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocSimulation1Power from GAP network optimization (TS).'),
    adHocSimulation1RunID: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocSimulation1RunID from GAP network optimization (TS).'),
    adHocSimulation1WaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocSimulation1WaterRate from GAP network optimization (TS).'),
    adHocSimulation2ChokeBeanSize: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocSimulation2ChokeBeanSize from GAP network optimization (TS).'),
    adHocSimulation2ChokeOpening: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocSimulation2ChokeOpening from GAP network optimization (TS).'),
    adHocSimulation2Comment: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocSimulation2Comment from GAP network optimization (TS).'),
    adHocSimulation2EspFrequency: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocSimulation2EspFrequency from GAP network optimization (TS).'),
    adHocSimulation2ExecutedBy: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocSimulation2ExecutedBy from GAP network optimization (TS).'),
    adHocSimulation2FBHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocSimulation2FBHP from GAP network optimization (TS).'),
    adHocSimulation2FWHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocSimulation2FWHP from GAP network optimization (TS).'),
    adHocSimulation2GasLiftRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocSimulation2GasLiftRate from GAP network optimization (TS).'),
    adHocSimulation2GasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocSimulation2GasRate from GAP network optimization (TS).'),
    adHocSimulation2OilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocSimulation2OilRate from GAP network optimization (TS).'),
    adHocSimulation2OptimizedParameter: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocSimulation2OptimizedParameter from GAP network optimization (TS).'),
    adHocSimulation2Power: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocSimulation2Power from GAP network optimization (TS).'),
    adHocSimulation2RunID: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocSimulation2RunID from GAP network optimization (TS).'),
    adHocSimulation2WaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocSimulation2WaterRate from GAP network optimization (TS).'),
    fsoprChokeBeanSize: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('fsoprChokeBeanSize from GAP network optimization (TS).'),
    fsoprChokeOpening: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('fsoprChokeOpening from GAP network optimization (TS).'),
    fsoprEspFrequency: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('fsoprEspFrequency from GAP network optimization (TS).'),
    fsoprFBHP: z.lazy(() => TimeSeriesSchema.nullish()).describe('fsoprFBHP from GAP network optimization (TS).'),
    fsoprFWHP: z.lazy(() => TimeSeriesSchema.nullish()).describe('fsoprFWHP from GAP network optimization (TS).'),
    fsoprGasLiftRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('fsoprGasLiftRate from GAP network optimization (TS).'),
    fsoprGasRate: z.lazy(() => TimeSeriesSchema.nullish()).describe('fsoprGasRate from GAP network optimization (TS).'),
    fsoprOilRate: z.lazy(() => TimeSeriesSchema.nullish()).describe('fsoprOilRate from GAP network optimization (TS).'),
    fsoprOptimizedParameter: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('fsoprOptimizedParameter from GAP network optimization (TS).'),
    fsoprPower: z.lazy(() => TimeSeriesSchema.nullish()).describe('fsoprPower from GAP network optimization (TS).'),
    fsoprRunID: z.lazy(() => TimeSeriesSchema.nullish()).describe('fsoprRunID from GAP network optimization (TS).'),
    fsoprWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('fsoprWaterRate from GAP network optimization (TS).'),
    hydraulicChokeBeanSize: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('hydraulicChokeBeanSize from GAP network optimization (TS).'),
    hydraulicChokeOpening: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('hydraulicChokeOpening from GAP network optimization (TS).'),
    hydraulicEspFrequency: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('hydraulicEspFrequency from GAP network optimization (TS).'),
    hydraulicFBHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('hydraulicFBHP from GAP network optimization (TS).'),
    hydraulicFWHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('hydraulicFWHP from GAP network optimization (TS).'),
    hydraulicGasLiftRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('hydraulicGasLiftRate from GAP network optimization (TS).'),
    hydraulicGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('hydraulicGasRate from GAP network optimization (TS).'),
    hydraulicOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('hydraulicOilRate from GAP network optimization (TS).'),
    hydraulicOptimizedParameter: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('hydraulicOptimizedParameter from GAP network optimization (TS).'),
    hydraulicPower: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('hydraulicPower from GAP network optimization (TS).'),
    hydraulicRunID: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('hydraulicRunID from GAP network optimization (TS).'),
    hydraulicWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('hydraulicWaterRate from GAP network optimization (TS).'),
    systemOptimizedChokeBeanSize: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('systemOptimizedChokeBeanSize from GAP network optimization (TS).'),
    systemOptimizedChokeChokeBeanSize: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('systemOptimizedChokeChokeBeanSize from GAP network optimization (TS).'),
    systemOptimizedChokeChokeOpening: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('systemOptimizedChokeChokeOpening from GAP network optimization (TS).'),
    systemOptimizedChokeEspFrequency: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('systemOptimizedChokeEspFrequency from GAP network optimization (TS).'),
    systemOptimizedChokeFBHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('systemOptimizedChokeFBHP from GAP network optimization (TS).'),
    systemOptimizedChokeFWHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('systemOptimizedChokeFWHP from GAP network optimization (TS).'),
    systemOptimizedChokeGasLiftRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('systemOptimizedChokeGasLiftRate from GAP network optimization (TS).'),
    systemOptimizedChokeGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('systemOptimizedChokeGasRate from GAP network optimization (TS).'),
    systemOptimizedChokeOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('systemOptimizedChokeOilRate from GAP network optimization (TS).'),
    systemOptimizedChokeOpening: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('systemOptimizedChokeOpening from GAP network optimization (TS).'),
    systemOptimizedChokeOptimizedParameter: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('systemOptimizedChokeOptimizedParameter from GAP network optimization (TS).'),
    systemOptimizedChokePower: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('systemOptimizedChokePower from GAP network optimization (TS).'),
    systemOptimizedChokeRunID: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('systemOptimizedChokeRunID from GAP network optimization (TS).'),
    systemOptimizedChokeWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('systemOptimizedChokeWaterRate from GAP network optimization (TS).'),
    systemOptimizedEspFrequency: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('systemOptimizedEspFrequency from GAP network optimization (TS).'),
    systemOptimizedFBHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('systemOptimizedFBHP from GAP network optimization (TS).'),
    systemOptimizedFWHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('systemOptimizedFWHP from GAP network optimization (TS).'),
    systemOptimizedGasLiftRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('systemOptimizedGasLiftRate from GAP network optimization (TS).'),
    systemOptimizedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('systemOptimizedGasRate from GAP network optimization (TS).'),
    systemOptimizedOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('systemOptimizedOilRate from GAP network optimization (TS).'),
    systemOptimizedOptimizedParameter: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('systemOptimizedOptimizedParameter from GAP network optimization (TS).'),
    systemOptimizedPower: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('systemOptimizedPower from GAP network optimization (TS).'),
    systemOptimizedRunID: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('systemOptimizedRunID from GAP network optimization (TS).'),
    systemOptimizedWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('systemOptimizedWaterRate from GAP network optimization (TS).'),
    technicalChokeBeanSize: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('technicalChokeBeanSize from GAP network optimization (TS).'),
    technicalChokeOpening: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('technicalChokeOpening from GAP network optimization (TS).'),
    technicalEspFrequency: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('technicalEspFrequency from GAP network optimization (TS).'),
    technicalFBHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('technicalFBHP from GAP network optimization (TS).'),
    technicalFWHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('technicalFWHP from GAP network optimization (TS).'),
    technicalGasLiftRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('technicalGasLiftRate from GAP network optimization (TS).'),
    technicalGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('technicalGasRate from GAP network optimization (TS).'),
    technicalOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('technicalOilRate from GAP network optimization (TS).'),
    technicalOptimizedParameter: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('technicalOptimizedParameter from GAP network optimization (TS).'),
    technicalPower: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('technicalPower from GAP network optimization (TS).'),
    technicalRunID: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('technicalRunID from GAP network optimization (TS).'),
    technicalWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('technicalWaterRate from GAP network optimization (TS).'),
    wellString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe('Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context.'),
  })
  .describe(
    'Optimization scenario rates, setpoints, and metadata per well string (WF7/WF11).\n\nSingle agent view for all optimization property families from the GAP network\noptimizer: systemOptimized*, technical*, hydraulic*, fsopr*, and adHoc*\nscenarios including rates, choke/ESP/power/gas-lift setpoints, pressures,\nrun IDs, and optimized parameters. For current-state string outputs and flow-\nassurance flags see NetworkOutputs_String_Agent; for per-network matched\nsnapshot see StringOutputs_Network_Agent.\n\nUse for: Network Surveillance (WF7), Production Optimization Scenarios (WF11).\n\n@name Optimized Rates - Network Scenarios (Agent)',
  );

export const NetworkRiskOptimizationScenariosSchema: z.ZodObject<Properties<NetworkRiskOptimizationScenarios>> = z
  .object({
    __typename: z.literal('NetworkRisk_OptimizationScenarios').optional(),
    aggregatedRisk: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'aggregatedRisk' in this 'NetworkRisk_OptimizationScenarios' view."),
    asphalteneDTMax: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'asphalteneDTMax' in this 'NetworkRisk_OptimizationScenarios' view."),
    asphalteneRisk: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'asphalteneRisk' in this 'NetworkRisk_OptimizationScenarios' view."),
    corrosionRateMax: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'corrosionRateMax' in this 'NetworkRisk_OptimizationScenarios' view."),
    corrosionRisk: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'corrosionRisk' in this 'NetworkRisk_OptimizationScenarios' view."),
    entityName: z
      .lazy(() => EntitySchema.nullish())
      .describe("Reference to the related 'Entity' entity for this 'NetworkRisk_OptimizationScenarios' row."),
    erosionMax: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'erosionMax' in this 'NetworkRisk_OptimizationScenarios' view."),
    erosionRisk: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'erosionRisk' in this 'NetworkRisk_OptimizationScenarios' view."),
    evrMax: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'evrMax' in this 'NetworkRisk_OptimizationScenarios' view."),
    evrRisk: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'evrRisk' in this 'NetworkRisk_OptimizationScenarios' view."),
    hydrateDTMax: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'hydrateDTMax' in this 'NetworkRisk_OptimizationScenarios' view."),
    hydrateRisk: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'hydrateRisk' in this 'NetworkRisk_OptimizationScenarios' view."),
    network: z
      .lazy(() => NetworkSchema.nullish())
      .describe("Reference to the related 'Network' entity for this 'NetworkRisk_OptimizationScenarios' row."),
    pe5StabilityMax: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'pe5StabilityMax' in this 'NetworkRisk_OptimizationScenarios' view."),
    pe5StabilityRisk: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'pe5StabilityRisk' in this 'NetworkRisk_OptimizationScenarios' view."),
    runID: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'runID' in this 'NetworkRisk_OptimizationScenarios' view."),
    scaleSIMax: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'scaleSIMax' in this 'NetworkRisk_OptimizationScenarios' view."),
    scaleSIRisk: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'scaleSIRisk' in this 'NetworkRisk_OptimizationScenarios' view."),
    scenarioName: z
      .string()
      .nullish()
      .describe("Text attribute 'scenarioName' for this 'NetworkRisk_OptimizationScenarios' row."),
    waxDTMax: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'waxDTMax' in this 'NetworkRisk_OptimizationScenarios' view."),
    waxRisk: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'waxRisk' in this 'NetworkRisk_OptimizationScenarios' view."),
  })
  .describe("View 'NetworkRisk_OptimizationScenarios' in the iPSO production optimization solution data model.");

export const NetworkRiskStringOptimizationScenariosAgentSchema: z.ZodObject<
  Properties<NetworkRiskStringOptimizationScenariosAgent>
> = z
  .object({
    __typename: z.literal('NetworkRiskString_OptimizationScenarios_Agent').optional(),
    aggregatedRisk: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Overall aggregated risk level for this scenario (TS).'),
    asphalteneDTMax: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Maximum asphaltene delta-T for this scenario (TS).'),
    asphalteneRisk: z.lazy(() => TimeSeriesSchema.nullish()).describe('Asphaltene risk level for this scenario (TS).'),
    corrosionRateMax: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Maximum corrosion rate for this scenario (TS).'),
    corrosionRisk: z.lazy(() => TimeSeriesSchema.nullish()).describe('Corrosion risk level for this scenario (TS).'),
    erosionMax: z.lazy(() => TimeSeriesSchema.nullish()).describe('Maximum erosion rate for this scenario (TS).'),
    erosionRisk: z.lazy(() => TimeSeriesSchema.nullish()).describe('Erosion risk level for this scenario (TS).'),
    evrMax: z.lazy(() => TimeSeriesSchema.nullish()).describe('Maximum erosion velocity ratio for this scenario (TS).'),
    evrRisk: z.lazy(() => TimeSeriesSchema.nullish()).describe('Erosion velocity risk level for this scenario (TS).'),
    hydrateDTMax: z.lazy(() => TimeSeriesSchema.nullish()).describe('Maximum hydrate delta-T for this scenario (TS).'),
    hydrateRisk: z.lazy(() => TimeSeriesSchema.nullish()).describe('Hydrate risk level for this scenario (TS).'),
    network: z.lazy(() => NetworkSchema.nullish()).describe('Reference to parent network model.'),
    pe5StabilityMax: z.lazy(() => TimeSeriesSchema.nullish()).describe('Maximum PE5 stability for this scenario (TS).'),
    pe5StabilityRisk: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('PE5 stability risk level for this scenario (TS).'),
    runID: z.lazy(() => TimeSeriesSchema.nullish()).describe('Unique identifier for this optimization run.'),
    scaleSIMax: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Maximum scale saturation index for this scenario (TS).'),
    scaleSIRisk: z.lazy(() => TimeSeriesSchema.nullish()).describe('Scale risk level for this scenario (TS).'),
    scenarioName: z.string().nullish().describe('Name of the optimization scenario.'),
    waxDTMax: z.lazy(() => TimeSeriesSchema.nullish()).describe('Maximum wax delta-T for this scenario (TS).'),
    waxRisk: z.lazy(() => TimeSeriesSchema.nullish()).describe('Wax risk level for this scenario (TS).'),
    wellString: z.lazy(() => StringAssetSchema.nullish()).describe('Well string identifier.'),
  })
  .describe(
    'Per-scenario flow assurance risk per well string (WF11/WF20).\n\nRisk scores for each optimization scenario on well strings, evaluated against a\ncurrent-state baseline. Filtered to instances whose externalId starts with\nstring:. Query by wellString and scenarioName. For current-state string risk\nsee NetworkRiskString_Agent; for pipeline scenarios see\nNetworkRiskPipeline_OptimizationScenarios_Agent.\n\nUse for: Production Optimization Scenarios (WF11), Flow Assurance Detection and Mitigation (WF20).\n\n@name Network Risk - String Optimization Scenarios (Agent)',
  );

export const NetworkRiskStringAgentSchema: z.ZodObject<Properties<NetworkRiskStringAgent>> = z
  .object({
    __typename: z.literal('NetworkRiskString_Agent').optional(),
    aggregatedRisk: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Overall aggregated flow assurance risk level (TS).'),
    asphalteneDTMax: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Maximum asphaltene onset temperature delta (TS).'),
    asphalteneRisk: z.lazy(() => TimeSeriesSchema.nullish()).describe('Asphaltene risk level (TS).'),
    corrosionRateMax: z.lazy(() => TimeSeriesSchema.nullish()).describe('Maximum corrosion rate across entity (TS).'),
    corrosionRisk: z.lazy(() => TimeSeriesSchema.nullish()).describe('Corrosion risk level (TS).'),
    erosionMax: z.lazy(() => TimeSeriesSchema.nullish()).describe('Maximum erosion rate (TS).'),
    erosionRisk: z.lazy(() => TimeSeriesSchema.nullish()).describe('Erosion risk level (TS).'),
    evrMax: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Maximum erosion velocity ratio (TS). >1 = exceeds limit.'),
    evrRisk: z.lazy(() => TimeSeriesSchema.nullish()).describe('Erosion velocity risk level (TS).'),
    hydrateDTMax: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Maximum hydrate temperature delta (TS). Negative = above hydrate curve.'),
    hydrateRisk: z.lazy(() => TimeSeriesSchema.nullish()).describe('Hydrate formation risk level (TS).'),
    network: z.lazy(() => NetworkSchema.nullish()).describe('Reference to parent network model.'),
    pe5StabilityMax: z.lazy(() => TimeSeriesSchema.nullish()).describe('Maximum PE5 stability indicator (TS).'),
    pe5StabilityRisk: z.lazy(() => TimeSeriesSchema.nullish()).describe('PE5 stability risk level (TS).'),
    scaleSIMax: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Maximum scale saturation index (TS). >1 = scaling likely.'),
    scaleSIRisk: z.lazy(() => TimeSeriesSchema.nullish()).describe('Scale risk level (TS).'),
    waxDTMax: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Maximum wax deposition temperature delta (TS). Negative = below WAT.'),
    waxRisk: z.lazy(() => TimeSeriesSchema.nullish()).describe('Wax deposition risk level (TS).'),
    wellString: z.lazy(() => StringAssetSchema.nullish()).describe('Well string identifier.'),
  })
  .describe(
    'Current-state flow assurance risk per well string (WF20).\n\nRisk scores and categories for well strings from the GAP network model.\nFiltered to instances whose externalId starts with string: (iPSO entity\nnaming convention). Query by wellString. For pipeline/flowline risk see\nNetworkRiskPipeline_Agent; for per-scenario risk see\nNetworkRiskString_OptimizationScenarios_Agent.\n\nUse for: Flow Assurance Detection and Mitigation (WF20).\n\n@name Network Risk - String (Agent)',
  );

export const NetworkRiskPipelineOptimizationScenariosAgentSchema: z.ZodObject<
  Properties<NetworkRiskPipelineOptimizationScenariosAgent>
> = z
  .object({
    __typename: z.literal('NetworkRiskPipeline_OptimizationScenarios_Agent').optional(),
    aggregatedRisk: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Overall aggregated risk level for this scenario (TS).'),
    asphalteneDTMax: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Maximum asphaltene delta-T for this scenario (TS).'),
    asphalteneRisk: z.lazy(() => TimeSeriesSchema.nullish()).describe('Asphaltene risk level for this scenario (TS).'),
    corrosionRateMax: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Maximum corrosion rate for this scenario (TS).'),
    corrosionRisk: z.lazy(() => TimeSeriesSchema.nullish()).describe('Corrosion risk level for this scenario (TS).'),
    erosionMax: z.lazy(() => TimeSeriesSchema.nullish()).describe('Maximum erosion rate for this scenario (TS).'),
    erosionRisk: z.lazy(() => TimeSeriesSchema.nullish()).describe('Erosion risk level for this scenario (TS).'),
    evrMax: z.lazy(() => TimeSeriesSchema.nullish()).describe('Maximum erosion velocity ratio for this scenario (TS).'),
    evrRisk: z.lazy(() => TimeSeriesSchema.nullish()).describe('Erosion velocity risk level for this scenario (TS).'),
    hydrateDTMax: z.lazy(() => TimeSeriesSchema.nullish()).describe('Maximum hydrate delta-T for this scenario (TS).'),
    hydrateRisk: z.lazy(() => TimeSeriesSchema.nullish()).describe('Hydrate risk level for this scenario (TS).'),
    network: z.lazy(() => NetworkSchema.nullish()).describe('Reference to parent network model.'),
    pe5StabilityMax: z.lazy(() => TimeSeriesSchema.nullish()).describe('Maximum PE5 stability for this scenario (TS).'),
    pe5StabilityRisk: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('PE5 stability risk level for this scenario (TS).'),
    pipelineEntity: z.lazy(() => PipelineSchema.nullish()).describe('Pipeline/flowline entity identifier.'),
    runID: z.lazy(() => TimeSeriesSchema.nullish()).describe('Unique identifier for this optimization run.'),
    scaleSIMax: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Maximum scale saturation index for this scenario (TS).'),
    scaleSIRisk: z.lazy(() => TimeSeriesSchema.nullish()).describe('Scale risk level for this scenario (TS).'),
    scenarioName: z.string().nullish().describe('Name of the optimization scenario.'),
    waxDTMax: z.lazy(() => TimeSeriesSchema.nullish()).describe('Maximum wax delta-T for this scenario (TS).'),
    waxRisk: z.lazy(() => TimeSeriesSchema.nullish()).describe('Wax risk level for this scenario (TS).'),
  })
  .describe(
    'Per-scenario flow assurance risk per pipeline/flowline entity (WF11/WF20).\n\nRisk scores for each optimization scenario on pipeline network components.\nFiltered to instances whose externalId starts with pipeline:. Query by\npipelineEntity and scenarioName. For current-state pipeline risk see\nNetworkRiskPipeline_Agent; for string scenarios see\nNetworkRiskString_OptimizationScenarios_Agent.\n\nUse for: Production Optimization Scenarios (WF11), Flow Assurance Detection and Mitigation (WF20).\n\n@name Network Risk - Pipeline Optimization Scenarios (Agent)',
  );

export const NetworkRiskPipelineAgentSchema: z.ZodObject<Properties<NetworkRiskPipelineAgent>> = z
  .object({
    __typename: z.literal('NetworkRiskPipeline_Agent').optional(),
    aggregatedRisk: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Overall aggregated flow assurance risk level (TS).'),
    asphalteneDTMax: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Maximum asphaltene onset temperature delta (TS).'),
    asphalteneRisk: z.lazy(() => TimeSeriesSchema.nullish()).describe('Asphaltene risk level (TS).'),
    corrosionRateMax: z.lazy(() => TimeSeriesSchema.nullish()).describe('Maximum corrosion rate across entity (TS).'),
    corrosionRisk: z.lazy(() => TimeSeriesSchema.nullish()).describe('Corrosion risk level (TS).'),
    erosionMax: z.lazy(() => TimeSeriesSchema.nullish()).describe('Maximum erosion rate (TS).'),
    erosionRisk: z.lazy(() => TimeSeriesSchema.nullish()).describe('Erosion risk level (TS).'),
    evrMax: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Maximum erosion velocity ratio (TS). >1 = exceeds limit.'),
    evrRisk: z.lazy(() => TimeSeriesSchema.nullish()).describe('Erosion velocity risk level (TS).'),
    hydrateDTMax: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Maximum hydrate temperature delta (TS). Negative = above hydrate curve.'),
    hydrateRisk: z.lazy(() => TimeSeriesSchema.nullish()).describe('Hydrate formation risk level (TS).'),
    network: z.lazy(() => NetworkSchema.nullish()).describe('Reference to parent network model.'),
    pe5StabilityMax: z.lazy(() => TimeSeriesSchema.nullish()).describe('Maximum PE5 stability indicator (TS).'),
    pe5StabilityRisk: z.lazy(() => TimeSeriesSchema.nullish()).describe('PE5 stability risk level (TS).'),
    pipelineEntity: z.lazy(() => PipelineSchema.nullish()).describe('Pipeline/flowline entity identifier.'),
    scaleSIMax: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Maximum scale saturation index (TS). >1 = scaling likely.'),
    scaleSIRisk: z.lazy(() => TimeSeriesSchema.nullish()).describe('Scale risk level (TS).'),
    waxDTMax: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Maximum wax deposition temperature delta (TS). Negative = below WAT.'),
    waxRisk: z.lazy(() => TimeSeriesSchema.nullish()).describe('Wax deposition risk level (TS).'),
  })
  .describe(
    'Current-state flow assurance risk per pipeline/flowline entity (WF20).\n\nRisk scores and categories for pipeline network components from the GAP network\nmodel. Filtered to instances whose externalId starts with pipeline: (iPSO\nentity naming convention). Query by pipelineEntity. For well-string risk see\nNetworkRiskString_Agent; for per-scenario risk see\nNetworkRiskPipeline_OptimizationScenarios_Agent.\n\nUse for: Flow Assurance Detection and Mitigation (WF20).\n\n@name Network Risk - Pipeline (Agent)',
  );

export const NetworkOutputsStringValidatedSchema: z.ZodObject<Properties<NetworkOutputsStringValidated>> = z
  .object({
    __typename: z.literal('NetworkOutputs_String_Validated').optional(),
    adHocOptimization1ValidatedChokeBeanSize: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization1ValidatedChokeOpening: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization1ValidatedEspFrequency: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization1ValidatedFBHP: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization1ValidatedFWHP: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization1ValidatedGasLiftRate: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization1ValidatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization1ValidatedOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization1ValidatedOptimizedParameter: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization1ValidatedPower: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization1ValidatedRunID: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization1ValidatedWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization2ValidatedChokeBeanSize: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization2ValidatedChokeOpening: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization2ValidatedEspFrequency: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization2ValidatedFBHP: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization2ValidatedFWHP: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization2ValidatedGasLiftRate: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization2ValidatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization2ValidatedOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization2ValidatedOptimizedParameter: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization2ValidatedPower: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization2ValidatedRunID: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization2ValidatedWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    entityName: z.lazy(() => StringAssetSchema.nullish()),
    systemOptimizedChokeValidatedChokeBeanSize: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeValidatedChokeOpening: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeValidatedEspFrequency: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeValidatedFBHP: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeValidatedFWHP: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeValidatedGasLiftRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeValidatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeValidatedOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeValidatedOptimizedParameter: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeValidatedPower: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeValidatedRunID: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeValidatedWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedChokeBeanSize: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedChokeOpening: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedEspFrequency: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedFBHP: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedFWHP: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedGasLiftRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedOptimizedParameter: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedPower: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedRunID: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedTop5BeforeOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedTop5BeforeWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedTop5OilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedTop5WaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedTop10BeforeOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedTop10BeforeWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedTop10OilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedTop10WaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedTop20BeforeOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedTop20BeforeWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedTop20OilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedTop20WaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  })
  .describe("View 'NetworkOutputs_String_Validated' in the iPSO production optimization solution data model.");

export const NetworkOutputsStringAgentSchema: z.ZodObject<Properties<NetworkOutputsStringAgent>> = z
  .object({
    __typename: z.literal('NetworkOutputs_String_Agent').optional(),
    asphalteneFlag_well: z.lazy(() => TimeSeriesSchema.nullish()).describe('Asphaltene risk flag at well (TS).'),
    calculatedChokeBeanSize: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Calculated choke bean size from network solve (TS).'),
    calculatedChokeOpening: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Calculated choke opening from network solve (TS).'),
    calculatedEspFrequency: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Calculated ESP frequency from network solve (Hz, TS).'),
    calculatedGasLiftRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Calculated gas lift rate from network solve (MSCF/d, TS).'),
    calculatedGasRateMatchIndex: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Gas rate match index, calculated vs measured (0-1 scale, TS).'),
    calculatedOilRateMatchIndex: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Oil rate match index, calculated vs measured (0-1 scale, TS).'),
    calculatedPower: z.lazy(() => TimeSeriesSchema.nullish()).describe('Calculated power from network solve (TS).'),
    calculatedPumpLquidRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Pump liquid rate from network solve (stb/d, TS).'),
    calculatedWaterRateMatchIndex: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Water rate match index, calculated vs measured (0-1 scale, TS).'),
    calculatedWellBHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Network-calculated bottomhole pressure (psi, TS).'),
    calculatedWellBHPGI: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Gas injection BHP from network solve (psi, TS).'),
    calculatedWellBHPWI: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Water injection BHP from network solve (psi, TS).'),
    calculatedWellESPMotorLoad: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('ESP motor load from network solve (TS).'),
    calculatedWellFBHP: z.lazy(() => TimeSeriesSchema.nullish()).describe('Network-calculated flowing BHP (psi, TS).'),
    calculatedWellFWHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Network-calculated flowing wellhead pressure (psi, TS).'),
    calculatedWellGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Network-solved gas production rate (MSCF/d, TS).'),
    calculatedWellGasRateGI: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Gas injection rate from network solve (MSCF/d, TS).'),
    calculatedWellLiquidRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Network-solved total liquid rate (stb/d, TS).'),
    calculatedWellOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Network-solved oil production rate (stb/d, TS).'),
    calculatedWellWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Network-solved water production rate (stb/d, TS).'),
    calculatedWellWaterRateWI: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Water injection rate from network solve (stb/d, TS).'),
    chokeDP: z.lazy(() => TimeSeriesSchema.nullish()).describe('Choke pressure drop from network solve (psi, TS).'),
    constraintFlag_well: z.lazy(() => TimeSeriesSchema.nullish()).describe('Operating constraint flag at well (TS).'),
    espEfficiency: z.lazy(() => TimeSeriesSchema.nullish()).describe('ESP efficiency from network solve (TS).'),
    formationGOR: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Formation gas-oil ratio input to GAP network model (scf/stb, TS).'),
    gapWellName: z.string().nullish().describe('GAP model well name mapping.'),
    gasLiftInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Gas lift injection rate from network solve (MSCF/d, TS).'),
    gasLiftInjectionPress: z.lazy(() => TimeSeriesSchema.nullish()).describe('Gas lift injection pressure (psi, TS).'),
    hydrateFlag_well: z.lazy(() => TimeSeriesSchema.nullish()).describe('Hydrate risk flag at well (TS).'),
    pe5StabilityFlag_well: z.lazy(() => TimeSeriesSchema.nullish()).describe('PE5 stability flag at well (TS).'),
    scaleFlag_well: z.lazy(() => TimeSeriesSchema.nullish()).describe('Scale risk flag at well (TS).'),
    waxFlag_well: z.lazy(() => TimeSeriesSchema.nullish()).describe('Wax deposition flag at well (TS).'),
    wellSolverDifference: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Difference between well solver estimated and measured oil rates (TS).'),
    wellSolverEstimatedOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Well solver estimated oil rate input (stb/d, TS).'),
    wellSolverMeasuredOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Well solver measured oil rate input (stb/d, TS).'),
    wellString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe('Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context.'),
  })
  .describe(
    'Current-state network string outputs and flow-assurance flags (WF7/WF8/WF20).\n\nCalculated production rates, match indices, well-solver calibration, current-\nstate equipment setpoints, injection rates, and per-string flow-assurance\nflags from the GAP network model. Excludes optimization scenario rates and\nsetpoints (see OptimizedRates_Network_String_Agent) and per-network matched\nnmv* outputs (see StringOutputs_Network_Agent).\n\nUse for: Network Surveillance (WF7), Network Model Validation (WF8),\nFlow Assurance (WF20). WF8: match indices and well-solver vs measured.\n\n@name Network String Outputs (Agent)',
  );

export const NetworkOutputsStringSchema: z.ZodObject<Properties<NetworkOutputsString>> = z
  .object({
    __typename: z.literal('NetworkOutputs_String').optional(),
    adHocOptimization1ChokeBeanSize: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'adHocOptimization1ChokeBeanSize' in this 'NetworkOutputs_String' view.",
      ),
    adHocOptimization1ChokeOpening: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'adHocOptimization1ChokeOpening' in this 'NetworkOutputs_String' view.",
      ),
    adHocOptimization1Comment: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization1EspFrequency: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'adHocOptimization1EspFrequency' in this 'NetworkOutputs_String' view.",
      ),
    adHocOptimization1ExecutedBy: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocOptimization1ExecutedBy' in this 'NetworkOutputs_String' view."),
    adHocOptimization1FBHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocOptimization1FBHP' in this 'NetworkOutputs_String' view."),
    adHocOptimization1FWHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocOptimization1FWHP' in this 'NetworkOutputs_String' view."),
    adHocOptimization1GasLiftRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocOptimization1GasLiftRate' in this 'NetworkOutputs_String' view."),
    adHocOptimization1GasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocOptimization1GasRate' in this 'NetworkOutputs_String' view."),
    adHocOptimization1OilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocOptimization1OilRate' in this 'NetworkOutputs_String' view."),
    adHocOptimization1OptimizedParameter: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'adHocOptimization1OptimizedParameter' in this 'NetworkOutputs_String' view.",
      ),
    adHocOptimization1Power: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocOptimization1Power' in this 'NetworkOutputs_String' view."),
    adHocOptimization1RunID: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocOptimization1RunID' in this 'NetworkOutputs_String' view."),
    adHocOptimization1WaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocOptimization1WaterRate' in this 'NetworkOutputs_String' view."),
    adHocOptimization2ChokeBeanSize: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'adHocOptimization2ChokeBeanSize' in this 'NetworkOutputs_String' view.",
      ),
    adHocOptimization2ChokeOpening: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'adHocOptimization2ChokeOpening' in this 'NetworkOutputs_String' view.",
      ),
    adHocOptimization2Comment: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization2EspFrequency: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'adHocOptimization2EspFrequency' in this 'NetworkOutputs_String' view.",
      ),
    adHocOptimization2ExecutedBy: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocOptimization2ExecutedBy' in this 'NetworkOutputs_String' view."),
    adHocOptimization2FBHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocOptimization2FBHP' in this 'NetworkOutputs_String' view."),
    adHocOptimization2FWHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocOptimization2FWHP' in this 'NetworkOutputs_String' view."),
    adHocOptimization2GasLiftRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocOptimization2GasLiftRate' in this 'NetworkOutputs_String' view."),
    adHocOptimization2GasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocOptimization2GasRate' in this 'NetworkOutputs_String' view."),
    adHocOptimization2OilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocOptimization2OilRate' in this 'NetworkOutputs_String' view."),
    adHocOptimization2OptimizedParameter: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'adHocOptimization2OptimizedParameter' in this 'NetworkOutputs_String' view.",
      ),
    adHocOptimization2Power: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocOptimization2Power' in this 'NetworkOutputs_String' view."),
    adHocOptimization2RunID: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocOptimization2RunID' in this 'NetworkOutputs_String' view."),
    adHocOptimization2WaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocOptimization2WaterRate' in this 'NetworkOutputs_String' view."),
    adHocSimulation1ChokeBeanSize: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocSimulation1ChokeBeanSize' in this 'NetworkOutputs_String' view."),
    adHocSimulation1ChokeOpening: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocSimulation1ChokeOpening' in this 'NetworkOutputs_String' view."),
    adHocSimulation1Comment: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocSimulation1EspFrequency: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocSimulation1EspFrequency' in this 'NetworkOutputs_String' view."),
    adHocSimulation1ExecutedBy: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocSimulation1ExecutedBy' in this 'NetworkOutputs_String' view."),
    adHocSimulation1FBHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocSimulation1FBHP' in this 'NetworkOutputs_String' view."),
    adHocSimulation1FWHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocSimulation1FWHP' in this 'NetworkOutputs_String' view."),
    adHocSimulation1GasLiftRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocSimulation1GasLiftRate' in this 'NetworkOutputs_String' view."),
    adHocSimulation1GasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocSimulation1GasRate' in this 'NetworkOutputs_String' view."),
    adHocSimulation1OilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocSimulation1OilRate' in this 'NetworkOutputs_String' view."),
    adHocSimulation1OptimizedParameter: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'adHocSimulation1OptimizedParameter' in this 'NetworkOutputs_String' view.",
      ),
    adHocSimulation1Power: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocSimulation1Power' in this 'NetworkOutputs_String' view."),
    adHocSimulation1RunID: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocSimulation1RunID' in this 'NetworkOutputs_String' view."),
    adHocSimulation1WaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocSimulation1WaterRate' in this 'NetworkOutputs_String' view."),
    adHocSimulation2ChokeBeanSize: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocSimulation2ChokeBeanSize' in this 'NetworkOutputs_String' view."),
    adHocSimulation2ChokeOpening: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocSimulation2ChokeOpening' in this 'NetworkOutputs_String' view."),
    adHocSimulation2Comment: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocSimulation2EspFrequency: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocSimulation2EspFrequency' in this 'NetworkOutputs_String' view."),
    adHocSimulation2ExecutedBy: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocSimulation2ExecutedBy' in this 'NetworkOutputs_String' view."),
    adHocSimulation2FBHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocSimulation2FBHP' in this 'NetworkOutputs_String' view."),
    adHocSimulation2FWHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocSimulation2FWHP' in this 'NetworkOutputs_String' view."),
    adHocSimulation2GasLiftRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocSimulation2GasLiftRate' in this 'NetworkOutputs_String' view."),
    adHocSimulation2GasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocSimulation2GasRate' in this 'NetworkOutputs_String' view."),
    adHocSimulation2OilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocSimulation2OilRate' in this 'NetworkOutputs_String' view."),
    adHocSimulation2OptimizedParameter: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'adHocSimulation2OptimizedParameter' in this 'NetworkOutputs_String' view.",
      ),
    adHocSimulation2Power: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocSimulation2Power' in this 'NetworkOutputs_String' view."),
    adHocSimulation2RunID: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocSimulation2RunID' in this 'NetworkOutputs_String' view."),
    adHocSimulation2WaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocSimulation2WaterRate' in this 'NetworkOutputs_String' view."),
    asphalteneFlag_well: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'asphalteneFlag_well' in this 'NetworkOutputs_String' view."),
    calculatedChokeBeanSize: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calculatedChokeBeanSize' in this 'NetworkOutputs_String' view."),
    calculatedChokeBeanSizeGI: z.lazy(() => TimeSeriesSchema.nullish()),
    calculatedChokeBeanSizeWI: z.lazy(() => TimeSeriesSchema.nullish()),
    calculatedChokeOpening: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calculatedChokeOpening' in this 'NetworkOutputs_String' view."),
    calculatedEspFrequency: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calculatedEspFrequency' in this 'NetworkOutputs_String' view."),
    calculatedGasLiftRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calculatedGasLiftRate' in this 'NetworkOutputs_String' view."),
    calculatedGasRateMatchIndex: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calculatedGasRateMatchIndex' in this 'NetworkOutputs_String' view."),
    calculatedOilRateMatchIndex: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calculatedOilRateMatchIndex' in this 'NetworkOutputs_String' view."),
    calculatedPower: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calculatedPower' in this 'NetworkOutputs_String' view."),
    calculatedPumpLquidRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calculatedPumpLquidRate' in this 'NetworkOutputs_String' view."),
    calculatedWaterRateMatchIndex: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calculatedWaterRateMatchIndex' in this 'NetworkOutputs_String' view."),
    calculatedWellBHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calculatedWellBHP' in this 'NetworkOutputs_String' view."),
    calculatedWellBHPGI: z.lazy(() => TimeSeriesSchema.nullish()),
    calculatedWellBHPWI: z.lazy(() => TimeSeriesSchema.nullish()),
    calculatedWellESPMotorLoad: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calculatedWellESPMotorLoad' in this 'NetworkOutputs_String' view."),
    calculatedWellFBHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calculatedWellFBHP' in this 'NetworkOutputs_String' view."),
    calculatedWellFWHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calculatedWellFWHP' in this 'NetworkOutputs_String' view."),
    calculatedWellGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calculatedWellGasRate' in this 'NetworkOutputs_String' view."),
    calculatedWellGasRateGI: z.lazy(() => TimeSeriesSchema.nullish()),
    calculatedWellLiquidRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calculatedWellLiquidRate' in this 'NetworkOutputs_String' view."),
    calculatedWellOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calculatedWellOilRate' in this 'NetworkOutputs_String' view."),
    calculatedWellWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calculatedWellWaterRate' in this 'NetworkOutputs_String' view."),
    calculatedWellWaterRateWI: z.lazy(() => TimeSeriesSchema.nullish()),
    chokeDP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'chokeDP' in this 'NetworkOutputs_String' view."),
    constraintFlag_well: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'constraintFlag_well' in this 'NetworkOutputs_String' view."),
    entityName: z
      .lazy(() => StringAssetSchema.nullish())
      .describe("Reference to the related 'String_asset' entity for this 'NetworkOutputs_String' row."),
    espEfficiency: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'espEfficiency' in this 'NetworkOutputs_String' view."),
    formationWellGasOilRatio: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'formationWellGasOilRatio' in this 'NetworkOutputs_String' view."),
    fsoprChokeBeanSize: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fsoprChokeBeanSize' in this 'NetworkOutputs_String' view."),
    fsoprChokeOpening: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fsoprChokeOpening' in this 'NetworkOutputs_String' view."),
    fsoprEspFrequency: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fsoprEspFrequency' in this 'NetworkOutputs_String' view."),
    fsoprFBHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fsoprFBHP' in this 'NetworkOutputs_String' view."),
    fsoprFWHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fsoprFWHP' in this 'NetworkOutputs_String' view."),
    fsoprGasLiftRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fsoprGasLiftRate' in this 'NetworkOutputs_String' view."),
    fsoprGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fsoprGasRate' in this 'NetworkOutputs_String' view."),
    fsoprOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fsoprOilRate' in this 'NetworkOutputs_String' view."),
    fsoprOptimizedParameter: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fsoprOptimizedParameter' in this 'NetworkOutputs_String' view."),
    fsoprPower: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fsoprPower' in this 'NetworkOutputs_String' view."),
    fsoprRunID: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fsoprRunID' in this 'NetworkOutputs_String' view."),
    fsoprWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fsoprWaterRate' in this 'NetworkOutputs_String' view."),
    gapOptimizedParameter: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gapOptimizedParameter' in this 'NetworkOutputs_String' view."),
    gapWellName: z.string().nullish().describe("Text attribute 'gapWellName' for this 'NetworkOutputs_String' row."),
    gapWellNameHistorical: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gapWellNameHistorical' in this 'NetworkOutputs_String' view."),
    gasLiftInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gasLiftInjection' in this 'NetworkOutputs_String' view."),
    gasLiftInjectionPress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gasLiftInjectionPress' in this 'NetworkOutputs_String' view."),
    hydrateFlag_well: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'hydrateFlag_well' in this 'NetworkOutputs_String' view."),
    hydraulicChokeBeanSize: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'hydraulicChokeBeanSize' in this 'NetworkOutputs_String' view."),
    hydraulicChokeOpening: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'hydraulicChokeOpening' in this 'NetworkOutputs_String' view."),
    hydraulicEspFrequency: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'hydraulicEspFrequency' in this 'NetworkOutputs_String' view."),
    hydraulicFBHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'hydraulicFBHP' in this 'NetworkOutputs_String' view."),
    hydraulicFWHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'hydraulicFWHP' in this 'NetworkOutputs_String' view."),
    hydraulicGasLiftRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'hydraulicGasLiftRate' in this 'NetworkOutputs_String' view."),
    hydraulicGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'hydraulicGasRate' in this 'NetworkOutputs_String' view."),
    hydraulicOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'hydraulicOilRate' in this 'NetworkOutputs_String' view."),
    hydraulicOptimizedParameter: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'hydraulicOptimizedParameter' in this 'NetworkOutputs_String' view."),
    hydraulicPower: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'hydraulicPower' in this 'NetworkOutputs_String' view."),
    hydraulicRunID: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'hydraulicRunID' in this 'NetworkOutputs_String' view."),
    hydraulicWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'hydraulicWaterRate' in this 'NetworkOutputs_String' view."),
    pe5StabilityFlag_well: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'pe5StabilityFlag_well' in this 'NetworkOutputs_String' view."),
    scaleFlag_well: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'scaleFlag_well' in this 'NetworkOutputs_String' view."),
    systemOptimizedChokeBeanSize: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'systemOptimizedChokeBeanSize' in this 'NetworkOutputs_String' view."),
    systemOptimizedChokeChokeBeanSize: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeChokeOpening: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeEspFrequency: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeFBHP: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeFWHP: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeGasLiftRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeOpening: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'systemOptimizedChokeOpening' in this 'NetworkOutputs_String' view."),
    systemOptimizedChokeOptimizedParameter: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokePower: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeRunID: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedEspFrequency: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'systemOptimizedEspFrequency' in this 'NetworkOutputs_String' view."),
    systemOptimizedFBHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'systemOptimizedFBHP' in this 'NetworkOutputs_String' view."),
    systemOptimizedFWHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'systemOptimizedFWHP' in this 'NetworkOutputs_String' view."),
    systemOptimizedGasLiftRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'systemOptimizedGasLiftRate' in this 'NetworkOutputs_String' view."),
    systemOptimizedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'systemOptimizedGasRate' in this 'NetworkOutputs_String' view."),
    systemOptimizedOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'systemOptimizedOilRate' in this 'NetworkOutputs_String' view."),
    systemOptimizedOptimizedParameter: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'systemOptimizedOptimizedParameter' in this 'NetworkOutputs_String' view.",
      ),
    systemOptimizedPower: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'systemOptimizedPower' in this 'NetworkOutputs_String' view."),
    systemOptimizedRunID: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'systemOptimizedRunID' in this 'NetworkOutputs_String' view."),
    systemOptimizedWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'systemOptimizedWaterRate' in this 'NetworkOutputs_String' view."),
    technicalChokeBeanSize: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'technicalChokeBeanSize' in this 'NetworkOutputs_String' view."),
    technicalChokeOpening: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'technicalChokeOpening' in this 'NetworkOutputs_String' view."),
    technicalEspFrequency: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'technicalEspFrequency' in this 'NetworkOutputs_String' view."),
    technicalFBHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'technicalFBHP' in this 'NetworkOutputs_String' view."),
    technicalFWHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'technicalFWHP' in this 'NetworkOutputs_String' view."),
    technicalGasLiftRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'technicalGasLiftRate' in this 'NetworkOutputs_String' view."),
    technicalGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'technicalGasRate' in this 'NetworkOutputs_String' view."),
    technicalOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'technicalOilRate' in this 'NetworkOutputs_String' view."),
    technicalOptimizedParameter: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'technicalOptimizedParameter' in this 'NetworkOutputs_String' view."),
    technicalPower: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'technicalPower' in this 'NetworkOutputs_String' view."),
    technicalRunID: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'technicalRunID' in this 'NetworkOutputs_String' view."),
    technicalWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'technicalWaterRate' in this 'NetworkOutputs_String' view."),
    waxFlag_well: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'waxFlag_well' in this 'NetworkOutputs_String' view."),
    wellSolverDifference: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellSolverDifference' in this 'NetworkOutputs_String' view."),
    wellSolverEstimatedOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellSolverEstimatedOilRate' in this 'NetworkOutputs_String' view."),
    wellSolverMeasuredOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellSolverMeasuredOilRate' in this 'NetworkOutputs_String' view."),
  })
  .describe("View 'NetworkOutputs_String' in the iPSO production optimization solution data model.");

export const NetworkOutputsRunsSchema: z.ZodObject<Properties<NetworkOutputsRuns>> = z
  .object({
    __typename: z.literal('NetworkOutputs_Runs').optional(),
    comment: z
      .string()
      .nullish()
      .describe("Reference to a time series for 'comment' in this 'NetworkOutputs_Runs' view."),
    createdBy: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'createdBy' in this 'NetworkOutputs_Runs' view."),
    entityName: z
      .lazy(() => NetworkSchema.nullish())
      .describe("Reference to the related 'Network' entity for this 'NetworkOutputs_Runs' row."),
    executedBy: z
      .string()
      .nullish()
      .describe("Reference to a time series for 'executedBy' in this 'NetworkOutputs_Runs' view."),
    executionDate: z.coerce
      .date<Date>()
      .nullish()
      .describe("Reference to a time series for 'executionDate' in this 'NetworkOutputs_Runs' view."),
    runId: z.string().describe("Reference to a time series for 'runId' in this 'NetworkOutputs_Runs' view."),
    scenarioType: z
      .string()
      .describe("Reference to a time series for 'scenarioType' in this 'NetworkOutputs_Runs' view."),
    status: z.string().describe("Reference to a time series for 'status' in this 'NetworkOutputs_Runs' view."),
  })
  .describe("View 'NetworkOutputs_Runs' in the iPSO production optimization solution data model.");

export const NetworkOutputsReservoirSchema: z.ZodObject<Properties<NetworkOutputsReservoir>> = z
  .object({
    __typename: z.literal('NetworkOutputs_Reservoir').optional(),
    adHocOptimization1GasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocOptimization1GasRate' in this 'NetworkOutputs_Reservoir' view."),
    adHocOptimization1OilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocOptimization1OilRate' in this 'NetworkOutputs_Reservoir' view."),
    adHocOptimization1RunID: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocOptimization1RunID' in this 'NetworkOutputs_Reservoir' view."),
    adHocOptimization1WaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'adHocOptimization1WaterRate' in this 'NetworkOutputs_Reservoir' view.",
      ),
    adHocOptimization2GasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocOptimization2GasRate' in this 'NetworkOutputs_Reservoir' view."),
    adHocOptimization2OilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocOptimization2OilRate' in this 'NetworkOutputs_Reservoir' view."),
    adHocOptimization2RunID: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocOptimization2RunID' in this 'NetworkOutputs_Reservoir' view."),
    adHocOptimization2WaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'adHocOptimization2WaterRate' in this 'NetworkOutputs_Reservoir' view.",
      ),
    adHocSimulation1GasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocSimulation1GasRate' in this 'NetworkOutputs_Reservoir' view."),
    adHocSimulation1OilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocSimulation1OilRate' in this 'NetworkOutputs_Reservoir' view."),
    adHocSimulation1RunID: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocSimulation1RunID' in this 'NetworkOutputs_Reservoir' view."),
    adHocSimulation1WaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocSimulation1WaterRate' in this 'NetworkOutputs_Reservoir' view."),
    adHocSimulation2GasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocSimulation2GasRate' in this 'NetworkOutputs_Reservoir' view."),
    adHocSimulation2OilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocSimulation2OilRate' in this 'NetworkOutputs_Reservoir' view."),
    adHocSimulation2RunID: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocSimulation2RunID' in this 'NetworkOutputs_Reservoir' view."),
    adHocSimulation2WaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocSimulation2WaterRate' in this 'NetworkOutputs_Reservoir' view."),
    calculatedTotalGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calculatedTotalGasRate' in this 'NetworkOutputs_Reservoir' view."),
    calculatedTotalLiquidRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calculatedTotalLiquidRate' in this 'NetworkOutputs_Reservoir' view."),
    calculatedTotalOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calculatedTotalOilRate' in this 'NetworkOutputs_Reservoir' view."),
    calculatedTotalWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calculatedTotalWaterRate' in this 'NetworkOutputs_Reservoir' view."),
    entityName: z
      .lazy(() => ReservoirSchema.nullish())
      .describe("Reference to the related 'Reservoir' entity for this 'NetworkOutputs_Reservoir' row."),
    fsoprGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fsoprGasRate' in this 'NetworkOutputs_Reservoir' view."),
    fsoprOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fsoprOilRate' in this 'NetworkOutputs_Reservoir' view."),
    fsoprRunID: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fsoprRunID' in this 'NetworkOutputs_Reservoir' view."),
    fsoprWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fsoprWaterRate' in this 'NetworkOutputs_Reservoir' view."),
    hydraulicGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'hydraulicGasRate' in this 'NetworkOutputs_Reservoir' view."),
    hydraulicOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'hydraulicOilRate' in this 'NetworkOutputs_Reservoir' view."),
    hydraulicRunID: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'hydraulicRunID' in this 'NetworkOutputs_Reservoir' view."),
    hydraulicWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'hydraulicWaterRate' in this 'NetworkOutputs_Reservoir' view."),
    systemOptimizedChokeGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'systemOptimizedChokeGasRate' in this 'NetworkOutputs_Reservoir' view.",
      ),
    systemOptimizedChokeOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'systemOptimizedChokeOilRate' in this 'NetworkOutputs_Reservoir' view.",
      ),
    systemOptimizedChokeRunID: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'systemOptimizedChokeRunID' in this 'NetworkOutputs_Reservoir' view."),
    systemOptimizedChokeWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'systemOptimizedChokeWaterRate' in this 'NetworkOutputs_Reservoir' view.",
      ),
    systemOptimizedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'systemOptimizedGasRate' in this 'NetworkOutputs_Reservoir' view."),
    systemOptimizedOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'systemOptimizedOilRate' in this 'NetworkOutputs_Reservoir' view."),
    systemOptimizedRunID: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'systemOptimizedRunID' in this 'NetworkOutputs_Reservoir' view."),
    systemOptimizedWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'systemOptimizedWaterRate' in this 'NetworkOutputs_Reservoir' view."),
    technicalGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'technicalGasRate' in this 'NetworkOutputs_Reservoir' view."),
    technicalOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'technicalOilRate' in this 'NetworkOutputs_Reservoir' view."),
    technicalRunID: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'technicalRunID' in this 'NetworkOutputs_Reservoir' view."),
    technicalWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'technicalWaterRate' in this 'NetworkOutputs_Reservoir' view."),
  })
  .describe("View 'NetworkOutputs_Reservoir' in the iPSO production optimization solution data model.");

export const NetworkOutputsFieldValidatedSchema: z.ZodObject<Properties<NetworkOutputsFieldValidated>> = z
  .object({
    __typename: z.literal('NetworkOutputs_Field_Validated').optional(),
    adHocOptimization1ValidatedGasLiftRate: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization1ValidatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization1ValidatedModelFileId: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization1ValidatedOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization1ValidatedPower: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization1ValidatedRunDateTime: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization1ValidatedRunStatus: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization1ValidatedWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization2ValidatedGasLiftRate: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization2ValidatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization2ValidatedModelFileId: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization2ValidatedOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization2ValidatedPower: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization2ValidatedRunDateTime: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization2ValidatedRunStatus: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization2ValidatedWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    entityName: z
      .lazy(() => FieldSchema.nullish())
      .describe("Reference to the related 'Field' entity for this 'NetworkOutputs_Field_Validated' row."),
    systemOptimizedChokeValidatedGasLiftRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeValidatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeValidatedModelFileId: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeValidatedOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeValidatedPower: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeValidatedRunDateTime: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeValidatedRunStatus: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeValidatedTop5GasLiftRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeValidatedTop5GasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeValidatedTop5OilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeValidatedTop5Power: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeValidatedTop5WaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeValidatedTop10GasLiftRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeValidatedTop10GasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeValidatedTop10OilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeValidatedTop10Power: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeValidatedTop10WaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeValidatedTop20GasLiftRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeValidatedTop20GasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeValidatedTop20OilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeValidatedTop20Power: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeValidatedTop20WaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeValidatedWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedGasLiftRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedModelFileId: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedPower: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedRunDateTime: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedRunStatus: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedTop5BeforeOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedTop5BeforeWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedTop5GasLiftRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedTop5GasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedTop5OilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedTop5Power: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedTop5WaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedTop10BeforeOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedTop10BeforeWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedTop10GasLiftRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedTop10GasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedTop10OilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedTop10Power: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedTop10WaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedTop20BeforeOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedTop20BeforeWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedTop20GasLiftRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedTop20GasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedTop20OilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedTop20Power: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedTop20WaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedValidatedWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
  })
  .describe("View 'NetworkOutputs_Field_Validated' in the iPSO production optimization solution data model.");

export const NetworkOutputsFieldAgentSchema: z.ZodObject<Properties<NetworkOutputsFieldAgent>> = z
  .object({
    __typename: z.literal('NetworkOutputs_Field_Agent').optional(),
    adHocOptimization1Comment: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocOptimization1Comment from GAP network optimization (TS) for the field.'),
    adHocOptimization1ExecutedBy: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocOptimization1ExecutedBy from GAP network optimization (TS) for the field.'),
    adHocOptimization1GasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization1OilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization1WaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization2Comment: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocOptimization2Comment from GAP network optimization (TS) for the field.'),
    adHocOptimization2ExecutedBy: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocOptimization2ExecutedBy from GAP network optimization (TS) for the field.'),
    adHocOptimization2GasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization2OilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization2WaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocSimulation1Comment: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocSimulation1Comment from GAP network optimization (TS) for the field.'),
    adHocSimulation1ExecutedBy: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocSimulation1ExecutedBy from GAP network optimization (TS) for the field.'),
    adHocSimulation1GasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocSimulation1OilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocSimulation1WaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocSimulation2Comment: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocSimulation2Comment from GAP network optimization (TS) for the field.'),
    adHocSimulation2ExecutedBy: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('adHocSimulation2ExecutedBy from GAP network optimization (TS) for the field.'),
    adHocSimulation2GasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocSimulation2OilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocSimulation2WaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    calcualtedSeparatorGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    calculatedFlowLinePressure: z.lazy(() => TimeSeriesSchema.nullish()),
    calculatedJointCo2: z.lazy(() => TimeSeriesSchema.nullish()),
    calculatedJointGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    calculatedJointH2S: z.lazy(() => TimeSeriesSchema.nullish()),
    calculatedJointLiquidRate: z.lazy(() => TimeSeriesSchema.nullish()),
    calculatedJointN2: z.lazy(() => TimeSeriesSchema.nullish()),
    calculatedJointOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    calculatedJointPressure: z.lazy(() => TimeSeriesSchema.nullish()),
    calculatedPressureMatchIndex: z.lazy(() => TimeSeriesSchema.nullish()),
    calculatedSeparatorOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    calculatedSepratorWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    calculatedTotalGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    calculatedTotalGasRateGI: z.lazy(() => TimeSeriesSchema.nullish()),
    calculatedTotalLiquidRate: z.lazy(() => TimeSeriesSchema.nullish()),
    calculatedTotalLiquidRateWI: z.lazy(() => TimeSeriesSchema.nullish()),
    calculatedTotalOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    calculatedTotalWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    calculatedTotalWaterRateWI: z.lazy(() => TimeSeriesSchema.nullish()),
    estimatedFlowlineUnstableflowFlag: z.lazy(() => TimeSeriesSchema.nullish()),
    estimatedFlowlineflowassuranceflag: z.lazy(() => TimeSeriesSchema.nullish()),
    fieldEntity: z
      .lazy(() => FieldSchema.nullish())
      .describe('Reference to field. Join to FlatHierarchy_Agent for reservoir/sector context.'),
    fsoprGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    fsoprOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    fsoprWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    hydraulicGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    hydraulicOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    hydraulicWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedGasLiftRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedPower: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    technicalGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    technicalOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    technicalWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    wellSolverEstimatedTotalGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    wellSolverEstimatedTotalLiquidRate: z.lazy(() => TimeSeriesSchema.nullish()),
    wellSolverEstimatedTotalOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    wellSolverEstimatedTotalWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    wellSolverGasDifference: z.lazy(() => TimeSeriesSchema.nullish()),
    wellSolverGasFlowMatchIndex: z.lazy(() => TimeSeriesSchema.nullish()),
    wellSolverLiquidDifference: z.lazy(() => TimeSeriesSchema.nullish()),
    wellSolverMeasuredTotalGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    wellSolverMeasuredTotalLiquidRate: z.lazy(() => TimeSeriesSchema.nullish()),
    wellSolverMeasuredTotalOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    wellSolverMeasuredTotalWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    wellSolverOilDifference: z.lazy(() => TimeSeriesSchema.nullish()),
    wellSolverOilFlowMatchIndex: z.lazy(() => TimeSeriesSchema.nullish()),
    wellSolverWaterDifference: z.lazy(() => TimeSeriesSchema.nullish()),
    wellSolverWaterFlowMatchIndex: z.lazy(() => TimeSeriesSchema.nullish()),
  })
  .describe(
    'Field-level scenario and optimization outputs from the solution data model (WF7/WF11).\n\nField-rolled-up production and injection metrics (oil/gas/water rates,\npressures, facility utilization) including scenario and optimization variants.\nUse for field-level what-if and optimization comparison. For WF7 field\nrollups from GAP see FieldOutputs_Agent. Excludes well-level and historical data.\n\nUse for: Network Surveillance (WF7), Network Model Validation (WF8),\nProduction Optimization (WF11).\n\n@name Network Outputs - Field (Agent)',
  );

export const NetworkOutputsFieldSchema: z.ZodObject<Properties<NetworkOutputsField>> = z
  .object({
    __typename: z.literal('NetworkOutputs_Field').optional(),
    adHocOptimization1Comment: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization1ExecutedBy: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocOptimization1ExecutedBy' in this 'NetworkOutputs_Field' view."),
    adHocOptimization1GasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocOptimization1GasRate' in this 'NetworkOutputs_Field' view."),
    adHocOptimization1OilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocOptimization1OilRate' in this 'NetworkOutputs_Field' view."),
    adHocOptimization1RunID: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization1WaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocOptimization1WaterRate' in this 'NetworkOutputs_Field' view."),
    adHocOptimization2Comment: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization2ExecutedBy: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocOptimization2ExecutedBy' in this 'NetworkOutputs_Field' view."),
    adHocOptimization2GasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocOptimization2GasRate' in this 'NetworkOutputs_Field' view."),
    adHocOptimization2OilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocOptimization2OilRate' in this 'NetworkOutputs_Field' view."),
    adHocOptimization2RunID: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocOptimization2WaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocOptimization2WaterRate' in this 'NetworkOutputs_Field' view."),
    adHocSimulation1Comment: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocSimulation1ExecutedBy: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocSimulation1ExecutedBy' in this 'NetworkOutputs_Field' view."),
    adHocSimulation1GasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocSimulation1GasRate' in this 'NetworkOutputs_Field' view."),
    adHocSimulation1OilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocSimulation1OilRate' in this 'NetworkOutputs_Field' view."),
    adHocSimulation1RunID: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocSimulation1WaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocSimulation1WaterRate' in this 'NetworkOutputs_Field' view."),
    adHocSimulation2Comment: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocSimulation2ExecutedBy: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocSimulation2ExecutedBy' in this 'NetworkOutputs_Field' view."),
    adHocSimulation2GasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocSimulation2GasRate' in this 'NetworkOutputs_Field' view."),
    adHocSimulation2OilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocSimulation2OilRate' in this 'NetworkOutputs_Field' view."),
    adHocSimulation2RunID: z.lazy(() => TimeSeriesSchema.nullish()),
    adHocSimulation2WaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'adHocSimulation2WaterRate' in this 'NetworkOutputs_Field' view."),
    calcualtedSeparatorGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calcualtedSeparatorGasRate' in this 'NetworkOutputs_Field' view."),
    calculatedFlowLinePressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calculatedFlowLinePressure' in this 'NetworkOutputs_Field' view."),
    calculatedJointCo2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calculatedJointCo2' in this 'NetworkOutputs_Field' view."),
    calculatedJointGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calculatedJointGasRate' in this 'NetworkOutputs_Field' view."),
    calculatedJointH2S: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calculatedJointH2S' in this 'NetworkOutputs_Field' view."),
    calculatedJointLiquidRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calculatedJointLiquidRate' in this 'NetworkOutputs_Field' view."),
    calculatedJointN2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calculatedJointN2' in this 'NetworkOutputs_Field' view."),
    calculatedJointOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calculatedJointOilRate' in this 'NetworkOutputs_Field' view."),
    calculatedJointPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calculatedJointPressure' in this 'NetworkOutputs_Field' view."),
    calculatedPressureMatchIndex: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calculatedPressureMatchIndex' in this 'NetworkOutputs_Field' view."),
    calculatedSeparatorOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calculatedSeparatorOilRate' in this 'NetworkOutputs_Field' view."),
    calculatedSepratorWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calculatedSepratorWaterRate' in this 'NetworkOutputs_Field' view."),
    calculatedTotalGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calculatedTotalGasRate' in this 'NetworkOutputs_Field' view."),
    calculatedTotalGasRateGI: z.lazy(() => TimeSeriesSchema.nullish()),
    calculatedTotalLiquidRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calculatedTotalLiquidRate' in this 'NetworkOutputs_Field' view."),
    calculatedTotalLiquidRateWI: z.lazy(() => TimeSeriesSchema.nullish()),
    calculatedTotalOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calculatedTotalOilRate' in this 'NetworkOutputs_Field' view."),
    calculatedTotalWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calculatedTotalWaterRate' in this 'NetworkOutputs_Field' view."),
    calculatedTotalWaterRateWI: z.lazy(() => TimeSeriesSchema.nullish()),
    entityName: z
      .lazy(() => FieldSchema.nullish())
      .describe("Reference to the related 'Field' entity for this 'NetworkOutputs_Field' row."),
    estimatedFlowlineUnstableflowFlag: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'estimatedFlowlineUnstableflowFlag' in this 'NetworkOutputs_Field' view.",
      ),
    estimatedFlowlineflowassuranceflag: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'estimatedFlowlineflowassuranceflag' in this 'NetworkOutputs_Field' view.",
      ),
    fsoprGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fsoprGasRate' in this 'NetworkOutputs_Field' view."),
    fsoprOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fsoprOilRate' in this 'NetworkOutputs_Field' view."),
    fsoprRunID: z.lazy(() => TimeSeriesSchema.nullish()),
    fsoprWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fsoprWaterRate' in this 'NetworkOutputs_Field' view."),
    hydraulicGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'hydraulicGasRate' in this 'NetworkOutputs_Field' view."),
    hydraulicOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'hydraulicOilRate' in this 'NetworkOutputs_Field' view."),
    hydraulicRunID: z.lazy(() => TimeSeriesSchema.nullish()),
    hydraulicWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'hydraulicWaterRate' in this 'NetworkOutputs_Field' view."),
    prpFileId: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeGasLiftRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokePower: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeRunID: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedChokeWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedGasLiftRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'systemOptimizedGasLiftRate' in this 'NetworkOutputs_Field' view."),
    systemOptimizedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'systemOptimizedGasRate' in this 'NetworkOutputs_Field' view."),
    systemOptimizedOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'systemOptimizedOilRate' in this 'NetworkOutputs_Field' view."),
    systemOptimizedPower: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'systemOptimizedPower' in this 'NetworkOutputs_Field' view."),
    systemOptimizedRunID: z.lazy(() => TimeSeriesSchema.nullish()),
    systemOptimizedWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'systemOptimizedWaterRate' in this 'NetworkOutputs_Field' view."),
    technicalGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'technicalGasRate' in this 'NetworkOutputs_Field' view."),
    technicalOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'technicalOilRate' in this 'NetworkOutputs_Field' view."),
    technicalRunID: z.lazy(() => TimeSeriesSchema.nullish()),
    technicalWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'technicalWaterRate' in this 'NetworkOutputs_Field' view."),
    wellSolverEstimatedTotalGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'wellSolverEstimatedTotalGasRate' in this 'NetworkOutputs_Field' view.",
      ),
    wellSolverEstimatedTotalLiquidRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'wellSolverEstimatedTotalLiquidRate' in this 'NetworkOutputs_Field' view.",
      ),
    wellSolverEstimatedTotalOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'wellSolverEstimatedTotalOilRate' in this 'NetworkOutputs_Field' view.",
      ),
    wellSolverEstimatedTotalWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'wellSolverEstimatedTotalWaterRate' in this 'NetworkOutputs_Field' view.",
      ),
    wellSolverGasDeviation: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellSolverGasDeviation' in this 'NetworkOutputs_Field' view."),
    wellSolverGasDifference: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellSolverGasDifference' in this 'NetworkOutputs_Field' view."),
    wellSolverGasFlowMatchIndex: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellSolverGasFlowMatchIndex' in this 'NetworkOutputs_Field' view."),
    wellSolverGasFlowMatchIndexTolerance: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'wellSolverGasFlowMatchIndexTolerance' in this 'NetworkOutputs_Field' view.",
      ),
    wellSolverLiquidDifference: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellSolverLiquidDifference' in this 'NetworkOutputs_Field' view."),
    wellSolverMeasuredTotalGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellSolverMeasuredTotalGasRate' in this 'NetworkOutputs_Field' view."),
    wellSolverMeasuredTotalLiquidRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'wellSolverMeasuredTotalLiquidRate' in this 'NetworkOutputs_Field' view.",
      ),
    wellSolverMeasuredTotalOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellSolverMeasuredTotalOilRate' in this 'NetworkOutputs_Field' view."),
    wellSolverMeasuredTotalWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'wellSolverMeasuredTotalWaterRate' in this 'NetworkOutputs_Field' view.",
      ),
    wellSolverOilDeviation: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellSolverOilDeviation' in this 'NetworkOutputs_Field' view."),
    wellSolverOilDifference: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellSolverOilDifference' in this 'NetworkOutputs_Field' view."),
    wellSolverOilFlowMatchIndex: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellSolverOilFlowMatchIndex' in this 'NetworkOutputs_Field' view."),
    wellSolverOilFlowMatchIndexTolerance: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'wellSolverOilFlowMatchIndexTolerance' in this 'NetworkOutputs_Field' view.",
      ),
    wellSolverWaterDeviation: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellSolverWaterDeviation' in this 'NetworkOutputs_Field' view."),
    wellSolverWaterDifference: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellSolverWaterDifference' in this 'NetworkOutputs_Field' view."),
    wellSolverWaterFlowMatchIndex: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellSolverWaterFlowMatchIndex' in this 'NetworkOutputs_Field' view."),
    wellSolverWaterFlowMatchIndexTolerance: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'wellSolverWaterFlowMatchIndexTolerance' in this 'NetworkOutputs_Field' view.",
      ),
  })
  .describe("View 'NetworkOutputs_Field' in the iPSO production optimization solution data model.");

export const NetworkInputsAgentSchema: z.ZodObject<Properties<NetworkInputsAgent>> = z
  .object({
    __typename: z.literal('NetworkInputs_Agent').optional(),
    availableGLRate: z.lazy(() => TimeSeriesSchema.nullish()),
    availablePower: z.lazy(() => TimeSeriesSchema.nullish()),
    capacityGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    capacityOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    capacityWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    flowlineMaxCFactor: z.lazy(() => TimeSeriesSchema.nullish()),
    flowlineMaxLinePressure: z.lazy(() => TimeSeriesSchema.nullish()),
    flowlineMaxMixtureVelocity: z.lazy(() => TimeSeriesSchema.nullish()),
    gasBarrelOfOilEquivalent: z.lazy(() => TimeSeriesSchema.nullish()),
    gasPrice: z.lazy(() => TimeSeriesSchema.nullish()),
    gasProcessingCost: z.lazy(() => TimeSeriesSchema.nullish()),
    jointMaxCO2: z.lazy(() => TimeSeriesSchema.nullish()),
    jointMaxGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    jointMaxH2S: z.lazy(() => TimeSeriesSchema.nullish()),
    jointMaxLiquidRate: z.lazy(() => TimeSeriesSchema.nullish()),
    jointMaxN2: z.lazy(() => TimeSeriesSchema.nullish()),
    jointMaxOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    jointMaxPressure: z.lazy(() => TimeSeriesSchema.nullish()),
    jointMinPressure: z.lazy(() => TimeSeriesSchema.nullish()),
    liftCost: z.lazy(() => TimeSeriesSchema.nullish()),
    manifoldPress: z.lazy(() => TimeSeriesSchema.nullish()),
    manifoldTemp: z.lazy(() => TimeSeriesSchema.nullish()),
    networkName: z.lazy(() => NetworkSchema.nullish()).describe('Reference to the network model entity.'),
    oilPrice: z.lazy(() => TimeSeriesSchema.nullish()),
    oilProcessingCost: z.lazy(() => TimeSeriesSchema.nullish()),
    plannedFacilityDowntime: z.lazy(() => TimeSeriesSchema.nullish()),
    separatorGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    separatorMaxGasRate: z.lazy(() => TimeSeriesSchema.nullish()),
    separatorMaxOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    separatorMaxWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    separatorOilRate: z.lazy(() => TimeSeriesSchema.nullish()),
    separatorPressure: z.lazy(() => TimeSeriesSchema.nullish()),
    separatorTemperature: z.lazy(() => TimeSeriesSchema.nullish()),
    separatorWaterRate: z.lazy(() => TimeSeriesSchema.nullish()),
    surfacePumpMaxLiquidRate: z.lazy(() => TimeSeriesSchema.nullish()),
    waterDisposalCost: z.lazy(() => TimeSeriesSchema.nullish()),
    wellMaxGOR: z.lazy(() => TimeSeriesSchema.nullish()),
  })
  .describe(
    'Network-level input conditions for the WF7 GAP network model (WF7).\n\nOperating constraints and facility-level input parameters (separator\nconditions, compressor settings, targets) applied to the network as a whole\non a given run. Use to understand the assumptions behind a network-level\nsimulation and to compare input sets across runs. For results see\nNetworkOutputs_Field_Agent and NetworkOutputs_String_Agent.\n\nUse for: Network Surveillance (WF7), Network Model Validation (WF8).\n\n@name Network Inputs (Agent)',
  );

export const NetworkInputsSchema: z.ZodObject<Properties<NetworkInputs>> = z
  .object({
    __typename: z.literal('NetworkInputs').optional(),
    asphalteneTable: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'asphalteneTable' in this 'NetworkInputs' view."),
    availableGLRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'availableGLRate' in this 'NetworkInputs' view."),
    availablePower: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'availablePower' in this 'NetworkInputs' view."),
    capacityGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'capacityGasRate' in this 'NetworkInputs' view."),
    capacityOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'capacityOilRate' in this 'NetworkInputs' view."),
    capacityWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'capacityWaterRate' in this 'NetworkInputs' view."),
    entityName: z
      .lazy(() => NetworkSchema.nullish())
      .describe("Reference to the related 'Network' entity for this 'NetworkInputs' row."),
    flowlineMaxCFactor: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'flowlineMaxCFactor' in this 'NetworkInputs' view."),
    flowlineMaxLinePressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'flowlineMaxLinePressure' in this 'NetworkInputs' view."),
    flowlineMaxMixtureVelocity: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'flowlineMaxMixtureVelocity' in this 'NetworkInputs' view."),
    gasBarrelOfOilEquivalent: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gasBarrelOfOilEquivalent' in this 'NetworkInputs' view."),
    gasPrice: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gasPrice' in this 'NetworkInputs' view."),
    gasProcessingCost: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gasProcessingCost' in this 'NetworkInputs' view."),
    hydrateTable: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'hydrateTable' in this 'NetworkInputs' view."),
    jointMaxCO2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'jointMaxCO2' in this 'NetworkInputs' view."),
    jointMaxGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'jointMaxGasRate' in this 'NetworkInputs' view."),
    jointMaxH2S: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'jointMaxH2S' in this 'NetworkInputs' view."),
    jointMaxLiquidRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'jointMaxLiquidRate' in this 'NetworkInputs' view."),
    jointMaxN2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'jointMaxN2' in this 'NetworkInputs' view."),
    jointMaxOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'jointMaxOilRate' in this 'NetworkInputs' view."),
    jointMaxPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'jointMaxPressure' in this 'NetworkInputs' view."),
    jointMinPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'jointMinPressure' in this 'NetworkInputs' view."),
    liftCost: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'liftCost' in this 'NetworkInputs' view."),
    manifoldPress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'manifoldPress' in this 'NetworkInputs' view."),
    manifoldTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'manifoldTemp' in this 'NetworkInputs' view."),
    oilPrice: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'oilPrice' in this 'NetworkInputs' view."),
    oilProcessingCost: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'oilProcessingCost' in this 'NetworkInputs' view."),
    plannedFacilityDowntime: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'plannedFacilityDowntime' in this 'NetworkInputs' view."),
    scaleTable: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'scaleTable' in this 'NetworkInputs' view."),
    separatorGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'separatorGasRate' in this 'NetworkInputs' view."),
    separatorMaxGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'separatorMaxGasRate' in this 'NetworkInputs' view."),
    separatorMaxOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'separatorMaxOilRate' in this 'NetworkInputs' view."),
    separatorMaxWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'separatorMaxWaterRate' in this 'NetworkInputs' view."),
    separatorOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'separatorOilRate' in this 'NetworkInputs' view."),
    separatorPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'separatorPressure' in this 'NetworkInputs' view."),
    separatorTemperature: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'separatorTemperature' in this 'NetworkInputs' view."),
    separatorWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'separatorWaterRate' in this 'NetworkInputs' view."),
    surfacePumpMaxLiquidRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'surfacePumpMaxLiquidRate' in this 'NetworkInputs' view."),
    waterDisposalCost: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'waterDisposalCost' in this 'NetworkInputs' view."),
    waxTable: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'waxTable' in this 'NetworkInputs' view."),
    wellMaxGOR: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellMaxGOR' in this 'NetworkInputs' view."),
  })
  .describe("View 'NetworkInputs' in the iPSO production optimization solution data model.");

export const MpfmOutputsSchema: z.ZodObject<Properties<MpfmOutputs>> = z
  .object({
    __typename: z.literal('MpfmOutputs').optional(),
    cgrLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'cgrLC' in this 'MpfmOutputs' view."),
    chokeAlarms: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'chokeAlarms' in this 'MpfmOutputs' view."),
    chokeAlarmsCode: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'chokeAlarmsCode' in this 'MpfmOutputs' view."),
    chokeMatchedliquidRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'chokeMatchedliquidRate' in this 'MpfmOutputs' view."),
    comments: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'comments' in this 'MpfmOutputs' view."),
    composition: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'composition' in this 'MpfmOutputs' view."),
    entityName: z
      .lazy(() => StringAssetSchema.nullish())
      .describe("Reference to the related 'String_asset' entity for this 'MpfmOutputs' row."),
    espwear: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'espwear' in this 'MpfmOutputs' view."),
    fluidProperties: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fluidProperties' in this 'MpfmOutputs' view."),
    formationGOR: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'formationGOR' in this 'MpfmOutputs' view."),
    gasDensityLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gasDensityLC' in this 'MpfmOutputs' view."),
    gasDensitySC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gasDensitySC' in this 'MpfmOutputs' view."),
    gasMassFlowRateLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gasMassFlowRateLC' in this 'MpfmOutputs' view."),
    gasMassFlowRateSC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gasMassFlowRateSC' in this 'MpfmOutputs' view."),
    gasVolumeFractionLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gasVolumeFractionLC' in this 'MpfmOutputs' view."),
    glFcvOutletTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'glFcvOutletTemp' in this 'MpfmOutputs' view."),
    glinjectionRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'glinjectionRate' in this 'MpfmOutputs' view."),
    historicalAlarms: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'historicalAlarms' in this 'MpfmOutputs' view."),
    historicalAlarmsCode: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'historicalAlarmsCode' in this 'MpfmOutputs' view."),
    liquidRateLc: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'liquidRateLc' in this 'MpfmOutputs' view."),
    liquidRateSc: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'liquidRateSc' in this 'MpfmOutputs' view."),
    modelAlarms: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelAlarms' in this 'MpfmOutputs' view."),
    modelAlarmsCode: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelAlarmsCode' in this 'MpfmOutputs' view."),
    modelComposition: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelComposition' in this 'MpfmOutputs' view."),
    modelMatchedBHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelMatchedBHP' in this 'MpfmOutputs' view."),
    modelMatchedgasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelMatchedgasRate' in this 'MpfmOutputs' view."),
    modelMatchedliquidRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelMatchedliquidRate' in this 'MpfmOutputs' view."),
    modelMatchedoilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelMatchedoilRate' in this 'MpfmOutputs' view."),
    modelMatchedwaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelMatchedwaterRate' in this 'MpfmOutputs' view."),
    modelMinStableRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelMinStableRate' in this 'MpfmOutputs' view."),
    modelProductivityIndex: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelProductivityIndex' in this 'MpfmOutputs' view."),
    modelReservoirModel: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelReservoirModel' in this 'MpfmOutputs' view."),
    modelReservoirPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelReservoirPressure' in this 'MpfmOutputs' view."),
    modelStabilityFlag: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelStabilityFlag' in this 'MpfmOutputs' view."),
    modelVlpModel: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelVlpModel' in this 'MpfmOutputs' view."),
    modelWellTestTimestamp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'modelWellTestTimestamp' in this 'MpfmOutputs' view."),
    mpfmAlarms: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmAlarms' in this 'MpfmOutputs' view."),
    mpfmDifferentialPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmDifferentialPressure' in this 'MpfmOutputs' view."),
    mpfmLinePressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmLinePressure' in this 'MpfmOutputs' view."),
    mpfmLineTemperature: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmLineTemperature' in this 'MpfmOutputs' view."),
    oilDensityLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'oilDensityLC' in this 'MpfmOutputs' view."),
    oilDensitySC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'oilDensitySC' in this 'MpfmOutputs' view."),
    oilMassFlowRateLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'oilMassFlowRateLC' in this 'MpfmOutputs' view."),
    oilMassFlowRateSC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'oilMassFlowRateSC' in this 'MpfmOutputs' view."),
    oilVolumeFractionLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'oilVolumeFractionLC' in this 'MpfmOutputs' view."),
    ptsDateTime: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'ptsDateTime' in this 'MpfmOutputs' view."),
    pumpDischargeTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'pumpDischargeTemp' in this 'MpfmOutputs' view."),
    pumpMotorTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'pumpMotorTemp' in this 'MpfmOutputs' view."),
    pumpPower: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'pumpPower' in this 'MpfmOutputs' view."),
    pumpVibration: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'pumpVibration' in this 'MpfmOutputs' view."),
    pvtAlarms: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'pvtAlarms' in this 'MpfmOutputs' view."),
    sampleDateTime: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'sampleDateTime' in this 'MpfmOutputs' view."),
    stablePeriodEndDate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'stablePeriodEndDate' in this 'MpfmOutputs' view."),
    stablePeriodStartDate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'stablePeriodStartDate' in this 'MpfmOutputs' view."),
    validatedBy: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'validatedBy' in this 'MpfmOutputs' view."),
    waterDensityLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'waterDensityLC' in this 'MpfmOutputs' view."),
    waterDensitySC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'waterDensitySC' in this 'MpfmOutputs' view."),
    waterMassFlowRateLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'waterMassFlowRateLC' in this 'MpfmOutputs' view."),
    waterMassFlowRateSC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'waterMassFlowRateSC' in this 'MpfmOutputs' view."),
    waterVolumeFractionLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'waterVolumeFractionLC' in this 'MpfmOutputs' view."),
    wellTestApprovedAllocationFlag: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestApprovedAllocationFlag' in this 'MpfmOutputs' view."),
    wellTestArtificialLiftType: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestArtificialLiftType' in this 'MpfmOutputs' view."),
    wellTestBottomHolePressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestBottomHolePressure' in this 'MpfmOutputs' view."),
    wellTestBottomHoleTemperature: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestBottomHoleTemperature' in this 'MpfmOutputs' view."),
    wellTestCGR: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestCGR' in this 'MpfmOutputs' view."),
    wellTestCasingHeadPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestCasingHeadPressure' in this 'MpfmOutputs' view."),
    wellTestCasingHeadTemperature: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestCasingHeadTemperature' in this 'MpfmOutputs' view."),
    wellTestChokeOpening: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestChokeOpening' in this 'MpfmOutputs' view."),
    wellTestChokeSize: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestChokeSize' in this 'MpfmOutputs' view."),
    wellTestDuration: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestDuration' in this 'MpfmOutputs' view."),
    wellTestEgorVendorStdGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestEgorVendorStdGasRate' in this 'MpfmOutputs' view."),
    wellTestEgorVendorStdOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestEgorVendorStdOilRate' in this 'MpfmOutputs' view."),
    wellTestEgorVendorStdWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestEgorVendorStdWaterRate' in this 'MpfmOutputs' view."),
    wellTestEndDate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestEndDate' in this 'MpfmOutputs' view."),
    wellTestEspMotorCurrent: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestEspMotorCurrent' in this 'MpfmOutputs' view."),
    wellTestEspMotorPower: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestEspMotorPower' in this 'MpfmOutputs' view."),
    wellTestEspMotorVoltage: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestEspMotorVoltage' in this 'MpfmOutputs' view."),
    wellTestEspPumpDischargePressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestEspPumpDischargePressure' in this 'MpfmOutputs' view."),
    wellTestEspPumpFrequency: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestEspPumpFrequency' in this 'MpfmOutputs' view."),
    wellTestEspPumpIntakePressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestEspPumpIntakePressure' in this 'MpfmOutputs' view."),
    wellTestEspPumpIntakeTemperature: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestEspPumpIntakeTemperature' in this 'MpfmOutputs' view."),
    wellTestFlowlinePressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestFlowlinePressure' in this 'MpfmOutputs' view."),
    wellTestFlowlineTemperature: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestFlowlineTemperature' in this 'MpfmOutputs' view."),
    wellTestGOR: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGOR' in this 'MpfmOutputs' view."),
    wellTestGasDensityInSitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGasDensityInSitu' in this 'MpfmOutputs' view."),
    wellTestGasLiftVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGasLiftVolume' in this 'MpfmOutputs' view."),
    wellTestGasRateInsitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGasRateInsitu' in this 'MpfmOutputs' view."),
    wellTestGasRatePts: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGasRatePts' in this 'MpfmOutputs' view."),
    wellTestGasRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGasRateStd' in this 'MpfmOutputs' view."),
    wellTestGlFlControlValvOutletPres: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGlFlControlValvOutletPres' in this 'MpfmOutputs' view."),
    wellTestGlFlControlValveInletPres: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGlFlControlValveInletPres' in this 'MpfmOutputs' view."),
    wellTestGlFlControlValveInletTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGlFlControlValveInletTemp' in this 'MpfmOutputs' view."),
    wellTestGlInjectionChokeOpening: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGlInjectionChokeOpening' in this 'MpfmOutputs' view."),
    wellTestGorInsitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGorInsitu' in this 'MpfmOutputs' view."),
    wellTestGorPts: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestGorPts' in this 'MpfmOutputs' view."),
    wellTestLiquidRatePts: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestLiquidRatePts' in this 'MpfmOutputs' view."),
    wellTestMpfmName: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestMpfmName' in this 'MpfmOutputs' view."),
    wellTestOilDensityInSitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestOilDensityInSitu' in this 'MpfmOutputs' view."),
    wellTestOilRateInsitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestOilRateInsitu' in this 'MpfmOutputs' view."),
    wellTestOilRatePts: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestOilRatePts' in this 'MpfmOutputs' view."),
    wellTestOilRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestOilRateStd' in this 'MpfmOutputs' view."),
    wellTestStartDate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestStartDate' in this 'MpfmOutputs' view."),
    wellTestStartDateDH: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestStartDateDH' in this 'MpfmOutputs' view."),
    wellTestStringFunction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestStringFunction' in this 'MpfmOutputs' view."),
    wellTestTestMethod: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestTestMethod' in this 'MpfmOutputs' view."),
    wellTestTestSeparatorLinePressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestTestSeparatorLinePressure' in this 'MpfmOutputs' view."),
    wellTestTestSeparatorLineTemperature: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestTestSeparatorLineTemperature' in this 'MpfmOutputs' view."),
    wellTestTestType: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestTestType' in this 'MpfmOutputs' view."),
    wellTestTestTypeDesc: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestTestTypeDesc' in this 'MpfmOutputs' view."),
    wellTestTotalGorStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestTotalGorStd' in this 'MpfmOutputs' view."),
    wellTestTotalMassFlowRateGas: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestTotalMassFlowRateGas' in this 'MpfmOutputs' view."),
    wellTestTotalMassFlowRateOil: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestTotalMassFlowRateOil' in this 'MpfmOutputs' view."),
    wellTestTotalMassFlowRateWater: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestTotalMassFlowRateWater' in this 'MpfmOutputs' view."),
    wellTestValidationFlag: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestValidationFlag' in this 'MpfmOutputs' view."),
    wellTestWGR: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestWGR' in this 'MpfmOutputs' view."),
    wellTestWaterCut: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestWaterCut' in this 'MpfmOutputs' view."),
    wellTestWaterCutInsitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestWaterCutInsitu' in this 'MpfmOutputs' view."),
    wellTestWaterCutPts: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestWaterCutPts' in this 'MpfmOutputs' view."),
    wellTestWaterRateInsitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestWaterRateInsitu' in this 'MpfmOutputs' view."),
    wellTestWaterRatePts: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestWaterRatePts' in this 'MpfmOutputs' view."),
    wellTestWaterRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestWaterRateStd' in this 'MpfmOutputs' view."),
    wellTestWellheadPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestWellheadPressure' in this 'MpfmOutputs' view."),
    wellTestWellheadTemperature: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellTestWellheadTemperature' in this 'MpfmOutputs' view."),
    wgrLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wgrLC' in this 'MpfmOutputs' view."),
    wlrLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wlrLC' in this 'MpfmOutputs' view."),
  })
  .describe("View 'MpfmOutputs' in the iPSO production optimization solution data model.");

export const MpfmInputsSchema: z.ZodObject<Properties<MpfmInputs>> = z
  .object({
    __typename: z.literal('MpfmInputs').optional(),
    entityName: z
      .lazy(() => MpfmSchema.nullish())
      .describe("Reference to the related 'Mpfm' entity for this 'MpfmInputs' row."),
    mpfmBSWMaxRange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmBSWMaxRange' in this 'MpfmInputs' view."),
    mpfmBSWMinRange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmBSWMinRange' in this 'MpfmInputs' view."),
    mpfmCalcCGRInSitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmCalcCGRInSitu' in this 'MpfmInputs' view."),
    mpfmCalcCGRStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmCalcCGRStd' in this 'MpfmInputs' view."),
    mpfmCalcGORInsitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmCalcGORInsitu' in this 'MpfmInputs' view."),
    mpfmCalcGORStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmCalcGORStd' in this 'MpfmInputs' view."),
    mpfmCalcGasDensityInSitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmCalcGasDensityInSitu' in this 'MpfmInputs' view."),
    mpfmCalcLiquidRateInSitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmCalcLiquidRateInSitu' in this 'MpfmInputs' view."),
    mpfmCalcLiquidRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmCalcLiquidRateStd' in this 'MpfmInputs' view."),
    mpfmCalcOilDensityInSitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmCalcOilDensityInSitu' in this 'MpfmInputs' view."),
    mpfmCalcWGRInSitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmCalcWGRInSitu' in this 'MpfmInputs' view."),
    mpfmCalcWGRStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmCalcWGRStd' in this 'MpfmInputs' view."),
    mpfmCalcWLRInSitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmCalcWLRInSitu' in this 'MpfmInputs' view."),
    mpfmCalcWaterDensityInSitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmCalcWaterDensityInSitu' in this 'MpfmInputs' view."),
    mpfmCumGasVolInSitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmCumGasVolInSitu' in this 'MpfmInputs' view."),
    mpfmCumGasVolStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmCumGasVolStd' in this 'MpfmInputs' view."),
    mpfmCumLiquidVolInSitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmCumLiquidVolInSitu' in this 'MpfmInputs' view."),
    mpfmCumLiquidVolStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmCumLiquidVolStd' in this 'MpfmInputs' view."),
    mpfmDeltaPressMaxRange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmDeltaPressMaxRange' in this 'MpfmInputs' view."),
    mpfmDeltaPressMinRange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmDeltaPressMinRange' in this 'MpfmInputs' view."),
    mpfmDifferentialPress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmDifferentialPress' in this 'MpfmInputs' view."),
    mpfmFlagOnTest: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmFlagOnTest' in this 'MpfmInputs' view."),
    mpfmGORLCMaxRange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmGORLCMaxRange' in this 'MpfmInputs' view."),
    mpfmGORLCMinRange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmGORLCMinRange' in this 'MpfmInputs' view."),
    mpfmGORSTB: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmGORSTB' in this 'MpfmInputs' view."),
    mpfmGVFInSitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmGVFInSitu' in this 'MpfmInputs' view."),
    mpfmGVFMaxRange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmGVFMaxRange' in this 'MpfmInputs' view."),
    mpfmGVFMinRange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmGVFMinRange' in this 'MpfmInputs' view."),
    mpfmGasDensityInSitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmGasDensityInSitu' in this 'MpfmInputs' view."),
    mpfmGasDensityMaxRange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmGasDensityMaxRange' in this 'MpfmInputs' view."),
    mpfmGasDensityMinRange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmGasDensityMinRange' in this 'MpfmInputs' view."),
    mpfmGasDensityStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmGasDensityStd' in this 'MpfmInputs' view."),
    mpfmGasMassFlowInSitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmGasMassFlowInSitu' in this 'MpfmInputs' view."),
    mpfmGasMassFlowRateMaxRange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmGasMassFlowRateMaxRange' in this 'MpfmInputs' view."),
    mpfmGasMassFlowRateMinRange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmGasMassFlowRateMinRange' in this 'MpfmInputs' view."),
    mpfmGasMassFlowStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmGasMassFlowStd' in this 'MpfmInputs' view."),
    mpfmGasMaxRange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmGasMaxRange' in this 'MpfmInputs' view."),
    mpfmGasMinRange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmGasMinRange' in this 'MpfmInputs' view."),
    mpfmGasRateInSitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmGasRateInSitu' in this 'MpfmInputs' view."),
    mpfmGasRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmGasRateStd' in this 'MpfmInputs' view."),
    mpfmLinePress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmLinePress' in this 'MpfmInputs' view."),
    mpfmLineTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmLineTemp' in this 'MpfmInputs' view."),
    mpfmLiqMaxRange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmLiqMaxRange' in this 'MpfmInputs' view."),
    mpfmLiqMinRange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmLiqMinRange' in this 'MpfmInputs' view."),
    mpfmLiquidRateInSitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmLiquidRateInSitu' in this 'MpfmInputs' view."),
    mpfmLiquidRateSTB: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmLiquidRateSTB' in this 'MpfmInputs' view."),
    mpfmOVFMaxRange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmOVFMaxRange' in this 'MpfmInputs' view."),
    mpfmOVFMinRange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmOVFMinRange' in this 'MpfmInputs' view."),
    mpfmOilDensityInSitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmOilDensityInSitu' in this 'MpfmInputs' view."),
    mpfmOilDensityMaxRange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmOilDensityMaxRange' in this 'MpfmInputs' view."),
    mpfmOilDensityMinRange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmOilDensityMinRange' in this 'MpfmInputs' view."),
    mpfmOilDensityStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmOilDensityStd' in this 'MpfmInputs' view."),
    mpfmOilMassFlowInSitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmOilMassFlowInSitu' in this 'MpfmInputs' view."),
    mpfmOilMassFlowRateMaxRange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmOilMassFlowRateMaxRange' in this 'MpfmInputs' view."),
    mpfmOilMassFlowRateMinRange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmOilMassFlowRateMinRange' in this 'MpfmInputs' view."),
    mpfmOilMassFlowStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmOilMassFlowStd' in this 'MpfmInputs' view."),
    mpfmOilMaxRange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmOilMaxRange' in this 'MpfmInputs' view."),
    mpfmOilMinRange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmOilMinRange' in this 'MpfmInputs' view."),
    mpfmOilRateInSitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmOilRateInSitu' in this 'MpfmInputs' view."),
    mpfmOilRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmOilRateStd' in this 'MpfmInputs' view."),
    mpfmOilVolFractionInSitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmOilVolFractionInSitu' in this 'MpfmInputs' view."),
    mpfmPressMaxRange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmPressMaxRange' in this 'MpfmInputs' view."),
    mpfmPressMinRange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmPressMinRange' in this 'MpfmInputs' view."),
    mpfmStatus: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmStatus' in this 'MpfmInputs' view."),
    mpfmTempMaxRange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmTempMaxRange' in this 'MpfmInputs' view."),
    mpfmTempMinRange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmTempMinRange' in this 'MpfmInputs' view."),
    mpfmTotalGORSCMaxRange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmTotalGORSCMaxRange' in this 'MpfmInputs' view."),
    mpfmTotalGORSCMinRange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmTotalGORSCMinRange' in this 'MpfmInputs' view."),
    mpfmTotalMassFlow: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmTotalMassFlow' in this 'MpfmInputs' view."),
    mpfmWLRMaxRange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmWLRMaxRange' in this 'MpfmInputs' view."),
    mpfmWLRMinRange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmWLRMinRange' in this 'MpfmInputs' view."),
    mpfmWVFMaxRange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmWVFMaxRange' in this 'MpfmInputs' view."),
    mpfmWVFMinRange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmWVFMinRange' in this 'MpfmInputs' view."),
    mpfmWaterCutInSitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmWaterCutInSitu' in this 'MpfmInputs' view."),
    mpfmWaterCutSTB: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmWaterCutSTB' in this 'MpfmInputs' view."),
    mpfmWaterDensityInSitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmWaterDensityInSitu' in this 'MpfmInputs' view."),
    mpfmWaterDensityMaxRange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmWaterDensityMaxRange' in this 'MpfmInputs' view."),
    mpfmWaterDensityMinRange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmWaterDensityMinRange' in this 'MpfmInputs' view."),
    mpfmWaterDensityStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmWaterDensityStd' in this 'MpfmInputs' view."),
    mpfmWaterMassFlowInSitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmWaterMassFlowInSitu' in this 'MpfmInputs' view."),
    mpfmWaterMassFlowRateMaxRange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmWaterMassFlowRateMaxRange' in this 'MpfmInputs' view."),
    mpfmWaterMassFlowRateMinRange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmWaterMassFlowRateMinRange' in this 'MpfmInputs' view."),
    mpfmWaterMassFlowStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmWaterMassFlowStd' in this 'MpfmInputs' view."),
    mpfmWaterMaxRange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmWaterMaxRange' in this 'MpfmInputs' view."),
    mpfmWaterMinRange: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmWaterMinRange' in this 'MpfmInputs' view."),
    mpfmWaterRateInSitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmWaterRateInSitu' in this 'MpfmInputs' view."),
    mpfmWaterRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmWaterRateStd' in this 'MpfmInputs' view."),
    mpfmWaterSalinity: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmWaterSalinity' in this 'MpfmInputs' view."),
    mpfmWaterVolumeFractionInSitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mpfmWaterVolumeFractionInSitu' in this 'MpfmInputs' view."),
  })
  .describe("View 'MpfmInputs' in the iPSO production optimization solution data model.");

export const ModelMatchedRatesStringAgentSchema: z.ZodObject<Properties<ModelMatchedRatesStringAgent>> = z
  .object({
    __typename: z.literal('ModelMatchedRates_String_Agent').optional(),
    cgrLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Model-matched condensate-gas ratio at live/local conditions (stb/MMscf, TS).'),
    cgrSC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Model-matched condensate-gas ratio at standard conditions (stb/MMscf, TS).'),
    chokeAlarms: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Choke model validation alarm (TS). 1 = pass, 0 = fail.\n@name chokeCheckStatus'),
    chokeMatchedgasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Choke equation gas rate (MMscfd, TS).\n@name chokeCalculatedGasRate'),
    chokeMatchedliquidRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Choke equation liquid rate (stb/d, TS).\n@name chokeCalculatedLiquidRate'),
    gasRateSC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Measured gas rate at standard conditions (MMscfd, TS).\n@name measuredGasRate'),
    gorLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Model-matched gas-oil ratio at live/local conditions (scf/stb, TS).'),
    historicalAlarms: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Historical trend validation alarm (TS). 1 = pass, 0 = fail.\n@name historyCheckStatus'),
    modelAlarms: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Prosper model validation alarm (TS). 1 = pass, 0 = fail.\n@name modelCheckStatus'),
    modelMatchedBHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Prosper model-matched flowing bottom-hole pressure (psi, TS).'),
    modelMatchedgasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Prosper model-matched gas rate (MMscfd, TS).\n@name modelMatchedGasRate'),
    modelMatchedliquidRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Prosper model-matched total liquid rate (stb/d, TS).\n@name modelMatchedLiquidRate'),
    modelMatchedoilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Prosper model-matched oil rate (stb/d, TS).\n@name modelMatchedOilRate'),
    modelMatchedwaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Prosper model-matched water rate (stb/d, TS).\n@name modelMatchedWaterRate'),
    oilRateSC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Measured oil rate at standard conditions (stb/d, TS).\n@name measuredOilRate'),
    pvtAlarms: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('PVT validation alarm (TS). 1 = pass, 0 = fail.\n@name pvtCheckStatus'),
    totalGorSC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Model-matched total gas-oil ratio at standard conditions (scf/stb, TS).'),
    waterCutLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Model-matched water cut at live/local conditions (fraction, TS).'),
    waterCutSC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Model-matched water cut at standard conditions (fraction, TS).'),
    wellString: z.lazy(() => StringAssetSchema.nullish()).describe('Well string identifier.'),
    wgrLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Model-matched water-gas ratio at live/local conditions (stb/MMscf, TS).'),
    wgrSC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Model-matched water-gas ratio at standard conditions (stb/MMscf, TS).'),
  })
  .describe(
    'Model-matched rates from Prosper well model calibration per well string.\n\nContains model-matched rates generated by the Prosper well model, which are\naligned with well test data, including oil, gas, water, liquid rates, and\nbottom hole pressure (BHP). Sourced from calibrated Prosper models and is used\nto evaluate the accuracy of the model against actual measurements, answering\nquestions related to model performance and well efficiency. It excludes raw\nwell test data or uncalibrated model outputs, distinguishing it from other\nviews that may focus on unprocessed measurements. Use cases: assessing model\nquality through alarm flags that highlight deviations from both measured data\nand historical performance trends.\n\n@name Model-Matched Rates - String (Agent)',
  );

export const MeasuredRatesWellTestStringAgentSchema: z.ZodObject<Properties<MeasuredRatesWellTestStringAgent>> = z
  .object({
    __typename: z.literal('MeasuredRates_WellTest_String_Agent').optional(),
    cgrLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Condensate-gas ratio at live/local conditions (stb/MMscf, TS).'),
    formationGOR: z.lazy(() => TimeSeriesSchema.nullish()).describe('Formation/reservoir gas-oil ratio (scf/stb, TS).'),
    wellString: z.lazy(() => StringAssetSchema.nullish()).describe('Well string identifier.'),
    wellTestApprovedAllocationFlag: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Well test allocation approval status (TS). Values: 'Accepted', 'Rejected'.\n@name isApproved"),
    wellTestCGR: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Condensate-gas ratio at standard conditions (stb/MMscf, TS).\n@name condensateGasRatio'),
    wellTestGOR: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Separator gas-oil ratio from well test (scf/stb, TS).'),
    wellTestGasRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Measured gas production rate at standard conditions (MMscfd, TS).\n@name gasRateStd'),
    wellTestGorInsitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Gas-oil ratio at downhole/insitu conditions (scf/stb, TS).\n@name gorInsitu'),
    wellTestGorPts: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Gas-oil ratio at PTS conditions (scf/stb, TS).\n@name gorPts'),
    wellTestLiquidRatePts: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Total liquid rate (oil + water) at PTS conditions (stb/d, TS).\n@name liquidRatePts'),
    wellTestOilRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Measured oil production rate at standard conditions (stb/d, TS).\n@name oilRateStd'),
    wellTestStartDate: z.lazy(() => TimeSeriesSchema.nullish()).describe('Well test start date (TS).\n@name testDate'),
    wellTestTotalGorStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Total gas-oil ratio at standard conditions (scf/stb, TS).\n@name totalGorStd'),
    wellTestWGR: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Water-gas ratio at standard conditions (stb/MMscf, TS).\n@name waterGasRatio'),
    wellTestWaterCut: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Water cut at standard conditions: water / (oil + water) * 100 (%, TS).\n@name waterCut'),
    wellTestWaterCutInsitu: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Water cut at downhole/insitu conditions (%, TS).\n@name waterCutInsitu'),
    wellTestWaterCutPts: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Water cut at PTS conditions (%, TS).\n@name waterCutPts'),
    wellTestWaterRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Measured water production rate at standard conditions (stb/d, TS).\n@name waterRateStd'),
    wgrLC: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Water-gas ratio at live/local conditions (stb/MMscf, TS).'),
  })
  .describe(
    'Well test measured rates per well string from separator measurements.\n\nContains comprehensive measurements from well tests, separator-measured rates\nof oil, gas, and water at standard conditions, along with pertinent metadata\nsuch as test dates and allocation approval flags. Sourced from actual well\ntests conducted in the field, providing a reliable basis for production rate\ncalibration and validation of network models. It can address analytical\nquestions regarding the latest well test results, approved tests, and specific\nratios like gas-to-oil and water-cut metrics. Excludes simulated or estimated\nrates, which may be present in other views, ensuring that users are working\nwith verified physical measurements.\n\n@name Measured Rates - Well Test (Agent)',
  );

export const MeasuredInjectionStringAgentSchema: z.ZodObject<Properties<MeasuredInjectionStringAgent>> = z
  .object({
    __typename: z.literal('MeasuredInjection_String_Agent').optional(),
    gasInjChokeOpening: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Gas injection choke opening (TS). Controls gas injection rate at wellhead.'),
    gasInjRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Measured gas injection rate (MSCF/d) from wellhead flow meter. This is the\ndirect measurement, not an allocated value. Use for real-time injection\nmonitoring and comparison with allocated volumes.',
      ),
    gasInjWellheadPress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Gas injection wellhead pressure (psia, TS). From wellhead meter; indicates line pressure and injectivity.',
      ),
    waterInjChokeOpening: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Water injection choke opening (TS). Controls water injection rate at wellhead.'),
    waterInjRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Measured water injection rate (stb/d) from wellhead flow meter. This is the\ndirect measurement, not an allocated value. Use for real-time injection\nmonitoring and comparison with allocated volumes.',
      ),
    waterInjWellheadPress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Water injection wellhead pressure (psia, TS). From wellhead meter; indicates line pressure and injectivity.',
      ),
    wellString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe('Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context.'),
  })
  .describe(
    'Measured injection rates from wellhead meters per well string (WF15).\n\nReal-time gas and water injection from wellhead meters; no allocation. Use for\nactual injection rates, trends, and well-string comparisons. For allocated volumes see AllocatedInjection_String_Agent.\n\nUse for: Water or Gas Injection Monitoring (WF15).',
  );

export const ManifoldInputsSchema: z.ZodObject<Properties<ManifoldInputs>> = z
  .object({
    __typename: z.literal('ManifoldInputs').optional(),
    entityName: z
      .lazy(() => EntitySchema.nullish())
      .describe("Reference to the related 'Manifold' entity for this 'ManifoldInputs' row."),
    manifoldGasInjPressure: z.lazy(() => TimeSeriesSchema.nullish()),
    manifoldGasInjRate: z.lazy(() => TimeSeriesSchema.nullish()),
    manifoldGasInjTemperature: z.lazy(() => TimeSeriesSchema.nullish()),
    manifoldWaterInjPressure: z.lazy(() => TimeSeriesSchema.nullish()),
    manifoldWaterInjRate: z.lazy(() => TimeSeriesSchema.nullish()),
    manifoldWaterInjTemperature: z.lazy(() => TimeSeriesSchema.nullish()),
  })
  .describe("View 'ManifoldInputs' in the iPSO production optimization solution data model.");

export const LocationInputsSchema: z.ZodObject<Properties<LocationInputs>> = z
  .object({
    __typename: z.literal('LocationInputs').optional(),
    entityName: z
      .lazy(() => LocationSchema.nullish())
      .describe("Reference to the related 'Location' entity for this 'LocationInputs' row."),
    flowLinePressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'flowLinePressure' in this 'LocationInputs' view."),
    waterHeaderPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'waterHeaderPressure' in this 'LocationInputs' view."),
    waterHeaderTemperature: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'waterHeaderTemperature' in this 'LocationInputs' view."),
  })
  .describe("View 'LocationInputs' in the iPSO production optimization solution data model.");

export const LiftTypeParameterStringSchema: z.ZodObject<Properties<LiftTypeParameterString>> = z
  .object({
    __typename: z.literal('LiftTypeParameter_String').optional(),
    amorphousFeS: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'amorphousFeS' in this 'LiftTypeParameter_String' view."),
    amorphousSilica: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'amorphousSilica' in this 'LiftTypeParameter_String' view."),
    anhydrite: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'anhydrite' in this 'LiftTypeParameter_String' view."),
    asphalteneMaxLimit: z
      .float32()
      .nullish()
      .describe("Numeric value 'asphalteneMaxLimit' (floating point) for this 'LiftTypeParameter_String' row."),
    asphalteneMinLimit: z
      .float32()
      .nullish()
      .describe("Numeric value 'asphalteneMinLimit' (floating point) for this 'LiftTypeParameter_String' row."),
    asphalteneRelativeWT: z
      .float32()
      .nullish()
      .describe("Numeric value 'asphalteneRelativeWT' (floating point) for this 'LiftTypeParameter_String' row."),
    asphalteneRisk: z
      .boolean()
      .nullish()
      .describe("Boolean flag 'asphalteneRisk' for this 'LiftTypeParameter_String' row."),
    baCO3: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'baCO3' in this 'LiftTypeParameter_String' view."),
    barite: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'barite' in this 'LiftTypeParameter_String' view."),
    caF2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'caF2' in this 'LiftTypeParameter_String' view."),
    caOH2Portlandite: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'caOH2Portlandite' in this 'LiftTypeParameter_String' view."),
    calcite: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calcite' in this 'LiftTypeParameter_String' view."),
    calestite: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'calestite' in this 'LiftTypeParameter_String' view."),
    chrysotile: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'chrysotile' in this 'LiftTypeParameter_String' view."),
    corrosionMaxLimit: z
      .float32()
      .nullish()
      .describe("Numeric value 'corrosionMaxLimit' (floating point) for this 'LiftTypeParameter_String' row."),
    corrosionMinLimit: z
      .float32()
      .nullish()
      .describe("Numeric value 'corrosionMinLimit' (floating point) for this 'LiftTypeParameter_String' row."),
    corrosionRelativeWT: z
      .float32()
      .nullish()
      .describe("Numeric value 'corrosionRelativeWT' (floating point) for this 'LiftTypeParameter_String' row."),
    diopside: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'diopside' in this 'LiftTypeParameter_String' view."),
    entityName: z
      .lazy(() => StringAssetSchema.nullish())
      .describe("Reference to the related 'String_asset' entity for this 'LiftTypeParameter_String' row."),
    erosionMaxLimit: z
      .float32()
      .nullish()
      .describe("Numeric value 'erosionMaxLimit' (floating point) for this 'LiftTypeParameter_String' row."),
    erosionMinLimit: z
      .float32()
      .nullish()
      .describe("Numeric value 'erosionMinLimit' (floating point) for this 'LiftTypeParameter_String' row."),
    erosionRelativeWT: z
      .float32()
      .nullish()
      .describe("Numeric value 'erosionRelativeWT' (floating point) for this 'LiftTypeParameter_String' row."),
    espMaxDischargePressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'espMaxDischargePressure' in this 'LiftTypeParameter_String' view."),
    espMaxDischargePressure_active: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Boolean flag 'espMaxDischargePressure_active' for this 'LiftTypeParameter_String' row."),
    espMaxFluidRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'espMaxFluidRate' in this 'LiftTypeParameter_String' view."),
    espMaxFluidRate_active: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Boolean flag 'espMaxFluidRate_active' for this 'LiftTypeParameter_String' row."),
    espMaxFreeGasInPump: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'espMaxFreeGasInPump' in this 'LiftTypeParameter_String' view."),
    espMaxFreeGasInPump_active: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Boolean flag 'espMaxFreeGasInPump_active' for this 'LiftTypeParameter_String' row."),
    espMaxHead: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'espMaxHead' in this 'LiftTypeParameter_String' view."),
    espMaxHead_active: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Boolean flag 'espMaxHead_active' for this 'LiftTypeParameter_String' row."),
    espMaxMotorAmps: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'espMaxMotorAmps' in this 'LiftTypeParameter_String' view."),
    espMaxMotorAmps_active: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Boolean flag 'espMaxMotorAmps_active' for this 'LiftTypeParameter_String' row."),
    espMaxMotorEfficiency: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'espMaxMotorEfficiency' in this 'LiftTypeParameter_String' view."),
    espMaxMotorEfficiency_active: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Boolean flag 'espMaxMotorEfficiency_active' for this 'LiftTypeParameter_String' row."),
    espMaxMotorLoadPermissible: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'espMaxMotorLoadPermissible' in this 'LiftTypeParameter_String' view."),
    espMaxMotorLoadPermissible_active: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Boolean flag 'espMaxMotorLoadPermissible_active' for this 'LiftTypeParameter_String' row."),
    espMaxMotorPwr: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'espMaxMotorPwr' in this 'LiftTypeParameter_String' view."),
    espMaxMotorPwr_active: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Boolean flag 'espMaxMotorPwr_active' for this 'LiftTypeParameter_String' row."),
    espMaxMotorSpeed_InductorType: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'espMaxMotorSpeed_InductorType' in this 'LiftTypeParameter_String' view.",
      ),
    espMaxMotorSpeed_InductorType_active: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Boolean flag 'espMaxMotorSpeed_InductorType_active' for this 'LiftTypeParameter_String' row."),
    espMaxMotorSpeed_PmmType: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'espMaxMotorSpeed_PmmType' in this 'LiftTypeParameter_String' view."),
    espMaxMotorSpeed_PmmType_active: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Boolean flag 'espMaxMotorSpeed_PmmType_active' for this 'LiftTypeParameter_String' row."),
    espMaxMotorTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'espMaxMotorTemp' in this 'LiftTypeParameter_String' view."),
    espMaxMotorTemp_active: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Boolean flag 'espMaxMotorTemp_active' for this 'LiftTypeParameter_String' row."),
    espMaxPumpDeltaTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'espMaxPumpDeltaTemp' in this 'LiftTypeParameter_String' view."),
    espMaxPumpDeltaTemp_active: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Boolean flag 'espMaxPumpDeltaTemp_active' for this 'LiftTypeParameter_String' row."),
    espMaxPumpFluidVelocity: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'espMaxPumpFluidVelocity' in this 'LiftTypeParameter_String' view."),
    espMaxPumpFluidVelocity_active: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Boolean flag 'espMaxPumpFluidVelocity_active' for this 'LiftTypeParameter_String' row."),
    espMaxPwrAvail_Generated: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'espMaxPwrAvail_Generated' in this 'LiftTypeParameter_String' view."),
    espMaxPwrAvail_Generated_active: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Boolean flag 'espMaxPwrAvail_Generated_active' for this 'LiftTypeParameter_String' row."),
    espMaxSurfaceKva: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'espMaxSurfaceKva' in this 'LiftTypeParameter_String' view."),
    espMaxSurfaceKva_active: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Boolean flag 'espMaxSurfaceKva_active' for this 'LiftTypeParameter_String' row."),
    espMaxTrqOnShaft: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'espMaxTrqOnShaft' in this 'LiftTypeParameter_String' view."),
    espMaxTrqOnShaft_active: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Boolean flag 'espMaxTrqOnShaft_active' for this 'LiftTypeParameter_String' row."),
    espMaxVoltageDropAlongCable: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'espMaxVoltageDropAlongCable' in this 'LiftTypeParameter_String' view.",
      ),
    espMaxVoltageDropAlongCable_active: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Boolean flag 'espMaxVoltageDropAlongCable_active' for this 'LiftTypeParameter_String' row."),
    espMinFluidRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'espMinFluidRate' in this 'LiftTypeParameter_String' view."),
    espMinFluidRate_active: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Boolean flag 'espMinFluidRate_active' for this 'LiftTypeParameter_String' row."),
    espMinIntakePressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'espMinIntakePressure' in this 'LiftTypeParameter_String' view."),
    espMinIntakePressure_active: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Boolean flag 'espMinIntakePressure_active' for this 'LiftTypeParameter_String' row."),
    espMinIntakeTemperature: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'espMinIntakeTemperature' in this 'LiftTypeParameter_String' view."),
    espMinIntakeTemperature_active: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Boolean flag 'espMinIntakeTemperature_active' for this 'LiftTypeParameter_String' row."),
    espMinMotorPowerFactor: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'espMinMotorPowerFactor' in this 'LiftTypeParameter_String' view."),
    espMinMotorPowerFactor_active: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Boolean flag 'espMinMotorPowerFactor_active' for this 'LiftTypeParameter_String' row."),
    espMinPumpFluidVelocity: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'espMinPumpFluidVelocity' in this 'LiftTypeParameter_String' view."),
    espMinPumpFluidVelocity_active: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Boolean flag 'espMinPumpFluidVelocity_active' for this 'LiftTypeParameter_String' row."),
    espPdpThreshold: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'espPdpThreshold' in this 'LiftTypeParameter_String' view."),
    espPipThreshold: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'espPipThreshold' in this 'LiftTypeParameter_String' view."),
    feCO3: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'feCO3' in this 'LiftTypeParameter_String' view."),
    fluidVelocity: z
      .boolean()
      .nullish()
      .describe("Boolean flag 'fluidVelocity' for this 'LiftTypeParameter_String' row."),
    fluidVelocityStatus: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fluidVelocityStatus' in this 'LiftTypeParameter_String' view."),
    fourCalcOptions: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'fourCalcOptions' in this 'LiftTypeParameter_String' view."),
    glMaxCasingHeadPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'glMaxCasingHeadPressure' in this 'LiftTypeParameter_String' view."),
    glMaxCasingHeadPressure_active: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Boolean flag 'glMaxCasingHeadPressure_active' for this 'LiftTypeParameter_String' row."),
    glMaxLiftChokeDeltaTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'glMaxLiftChokeDeltaTemp' in this 'LiftTypeParameter_String' view."),
    glMaxLiftChokeDeltaTemp_active: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Boolean flag 'glMaxLiftChokeDeltaTemp_active' for this 'LiftTypeParameter_String' row."),
    glMaxManifoldPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'glMaxManifoldPressure' in this 'LiftTypeParameter_String' view."),
    glMaxManifoldPressure_active: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Boolean flag 'glMaxManifoldPressure_active' for this 'LiftTypeParameter_String' row."),
    glMaxWellHeadTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'glMaxWellHeadTemp' in this 'LiftTypeParameter_String' view."),
    glMaxWellHeadTemp_active: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Boolean flag 'glMaxWellHeadTemp_active' for this 'LiftTypeParameter_String' row."),
    glMinBHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'glMinBHP' in this 'LiftTypeParameter_String' view."),
    glMinBHP_active: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Boolean flag 'glMinBHP_active' for this 'LiftTypeParameter_String' row."),
    glMinCasingHeadPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'glMinCasingHeadPressure' in this 'LiftTypeParameter_String' view."),
    glMinCasingHeadPressure_active: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Boolean flag 'glMinCasingHeadPressure_active' for this 'LiftTypeParameter_String' row."),
    glMinManifolddPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'glMinManifolddPressure' in this 'LiftTypeParameter_String' view."),
    glMinManifolddPressure_active: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Boolean flag 'glMinManifolddPressure_active' for this 'LiftTypeParameter_String' row."),
    glMinWellHeadPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'glMinWellHeadPressure' in this 'LiftTypeParameter_String' view."),
    glMinWellHeadPressure_active: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Boolean flag 'glMinWellHeadPressure_active' for this 'LiftTypeParameter_String' row."),
    greenalite: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'greenalite' in this 'LiftTypeParameter_String' view."),
    gypsum: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gypsum' in this 'LiftTypeParameter_String' view."),
    halite: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'halite' in this 'LiftTypeParameter_String' view."),
    hemihydrate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'hemihydrate' in this 'LiftTypeParameter_String' view."),
    hydrateMaxLimit: z
      .float32()
      .nullish()
      .describe("Numeric value 'hydrateMaxLimit' (floating point) for this 'LiftTypeParameter_String' row."),
    hydrateMinLimit: z
      .float32()
      .nullish()
      .describe("Numeric value 'hydrateMinLimit' (floating point) for this 'LiftTypeParameter_String' row."),
    hydrateRelativeWT: z
      .float32()
      .nullish()
      .describe("Numeric value 'hydrateRelativeWT' (floating point) for this 'LiftTypeParameter_String' row."),
    hydrateRisk: z.boolean().nullish().describe("Boolean flag 'hydrateRisk' for this 'LiftTypeParameter_String' row."),
    liquidLoadingMaxLimit: z
      .float32()
      .nullish()
      .describe("Numeric value 'liquidLoadingMaxLimit' (floating point) for this 'LiftTypeParameter_String' row."),
    liquidLoadingMinLimit: z
      .float32()
      .nullish()
      .describe("Numeric value 'liquidLoadingMinLimit' (floating point) for this 'LiftTypeParameter_String' row."),
    liquidLoadingRelativeWT: z
      .float32()
      .nullish()
      .describe("Numeric value 'liquidLoadingRelativeWT' (floating point) for this 'LiftTypeParameter_String' row."),
    mackinawite: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mackinawite' in this 'LiftTypeParameter_String' view."),
    maxGOR: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'maxGOR' in this 'LiftTypeParameter_String' view."),
    maxGOR_active: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Boolean flag 'maxGOR_active' for this 'LiftTypeParameter_String' row."),
    maxLiquidRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'maxLiquidRate' in this 'LiftTypeParameter_String' view."),
    maxLiquidRate_active: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Boolean flag 'maxLiquidRate_active' for this 'LiftTypeParameter_String' row."),
    maxOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'maxOilRate' in this 'LiftTypeParameter_String' view."),
    maxOilRate_active: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Boolean flag 'maxOilRate_active' for this 'LiftTypeParameter_String' row."),
    maxWellHeadPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'maxWellHeadPressure' in this 'LiftTypeParameter_String' view."),
    maxWellHeadPressure_active: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Boolean flag 'maxWellHeadPressure_active' for this 'LiftTypeParameter_String' row."),
    mgOH2Brucite: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'mgOH2Brucite' in this 'LiftTypeParameter_String' view."),
    pbSGalena: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'pbSGalena' in this 'LiftTypeParameter_String' view."),
    pe5MaxLimit: z
      .float32()
      .nullish()
      .describe("Numeric value 'pe5MaxLimit' (floating point) for this 'LiftTypeParameter_String' row."),
    pe5MinLimit: z
      .float32()
      .nullish()
      .describe("Numeric value 'pe5MinLimit' (floating point) for this 'LiftTypeParameter_String' row."),
    pe5RelativeWT: z
      .float32()
      .nullish()
      .describe("Numeric value 'pe5RelativeWT' (floating point) for this 'LiftTypeParameter_String' row."),
    pe5StabilityCriteria: z
      .boolean()
      .nullish()
      .describe("Boolean flag 'pe5StabilityCriteria' for this 'LiftTypeParameter_String' row."),
    pe5StabilityCriteriaStatus: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'pe5StabilityCriteriaStatus' in this 'LiftTypeParameter_String' view."),
    quartz: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'quartz' in this 'LiftTypeParameter_String' view."),
    srCO3: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'srCO3' in this 'LiftTypeParameter_String' view."),
    troilitePyrrhotite: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'troilitePyrrhotite' in this 'LiftTypeParameter_String' view."),
    usePhTuning: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'usePhTuning' in this 'LiftTypeParameter_String' view."),
    waxMaxLimit: z
      .float32()
      .nullish()
      .describe("Numeric value 'waxMaxLimit' (floating point) for this 'LiftTypeParameter_String' row."),
    waxMinLimit: z
      .float32()
      .nullish()
      .describe("Numeric value 'waxMinLimit' (floating point) for this 'LiftTypeParameter_String' row."),
    waxRelativeWT: z
      .float32()
      .nullish()
      .describe("Numeric value 'waxRelativeWT' (floating point) for this 'LiftTypeParameter_String' row."),
    waxRisk: z.boolean().nullish().describe("Boolean flag 'waxRisk' for this 'LiftTypeParameter_String' row."),
    znCO3: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'znCO3' in this 'LiftTypeParameter_String' view."),
    znS: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'znS' in this 'LiftTypeParameter_String' view."),
  })
  .describe("View 'LiftTypeParameter_String' in the iPSO production optimization solution data model.");

export const JointOutputsNetworkAgentSchema: z.ZodObject<Properties<JointOutputsNetworkAgent>> = z
  .object({
    __typename: z.literal('JointOutputs_Network_Agent').optional(),
    entityName: z.json().nullish().describe('Junction/manifold entity name.'),
    jointEntity: z.lazy(() => EntitySchema.nullish()).describe('Reference to junction/manifold entity.'),
    network: z.lazy(() => NetworkSchema.nullish()).describe('Reference to parent network model.'),
    nmvCgr: z.lazy(() => TimeSeriesSchema.nullish()).describe('Condensate-gas ratio at junction (TS).'),
    nmvDp: z.lazy(() => TimeSeriesSchema.nullish()).describe('Differential pressure at junction (TS).'),
    nmvGlr: z.lazy(() => TimeSeriesSchema.nullish()).describe('Gas-liquid ratio at junction (TS).'),
    nmvGor: z.lazy(() => TimeSeriesSchema.nullish()).describe('Gas-oil ratio at junction (TS).'),
    nmvInjectionGasRate: z.lazy(() => TimeSeriesSchema.nullish()).describe('Gas injection rate at junction (TS).'),
    nmvInjectionWaterRate: z.lazy(() => TimeSeriesSchema.nullish()).describe('Water injection rate at junction (TS).'),
    nmvJointCO2: z.lazy(() => TimeSeriesSchema.nullish()).describe('CO2 content at junction (TS).'),
    nmvJointGasRate: z.lazy(() => TimeSeriesSchema.nullish()).describe('Gas rate at junction (TS).'),
    nmvJointH2S: z.lazy(() => TimeSeriesSchema.nullish()).describe('H2S content at junction (TS).'),
    nmvJointLiquidRate: z.lazy(() => TimeSeriesSchema.nullish()).describe('Liquid rate at junction (TS).'),
    nmvJointN2: z.lazy(() => TimeSeriesSchema.nullish()).describe('N2 content at junction (TS).'),
    nmvJointOilRate: z.lazy(() => TimeSeriesSchema.nullish()).describe('Oil rate at junction (TS).'),
    nmvJointPressure: z.lazy(() => TimeSeriesSchema.nullish()).describe('Pressure at junction (TS).'),
    nmvJointTemperature: z.lazy(() => TimeSeriesSchema.nullish()).describe('Temperature at junction (TS).'),
    nmvJointViolatingConstraintsFlag: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Junction operating outside constraints (0/1, TS).'),
    nmvPdown: z.lazy(() => TimeSeriesSchema.nullish()).describe('Downstream pressure (TS).'),
    nmvTdown: z.lazy(() => TimeSeriesSchema.nullish()).describe('Downstream temperature (TS).'),
    nmvWaterCut: z.lazy(() => TimeSeriesSchema.nullish()).describe('Water cut at junction (TS).'),
    nmvWaterRate: z.lazy(() => TimeSeriesSchema.nullish()).describe('Water rate at junction (TS).'),
    nmvWgr: z.lazy(() => TimeSeriesSchema.nullish()).describe('Water-gas ratio at junction (TS).'),
  })
  .describe(
    'Junction and node-level outputs from WF7 GAP network simulation (WF7/WF20).\n\nPressures, temperatures, and oil/gas/liquid flow rates at network junctions\nand nodes. Use to trace fluid behavior through the network, identify\nbottlenecks, and analyze how upstream parameter changes propagate to\ndownstream nodes. Excludes historical time series and\nsystem-level aggregates.\n\nUse for: Network Surveillance (WF7), Flow Assurance Detection and Mitigation (WF20).\n\n@name Joint Outputs - Network (Agent)',
  );

export const InjectionPerformanceStringAgentSchema: z.ZodObject<Properties<InjectionPerformanceStringAgent>> = z
  .object({
    __typename: z.literal('InjectionPerformance_String_Agent').optional(),
    cumulativeGasInjPress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Average WHP during cumulative gas injection period (psi, TS).'),
    cumulativeGasInjVol: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Cumulative gas injection volume (MSCF, TS). Used for voidage tracking.'),
    cumulativeWaterInjPress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Average WHP during cumulative water injection period (psi, TS).'),
    cumulativeWaterInjVol: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Cumulative water injection volume (stb, TS). Used for voidage tracking.'),
    downholeGasInjectionVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Cumulative gas injection at reservoir conditions (rb, TS).'),
    downholeWaterInjectionVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Cumulative water injection at reservoir conditions (rb, TS). Used for\nVRR and material balance calculations.',
      ),
    giBHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Bottom-hole pressure during gas injection (psi, TS). Measured if\ninstrumented, otherwise calculated from WHP.',
      ),
    giRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Current gas injection rate (MSCF/d, TS). Real-time from flow meter\nor calculated from operating conditions.',
      ),
    giTargetRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Target gas injection rate (MSCF/d, TS) from production plan or optimization.\nCompare to giRate to assess injection compliance.',
      ),
    giTechnicalRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Maximum technically achievable gas injection rate (MSCF/d, TS) given\ncurrent well and facility constraints.',
      ),
    giWHP: z.lazy(() => TimeSeriesSchema.nullish()).describe('Wellhead pressure during gas injection (psi, TS).'),
    hallInterpretation: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Hall plot trend interpretation: 'STABLE', 'IMPROVING', 'DECLINING',\n'STIMULATION_NEEDED'. Key diagnostic for injection well surveillance.",
      ),
    hallLine: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Hall plot cumulative value or slope (TS). Trend changes indicate\ninjectivity changes over time.'),
    injectionEfficiency: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Injection efficiency (%, TS). Actual rate / target rate. 100% = fully\nmeeting target.'),
    injectionEfficiencyFlag: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Flag: 1 = below efficiency threshold (needs attention), 0 = acceptable.'),
    injectionEfficiencyRank: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Rank among all injectors (1 = best, TS). Use to identify worst performers.'),
    injectivityIndex: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Injectivity index (stb/d/psi, TS). Rate of injection per unit\npressure increase. Key metric for injection well health.',
      ),
    wellString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe('Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context.'),
    wiBHP: z.lazy(() => TimeSeriesSchema.nullish()).describe('Bottom-hole pressure during water injection (psi, TS).'),
    wiRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Current water injection rate (stb/d, TS). Real-time from flow meter.'),
    wiTargetRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Target water injection rate (stb/d, TS) from production plan or optimization.'),
    wiTechnicalRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Maximum technically achievable water injection rate (stb/d, TS).'),
    wiWHP: z.lazy(() => TimeSeriesSchema.nullish()).describe('Wellhead pressure during water injection (psi, TS).'),
  })
  .describe(
    'Injection well performance metrics at string level (WF15).\n\nGas and water injection rates, pressures, efficiency, Hall plot. Use for\neffectiveness of injection strategies, injectivity trends, compliance with\ntargets, and Hall plot diagnostics. Excludes surface facility or reservoir views.\n\nUse for: Water or Gas Injection Monitoring (WF15).\n\n@name Injection Performance - String Level (Agent)',
  );

export const InjectionHeaderOutputsNetworkAgentSchema: z.ZodObject<Properties<InjectionHeaderOutputsNetworkAgent>> = z
  .object({
    __typename: z.literal('InjectionHeaderOutputs_Network_Agent').optional(),
    entityName: z.lazy(() => EntitySchema.nullish()).describe('Injection header entity name.'),
    network: z.lazy(() => NetworkSchema.nullish()).describe('Reference to parent network model.'),
    nmvEstimatedGasInjPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Estimated gas injection pressure (TS).'),
    nmvEstimatedGasInjRate: z.lazy(() => TimeSeriesSchema.nullish()).describe('Estimated gas injection rate (TS).'),
    nmvEstimatedGasInjTemperature: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Estimated gas injection temperature (TS).'),
    nmvEstimatedWaterInjPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Estimated water injection pressure (TS).'),
    nmvEstimatedWaterInjRate: z.lazy(() => TimeSeriesSchema.nullish()).describe('Estimated water injection rate (TS).'),
    nmvEstimatedWaterInjTemperature: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Estimated water injection temperature (TS).'),
    nmvGasInjectionFmi: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Gas injection facility max intake utilization (%, TS).'),
    nmvMeasuredGasInjPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Measured gas injection pressure (TS).'),
    nmvMeasuredGasInjRate: z.lazy(() => TimeSeriesSchema.nullish()).describe('Measured gas injection rate (TS).'),
    nmvMeasuredGasInjTemperature: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Measured gas injection temperature (TS).'),
    nmvMeasuredWaterInjPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Measured water injection pressure (TS).'),
    nmvMeasuredWaterInjRate: z.lazy(() => TimeSeriesSchema.nullish()).describe('Measured water injection rate (TS).'),
    nmvMeasuredWaterInjTemperature: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Measured water injection temperature (TS).'),
    nmvWaterInjectionFmi: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Water injection facility max intake utilization (%, TS).'),
  })
  .describe(
    'Injection header outputs from WF7 GAP network simulation (WF7).\n\nMeasured and estimated water and gas injection rates, pressures, and\ntemperatures per injection header/branch. Use for injection-network\nperformance, operational-limit checks, and identification of header\nbottlenecks across branches and wells. Excludes historical time series and\nwell-level injection diagnostics (see InjectionPerformance_String_Agent).\n\nUse for: Network Surveillance (WF7), Injection Monitoring (WF14).\n\n@name Injection Header Outputs - Network (Agent)',
  );

export const InactiveStringSchema: z.ZodObject<Properties<InactiveString>> = z
  .object({
    __typename: z.literal('Inactive_String').optional(),
    actionDate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'actionDate' in this 'Inactive_String' view."),
    actionStatus: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'actionStatus' in this 'Inactive_String' view."),
    categoryCode: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'categoryCode' in this 'Inactive_String' view."),
    downtimeStartDate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'downtimeStartDate' in this 'Inactive_String' view."),
    duration: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'duration' in this 'Inactive_String' view."),
    entityName: z
      .lazy(() => StringAssetSchema.nullish())
      .describe("Reference to the related 'String_asset' entity for this 'Inactive_String' row."),
    expectedRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'expectedRate' in this 'Inactive_String' view."),
    inactiveCategory: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'inactiveCategory' in this 'Inactive_String' view."),
    problemName: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'problemName' in this 'Inactive_String' view."),
    stringStatus: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'stringStatus' in this 'Inactive_String' view."),
    stringStatusAll: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'stringStatusAll' in this 'Inactive_String' view."),
  })
  .describe("View 'Inactive_String' in the iPSO production optimization solution data model.");

export const InactiveStringAgentSchema: z.ZodObject<Properties<InactiveStringAgent>> = z
  .object({
    __typename: z.literal('InactiveString_Agent').optional(),
    downtimeStartDate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Date when the string became inactive. Used to calculate downtime duration\nand track inactive well aging.',
      ),
    inactiveCategory: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Category of inactivity explaining why the string is inactive, e.g.,\n'MECHANICAL_FAILURE', 'AWAITING_WORKOVER', 'LOW_PRODUCTIVITY', 'ABANDONED'.",
      ),
    stringStatus: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Activity status of the string: 'ACTIVE' or 'INACTIVE'. Active strings are\navailable for production/injection. Inactive strings are temporarily or\npermanently offline (awaiting workover, abandoned, etc.).",
      ),
    wellString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe('Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context.'),
  })
  .describe(
    'Long-term well string inactivity with reasons and downtime start dates (WF25/WF18).\n\nStrings classified INACTIVE (extended/indefinite offline). Distinct from\nWellStatus_String_Agent (real-time flowing/shut-in). Use for inactive well\naging, downtime impact, workover candidate screening, well availability.\n\nUse for: Well Status Detection (WF25), Real-Time Surveillance (WF18).',
  );

export const GasLiftMeasurementsStringAgentSchema: z.ZodObject<Properties<GasLiftMeasurementsStringAgent>> = z
  .object({
    __typename: z.literal('GasLiftMeasurements_String_Agent').optional(),
    annulusPress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Annulus pressure (psia, TS). Difference from casingHeadPress can indicate tubing leaks.'),
    bottomHolePress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Bottom-hole flowing pressure (psia, TS). Compare to glMinBHP target for GL efficiency.'),
    bottomHoleTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Bottom-hole temperature (°F, TS). Important for PVT calculations.'),
    casingHeadPress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Casing head pressure (psia, TS). Critical for gas lift operation — affects\ninjection depth and valve opening. Oscillations indicate instability/multipointing.',
      ),
    chokeOpening: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Production choke opening (% or 64ths, TS). Affects backpressure on well.'),
    chokeSize: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Surface choke size setting (TS). Used for choke performance calculations.'),
    flowLinePress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Downstream flowline pressure (psia, TS). High flowline pressure reduces well deliverability.'),
    flowLineTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Flowline temperature (°F, TS). Used for hydrate risk assessment.'),
    gasLiftFlowCVInletPress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Inlet pressure at the gas lift flow control valve (psia, TS). Used to\ncalculate injection differential and optimize gas allocation.',
      ),
    gasLiftFlowCVSize: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Effective orifice/trim size of the gas lift flow control valve (TS).'),
    gasLiftInjRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Current gas lift injection rate (Mscf/d, TS). Compare to design rate and\nlimits. Higher than expected may indicate multipointing.',
      ),
    gasLiftInjTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Gas lift injection temperature (°F, TS). Important for hydrate risk assessment.'),
    liftType: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Artificial lift type (TS). Confirm value = GAS_LIFT before querying GL-specific diagnostics.'),
    wellHeadPress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Flowing wellhead pressure (psia, TS). Combined with casing pressure indicates lift efficiency.'),
    wellHeadTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Flowing wellhead temperature (°F, TS). Temperature differential helps diagnose flow issues.'),
    wellString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe('Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context.'),
  })
  .describe(
    'Real-time gas lift sensor readings per well string (WF14).\n\nLive measurements: injection rate, CV inlet pressure/temperature, CV size,\ncasing/wellhead pressures and temperatures, annulus pressure, choke settings,\ndownhole BHP/BHT. Compare against GasLiftLimits_String_Agent. For calculated outputs see GasLiftCalculations_String_Agent.\n\nUse for: Gas Lift Troubleshooting and Diagnostics (WF14).\n\n@name Gas Lift Measurements - Well String (Agent)',
  );

export const GasLiftLimitsStringAgentSchema: z.ZodObject<Properties<GasLiftLimitsStringAgent>> = z
  .object({
    __typename: z.literal('GasLiftLimits_String_Agent').optional(),
    asphalteneRisk: z.boolean().nullish().describe('Asphaltene deposition risk flag or score for this well string.'),
    fluidVelocity: z
      .boolean()
      .nullish()
      .describe('Fluid velocity limit or reference value (ft/s, TS). Used for erosion and flow assurance checks.'),
    glMaxCasingHeadPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Maximum allowable casing head pressure (psia, TS). Exceeding may damage casing or cause valve malfunction.',
      ),
    glMaxCasingHeadPressure_active: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Boolean flag — glMaxCasingHeadPressure limit is actively monitored for alarms.'),
    glMaxLiftChokeDeltaTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Maximum temperature drop across gas lift choke (°F, TS). Excessive cooling may cause hydrate formation.',
      ),
    glMaxManifoldPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Maximum manifold pressure limit (psia, TS). High manifold pressure reduces available lift gas differential.',
      ),
    glMaxWellHeadTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Maximum wellhead temperature limit (°F, TS).'),
    glMinBHP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Minimum bottomhole pressure target (psia, TS). Gas lift should achieve this BHP for optimal production.',
      ),
    glMinCasingHeadPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Minimum casing head pressure for stable injection (psia, TS). Below this, may not reach operating valve depth.',
      ),
    glMinCasingHeadPressure_active: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Boolean flag — glMinCasingHeadPressure limit is actively monitored for alarms.'),
    glMinManifolddPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Minimum manifold pressure limit (psia, TS). Below this may cause unstable flow.'),
    glMinWellHeadPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Minimum wellhead pressure for stable flow (psia, TS). Below may cause heading.'),
    hydrateRisk: z.boolean().nullish().describe('Hydrate formation risk flag or score for this well string.'),
    maxGOR: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Maximum GOR limit (scf/stb, TS). High GOR may indicate gas breakthrough or lift issues.'),
    maxLiquidRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Maximum liquid rate limit (stb/d, TS). Facility or well capacity constraint.'),
    maxOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Maximum oil rate limit (stb/d, TS). Allocation or facility constraint.'),
    maxWellHeadPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Maximum wellhead pressure limit (psia, TS). Equipment rating limit.'),
    pe5StabilityCriteria: z.boolean().nullish().describe('PE5 flow stability criteria threshold for this well string.'),
    waxRisk: z.boolean().nullish().describe('Wax deposition risk flag or score for this well string.'),
    wellString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe('Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context.'),
  })
  .describe(
    'Gas lift operating limit thresholds per well string (WF14).\n\nEngineering limits: casing/wellhead pressures, manifold pressure, BHP target,\ntemperature, rate limits (liquid, oil, GOR), monitoring flags. Compare against GasLiftMeasurements_String_Agent for exceedances. For ESP use ESPLimits_String_Agent.\n\nUse for: Gas Lift Troubleshooting and Diagnostics (WF14).\n\n@name Gas Lift Operating Limits - Well String (Agent)',
  );

export const GasLiftCalculationsStringAgentSchema: z.ZodObject<Properties<GasLiftCalculationsStringAgent>> = z
  .object({
    __typename: z.literal('GasLiftCalculations_String_Agent').optional(),
    glChokeCdCalc: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Calculated GL choke discharge coefficient (Cd, TS). Deviations from\ntypical values may indicate erosion or plugging.',
      ),
    glChokeSizeCalc: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Calculated GL choke size required to achieve current GLIR given upstream\npressure conditions (64ths inch, TS).',
      ),
    glirAllocated: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Allocated gas lift injection rate from daily allocation (MSCF/d, TS).'),
    glirChokeEquation: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Gas lift injection rate calculated from GL choke equation (MSCF/d, TS).'),
    glirMeasured: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Measured gas lift injection rate from flow meter (MSCF/d, TS).'),
    glirNetworkSimulation: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Gas lift injection rate from network simulation model (MSCF/d, TS).'),
    glirSelected: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Selected/priority gas lift injection rate (MSCF/d, TS). The most reliable\nGLIR value — use for optimization and surveillance.',
      ),
    glirSelectedType: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Source of selected GLIR. Values: MEASURED, NETWORK_SIMULATION, CHOKE_EQUATION, ALLOCATED.'),
    glqlAnalysisStatus: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Status of gas lift rate calculation. Values: SUCCESS, FAILED, NO_DATA.'),
    wellString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe('Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context.'),
  })
  .describe(
    'Model-calculated gas lift outputs per well string (WF14).\n\nGLIR variants (measured, network, choke, allocated, priority), GL analysis status,\nchoke parameters. Use glirSelected for best-available GLIR. Use with GasLiftMeasurements_String_Agent and GasLiftLimits_String_Agent.\n\nUse for: Gas Lift Troubleshooting and Diagnostics (WF14).\n\n@name Gas Lift Calculations - Well String (Agent)',
  );

export const FluidCompositionSchema: z.ZodObject<Properties<FluidComposition>> = z
  .object({
    __typename: z.literal('FluidComposition').optional(),
    c1: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'c1' in this 'FluidComposition' view."),
    c2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'c2' in this 'FluidComposition' view."),
    c3: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'c3' in this 'FluidComposition' view."),
    c6: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'c6' in this 'FluidComposition' view."),
    c7c14: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'c7c14' in this 'FluidComposition' view."),
    c15c25: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'c15c25' in this 'FluidComposition' view."),
    c26c80: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'c26c80' in this 'FluidComposition' view."),
    cgr: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'cgr' in this 'FluidComposition' view."),
    co2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'co2' in this 'FluidComposition' view."),
    condensateGravity: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'condensateGravity' in this 'FluidComposition' view."),
    entityName: z
      .lazy(() => FieldSchema.nullish())
      .describe("Reference to the related 'Field' entity for this 'FluidComposition' row."),
    h2s: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'h2s' in this 'FluidComposition' view."),
    iC4: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'iC4' in this 'FluidComposition' view."),
    iC5: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'iC5' in this 'FluidComposition' view."),
    n2: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'n2' in this 'FluidComposition' view."),
    nC4: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'nC4' in this 'FluidComposition' view."),
    nC5: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'nC5' in this 'FluidComposition' view."),
    specificGasGravity: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'specificGasGravity' in this 'FluidComposition' view."),
    waterSalinity: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'waterSalinity' in this 'FluidComposition' view."),
    wgr: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wgr' in this 'FluidComposition' view."),
  })
  .describe("View 'FluidComposition' in the iPSO production optimization solution data model.");

export const FlowlineOutputsNetworkAgentSchema: z.ZodObject<Properties<FlowlineOutputsNetworkAgent>> = z
  .object({
    __typename: z.literal('FlowlineOutputs_Network_Agent').optional(),
    connectedManifoldIdGI: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Connected manifold for gas injection path.'),
    connectedManifoldIdWI: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Connected manifold for water injection path.'),
    entityName: z.json().nullish().describe('Flowline entity name.'),
    estimatedFlowlineDeltaP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Estimated pressure drop across flowline (TS).'),
    network: z.lazy(() => NetworkSchema.nullish()).describe('Reference to parent network model.'),
    nmvAboveErosionVelocity: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Above erosion velocity threshold (0/1, TS).'),
    nmvAsphalteneFlag: z.lazy(() => TimeSeriesSchema.nullish()).describe('Asphaltene deposition risk (0/1, TS).'),
    nmvBottleneckFlag: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Flowline identified as production bottleneck (0/1, TS).'),
    nmvCFactor: z.lazy(() => TimeSeriesSchema.nullish()).describe('C-factor for inflow performance (TS).'),
    nmvCgr: z.lazy(() => TimeSeriesSchema.nullish()).describe('Condensate-gas ratio (TS).'),
    nmvConnectedManifoldId: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('ID of connected production manifold/junction.'),
    nmvDp: z.lazy(() => TimeSeriesSchema.nullish()).describe('Differential pressure across flowline (TS).'),
    nmvErosionVelocity: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Erosion velocity ratio (TS). >1 = exceeds erosion limit.'),
    nmvErosionalVelocityFlag: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Erosional velocity limit flag (0/1, TS).'),
    nmvFlowlinePressure: z.lazy(() => TimeSeriesSchema.nullish()).describe('Simulated flowline outlet pressure (TS).'),
    nmvGasRate: z.lazy(() => TimeSeriesSchema.nullish()).describe('Gas flow rate through flowline (TS).'),
    nmvGlr: z.lazy(() => TimeSeriesSchema.nullish()).describe('Gas-liquid ratio (TS).'),
    nmvGor: z.lazy(() => TimeSeriesSchema.nullish()).describe('Gas-oil ratio (TS).'),
    nmvHydrateFlag: z.lazy(() => TimeSeriesSchema.nullish()).describe('Hydrate formation risk (0/1, TS).'),
    nmvInjectionGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Gas injection flow rate through flowline (TS).'),
    nmvInjectionWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Water injection flow rate through flowline (TS).'),
    nmvLiquidRate: z.lazy(() => TimeSeriesSchema.nullish()).describe('Total liquid flow rate through flowline (TS).'),
    nmvMeasuredFlowlinePressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Measured flowline pressure for comparison to simulated (TS).'),
    nmvMixtureVelocity: z.lazy(() => TimeSeriesSchema.nullish()).describe('Mixture velocity in flowline (TS).'),
    nmvOilRate: z.lazy(() => TimeSeriesSchema.nullish()).describe('Oil flow rate through flowline (TS).'),
    nmvPe5StabilityFlag: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('PE5 flow stability indicator (0/1, TS). 1 = stable.'),
    nmvPressure: z.lazy(() => TimeSeriesSchema.nullish()).describe('Pressure at flowline node (TS).'),
    nmvPressureMatchIndex: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Pressure match quality (0-1, TS). 1 = perfect match between simulated and measured.'),
    nmvPressureMatchIndexFLP: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Flowline-specific pressure match quality (0-1, TS).'),
    nmvScaleFlag: z.lazy(() => TimeSeriesSchema.nullish()).describe('Scale formation risk (0/1, TS).'),
    nmvTemperature: z.lazy(() => TimeSeriesSchema.nullish()).describe('Temperature at flowline node (TS).'),
    nmvUnstableFlag: z.lazy(() => TimeSeriesSchema.nullish()).describe('Unstable flow detected (0/1, TS).'),
    nmvViolatingConstraintsFlag: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Operating outside defined constraints (0/1, TS).'),
    nmvWaterCut: z.lazy(() => TimeSeriesSchema.nullish()).describe('Water cut fraction (TS).'),
    nmvWaterRate: z.lazy(() => TimeSeriesSchema.nullish()).describe('Water flow rate through flowline (TS).'),
    nmvWaxFlag: z.lazy(() => TimeSeriesSchema.nullish()).describe('Wax deposition risk (0/1, TS).'),
    nmvWgr: z.lazy(() => TimeSeriesSchema.nullish()).describe('Water-gas ratio (TS).'),
    pipelineEntity: z.lazy(() => EntitySchema.nullish()).describe('Flowline entity name.'),
  })
  .describe(
    'Flowline-level outputs from GAP network simulation (WF20).\n\nPressure drops, flow rates, erosion/corrosion metrics per flowline. Use for\nflowline performance, constraints, and failure points. Excludes historical or real-time time-series.\n\nUse for: Flow Assurance Detection and Mitigation (WF20).\n\n@name Flowline Outputs - Network (Agent)',
  );

export const FieldOutputsAgentSchema: z.ZodObject<Properties<FieldOutputsAgent>> = z
  .object({
    __typename: z.literal('FieldOutputs_Agent').optional(),
    fieldEntity: z
      .lazy(() => FieldSchema.nullish())
      .describe('Reference to field. Join to FlatHierarchy_Agent for reservoir/sector context.'),
    wellsActiveGi: z.lazy(() => TimeSeriesSchema.nullish()).describe('Count of active gas injectors (TS).'),
    wellsActiveGpNf: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Count of active gas producers on natural flow (TS).'),
    wellsActiveOpEsp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Count of active oil producers on ESP lift (TS).'),
    wellsActiveOpGl: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Count of active oil producers on gas lift (TS).'),
    wellsActiveOpNf: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Count of active oil producers on natural flow (TS).'),
    wellsActiveWAG: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Count of active WAG (Water Alternating Gas) injectors (TS).'),
    wellsActiveWi: z.lazy(() => TimeSeriesSchema.nullish()).describe('Count of active water injectors (TS).'),
    wellsInActiveGi: z.lazy(() => TimeSeriesSchema.nullish()).describe('Count of inactive gas injectors (TS).'),
    wellsInActiveGpNf: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Count of inactive gas producers on natural flow (TS).'),
    wellsInActiveOpEsp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Count of inactive oil producers on ESP lift (TS).'),
    wellsInActiveOpGl: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Count of inactive oil producers on gas lift (TS).'),
    wellsInActiveOpNf: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Count of inactive oil producers on natural flow (TS).'),
    wellsInActiveWi: z.lazy(() => TimeSeriesSchema.nullish()).describe('Count of inactive water injectors (TS).'),
    wellsInactiveWAG: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Count of inactive WAG (Water Alternating Gas) injectors (TS).'),
  })
  .describe(
    'Field-level calculated outputs from WF7 GAP network model (WF7).\n\nTotal oil/gas/water rates, GOR, water cut, and active/inactive well counts\nper field derived from the GAP simulation. Use for field-level performance,\nresource utilization, and efficiency questions. For scenario and optimization\nfield outputs see NetworkOutputs_Field_Agent. Excludes historical trends and wellbore\ndetails.\n\nUse for: Network Surveillance (WF7).\n\n@name Field Outputs (Agent)',
  );

export const FieldOutputsSchema: z.ZodObject<Properties<FieldOutputs>> = z
  .object({
    __typename: z.literal('FieldOutputs').optional(),
    entityName: z
      .lazy(() => FieldSchema.nullish())
      .describe(
        'Name of the field for which aggregated well status and performance outputs are reported in this view.',
      ),
    wellsActiveGi: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of the number of active gas injector wells (GI) in the field.'),
    wellsActiveGpNf: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of the number of active producer wells flowing to gas plant (GP) or similar grouping while on natural flow (NF) in the field.',
      ),
    wellsActiveOpEsp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of the number of active producer wells on ESP (electric submersible pump) lift in the field.',
      ),
    wellsActiveOpGl: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of the number of active producer wells on gas lift (GL) in the field.'),
    wellsActiveOpNf: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of the number of active producer wells on natural flow (NF) in the field.'),
    wellsActiveWAG: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of the number of active WAG (water-alternating-gas) wells in the field.'),
    wellsActiveWi: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of the number of active water injector wells (WI) in the field.'),
    wellsInActiveGi: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of the number of inactive gas injector wells (GI) in the field.'),
    wellsInActiveGpNf: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Time series of the number of inactive producer wells flowing to gas plant (GP) or similar grouping while on natural flow (NF) in the field.',
      ),
    wellsInActiveOpEsp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of the number of inactive producer wells on ESP lift in the field.'),
    wellsInActiveOpGl: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of the number of inactive producer wells on gas lift (GL) in the field.'),
    wellsInActiveOpNf: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of the number of inactive producer wells on natural flow (NF) in the field.'),
    wellsInActiveWi: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of the number of inactive water injector wells (WI) in the field.'),
    wellsInactiveWAG: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of the number of inactive WAG (water-alternating-gas) wells in the field.'),
  })
  .describe(
    'Aggregated field-level outputs including counts of active and inactive wells by lift type and service (producers, gas injectors, water injectors, WAG wells) used for monitoring field performance and optimization decisions.',
  );

export const FieldInputsAgentSchema: z.ZodObject<Properties<FieldInputsAgent>> = z
  .object({
    __typename: z.literal('FieldInputs_Agent').optional(),
    actualGasInjection: z.lazy(() => TimeSeriesSchema.nullish()).describe('Actual gas injection volume (TS).'),
    actualGasInjectionRate: z.lazy(() => TimeSeriesSchema.nullish()).describe('Actual gas injection rate (TS).'),
    actualGasProduction: z.lazy(() => TimeSeriesSchema.nullish()).describe('Actual gas production volume (TS).'),
    actualGasProductionRate: z.lazy(() => TimeSeriesSchema.nullish()).describe('Actual gas production rate (TS).'),
    actualOilProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Actual oil production volume for this field (TS).'),
    actualOilProductionRate: z.lazy(() => TimeSeriesSchema.nullish()).describe('Actual oil production rate (TS).'),
    actualWaterInjection: z.lazy(() => TimeSeriesSchema.nullish()).describe('Actual water injection volume (TS).'),
    actualWaterInjectionRate: z.lazy(() => TimeSeriesSchema.nullish()).describe('Actual water injection rate (TS).'),
    actualWaterProduction: z.lazy(() => TimeSeriesSchema.nullish()).describe('Actual water production volume (TS).'),
    actualWaterProductionRate: z.lazy(() => TimeSeriesSchema.nullish()).describe('Actual water production rate (TS).'),
    ambientTemperature: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Ambient temperature at field location (TS).'),
    associatedGasProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Associated gas production volume (TS). Gas produced with oil.'),
    associatedGasProductionRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Associated gas production rate (TS).'),
    fieldEntity: z
      .lazy(() => FieldSchema.nullish())
      .describe('Reference to field. Join to FlatHierarchy_Agent for reservoir/sector context.'),
    nonASRGasInjection: z.lazy(() => TimeSeriesSchema.nullish()).describe('Non-associated gas injection volume (TS).'),
    nonASRGasInjectionRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Non-associated gas injection rate (TS).'),
    nonAssociatedGasProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Non-associated gas production volume (TS). Gas from gas cap or gas reservoir.'),
    nonAssociatedGasProductionRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Non-associated gas production rate (TS).'),
    potentialGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Unconstrained gas injection potential (TS).'),
    potentialGasProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Unconstrained gas production potential (TS).'),
    potentialOilProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Unconstrained oil production potential (TS). Maximum achievable without system limits.'),
    potentialWaterInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Unconstrained water injection potential (TS).'),
    potentialWaterProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Unconstrained water production potential (TS).'),
    targetGasInjection: z.lazy(() => TimeSeriesSchema.nullish()).describe('Target gas injection volume (TS).'),
    targetGasProduction: z.lazy(() => TimeSeriesSchema.nullish()).describe('Target gas production volume (TS).'),
    targetOilProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Target oil production volume for this field (TS).'),
    targetWaterInjection: z.lazy(() => TimeSeriesSchema.nullish()).describe('Target water injection volume (TS).'),
    targetWaterProduction: z.lazy(() => TimeSeriesSchema.nullish()).describe('Target water production volume (TS).'),
  })
  .describe(
    'Field-level input conditions for GAP network runs (WF7/WF8).\n\nMeasured and target oil/water/gas production rates and facility constraints\n(separator pressures, temperatures) used as inputs to the GAP simulation per\nfield. Use to understand what the model assumed for a field on a given run\nand to diagnose input-driven discrepancies. Excludes simulation outputs (see\nFieldOutputs_Agent and NetworkOutputs_Field_Agent) and historical trends.\n\nUse for: Network Surveillance (WF7), Network Model Validation (WF8).\n\n@name Field Inputs (Agent)',
  );

export const FieldInputsSchema: z.ZodObject<Properties<FieldInputs>> = z
  .object({
    __typename: z.literal('FieldInputs').optional(),
    actualGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'actualGasInjection' in this 'FieldInputs' view."),
    actualGasInjectionRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'actualGasInjectionRate' in this 'FieldInputs' view."),
    actualGasProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'actualGasProduction' in this 'FieldInputs' view."),
    actualGasProductionRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'actualGasProductionRate' in this 'FieldInputs' view."),
    actualOilProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'actualOilProduction' in this 'FieldInputs' view."),
    actualOilProductionRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'actualOilProductionRate' in this 'FieldInputs' view."),
    actualWaterInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'actualWaterInjection' in this 'FieldInputs' view."),
    actualWaterInjectionRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'actualWaterInjectionRate' in this 'FieldInputs' view."),
    actualWaterProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'actualWaterProduction' in this 'FieldInputs' view."),
    actualWaterProductionRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'actualWaterProductionRate' in this 'FieldInputs' view."),
    ambientTemperature: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'ambientTemperature' in this 'FieldInputs' view."),
    associatedGasProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'associatedGasProduction' in this 'FieldInputs' view."),
    associatedGasProductionRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'associatedGasProductionRate' in this 'FieldInputs' view."),
    entityName: z
      .lazy(() => FieldSchema.nullish())
      .describe("Reference to the related 'Field' entity for this 'FieldInputs' row."),
    nonASRGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'nonASRGasInjection' in this 'FieldInputs' view."),
    nonASRGasInjectionRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'nonASRGasInjectionRate' in this 'FieldInputs' view."),
    nonAssociatedGasProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'nonAssociatedGasProduction' in this 'FieldInputs' view."),
    nonAssociatedGasProductionRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'nonAssociatedGasProductionRate' in this 'FieldInputs' view."),
    potentialGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialGasInjection' in this 'FieldInputs' view."),
    potentialGasProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialGasProduction' in this 'FieldInputs' view."),
    potentialOilProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialOilProduction' in this 'FieldInputs' view."),
    potentialWaterInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialWaterInjection' in this 'FieldInputs' view."),
    potentialWaterProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialWaterProduction' in this 'FieldInputs' view."),
    realTimeTotalOilProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'realTimeTotalOilProduction' in this 'FieldInputs' view."),
    targetGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetGasInjection' in this 'FieldInputs' view."),
    targetGasProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetGasProduction' in this 'FieldInputs' view."),
    targetOilProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetOilProduction' in this 'FieldInputs' view."),
    targetWaterInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetWaterInjection' in this 'FieldInputs' view."),
    targetWaterProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetWaterProduction' in this 'FieldInputs' view."),
  })
  .describe("View 'FieldInputs' in the iPSO production optimization solution data model.");

export const EventsStringSchema: z.ZodObject<Properties<EventsString>> = z
  .object({
    __typename: z.literal('Events_String').optional(),
    bottomholePressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'bottomholePressure' in this 'Events_String' view."),
    bottomholeTemperature: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'bottomholeTemperature' in this 'Events_String' view."),
    casingPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'casingPressure' in this 'Events_String' view."),
    chokeSize: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'chokeSize' in this 'Events_String' view."),
    chokeSizePct: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'chokeSizePct' in this 'Events_String' view."),
    currentStatus: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'currentStatus' in this 'Events_String' view."),
    downType: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'downType' in this 'Events_String' view."),
    entityName: z
      .lazy(() => StringAssetSchema.nullish())
      .describe("Reference to the related 'String_asset' entity for this 'Events_String' row."),
    eventDesc: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'eventDesc' in this 'Events_String' view."),
    eventReason: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'eventReason' in this 'Events_String' view."),
    eventStartDateTime: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'eventStartDateTime' in this 'Events_String' view."),
    gasInjRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gasInjRate' in this 'Events_String' view."),
    gasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gasRate' in this 'Events_String' view."),
    gor: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'gor' in this 'Events_String' view."),
    oilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'oilRate' in this 'Events_String' view."),
    producingMethod: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'producingMethod' in this 'Events_String' view."),
    producingMethodDesc: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'producingMethodDesc' in this 'Events_String' view."),
    producingStatus: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'producingStatus' in this 'Events_String' view."),
    producingStatusDesc: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'producingStatusDesc' in this 'Events_String' view."),
    remarks: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'remarks' in this 'Events_String' view."),
    statusCode: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'statusCode' in this 'Events_String' view."),
    stringFunction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'stringFunction' in this 'Events_String' view."),
    waterCut: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'waterCut' in this 'Events_String' view."),
    waterInjRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'waterInjRate' in this 'Events_String' view."),
    wellheadPressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellheadPressure' in this 'Events_String' view."),
    wellheadTemperature: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'wellheadTemperature' in this 'Events_String' view."),
  })
  .describe("View 'Events_String' in the iPSO production optimization solution data model.");

export const EstimatedRatesStringAgentSchema: z.ZodObject<Properties<EstimatedRatesStringAgent>> = z
  .object({
    __typename: z.literal('EstimatedRates_String_Agent').optional(),
    chokeAnalysisFbhp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Flowing bottom-hole pressure from choke analysis (psi, TS).'),
    chokeAnalysisGasRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Gas rate from choke equation analysis (MSCF/d, TS).'),
    chokeAnalysisLiquidRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Total liquid rate from choke equation analysis, oil + water (stb/d, TS).'),
    chokeAnalysisOilRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Oil rate from choke equation analysis (stb/d, TS).'),
    chokeAnalysisStatus: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Choke analysis calculation status. Values: SUCCESS, FAILED, CRITICAL_FLOW, SUBCRITICAL_FLOW.'),
    chokeAnalysisWaterRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Water rate from choke equation analysis (stb/d, TS).'),
    curveAnalysisFbhp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Flowing BHP from performance curve analysis (psi, TS).'),
    curveAnalysisGasRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Gas rate from performance curve analysis (MSCF/d, TS).'),
    curveAnalysisLiquidRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Total liquid rate from performance curve lookup (stb/d, TS).'),
    curveAnalysisOilRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Oil rate from performance curve lookup (stb/d, TS).'),
    curveAnalysisWaterRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Water rate from performance curve analysis (stb/d, TS).'),
    dataAnalysisFbhp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Flowing BHP from data-driven analysis / ML models (psi, TS).'),
    dataAnalysisGasRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Gas rate from data-driven analysis / ML models (MSCF/d, TS).'),
    dataAnalysisLiquidRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Total liquid rate from data-driven analysis / ML models (stb/d, TS).'),
    dataAnalysisOilRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Oil rate from data-driven analysis / ML models (stb/d, TS).'),
    dataAnalysisWaterRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Water rate from data-driven analysis / ML models (stb/d, TS).'),
    iprAnalysisFbhp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Flowing BHP used for IPR curve lookup (psi, TS).'),
    iprAnalysisGasRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Gas rate from IPR curve analysis (MSCF/d, TS).'),
    iprAnalysisLiquidRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Total liquid rate from IPR curve. Represents reservoir deliverability potential (stb/d, TS).'),
    iprAnalysisOilRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Oil rate from IPR curve at current reservoir/flowing conditions (stb/d, TS).'),
    iprAnalysisWaterRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Water rate from IPR curve analysis (stb/d, TS).'),
    pressureSource: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Source of the BHP value. Values: MEASURED (downhole gauge), CALCULATED (from WHP traverse), ESTIMATED (correlation).',
      ),
    priorityFbhp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Best-available flowing bottom-hole pressure from the priority method (psi, TS).'),
    priorityGasRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Best-available estimated gas rate from the priority analysis method (MSCF/d, TS).'),
    priorityLiquidRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Best-available estimated total liquid rate, oil + water (stb/d, TS).'),
    priorityMethod: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Analysis method that produced the priority rates. Values: SYSTEM_ANALYSIS, CHOKE_ANALYSIS, ALLOCATION, WELL_TEST, DATA_ANALYSIS.',
      ),
    priorityOilRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Best-available estimated oil rate from the priority analysis method (stb/d, TS).'),
    priorityWaterRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Best-available estimated water rate from the priority analysis method (stb/d, TS).'),
    reservoirPressureDatum: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Current reservoir pressure at datum depth (psi, TS).'),
    reservoirPressureMidPerforation: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Reservoir pressure corrected to mid-perforation depth. Used directly in IPR calculations (psi, TS).'),
    systemAnalysisFbhp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Flowing bottom-hole pressure from system analysis (psi, TS).'),
    systemAnalysisGasRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Gas rate from IPR/VLP system analysis (MSCF/d, TS).'),
    systemAnalysisLiquidRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Total liquid rate from IPR/VLP system analysis, oil + water (stb/d, TS).'),
    systemAnalysisOilRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Oil rate from IPR/VLP system analysis (stb/d, TS).'),
    systemAnalysisStatus: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('System analysis calculation status. Values: SUCCESS, FAILED, NO_INTERSECTION, INVALID_INPUT.'),
    systemAnalysisWaterRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Water rate from IPR/VLP system analysis (stb/d, TS).'),
    vlpAnalysisFbhp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Flowing BHP from VLP curve at current rate and WHP (psi, TS).'),
    vlpAnalysisGasRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Gas rate from VLP curve analysis (MSCF/d, TS).'),
    vlpAnalysisLiquidRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Total liquid rate from VLP curve. Represents tubing hydraulic capacity (stb/d, TS).'),
    vlpAnalysisOilRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Oil rate from VLP curve at current tubing/separator conditions (stb/d, TS).'),
    vlpAnalysisWaterRateStd: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Water rate from VLP curve analysis (stb/d, TS).'),
    wellString: z.lazy(() => StringAssetSchema.nullish()).describe('Well string identifier.'),
  })
  .describe(
    'All estimated rates and BHP per well string across every estimation method.\n\nFor simple rate lookups use PriorityRates_String_Agent. Use this view when\ncomparing estimation methods. Exposes priority, system analysis (IPR+VLP),\nchoke, IPR-only, VLP-only, performance curve, and data-driven/ML. For\nperformance scores and analysis status see RateDiagnostics_String_Agent.\n\nUse for: comparing estimation methods (WF10).\n\n@name Estimated Rates - Well String (Agent)',
  );

export const EspMeasurementsStringAgentSchema: z.ZodObject<Properties<EspMeasurementsStringAgent>> = z
  .object({
    __typename: z.literal('ESPMeasurements_String_Agent').optional(),
    annulusPress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Annulus pressure (psia, TS). Difference from casingHeadPress can indicate tubing leaks.'),
    bottomHolePress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Bottom-hole flowing pressure (psia, TS). Used to calculate drawdown and\ncompare to reservoir pressure for productivity analysis.',
      ),
    bottomHoleTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Bottom-hole temperature (°F, TS). Important for PVT and pump performance calculations.'),
    casingHeadPress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Casing head pressure (psia, TS). Surface annulus pressure; useful for well integrity and flow context.',
      ),
    chokeOpening: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Production choke opening (% or 64ths, TS). Affects backpressure on well and ESP discharge.'),
    chokeSize: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Choke size (64ths or mm, TS). With wellhead pressure defines backpressure and rate.'),
    flowLinePress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Flowline pressure (psia, TS). Downstream backpressure on ESP; high value can indicate restriction or manifold pressure.',
      ),
    flowLineTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Flowline temperature (°F, TS). Surface fluid temp; compare to wellHeadTemp for heat loss.'),
    liftType: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Artificial lift type (TS). Confirm value = ESP before querying ESP-specific diagnostics.'),
    pumpCurrent: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Motor current draw (amps, TS). Indicates motor loading. Compare to\nespMaxMotorAmps limit — overload causes overheating and potential failure.',
      ),
    pumpDischargePress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Pressure at pump discharge (psia, TS). Differential with intake shows pump\nhead. Compare to espMaxDischargePressure limit.',
      ),
    pumpDischargeTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Temperature at pump discharge (°F, TS). High delta-T (discharge - intake)\nmay indicate low flow. Compare to espMaxPumpDeltaTemp.',
      ),
    pumpFrequency: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'ESP pump operating frequency (Hz, TS). Controlled by VSD. Compare to design\nfrequency for speed-related diagnostics.',
      ),
    pumpIntakePress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Pressure at pump intake (psia, TS). Low intake pressure may indicate gas\ninterference or upthrust condition. Compare to espMinIntakePressure limit.',
      ),
    pumpIntakeTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Temperature at pump intake (°F, TS). Fluid cools the motor — low temp with high motor temp indicates poor cooling.',
      ),
    pumpMotorTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'ESP motor winding temperature (°F, TS). CRITICAL for motor protection.\nCompare to espMaxMotorTemp limit — exceeding causes insulation damage.',
      ),
    pumpVibration: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Vibration sensor reading (TS). High vibration indicates mechanical issues:\nworn bearings, shaft misalignment, or gas slugging through pump.',
      ),
    pumpVoltage: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Surface voltage supplied to ESP (volts, TS). Low voltage causes high current and overheating.'),
    wellHeadPress: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Flowing wellhead pressure (psia, TS). Tubing head pressure; compare with intake/discharge for pump head.',
      ),
    wellHeadTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Flowing wellhead temperature (°F, TS). Surface fluid temp; useful for flow assurance and pump cooling context.',
      ),
    wellString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe('Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context.'),
  })
  .describe(
    'Real-time ESP sensor readings per well string (WF12).\n\nLive measurements: pump frequency, intake/discharge pressures and temperatures,\nmotor current, voltage, vibration, downhole BHP/BHT. Use to monitor pump health\nand compare against ESPLimits_String_Agent. For calculated outputs see ESPCalculations_String_Agent.\n\nUse for: ESP and Motor Performance and Diagnostics (WF12).\n\n@name ESP Measurements - Well String (Agent)',
  );

export const EspLimitsStringAgentSchema: z.ZodObject<Properties<EspLimitsStringAgent>> = z
  .object({
    __typename: z.literal('ESPLimits_String_Agent').optional(),
    asphalteneRisk: z.boolean().nullish().describe('Asphaltene deposition risk flag or score for this well string.'),
    espMaxDischargePressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Maximum discharge pressure limit (psia, TS). Exceeding may cause mechanical overload.'),
    espMaxFluidRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Maximum fluid rate pump can handle (stb/d, TS). Above this, pump\nexperiences upthrust and shaft wear.',
      ),
    espMaxFreeGasInPump: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Maximum free gas the pump can tolerate (%, TS). High gas causes gas\nlocking and damage — use gas separator if exceeded.',
      ),
    espMaxHead: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Maximum head the pump can develop (ft, TS). Exceeding causes mechanical overload.'),
    espMaxMotorAmps: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Maximum allowable motor current (amps, TS). When pumpCurrent exceeds this,\nmotor is overloaded — indicates undersized pump or high head conditions.',
      ),
    espMaxMotorAmps_active: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Boolean flag — espMaxMotorAmps limit is actively monitored for alarms.'),
    espMaxMotorPwr: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Maximum motor power limit (HP or kW, TS). Used to size VSD and cables.'),
    espMaxMotorTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Maximum allowable motor temperature (°F, TS). When pumpMotorTemp exceeds\nthis, motor damage risk is high. Critical alarm threshold.',
      ),
    espMaxMotorTemp_active: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Boolean flag — espMaxMotorTemp limit is actively monitored for alarms.'),
    espMaxPumpDeltaTemp: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Maximum temperature rise across pump (°F, TS). High delta-T indicates low\nflow — motor not adequately cooled by fluid.',
      ),
    espMinFluidRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Minimum fluid rate for stable operation (stb/d, TS). Below this, pump may\nexperience downthrust and motor overheating.',
      ),
    espMinIntakePressure: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Minimum intake pressure limit (psia, TS). Below this, gas breakout causes\ncavitation and pump damage. Critical operating limit.',
      ),
    espMinIntakePressure_active: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Boolean flag — espMinIntakePressure limit is actively monitored for alarms.'),
    fluidVelocity: z
      .boolean()
      .nullish()
      .describe('Fluid velocity limit or reference value (ft/s, TS). Used for erosion and flow assurance checks.'),
    hydrateRisk: z.boolean().nullish().describe('Hydrate formation risk flag or score for this well string.'),
    maxGOR: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Maximum GOR limit (scf/stb, TS). High GOR may indicate gas breakthrough or lift issues.'),
    maxLiquidRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Maximum liquid rate limit (stb/d, TS). Facility or well capacity constraint.'),
    maxOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Maximum oil rate limit (stb/d, TS). Allocation or facility constraint.'),
    pe5StabilityCriteria: z.boolean().nullish().describe('PE5 flow stability criteria threshold for this well string.'),
    waxRisk: z.boolean().nullish().describe('Wax deposition risk flag or score for this well string.'),
    wellString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe('Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context.'),
  })
  .describe(
    'ESP operating limit thresholds per well string (WF12).\n\nEngineering limits: motor temp/current/power, pump delta-T, fluid rates,\nintake/discharge pressures, head, free gas tolerance, monitoring flags.\nCompare against ESPMeasurements_String_Agent for limit exceedances. For gas lift use GasLiftLimits_String_Agent.\n\nUse for: ESP and Motor Performance and Diagnostics (WF12).\n\n@name ESP Operating Limits - Well String (Agent)',
  );

export const EspCalculationsStringAgentSchema: z.ZodObject<Properties<EspCalculationsStringAgent>> = z
  .object({
    __typename: z.literal('ESPCalculations_String_Agent').optional(),
    espqlAnalysisStatus: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Status of ESP rate calculation. Values: SUCCESS, FAILED, NO_DATA. Check before using ESP-derived outputs.',
      ),
    motorEfficiency: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'ESP motor efficiency (%, TS). Ratio of hydraulic power output to electrical\npower input. Declining trend may indicate motor degradation.',
      ),
    motorLoad: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'ESP motor load (%, TS). Current electrical load as percentage of rated\ncapacity. High values indicate operating near limits.',
      ),
    pumpAvgRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Average pump rate (stb/d, TS) over the calculation period.'),
    pumpHead: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'ESP pump head (ft, TS). Pressure increase provided by the pump. Compare\nto pump curve to assess operating point and efficiency.',
      ),
    wellString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe('Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context.'),
  })
  .describe(
    'Model-calculated ESP performance outputs per well string (WF12).\n\nMotor efficiency and load, pump head, average pump rate, calculation status.\nUse with ESPMeasurements_String_Agent and ESPLimits_String_Agent for full ESP diagnostics.\n\nUse for: ESP and Motor Performance and Diagnostics (WF12).\n\n@name ESP Calculations - Well String (Agent)',
  );

export const DataDrivenRatesStringAgentSchema: z.ZodObject<Properties<DataDrivenRatesStringAgent>> = z
  .object({
    __typename: z.literal('DataDrivenRates_String_Agent').optional(),
    dataDrivenGasRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
    dataDrivenLiquidRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
    dataDrivenOilRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
    dataDrivenWaterRateStd: z.lazy(() => TimeSeriesSchema.nullish()),
    giBHPCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
    giTargetRateCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
    giTechnicalRateCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
    giWHPCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
    wellString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe('Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context.'),
    wiBHPCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
    wiTargetRateCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
    wiTechnicalRateCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
    wiWHPCompliance: z.lazy(() => TimeSeriesSchema.nullish()),
  })
  .describe(
    'Data-driven and ML rate estimates with injection compliance per well string (WF10).\n\nProperties from WellOutputs_Ext_1_String. ML-derived oil, gas, water, liquid\nrates and injector compliance. Use when querying ML outputs or injector compliance. For physics-based and priority rates use EstimatedRates_String_Agent.\n\nUse for: Real-Time Well Rate and Pressure Estimation (WF10).\n\n@name Data-Driven Rates - String (Agent)',
  );

export const DailyRollupReservoirAgentSchema: z.ZodObject<Properties<DailyRollupReservoirAgent>> = z
  .object({
    __typename: z.literal('DailyRollupReservoir_Agent').optional(),
    dayAllocInjGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated gas injection volume (Sm3). Reservoir total.'),
    dayAllocInjGasInjectionRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated gas injection rate (Sm3/d).'),
    dayAllocInjWaterInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated water injection volume (Sm3). Reservoir total.'),
    dayAllocInjWaterInjectionRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated water injection rate (Sm3/d).'),
    dayAllocProdAllocatedGas: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated gas production volume (Sm3). Reservoir total.'),
    dayAllocProdAllocatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated gas production rate (Sm3/d).'),
    dayAllocProdAllocatedOil: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated oil production volume (Sm3). Reservoir total.'),
    dayAllocProdAllocatedOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated oil production rate (Sm3/d or bbl/d).'),
    dayAllocProdAllocatedWater: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated water production volume (Sm3). Reservoir total.'),
    dayAllocProdAllocatedWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated water production rate (Sm3/d).'),
    potentialGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Unconstrained gas injection potential. For injection performance.'),
    potentialGasProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Unconstrained gas production potential. Performance benchmark.'),
    potentialOilProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Unconstrained oil production potential. Performance benchmark.'),
    potentialWaterInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Unconstrained water injection potential. For injection performance.'),
    potentialWaterProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Unconstrained water production potential. Performance benchmark.'),
    reservoirEntity: z
      .lazy(() => ReservoirSchema.nullish())
      .describe('Reference to reservoir. Join to FlatHierarchy_Agent for field/asset context.'),
    targetGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Target gas injection from planning. For gap analysis.'),
    targetGasProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Target gas production from planning. For gap analysis.'),
    targetOilproduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Target oil production from planning. For gap analysis.'),
    targetWaterInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Target water injection from planning. For gap analysis.'),
    targetWaterProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Target water production from planning. For gap analysis.'),
  })
  .describe(
    'Reservoir-level daily rollup of allocated oil, gas, and water production and injection volumes, rates, and targets.',
  );

export const DailyRollupOutputWellSchema: z.ZodObject<Properties<DailyRollupOutputWell>> = z
  .object({
    __typename: z.literal('DailyRollupOutput_Well').optional(),
    dayAllocInjGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'dayAllocInjGasInjection' in this 'DailyRollupOutput_Well' view."),
    dayAllocInjGasInjectionRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'dayAllocInjGasInjectionRate' in this 'DailyRollupOutput_Well' view."),
    dayAllocInjWaterInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'dayAllocInjWaterInjection' in this 'DailyRollupOutput_Well' view."),
    dayAllocInjWaterInjectionRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'dayAllocInjWaterInjectionRate' in this 'DailyRollupOutput_Well' view.",
      ),
    dayAllocProdAllocatedGas: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series of allocated gas production volume for the well.'),
    dayAllocProdAllocatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series of average allocated gas production rate for the well.'),
    dayAllocProdAllocatedOil: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series of allocated oil production volume for the well.'),
    dayAllocProdAllocatedOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series of average allocated oil production rate for the well.'),
    dayAllocProdAllocatedWater: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series of allocated water production volume for the well.'),
    dayAllocProdAllocatedWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series of average allocated water production rate for the well.'),
    entityName: z
      .lazy(() => WellSchema.nullish())
      .describe('Well name for which daily allocated production and injection rollups are reported in this view.'),
    potentialGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialGasInjection' in this 'DailyRollupOutput_Well' view."),
    potentialGasProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialGasProduction' in this 'DailyRollupOutput_Well' view."),
    potentialOilProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialOilProduction' in this 'DailyRollupOutput_Well' view."),
    potentialWaterInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialWaterInjection' in this 'DailyRollupOutput_Well' view."),
    potentialWaterProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialWaterProduction' in this 'DailyRollupOutput_Well' view."),
    targetGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetGasInjection' in this 'DailyRollupOutput_Well' view."),
    targetGasProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetGasProduction' in this 'DailyRollupOutput_Well' view."),
    targetOilproduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetOilproduction' in this 'DailyRollupOutput_Well' view."),
    targetWaterInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetWaterInjection' in this 'DailyRollupOutput_Well' view."),
    targetWaterProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetWaterProduction' in this 'DailyRollupOutput_Well' view."),
  })
  .describe(
    'Well-level daily rollup of allocated production and injection, including daily oil, gas and water volumes and rates, as well as potential versus target production and injection used for individual well performance tracking.',
  );

export const DailyRollupOutputReservoirSchema: z.ZodObject<Properties<DailyRollupOutputReservoir>> = z
  .object({
    __typename: z.literal('DailyRollupOutput_Reservoir').optional(),
    dayAllocInjGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'dayAllocInjGasInjection' in this 'DailyRollupOutput_Reservoir' view."),
    dayAllocInjGasInjectionRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'dayAllocInjGasInjectionRate' in this 'DailyRollupOutput_Reservoir' view.",
      ),
    dayAllocInjWaterInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'dayAllocInjWaterInjection' in this 'DailyRollupOutput_Reservoir' view.",
      ),
    dayAllocInjWaterInjectionRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'dayAllocInjWaterInjectionRate' in this 'DailyRollupOutput_Reservoir' view.",
      ),
    dayAllocProdAllocatedGas: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series of total allocated gas production volume for the reservoir.'),
    dayAllocProdAllocatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series of average allocated gas production rate for the reservoir.'),
    dayAllocProdAllocatedOil: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series of total allocated oil production volume for the reservoir.'),
    dayAllocProdAllocatedOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series of average allocated oil production rate for the reservoir.'),
    dayAllocProdAllocatedWater: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series of total allocated water production volume for the reservoir.'),
    dayAllocProdAllocatedWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series of average allocated water production rate for the reservoir.'),
    entityName: z
      .lazy(() => ReservoirSchema.nullish())
      .describe('Reservoir name for which daily allocated production and injection rollups are reported in this view.'),
    potentialGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialGasInjection' in this 'DailyRollupOutput_Reservoir' view."),
    potentialGasProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialGasProduction' in this 'DailyRollupOutput_Reservoir' view."),
    potentialOilProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialOilProduction' in this 'DailyRollupOutput_Reservoir' view."),
    potentialWaterInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialWaterInjection' in this 'DailyRollupOutput_Reservoir' view."),
    potentialWaterProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'potentialWaterProduction' in this 'DailyRollupOutput_Reservoir' view.",
      ),
    targetGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetGasInjection' in this 'DailyRollupOutput_Reservoir' view."),
    targetGasProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetGasProduction' in this 'DailyRollupOutput_Reservoir' view."),
    targetOilproduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetOilproduction' in this 'DailyRollupOutput_Reservoir' view."),
    targetWaterInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetWaterInjection' in this 'DailyRollupOutput_Reservoir' view."),
    targetWaterProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetWaterProduction' in this 'DailyRollupOutput_Reservoir' view."),
  })
  .describe(
    'Reservoir-level daily rollup of allocated production and injection, including daily oil, gas and water volumes and rates, as well as potential versus target production and injection used for reservoir performance tracking.',
  );

export const DailyRollupOutputLocationSchema: z.ZodObject<Properties<DailyRollupOutputLocation>> = z
  .object({
    __typename: z.literal('DailyRollupOutput_Location').optional(),
    dayAllocInjGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'dayAllocInjGasInjection' in this 'DailyRollupOutput_Location' view."),
    dayAllocInjGasInjectionRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'dayAllocInjGasInjectionRate' in this 'DailyRollupOutput_Location' view.",
      ),
    dayAllocInjWaterInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'dayAllocInjWaterInjection' in this 'DailyRollupOutput_Location' view.",
      ),
    dayAllocInjWaterInjectionRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'dayAllocInjWaterInjectionRate' in this 'DailyRollupOutput_Location' view.",
      ),
    dayAllocProdAllocatedGas: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series of allocated gas production volume for the location.'),
    dayAllocProdAllocatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series of average allocated gas production rate for the location.'),
    dayAllocProdAllocatedOil: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series of allocated oil production volume for the location.'),
    dayAllocProdAllocatedOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series of average allocated oil production rate for the location.'),
    dayAllocProdAllocatedWater: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series of allocated water production volume for the location.'),
    dayAllocProdAllocatedWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series of average allocated water production rate for the location.'),
    entityName: z
      .lazy(() => LocationSchema.nullish())
      .describe(
        'Location name (facility or network node) for which daily allocated production and injection rollups are reported in this view.',
      ),
    potentialGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialGasInjection' in this 'DailyRollupOutput_Location' view."),
    potentialGasProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialGasProduction' in this 'DailyRollupOutput_Location' view."),
    potentialOilProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialOilProduction' in this 'DailyRollupOutput_Location' view."),
    potentialWaterInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialWaterInjection' in this 'DailyRollupOutput_Location' view."),
    potentialWaterProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialWaterProduction' in this 'DailyRollupOutput_Location' view."),
    targetGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetGasInjection' in this 'DailyRollupOutput_Location' view."),
    targetGasProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetGasProduction' in this 'DailyRollupOutput_Location' view."),
    targetOilproduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetOilproduction' in this 'DailyRollupOutput_Location' view."),
    targetWaterInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetWaterInjection' in this 'DailyRollupOutput_Location' view."),
    targetWaterProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetWaterProduction' in this 'DailyRollupOutput_Location' view."),
  })
  .describe(
    'Location-level daily rollup of allocated production and injection, including daily oil, gas and water volumes and rates, as well as potential versus target production and injection used for facility or network node performance tracking.',
  );

export const DailyRollupOutputFieldSchema: z.ZodObject<Properties<DailyRollupOutputField>> = z
  .object({
    __typename: z.literal('DailyRollupOutput_Field').optional(),
    dayAllocInjGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'dayAllocInjGasInjection' in this 'DailyRollupOutput_Field' view."),
    dayAllocInjGasInjectionRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'dayAllocInjGasInjectionRate' in this 'DailyRollupOutput_Field' view."),
    dayAllocInjWaterInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'dayAllocInjWaterInjection' in this 'DailyRollupOutput_Field' view."),
    dayAllocInjWaterInjectionRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'dayAllocInjWaterInjectionRate' in this 'DailyRollupOutput_Field' view.",
      ),
    dayAllocProdAllocatedGas: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series of total allocated gas production volume for the field.'),
    dayAllocProdAllocatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series of average allocated gas production rate for the field.'),
    dayAllocProdAllocatedOil: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series of total allocated oil production volume for the field.'),
    dayAllocProdAllocatedOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series of average allocated oil production rate for the field.'),
    dayAllocProdAllocatedWater: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series of total allocated water production volume for the field.'),
    dayAllocProdAllocatedWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series of average allocated water production rate for the field.'),
    entityName: z
      .lazy(() => FieldSchema.nullish())
      .describe('Field name for which daily allocated production and injection rollups are reported in this view.'),
    potentialGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialGasInjection' in this 'DailyRollupOutput_Field' view."),
    potentialGasProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialGasProduction' in this 'DailyRollupOutput_Field' view."),
    potentialOilProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialOilProduction' in this 'DailyRollupOutput_Field' view."),
    potentialWaterInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialWaterInjection' in this 'DailyRollupOutput_Field' view."),
    potentialWaterProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialWaterProduction' in this 'DailyRollupOutput_Field' view."),
    targetGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetGasInjection' in this 'DailyRollupOutput_Field' view."),
    targetGasProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetGasProduction' in this 'DailyRollupOutput_Field' view."),
    targetOilproduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetOilproduction' in this 'DailyRollupOutput_Field' view."),
    targetWaterInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetWaterInjection' in this 'DailyRollupOutput_Field' view."),
    targetWaterProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetWaterProduction' in this 'DailyRollupOutput_Field' view."),
  })
  .describe(
    'Field-level daily rollup of allocated production and injection, including daily oil, gas and water volumes and rates, as well as potential versus target production and injection used for field performance tracking.',
  );

export const DailyRollupOutputCompanySchema: z.ZodObject<Properties<DailyRollupOutputCompany>> = z
  .object({
    __typename: z.literal('DailyRollupOutput_Company').optional(),
    dayAllocInjGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'dayAllocInjGasInjection' in this 'DailyRollupOutput_Company' view."),
    dayAllocInjGasInjectionRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'dayAllocInjGasInjectionRate' in this 'DailyRollupOutput_Company' view.",
      ),
    dayAllocInjWaterInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'dayAllocInjWaterInjection' in this 'DailyRollupOutput_Company' view."),
    dayAllocInjWaterInjectionRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'dayAllocInjWaterInjectionRate' in this 'DailyRollupOutput_Company' view.",
      ),
    dayAllocProdAllocatedGas: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series of total allocated gas production volume for the company.'),
    dayAllocProdAllocatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series of average allocated gas production rate for the company.'),
    dayAllocProdAllocatedOil: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series of total allocated oil production volume for the company.'),
    dayAllocProdAllocatedOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series of average allocated oil production rate for the company.'),
    dayAllocProdAllocatedWater: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series of total allocated water production volume for the company.'),
    dayAllocProdAllocatedWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series of average allocated water production rate for the company.'),
    entityName: z
      .lazy(() => CompanySchema.nullish())
      .describe('Company name for which daily allocated production and injection rollups are reported in this view.'),
    potentialGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialGasInjection' in this 'DailyRollupOutput_Company' view."),
    potentialGasProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialGasProduction' in this 'DailyRollupOutput_Company' view."),
    potentialOilProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialOilProduction' in this 'DailyRollupOutput_Company' view."),
    potentialWaterInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialWaterInjection' in this 'DailyRollupOutput_Company' view."),
    potentialWaterProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialWaterProduction' in this 'DailyRollupOutput_Company' view."),
    targetGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetGasInjection' in this 'DailyRollupOutput_Company' view."),
    targetGasProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetGasProduction' in this 'DailyRollupOutput_Company' view."),
    targetOilproduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetOilproduction' in this 'DailyRollupOutput_Company' view."),
    targetWaterInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetWaterInjection' in this 'DailyRollupOutput_Company' view."),
    targetWaterProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetWaterProduction' in this 'DailyRollupOutput_Company' view."),
  })
  .describe(
    'Company-level daily rollup of allocated production and injection, including daily oil, gas and water volumes and rates, as well as potential versus target production and injection used for corporate performance tracking.',
  );

export const DailyRollupOutputAssetSchema: z.ZodObject<Properties<DailyRollupOutputAsset>> = z
  .object({
    __typename: z.literal('DailyRollupOutput_Asset').optional(),
    dayAllocInjGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'dayAllocInjGasInjection' in this 'DailyRollupOutput_Asset' view."),
    dayAllocInjGasInjectionRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'dayAllocInjGasInjectionRate' in this 'DailyRollupOutput_Asset' view."),
    dayAllocInjWaterInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'dayAllocInjWaterInjection' in this 'DailyRollupOutput_Asset' view."),
    dayAllocInjWaterInjectionRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Reference to a time series for 'dayAllocInjWaterInjectionRate' in this 'DailyRollupOutput_Asset' view.",
      ),
    dayAllocProdAllocatedGas: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series of total allocated gas production volume for the asset.'),
    dayAllocProdAllocatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series of average allocated gas production rate for the asset.'),
    dayAllocProdAllocatedOil: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series of total allocated oil production volume for the asset.'),
    dayAllocProdAllocatedOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series of average allocated oil production rate for the asset.'),
    dayAllocProdAllocatedWater: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series of total allocated water production volume for the asset.'),
    dayAllocProdAllocatedWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series of average allocated water production rate for the asset.'),
    entityName: z
      .lazy(() => AssetSchema.nullish())
      .describe('Asset name for which daily allocated production and injection rollups are reported in this view.'),
    potentialGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialGasInjection' in this 'DailyRollupOutput_Asset' view."),
    potentialGasProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialGasProduction' in this 'DailyRollupOutput_Asset' view."),
    potentialOilProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialOilProduction' in this 'DailyRollupOutput_Asset' view."),
    potentialWaterInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialWaterInjection' in this 'DailyRollupOutput_Asset' view."),
    potentialWaterProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'potentialWaterProduction' in this 'DailyRollupOutput_Asset' view."),
    targetGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetGasInjection' in this 'DailyRollupOutput_Asset' view."),
    targetGasProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetGasProduction' in this 'DailyRollupOutput_Asset' view."),
    targetOilproduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetOilproduction' in this 'DailyRollupOutput_Asset' view."),
    targetWaterInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetWaterInjection' in this 'DailyRollupOutput_Asset' view."),
    targetWaterProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe("Reference to a time series for 'targetWaterProduction' in this 'DailyRollupOutput_Asset' view."),
  })
  .describe(
    'Asset-level daily rollup of allocated production and injection, including daily oil, gas and water volumes and rates, as well as potential versus target production and injection used for asset performance tracking.',
  );

export const DailyRollupLocationAgentSchema: z.ZodObject<Properties<DailyRollupLocationAgent>> = z
  .object({
    __typename: z.literal('DailyRollupLocation_Agent').optional(),
    dayAllocInjGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated gas injection volume (Sm3). Location total.'),
    dayAllocInjGasInjectionRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated gas injection rate (Sm3/d).'),
    dayAllocInjWaterInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated water injection volume (Sm3). Location total.'),
    dayAllocInjWaterInjectionRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated water injection rate (Sm3/d).'),
    dayAllocProdAllocatedGas: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated gas production volume (Sm3). Location total.'),
    dayAllocProdAllocatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated gas production rate (Sm3/d).'),
    dayAllocProdAllocatedOil: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated oil production volume (Sm3). Location total.'),
    dayAllocProdAllocatedOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated oil production rate (Sm3/d or bbl/d).'),
    dayAllocProdAllocatedWater: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated water production volume (Sm3). Location total.'),
    dayAllocProdAllocatedWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated water production rate (Sm3/d).'),
    locationEntity: z
      .lazy(() => LocationSchema.nullish())
      .describe(
        'Reference to location (facility or network node). Join to FlatHierarchy_Agent for field/asset context.',
      ),
    potentialGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Unconstrained gas injection potential. For injection performance.'),
    potentialGasProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Unconstrained gas production potential. Performance benchmark.'),
    potentialOilProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Unconstrained oil production potential. Performance benchmark.'),
    potentialWaterInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Unconstrained water injection potential. For injection performance.'),
    potentialWaterProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Unconstrained water production potential. Performance benchmark.'),
    targetGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Target gas injection from planning. For gap analysis.'),
    targetGasProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Target gas production from planning. For gap analysis.'),
    targetOilproduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Target oil production from planning. For gap analysis.'),
    targetWaterInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Target water injection from planning. For gap analysis.'),
    targetWaterProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Target water production from planning. For gap analysis.'),
  })
  .describe(
    'Location-level daily rollup of allocated oil, gas, and water production and injection volumes, rates, and targets.',
  );

export const DailyRollupFieldAgentSchema: z.ZodObject<Properties<DailyRollupFieldAgent>> = z
  .object({
    __typename: z.literal('DailyRollupField_Agent').optional(),
    dayAllocInjGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated gas injection volume (Sm3). Field total.'),
    dayAllocInjGasInjectionRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated gas injection rate (Sm3/d).'),
    dayAllocInjWaterInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated water injection volume (Sm3). Field total.'),
    dayAllocInjWaterInjectionRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated water injection rate (Sm3/d).'),
    dayAllocProdAllocatedGas: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated gas production volume (Sm3). Field total.'),
    dayAllocProdAllocatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated gas production rate (Sm3/d).'),
    dayAllocProdAllocatedOil: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated oil production volume (Sm3). Field total.'),
    dayAllocProdAllocatedOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated oil production rate (Sm3/d or bbl/d).'),
    dayAllocProdAllocatedWater: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated water production volume (Sm3). Field total.'),
    dayAllocProdAllocatedWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated water production rate (Sm3/d).'),
    fieldEntity: z
      .lazy(() => FieldSchema.nullish())
      .describe('Reference to field. Join to FlatHierarchy_Agent for reservoir/sector context.'),
    potentialGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Unconstrained gas injection potential. For injection performance.'),
    potentialGasProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Unconstrained gas production potential. Performance benchmark.'),
    potentialOilProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Unconstrained oil production potential. Performance benchmark.'),
    potentialWaterInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Unconstrained water injection potential. For injection performance.'),
    potentialWaterProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Unconstrained water production potential. Performance benchmark.'),
    targetGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Target gas injection from planning. For gap analysis.'),
    targetGasProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Target gas production from planning. For gap analysis.'),
    targetOilproduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Target oil production from planning. For gap analysis.'),
    targetWaterInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Target water injection from planning. For gap analysis.'),
    targetWaterProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Target water production from planning. For gap analysis.'),
  })
  .describe(
    'Field-level daily rollup of allocated oil, gas, and water production and injection volumes, rates, and targets.',
  );

export const DailyRollupCompanyAgentSchema: z.ZodObject<Properties<DailyRollupCompanyAgent>> = z
  .object({
    __typename: z.literal('DailyRollupCompany_Agent').optional(),
    companyEntity: z
      .lazy(() => CompanySchema.nullish())
      .describe('Reference to company. Top of the hierarchy; join to FlatHierarchy_Agent for asset/field breakdown.'),
    dayAllocInjGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated gas injection volume (Sm3). Company total.'),
    dayAllocInjGasInjectionRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated gas injection rate (Sm3/d).'),
    dayAllocInjWaterInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated water injection volume (Sm3). Company total.'),
    dayAllocInjWaterInjectionRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated water injection rate (Sm3/d).'),
    dayAllocProdAllocatedGas: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated gas production volume (Sm3). Company total.'),
    dayAllocProdAllocatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated gas production rate (Sm3/d).'),
    dayAllocProdAllocatedOil: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated oil production volume (Sm3). Company total.'),
    dayAllocProdAllocatedOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated oil production rate (Sm3/d or bbl/d).'),
    dayAllocProdAllocatedWater: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated water production volume (Sm3). Company total.'),
    dayAllocProdAllocatedWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated water production rate (Sm3/d).'),
    potentialGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Unconstrained gas injection potential. For injection performance.'),
    potentialGasProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Unconstrained gas production potential. Performance benchmark.'),
    potentialOilProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Unconstrained oil production potential. Performance benchmark.'),
    potentialWaterInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Unconstrained water injection potential. For injection performance.'),
    potentialWaterProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Unconstrained water production potential. Performance benchmark.'),
    targetGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Target gas injection from planning. For gap analysis.'),
    targetGasProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Target gas production from planning. For gap analysis.'),
    targetOilproduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Target oil production from planning. For gap analysis.'),
    targetWaterInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Target water injection from planning. For gap analysis.'),
    targetWaterProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Target water production from planning. For gap analysis.'),
  })
  .describe(
    'Company-level daily rollup of allocated oil, gas, and water production and injection volumes, rates, and targets.',
  );

export const DailyRollupAssetAgentSchema: z.ZodObject<Properties<DailyRollupAssetAgent>> = z
  .object({
    __typename: z.literal('DailyRollupAsset_Agent').optional(),
    assetEntity: z
      .lazy(() => AssetSchema.nullish())
      .describe('Reference to asset. Join to FlatHierarchy_Agent for field/company context.'),
    dayAllocInjGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated gas injection volume (Sm3). Asset total.'),
    dayAllocInjGasInjectionRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated gas injection rate (Sm3/d).'),
    dayAllocInjWaterInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated water injection volume (Sm3). Asset total.'),
    dayAllocInjWaterInjectionRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated water injection rate (Sm3/d).'),
    dayAllocProdAllocatedGas: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated gas production volume (Sm3). Asset total.'),
    dayAllocProdAllocatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated gas production rate (Sm3/d).'),
    dayAllocProdAllocatedOil: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated oil production volume (Sm3). Asset total.'),
    dayAllocProdAllocatedOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated oil production rate (Sm3/d or bbl/d).'),
    dayAllocProdAllocatedWater: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated water production volume (Sm3). Asset total.'),
    dayAllocProdAllocatedWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated water production rate (Sm3/d).'),
    potentialGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Unconstrained gas injection potential. For injection performance.'),
    potentialGasProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Unconstrained gas production potential. Performance benchmark.'),
    potentialOilProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Unconstrained oil production potential. Performance benchmark.'),
    potentialWaterInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Unconstrained water injection potential. For injection performance.'),
    potentialWaterProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Unconstrained water production potential. Performance benchmark.'),
    targetGasInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Target gas injection from planning. For gap analysis.'),
    targetGasProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Target gas production from planning. For gap analysis.'),
    targetOilproduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Target oil production from planning. For gap analysis.'),
    targetWaterInjection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Target water injection from planning. For gap analysis.'),
    targetWaterProduction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Target water production from planning. For gap analysis.'),
  })
  .describe(
    'Asset-level daily rollup of allocated oil, gas, and water production and injection volumes, rates, and targets.',
  );

export const ChokeOutputsNetworkAgentSchema: z.ZodObject<Properties<ChokeOutputsNetworkAgent>> = z
  .object({
    __typename: z.literal('ChokeOutputs_Network_Agent').optional(),
    entityName: z.lazy(() => EntitySchema.nullish()).describe('Choke entity name.'),
    network: z.lazy(() => NetworkSchema.nullish()).describe('Reference to parent network model.'),
    nmvChokeSize: z.lazy(() => TimeSeriesSchema.nullish()).describe('Choke bean size (64ths inch, TS).'),
  })
  .describe(
    'Choke-level outputs from WF7 GAP network simulation (WF7/WF20).\n\nUpstream and downstream pressures, pressure differentials, flow regimes, and\noperating conditions per choke. Use for choke performance analysis, pressure\ndrop evaluation, and flow-regime assessment across operational scenarios.\nExcludes historical performance or maintenance records.\n\nUse for: Network Surveillance (WF7), Flow Assurance Detection and Mitigation (WF20).\n\n@name Choke Outputs - Network (Agent)',
  );

export const AllocationOutputStringSchema: z.ZodObject<Properties<AllocationOutputString>> = z
  .object({
    __typename: z.literal('AllocationOutput_String').optional(),
    allocInjActiveHours: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of hours this string was actively injecting during each allocation period.'),
    allocProdActiveHours: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of hours this string was actively producing during each allocation period.'),
    allocatedGasInjRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of allocated gas injection rate for this string at the allocation time resolution.'),
    allocatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of allocated gas production rate for this string at the allocation time resolution.'),
    allocatedOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of allocated oil production rate for this string at the allocation time resolution.'),
    allocatedWaterInjRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of allocated water injection rate for this string at the allocation time resolution.'),
    allocatedWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Time series of allocated water production rate for this string at the allocation time resolution.'),
    entityName: z
      .lazy(() => StringAssetSchema.nullish())
      .describe(
        "Name of the well string (completion) whose instantaneous allocation outputs are represented in this view, sourced from the 'String_asset' view.",
      ),
  })
  .describe(
    'Instantaneous allocation outputs for each well string, including allocated oil, gas and water production rates, associated injection rates and active hours used in the production and injection allocation process.',
  );

export const AllocationFactorsFieldAgentSchema: z.ZodObject<Properties<AllocationFactorsFieldAgent>> = z
  .object({
    __typename: z.literal('AllocationFactors_Field_Agent').optional(),
    field: z
      .lazy(() => FieldSchema.nullish())
      .describe('Reference to field. Use for Field scope and to join to hierarchy views.'),
    gasInjectionAllocationFactor: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Gas injection allocation factor for this field (fraction, TS).\nUse for "Show injection gas Allocation Factor trend" over Day/Week/Month/Quarter/Year.',
      ),
    preferredVFMAssociatedGasAllocationFactor: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Associated gas production allocation factor for this field (fraction, TS). Preferred VFM method.\nUse for "Show associated gas Allocation Factor trend" over Day/Week/Month/Quarter/Year.',
      ),
    preferredVFMNonAssociatedGasAllocationFactor: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Non-associated gas production allocation factor for this field (fraction, TS). Preferred VFM method.\nUse for "Show non associated gas Allocation Factor trend" over Day/Week/Month/Quarter/Year.',
      ),
    preferredVFMOilAllocationFactor: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Oil production allocation factor for this field (fraction, TS). Preferred VFM method.\nUse for "Show oil Allocation Factor trend" over Day/Week/Month/Quarter/Year.',
      ),
    preferredVFMWaterAllocationFactor: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Water production allocation factor for this field (fraction, TS). Preferred VFM method.\nUse for "Show water Allocation Factor trend" over Day/Week/Month/Quarter/Year.',
      ),
    waterInjectionAllocationFactor: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Water injection allocation factor for this field (fraction, TS).\nUse for "Show injection water Allocation Factor trend" over Day/Week/Month/Quarter/Year.',
      ),
    weightedAverageVFMAssociatedGasAllocationFactor: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Weighted average VFM associated gas allocation factor for this field (fraction, TS).'),
    weightedAverageVFMNonAssociatedGasAllocationFactor: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Weighted average VFM non-associated gas allocation factor for this field (fraction, TS).'),
    weightedAverageVFMOilAllocationFactor: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Weighted average VFM oil production allocation factor for this field (fraction, TS).'),
    weightedAverageVFMWaterAllocationFactor: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Weighted average VFM water allocation factor for this field (fraction, TS).'),
  })
  .describe(
    'Field-level allocation factor time series (WF5).\n\nVFM-based allocation factors for oil, assoc/non-assoc gas, water production, and gas/water injection at field level. Use for allocation factor trends by period and field/reservoir/sector. Use with FlatHierarchy_Agent or DailyRollupField_Agent for context.\n\nUse for: Production Allocation (WF5), Gas Lift Estimation and Allocation (WF13).\n\n@name Allocation Factors - Field (Agent)',
  );

export const AllocatedRatesVfmStringAgentSchema: z.ZodObject<Properties<AllocatedRatesVfmStringAgent>> = z
  .object({
    __typename: z.literal('AllocatedRates_VFM_String_Agent').optional(),
    averageGasInjectionRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Average gas injection rate (MSCF/d, TS).'),
    averageWaterInjectionRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Average water injection rate (stb/d, TS).'),
    oilProductionAllocationStatus: z.lazy(() => TimeSeriesSchema.nullish()).describe('Oil allocation workflow status.'),
    preferredVFMAverageAssociatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Preferred VFM method average associated gas rate (MSCF/d, TS).'),
    preferredVFMAverageNonAssociatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Preferred VFM method average non-associated gas rate (MSCF/d, TS).'),
    preferredVFMAverageOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Preferred VFM method average oil rate (stb/d, TS).'),
    preferredVFMAverageWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Preferred VFM method average water rate (stb/d, TS).'),
    preferredVFMDataSourceFlag: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Which VFM method was selected as preferred.'),
    preferredVFMEstimatedWellOilVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Estimated well oil volume from preferred VFM method (stb, TS).'),
    preferredVFMEstimatedWellWaterVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Estimated well water volume from preferred VFM method (stb, TS).'),
    vfmChokeAverageOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Choke analysis average oil rate (stb/d, TS).'),
    vfmDataDrivenAverageOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Data-driven model average oil rate (stb/d, TS).'),
    vfmESPAverageOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('ESP analysis average oil rate (stb/d, TS).'),
    vfmIPRAverageOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('IPR analysis average oil rate (stb/d, TS).'),
    vfmPreferredMethodAssociatedGasAllocationRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Allocated AG rate from preferred VFM method (MSCF/d, TS).'),
    vfmPreferredMethodNonAssociatedGasAllocationRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Allocated NAG rate from preferred VFM method (MSCF/d, TS).'),
    vfmPreferredMethodOilAllocationRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Allocated oil rate from preferred VFM method (stb/d, TS).'),
    vfmPreferredMethodWaterAllocationRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Allocated water rate from preferred VFM method (stb/d, TS).'),
    vfmSystemAnalysisAverageOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('System analysis average oil rate (stb/d, TS).'),
    vfmVLPAverageOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('VLP analysis average oil rate (stb/d, TS).'),
    vfmWeightedAverageAssociatedGasAllocationRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Allocated AG rate from weighted average method (MSCF/d, TS).'),
    vfmWeightedAverageMethodOilAllocationRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Allocated oil rate from weighted average method (stb/d, TS).'),
    vfmWeightedAverageNonAssociatedGasAllocationRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Allocated NAG rate from weighted average method (MSCF/d, TS).'),
    vfmWeightedAverageWaterAllocationRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Allocated water rate from weighted average method (stb/d, TS).'),
    weightedAverageDataSourceFlag: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Data source flag for weighted average method.'),
    weightedAverageVFMAssociatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Weighted average associated gas rate across VFM methods (MSCF/d, TS).'),
    weightedAverageVFMEstimatedWellOilVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Estimated oil volume from weighted average method (stb, TS).'),
    weightedAverageVFMNonAssociatedGasRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Weighted average non-associated gas rate (MSCF/d, TS).'),
    weightedAverageVFMOilRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Weighted average oil rate across all VFM methods (stb/d, TS).'),
    weightedAverageVFMWaterRate: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Weighted average water rate across VFM methods (stb/d, TS).'),
    wellString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe('Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context.'),
    wellUptime: z.lazy(() => TimeSeriesSchema.nullish()).describe('Well uptime hours in allocation period (hrs, TS).'),
  })
  .describe(
    'VFM-based allocation rates per well string from WF05 (WF5).\n\nPreferred and weighted-average VFM rates, per-method average oil rates. Use for\ncomparison of allocated rates across methods and preferred vs weighted average. Excludes raw production data.\n\nUse for: Production Allocation (WF5), Gas Lift Estimation and Allocation (WF13).\n\n@name Allocated Rates - VFM Reconciliation (Agent)',
  );

export const AllocatedRatesDailyStringAgentSchema: z.ZodObject<Properties<AllocatedRatesDailyStringAgent>> = z
  .object({
    __typename: z.literal('AllocatedRates_Daily_String_Agent').optional(),
    dayAllocProdActiveHours: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Number of hours (0-24) the string was actively producing during the day.\nUsed to calculate onstream efficiency.',
      ),
    dayAllocProdAllocatedGas: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated gas production volume (MSCF/d). Use for Day/Week time ranges.'),
    dayAllocProdAllocatedOil: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Daily allocated oil production volume (stb/d). Use for Day/Week time ranges.\nThis is the string's official allocated share of total metered oil.",
      ),
    dayAllocProdAllocatedWater: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Daily allocated water production volume (stb/d). Use for Day/Week time ranges.\nUsed for water cut analysis and water handling planning.',
      ),
    monthAllocProdActiveDays: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Number of days (0-31) the string was actively producing during the month.\nUsed to calculate monthly onstream efficiency.',
      ),
    monthAllocProdAllocatedGas: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Monthly allocated gas production volume (MSCF). Use for Month/Quarter/Year queries.\nSum of daily allocated gas for the calendar month.',
      ),
    monthAllocProdAllocatedOil: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Monthly allocated oil production volume (stb). Use for Month/Quarter/Year queries.\nSum of daily allocated oil for the calendar month.',
      ),
    monthAllocProdAllocatedWater: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Monthly allocated water production volume (stb). Use for Month/Quarter/Year queries.\nSum of daily allocated water for the calendar month.',
      ),
    wellString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe('Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context.'),
  })
  .describe(
    'Daily and monthly allocated production volumes per well string (WF5).\n\nAllocated oil, gas, water; active hours and days per string from reconciled\nmetered volumes. Use for production performance, uptime, and forecasting. For raw/unallocated data see other views.\n\nUse for: Production Allocation (WF5), Gas Lift Estimation and Allocation (WF13).\n\n@name Allocated Rates - Daily/Monthly (Agent)',
  );

export const AllocatedPropertiesStringSchema: z.ZodObject<Properties<AllocatedPropertiesString>> = z
  .object({
    __typename: z.literal('AllocatedProperties_String').optional(),
    dayAllocProdActiveHours: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Daily time series of the number of hours this string was actively producing in the allocation period.',
      ),
    dayAllocProdAllocatedGas: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Daily allocated gas production volume or rate for this string resulting from the production allocation process.',
      ),
    dayAllocProdAllocatedOil: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Daily allocated oil production volume for this string resulting from the production allocation process.',
      ),
    dayAllocProdAllocatedWater: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Daily allocated water production volume or rate for this string resulting from the production allocation process.',
      ),
    dayAllocProdFlowDirection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Daily time series describing the net flow direction of production for this string (for example flowing from reservoir to surface or reversed).',
      ),
    dayAllocProdProdMethod: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Daily time series of the production method applied to this string for allocated production (for example natural flow, gas lift, ESP).',
      ),
    dayAllocProdProdMode: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Daily time series of the operating or production mode of this string during production allocation (for example normal, test, shut-in).',
      ),
    dayAllocProdStringFunction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Daily time series indicating the string function classification (for example producer or injector) used in the production allocation for this string.',
      ),
    dayGPAllocVolActiveHours: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Daily time series of the number of hours contributing to gas plant (GP) allocated gas volume for this string.',
      ),
    dayGPAllocVolAllocatedGas: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated gas volume at the gas plant (GP) level attributed to this string.'),
    dayGPAllocVolFlowDirection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Daily time series describing the flow direction associated with gas plant (GP) allocated gas volume for this string.',
      ),
    dayGPAllocVolProdMethod: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Daily time series of the production method associated with gas plant (GP) allocated gas volume for this string.',
      ),
    dayGPAllocVolProdMode: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Daily time series of the operating mode associated with gas plant (GP) allocated gas volume for this string.',
      ),
    dayGPAllocVolStringFunction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Daily time series indicating the string function classification associated with gas plant (GP) allocated gas volume for this string.',
      ),
    dayGasInjActiveHours: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series of the number of hours this string was active for gas injection.'),
    dayGasInjFlowDirection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series describing the flow direction of gas injection associated with this string.'),
    dayGasInjGasInjVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated gas injection volume for this string.'),
    dayGasInjMaterialType: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series indicating the type of gas or material being injected through this string.'),
    dayGasInjProdMode: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series of the operating mode applicable while gas is being injected through this string.'),
    dayGasInjStringFunction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Daily time series indicating the string function classification for gas injection service on this string.',
      ),
    dayWaterInjActiveHours: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series of the number of hours this string was active for water injection.'),
    dayWaterInjFlowDirection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series describing the flow direction of water injection associated with this string.'),
    dayWaterInjMaterialType: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily time series indicating the type of water or chemical being injected through this string.'),
    dayWaterInjProdMode: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Daily time series of the operating mode applicable while water is being injected through this string.',
      ),
    dayWaterInjStringFunction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Daily time series indicating the string function classification for water injection service on this string.',
      ),
    dayWaterInjWaterInjVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Daily allocated water injection volume for this string.'),
    entityName: z
      .lazy(() => StringAssetSchema.nullish())
      .describe(
        "Name of the well string (completion) for which allocated production and injection properties are calculated, sourced from the 'String_asset' view.",
      ),
    monthAllocProdActiveDays: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Monthly time series indicating the number of days this string was actively producing within the month.',
      ),
    monthAllocProdAllocatedGas: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Monthly allocated gas production volume for this string resulting from the production allocation process.',
      ),
    monthAllocProdAllocatedOil: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Monthly allocated oil production volume for this string resulting from the production allocation process.',
      ),
    monthAllocProdAllocatedWater: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Monthly allocated water production volume for this string resulting from the production allocation process.',
      ),
    monthAllocProdFlowDirection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Monthly time series describing the dominant production flow direction for this string.'),
    monthAllocProdProdMethod: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Monthly time series summarizing the dominant production method applied to this string for allocated production.',
      ),
    monthAllocProdStringFunction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Monthly time series indicating the string function classification used in the production allocation for this string.',
      ),
    monthGPAllocVolActiveHours: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Monthly time series of the number of hours contributing to gas plant (GP) allocated gas volume for this string.',
      ),
    monthGPAllocVolAllocatedGas: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Monthly allocated gas volume at the gas plant (GP) level attributed to this string.'),
    monthGPAllocVolFlowDirection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Monthly time series describing the dominant flow direction associated with gas plant (GP) allocated gas volume for this string.',
      ),
    monthGPAllocVolProdMethod: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Monthly time series of the dominant production method associated with gas plant (GP) allocated gas volume for this string.',
      ),
    monthGPAllocVolProdMode: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Monthly time series of the operating mode associated with gas plant (GP) allocated gas volume for this string.',
      ),
    monthGPAllocVolStringFunction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Monthly time series indicating the string function classification associated with gas plant (GP) allocated gas volume for this string.',
      ),
    monthGasInjActiveDays: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Monthly time series indicating the number of days this string was active for gas injection.'),
    monthGasInjFlowDirection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Monthly time series describing the dominant gas injection flow direction associated with this string.',
      ),
    monthGasInjGasInjVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Monthly allocated gas injection volume for this string.'),
    monthGasInjMaterialType: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Monthly time series indicating the predominant gas or material type injected through this string.'),
    monthGasInjProdMode: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Monthly time series summarizing the operating mode while gas is being injected through this string.'),
    monthGasInjStringFunction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Monthly time series indicating the string function classification for gas injection service on this string.',
      ),
    monthWaterInjActiveDays: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Monthly time series indicating the number of days this string was active for water injection.'),
    monthWaterInjFlowDirection: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Monthly time series describing the dominant water injection flow direction associated with this string.',
      ),
    monthWaterInjMaterialType: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Monthly time series indicating the predominant water or chemical type injected through this string.'),
    monthWaterInjProdMode: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Monthly time series summarizing the operating mode while water is being injected through this string.',
      ),
    monthWaterInjStringFunction: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Monthly time series indicating the string function classification for water injection service on this string.',
      ),
    monthWaterInjWaterInjVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Monthly allocated water injection volume for this string.'),
  })
  .describe(
    'Daily and monthly allocated production and injection properties for each well string, including allocated oil, gas, water, gas lift and water injection volumes, flow directions, production methods and modes for use in production allocation and performance analysis.',
  );

export const AllocatedInjectionStringAgentSchema: z.ZodObject<Properties<AllocatedInjectionStringAgent>> = z
  .object({
    __typename: z.literal('AllocatedInjection_String_Agent').optional(),
    dayGasInjActiveHours: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Number of hours (0-24) the string was actively injecting gas during the day.'),
    dayGasInjGasInjVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Daily allocated gas injection volume (MSCF/d). Use for Day/Week time ranges.\nThe string's allocated share of total metered gas injection.",
      ),
    dayWaterInjActiveHours: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Number of hours (0-24) the string was actively injecting water during the day.'),
    dayWaterInjWaterInjVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        "Daily allocated water injection volume (stb/d). Use for Day/Week time ranges.\nThe string's allocated share of total metered water injection.",
      ),
    monthGasInjActiveDays: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Number of days (0-31) the string was actively injecting gas during the month.'),
    monthGasInjGasInjVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Monthly allocated gas injection volume (MSCF). Use for Month/Quarter/Year queries.\nSum of daily gas injection for the calendar month.',
      ),
    monthWaterInjActiveDays: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe('Number of days (0-31) the string was actively injecting water during the month.'),
    monthWaterInjWaterInjVolume: z
      .lazy(() => TimeSeriesSchema.nullish())
      .describe(
        'Monthly allocated water injection volume (stb). Use for Month/Quarter/Year queries.\nSum of daily water injection for the calendar month.',
      ),
    wellString: z
      .lazy(() => StringAssetSchema.nullish())
      .describe('Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context.'),
  })
  .describe(
    'Allocated injection volumes per well string for water and gas (WF15).\n\nDaily and monthly allocated gas and water injection, active hours/days per type.\nUse for injection performance, reporting, and trend analysis. For measured rates see MeasuredInjection_String_Agent.\n\nUse for: Water or Gas Injection Monitoring (WF15), Production Allocation (WF5).',
  );

export const AlarmDefinitionSchema: z.ZodObject<Properties<AlarmDefinition>> = z
  .object({
    __typename: z.literal('AlarmDefinition').optional(),
    alarmCategory: z.string().nullish().describe("Text attribute 'alarmCategory' for this 'AlarmDefinition' row."),
    alarmCounterToTicket: z
      .number()
      .nullish()
      .describe("Numeric value 'alarmCounterToTicket' (integer) for this 'AlarmDefinition' row."),
    alarmCriticality: z
      .string()
      .nullish()
      .describe("Text attribute 'alarmCriticality' for this 'AlarmDefinition' row."),
    alarmDataSource: z.string().nullish().describe("Text attribute 'alarmDataSource' for this 'AlarmDefinition' row."),
    alarmDescription: z
      .string()
      .nullish()
      .describe("Text attribute 'alarmDescription' for this 'AlarmDefinition' row."),
    alarmMessage: z.string().nullish().describe("Text attribute 'alarmMessage' for this 'AlarmDefinition' row."),
    alarmMsgParameter: z
      .string()
      .nullish()
      .describe("Text attribute 'alarmMsgParameter' for this 'AlarmDefinition' row."),
    alarmName: z.string().nullish().describe("Text attribute 'alarmName' for this 'AlarmDefinition' row."),
    alarmPriority: z.string().nullish().describe("Text attribute 'alarmPriority' for this 'AlarmDefinition' row."),
    alarmType: z.string().nullish().describe("Text attribute 'alarmType' for this 'AlarmDefinition' row."),
    alarmTypeCategory: z
      .string()
      .nullish()
      .describe("Text attribute 'alarmTypeCategory' for this 'AlarmDefinition' row."),
    alarmTypeSubCategory: z
      .string()
      .nullish()
      .describe("Text attribute 'alarmTypeSubCategory' for this 'AlarmDefinition' row."),
    alarmUnifiedCode: z
      .string()
      .nullish()
      .describe("Text attribute 'alarmUnifiedCode' for this 'AlarmDefinition' row."),
    isAlarmTicket: z.string().nullish().describe("Text attribute 'isAlarmTicket' for this 'AlarmDefinition' row."),
    subCategory: z.string().nullish().describe("Text attribute 'subCategory' for this 'AlarmDefinition' row."),
    subWorkflowName: z.string().nullish().describe("Text attribute 'subWorkflowName' for this 'AlarmDefinition' row."),
    ticketAsset: z.string().nullish().describe("Text attribute 'ticketAsset' for this 'AlarmDefinition' row."),
    ticketAssignedGroup: z
      .string()
      .nullish()
      .describe("Text attribute 'ticketAssignedGroup' for this 'AlarmDefinition' row."),
    ticketAssignedTo: z
      .string()
      .nullish()
      .describe("Text attribute 'ticketAssignedTo' for this 'AlarmDefinition' row."),
    ticketDept: z.string().nullish().describe("Text attribute 'ticketDept' for this 'AlarmDefinition' row."),
    ticketRecommedation: z
      .string()
      .nullish()
      .describe("Text attribute 'ticketRecommedation' for this 'AlarmDefinition' row."),
    workflowCode: z.string().nullish().describe("Text attribute 'workflowCode' for this 'AlarmDefinition' row."),
    workflowName: z.string().nullish().describe("Text attribute 'workflowName' for this 'AlarmDefinition' row."),
  })
  .describe("View 'AlarmDefinition' in the iPSO production optimization solution data model.");

export const WfAlarmsSchema: z.ZodObject<Properties<WfAlarms>> = z
  .object({
    __typename: z.literal('WfAlarms').optional(),
    additionalInformation: z.json().nullish().describe("Property 'additionalInformation' for this 'WfAlarms' row."),
    alarmCode: z
      .lazy(() => AlarmDefinitionSchema.nullish())
      .describe("Reference to the related 'AlarmDefinition' entity for this 'WfAlarms' row."),
    alarmCounter: z.number().describe("Numeric value 'alarmCounter' (integer) for this 'WfAlarms' row."),
    alarmFlags: z.string().nullish().describe("Text attribute 'alarmFlags' for this 'WfAlarms' row."),
    customWorkflowAlarmMessage: z
      .string()
      .describe("Text attribute 'customWorkflowAlarmMessage' for this 'WfAlarms' row."),
    endDateTime: z.coerce.date<Date>().describe("Timestamp 'endDateTime' associated with this 'WfAlarms' row."),
    entityExternalId: z.string().describe("Text attribute 'entityExternalId' for this 'WfAlarms' row."),
    entityName: z.string().describe("Text attribute 'entityName' for this 'WfAlarms' row."),
    entityType: z.string().describe("Text attribute 'entityType' for this 'WfAlarms' row."),
    markAsRead: z.json().nullish().describe("Property 'markAsRead' for this 'WfAlarms' row."),
    operationType: z.string().nullish().describe("Text attribute 'operationType' for this 'WfAlarms' row."),
    referencedEntityStartDateTime: z.coerce.date<Date>().nullish(),
    relatedEntity: z.string().nullish().describe("Text attribute 'relatedEntity' for this 'WfAlarms' row."),
    relatedEntityExternalId: z
      .string()
      .nullish()
      .describe("Text attribute 'relatedEntityExternalId' for this 'WfAlarms' row."),
    removeAlaramForUser: z.json().nullish().describe("Property 'removeAlaramForUser' for this 'WfAlarms' row."),
    runId: z.string().nullish().describe("Text attribute 'runId' for this 'WfAlarms' row."),
    ssWorkflowAlarmMessage: z
      .string()
      .nullish()
      .describe("Text attribute 'ssWorkflowAlarmMessage' for this 'WfAlarms' row."),
    startDateTime: z.coerce.date<Date>().describe("Timestamp 'startDateTime' associated with this 'WfAlarms' row."),
    ticketId: z.string().nullish().describe("Text attribute 'ticketId' for this 'WfAlarms' row."),
  })
  .describe("View 'WfAlarms' in the iPSO production optimization solution data model.");
